import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AiBotTemplateWithFieldsOutput = {
  __typename?: "AiBotTemplateWithFieldsOutput";
  createdAt: Scalars["String"];
  description?: Maybe<LanguageMap>;
  fields: Scalars["String"];
  id: Scalars["ID"];
  name: LanguageMap;
};

export type AiBotUserSettingsOutput = {
  __typename?: "AiBotUserSettingsOutput";
  botId: Scalars["ID"];
  createdAt: Scalars["String"];
  id: Scalars["ID"];
  templateId: Scalars["ID"];
  updatedAt: Scalars["String"];
  userSettings?: Maybe<Scalars["String"]>;
};

export enum AnalyticsAppointmentsDistributionLabels {
  Bots = "BOTS",
  Managers = "MANAGERS",
}

export enum AnalyticsCalendarInterval {
  Custom = "CUSTOM",
  Day = "DAY",
  Hour = "HOUR",
  Month = "MONTH",
  Quarter = "QUARTER",
  Week = "WEEK",
}

export type AnalyticsHeatMapSeriesDataItem = {
  __typename?: "AnalyticsHeatMapSeriesDataItem";
  x: Scalars["String"];
  y: Scalars["Int"];
};

export type AnalyticsHeatMapSeriesItem = {
  __typename?: "AnalyticsHeatMapSeriesItem";
  data: Array<Maybe<AnalyticsHeatMapSeriesDataItem>>;
  name: Scalars["String"];
};

export type AnalyticsOperatorsMetricsTableRow = {
  __typename?: "AnalyticsOperatorsMetricsTableRow";
  avgAcceptedSec: Scalars["Float"];
  avgFirstMessageSec: Scalars["Float"];
  completedChats: Scalars["Int"];
  operatorName: Scalars["String"];
};

export type ApiKey = {
  __typename?: "ApiKey";
  apiKey: Scalars["String"];
  createdAt: Scalars["String"];
  id: Scalars["ID"];
  lastCallAt?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
};

export type ApiKeyId = {
  __typename?: "ApiKeyId";
  id: Scalars["ID"];
};

export type ApiKeyShort = {
  __typename?: "ApiKeyShort";
  apiKey: Scalars["String"];
  id: Scalars["ID"];
};

export type AppField = {
  __typename?: "AppField";
  c?: Maybe<Array<AppFieldDetails>>;
  d?: Maybe<LanguageMap>;
  dt?: Maybe<AppFieldDataTypeType>;
  dts?: Maybe<Array<AppFieldDataTypesType>>;
  mn?: Maybe<Scalars["Int"]>;
  mx?: Maybe<Scalars["Int"]>;
  n: LanguageMap;
  p?: Maybe<LanguageMap>;
  r?: Maybe<Scalars["Boolean"]>;
  t: AppFieldTypeType;
  tg: Scalars["String"];
  v?: Maybe<Scalars["String"]>;
};

export enum AppFieldDataTypeType {
  Number = "number",
  Secret = "secret",
  Select = "select",
  String = "string",
}

export enum AppFieldDataTypesType {
  Node = "node",
  User = "user",
}

export type AppFieldDetails = AppFieldInner | AppFieldsGroupInner;

export type AppFieldInner = {
  __typename?: "AppFieldInner";
  d?: Maybe<LanguageMap>;
  dt?: Maybe<AppFieldDataTypeType>;
  dts?: Maybe<Array<AppFieldDataTypesType>>;
  mn?: Maybe<Scalars["Int"]>;
  mx?: Maybe<Scalars["Int"]>;
  n: LanguageMap;
  p?: Maybe<LanguageMap>;
  r?: Maybe<Scalars["Boolean"]>;
  t: AppFieldTypeType;
  tg: Scalars["String"];
  v?: Maybe<Scalars["String"]>;
};

export enum AppFieldSettingsDataTypeType {
  Node = "node",
  Number = "number",
  Secret = "secret",
  Select = "select",
  String = "string",
  User = "user",
}

export enum AppFieldTypeType {
  AreaMultiselect = "areaMultiselect",
  Input = "input",
  Multiselect = "multiselect",
  Select = "select",
}

export type AppFieldsGroup = {
  __typename?: "AppFieldsGroup";
  c: Array<AppField>;
  g: AppFieldsGroupType;
};

export type AppFieldsGroupInner = {
  __typename?: "AppFieldsGroupInner";
  c: Array<AppFieldInner>;
  g: AppFieldsGroupType;
};

export enum AppFieldsGroupType {
  Action = "action",
  Common = "common",
  Fields = "fields",
}

export type AppGallery = {
  __typename?: "AppGallery";
  alt: LanguageMap;
  height: Scalars["Int"];
  imageUrl?: Maybe<Scalars["String"]>;
  videoUrl?: Maybe<Scalars["String"]>;
  width: Scalars["Int"];
};

export type AppInstallation = {
  __typename?: "AppInstallation";
  createdAt: Scalars["String"];
  id: Scalars["ID"];
  localId?: Maybe<Scalars["String"]>;
  method?: Maybe<MethodType>;
  settings?: Maybe<Array<Maybe<AppSettingsGroup>>>;
};

export type AppOutput = {
  __typename?: "AppOutput";
  createdAt: Scalars["String"];
  description?: Maybe<LanguageMap>;
  gallery?: Maybe<Scalars["String"]>;
  iconUrl: Scalars["String"];
  id: Scalars["ID"];
  instructions?: Maybe<LanguageMap>;
  isAvailable: Scalars["Boolean"];
  isInstalled: Scalars["Boolean"];
  latestVersion: Scalars["String"];
  name: LanguageMap;
  tag: Scalars["String"];
  type: AppType;
  versions: Array<Maybe<AppVersion>>;
};

export type AppSettingsField = {
  __typename?: "AppSettingsField";
  c?: Maybe<Array<AppSettingsFieldDetails>>;
  dt: AppFieldSettingsDataTypeType;
  tg: Scalars["String"];
  v: Scalars["String"];
};

export type AppSettingsFieldDetails =
  | AppSettingsFieldInner
  | AppSettingsGroupInner;

export type AppSettingsFieldInner = {
  __typename?: "AppSettingsFieldInner";
  dt: AppFieldSettingsDataTypeType;
  tg: Scalars["String"];
  v: Scalars["String"];
};

export type AppSettingsGroup = {
  __typename?: "AppSettingsGroup";
  c: Array<AppSettingsField>;
  g: AppFieldsGroupType;
};

export type AppSettingsGroupInner = {
  __typename?: "AppSettingsGroupInner";
  c: Array<AppSettingsFieldInner>;
  g: AppFieldsGroupType;
};

export enum AppType {
  BotNode = "BOT_NODE",
  Webhook = "WEBHOOK",
}

export type AppVersion = {
  __typename?: "AppVersion";
  createdAt: Scalars["String"];
  fields: Array<Maybe<AppFieldsGroup>>;
  id: Scalars["ID"];
  installations: Array<Maybe<AppInstallation>>;
  isInstalled: Scalars["Boolean"];
  version: Scalars["String"];
};

export type AppointmentsDistribution = {
  __typename?: "AppointmentsDistribution";
  labels: Array<AnalyticsAppointmentsDistributionLabels>;
  series: Array<Scalars["Int"]>;
};

export type BaseCalendarEventOutput2 = {
  __typename?: "BaseCalendarEventOutput2";
  actionType?: Maybe<CalendarEventActionType>;
  event?: Maybe<CalendarEventOutput2>;
};

export type BotOutput = {
  __typename?: "BotOutput";
  botType?: Maybe<BotType>;
  connectedChannels?: Maybe<Array<Maybe<ChannelOutput2>>>;
  createdAt?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  isActive?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
  publishedAt?: Maybe<Scalars["String"]>;
  sessionsCount?: Maybe<Scalars["Int"]>;
  status?: Maybe<BotStatus>;
  teamsIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  updatedAt?: Maybe<Scalars["String"]>;
  userSettingsRaw?: Maybe<Scalars["String"]>;
};

export enum BotStatus {
  Deleted = "DELETED",
  Deletion = "DELETION",
  Draft = "DRAFT",
  Published = "PUBLISHED",
}

export enum BotType {
  Ai = "AI",
  Scheme = "SCHEME",
}

export type ButtonInput = {
  botId?: InputMaybe<Scalars["String"]>;
  buttonOrder?: InputMaybe<Scalars["Int"]>;
  flowId?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  localId?: InputMaybe<Scalars["String"]>;
  localNodeId?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  nodeId?: InputMaybe<Scalars["String"]>;
};

export type ButtonOutput = {
  __typename?: "ButtonOutput";
  botId?: Maybe<Scalars["String"]>;
  buttonOrder?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["String"]>;
  localId?: Maybe<Scalars["String"]>;
  localNodeId?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  nodeId?: Maybe<Scalars["String"]>;
};

export enum CalendarEventActionType {
  Created = "CREATED",
  Deleted = "DELETED",
  Reminded = "REMINDED",
  Updated = "UPDATED",
}

export type CalendarEventOutput2 = {
  __typename?: "CalendarEventOutput2";
  createdAt: Scalars["String"];
  deletedAt?: Maybe<Scalars["String"]>;
  description: Scalars["String"];
  ends?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  isBot: Scalars["Boolean"];
  isNonWorking?: Maybe<Scalars["Boolean"]>;
  operatorId?: Maybe<Scalars["String"]>;
  roomId?: Maybe<Scalars["String"]>;
  starts?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  updatedAt: Scalars["String"];
  userId?: Maybe<Scalars["String"]>;
};

export type Card = {
  __typename?: "Card";
  brand?: Maybe<Scalars["String"]>;
  expMonth?: Maybe<Scalars["Int"]>;
  expYear?: Maybe<Scalars["Int"]>;
  last4?: Maybe<Scalars["String"]>;
};

export type ChangeDeletionStatusesInput = {
  usersIds: Array<Scalars["String"]>;
};

export type ChannelOutput2 = {
  __typename?: "ChannelOutput2";
  bot?: Maybe<BotOutput>;
  createdAt: Scalars["String"];
  deletedAt?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  link: Scalars["String"];
  name: Scalars["String"];
  publicId: Scalars["String"];
  status: ChannelStatus;
  type: ChannelType;
  updatedAt: Scalars["String"];
};

export enum ChannelStatus {
  Active = "ACTIVE",
  Error = "ERROR",
  Inactive = "INACTIVE",
  PendingDeactivation = "PENDING_DEACTIVATION",
  PendingDeletion = "PENDING_DELETION",
}

export type ChannelStatusOutput = {
  __typename?: "ChannelStatusOutput";
  statusDescription?: Maybe<Scalars["String"]>;
  statusId?: Maybe<Scalars["String"]>;
  statusName?: Maybe<Scalars["String"]>;
};

export enum ChannelType {
  Email = "EMAIL",
  FacebookMessenger = "FACEBOOK_MESSENGER",
  Instagram = "INSTAGRAM",
  Sms = "SMS",
  Telegram = "TELEGRAM",
  Vk = "VK",
  Whatsapp = "WHATSAPP",
}

export enum ChannelsModes {
  Bot = "BOT",
  Human = "HUMAN",
}

export type ChatSnippetsCategoriesOutput = {
  __typename?: "ChatSnippetsCategoriesOutput";
  categoryId?: Maybe<Scalars["String"]>;
  categoryName?: Maybe<Scalars["String"]>;
  parentId?: Maybe<Scalars["String"]>;
  totalSnippetsCount?: Maybe<Scalars["Int"]>;
  userId?: Maybe<Scalars["String"]>;
};

export type ChatSnippetsFavoritesOutput = {
  __typename?: "ChatSnippetsFavoritesOutput";
  isFavorite: Scalars["Boolean"];
  snippetId?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
};

export type ChatSnippetsOutput = {
  __typename?: "ChatSnippetsOutput";
  categoryId?: Maybe<Scalars["String"]>;
  isFavorite: Scalars["Boolean"];
  snippet?: Maybe<Scalars["String"]>;
  snippetId?: Maybe<Scalars["String"]>;
  teamsIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  userId?: Maybe<Scalars["String"]>;
};

export type ChatsAnalyticsOutput = {
  __typename?: "ChatsAnalyticsOutput";
  acceptedChats: Scalars["Int"];
  calendarAppointments: AppointmentsDistribution;
  invisibleChats: Scalars["Int"];
  newChats7d: LineChart;
  nonAcceptedChats: Scalars["Int"];
  nonRespondedChats: Scalars["Int"];
};

export enum CheckCodeStatus {
  Approved = "approved",
  Disapproved = "disapproved",
  Pending = "pending",
}

export type ClientTodoTasksOutput = {
  __typename?: "ClientTodoTasksOutput";
  createdAt: Scalars["String"];
  deadline?: Maybe<Scalars["String"]>;
  deletedAt?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  isDone: Scalars["Boolean"];
  operatorId?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["String"];
};

export type CommentOutput2 = {
  __typename?: "CommentOutput2";
  clientId?: Maybe<Scalars["String"]>;
  comment?: Maybe<Scalars["String"]>;
  commentId?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["String"]>;
  operator?: Maybe<UserOutput>;
};

export type CommonUserFields = {
  __typename?: "CommonUserFields";
  autoNickname?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  userpicUrl?: Maybe<Scalars["String"]>;
};

export type CreateChatRoomMessageInput = {
  chatRoomId: Scalars["String"];
  isClient: Scalars["Boolean"];
  localMessageId?: InputMaybe<Scalars["String"]>;
  messageAuthorId: Scalars["String"];
  messageChannelId: Scalars["String"];
  messageChannelType: ChannelType;
  messageContent?: InputMaybe<Scalars["String"]>;
  messageMetadata?: InputMaybe<Scalars["String"]>;
  messageText?: InputMaybe<Scalars["String"]>;
};

export type CreateCommentOnClientInput = {
  clientId: Scalars["String"];
  comment: Scalars["String"];
  operatorId: Scalars["String"];
};

export type CreateTeamInput = {
  name: Scalars["String"];
  usersIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export enum CustomFieldDataType {
  Date = "DATE",
  Email = "EMAIL",
  Multiselect = "MULTISELECT",
  Number = "NUMBER",
  Phone = "PHONE",
  Text = "TEXT",
  Url = "URL",
}

export enum CustomFieldMethodType {
  Create = "CREATE",
  Delete = "DELETE",
  Update = "UPDATE",
}

export type CustomFieldOutput = {
  __typename?: "CustomFieldOutput";
  dataType: CustomFieldDataType;
  description?: Maybe<Scalars["String"]>;
  fieldName: Scalars["String"];
  fieldOrder: Scalars["Int"];
  id: Scalars["String"];
};

export type DataByChannelType = {
  __typename?: "DataByChannelType";
  labels: Array<Maybe<Scalars["String"]>>;
  series: SeriesByChannelType;
};

export type DataByLabelsType = {
  __typename?: "DataByLabelsType";
  labels: Array<Maybe<Scalars["String"]>>;
  series: Array<Maybe<Scalars["Int"]>>;
};

export enum DealerExportKind {
  Communications = "communications",
  Contacts = "contacts",
}

export type DealerExportRequest = {
  __typename?: "DealerExportRequest";
  email?: Maybe<Scalars["String"]>;
  status: Scalars["String"];
};

export enum DealershipType {
  New = "NEW",
  Old = "OLD",
  Used = "USED",
}

export type DeleteMessageOutput = {
  __typename?: "DeleteMessageOutput";
  channelId?: Maybe<Scalars["String"]>;
  channelType?: Maybe<ChannelType>;
  chatRoomId?: Maybe<Scalars["String"]>;
  messageId?: Maybe<Scalars["String"]>;
};

export type DeleteOrganizationsOutput = {
  __typename?: "DeleteOrganizationsOutput";
  deleted?: Maybe<Scalars["Boolean"]>;
  teamsIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type DeployOrganizationOutput = {
  __typename?: "DeployOrganizationOutput";
  oid: Scalars["String"];
};

export type EdgeInput = {
  botId?: InputMaybe<Scalars["String"]>;
  childId?: InputMaybe<Scalars["String"]>;
  flowId?: InputMaybe<Scalars["String"]>;
  handleParentId?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isDelete?: InputMaybe<Scalars["Boolean"]>;
  localChildId?: InputMaybe<Scalars["String"]>;
  localHandleParentId?: InputMaybe<Scalars["String"]>;
  localId?: InputMaybe<Scalars["String"]>;
  localParentId?: InputMaybe<Scalars["String"]>;
  parentId?: InputMaybe<Scalars["String"]>;
};

export type EdgeOutput = {
  __typename?: "EdgeOutput";
  botId?: Maybe<Scalars["String"]>;
  childId?: Maybe<Scalars["String"]>;
  flowId?: Maybe<Scalars["String"]>;
  handleParentId?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  isDelete?: Maybe<Scalars["Boolean"]>;
  localChildId?: Maybe<Scalars["String"]>;
  localHandleParentId?: Maybe<Scalars["String"]>;
  localId?: Maybe<Scalars["String"]>;
  localParentId?: Maybe<Scalars["String"]>;
  parentId?: Maybe<Scalars["String"]>;
};

export type EmailAvailability = {
  __typename?: "EmailAvailability";
  taken: Scalars["Boolean"];
};

export enum FtpSyncStatus {
  Failed = "FAILED",
  Never = "NEVER",
  Success = "SUCCESS",
}

export type FtpSyncStatusOutput = {
  __typename?: "FTPSyncStatusOutput";
  lastSyncAt?: Maybe<Scalars["String"]>;
  lastSyncStatus?: Maybe<FtpSyncStatus>;
};

export type FacebookPagesCategoryListOutput = {
  __typename?: "FacebookPagesCategoryListOutput";
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type FacebookPagesCursorsOutput = {
  __typename?: "FacebookPagesCursorsOutput";
  after?: Maybe<Scalars["String"]>;
  before?: Maybe<Scalars["String"]>;
};

export type FacebookPagesDataOutput = {
  __typename?: "FacebookPagesDataOutput";
  access_token?: Maybe<Scalars["String"]>;
  category?: Maybe<Scalars["String"]>;
  category_list?: Maybe<Array<Maybe<FacebookPagesCategoryListOutput>>>;
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  tasks?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type FacebookPagesPagingOutput = {
  __typename?: "FacebookPagesPagingOutput";
  cursors?: Maybe<FacebookPagesCursorsOutput>;
};

export type FeatureFlagEvaluation = {
  __typename?: "FeatureFlagEvaluation";
  enabled: Scalars["Boolean"];
  flagId: Scalars["String"];
  value?: Maybe<Scalars["String"]>;
};

export type FeatureFlagTraitInput = {
  key: Scalars["String"];
  value?: InputMaybe<Scalars["String"]>;
};

export type FileItemOutput = {
  __typename?: "FileItemOutput";
  createdAt?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<FileStatus>;
  url?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
};

export enum FileStatus {
  Decline = "DECLINE",
  Done = "DONE",
  Error = "ERROR",
  InProgress = "IN_PROGRESS",
}

export type FlowOutput = {
  __typename?: "FlowOutput";
  botId?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  isMain?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["String"]>;
};

export type GeneralAnalyticsOutput = {
  __typename?: "GeneralAnalyticsOutput";
  appointmentsNonWorking: DataByLabelsType;
  calendarAppointments: AppointmentsDistribution;
  chatsByChannels: DataByChannelType;
  leadsByMarketplace: DataByLabelsType;
  leadsNonWorking: DataByLabelsType;
  nonAcceptedChats: Scalars["Int"];
  totalChats: Scalars["Int"];
  totalContacts: Scalars["Int"];
};

export type GetCalendarEventsOutput = {
  __typename?: "GetCalendarEventsOutput";
  events?: Maybe<Array<Maybe<CalendarEventOutput2>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type GetChatRoomMessagesOutput = {
  __typename?: "GetChatRoomMessagesOutput";
  chatRoomMessages?: Maybe<Array<Maybe<MessageOutput>>>;
  pagingState?: Maybe<Scalars["String"]>;
  roomId?: Maybe<Scalars["String"]>;
};

export type GetChatSnippets = {
  __typename?: "GetChatSnippets";
  snippets?: Maybe<Array<Maybe<ChatSnippetsOutput>>>;
  totalNumberOfSnippets?: Maybe<Scalars["Int"]>;
};

export type GetChatSnippetsCategories = {
  __typename?: "GetChatSnippetsCategories";
  categories?: Maybe<Array<Maybe<ChatSnippetsCategoriesOutput>>>;
  totalNumberOfCategories?: Maybe<Scalars["Int"]>;
};

export type GetChatSnippetsFavorites = {
  __typename?: "GetChatSnippetsFavorites";
  favorites?: Maybe<Array<Maybe<ChatSnippetsFavoritesOutput>>>;
  totalNumberOfFavorites?: Maybe<Scalars["Int"]>;
};

export type GetChatsAnalyticsInput = {
  calendarInterval: AnalyticsCalendarInterval;
  period: PeriodInput;
};

export type GetCommentsOnClientOutput2 = {
  __typename?: "GetCommentsOnClientOutput2";
  commentCount?: Maybe<Scalars["Int"]>;
  comments?: Maybe<Array<Maybe<CommentOutput2>>>;
};

export type GetFacebookPagesOutput = {
  __typename?: "GetFacebookPagesOutput";
  data?: Maybe<Array<Maybe<FacebookPagesDataOutput>>>;
  paging?: Maybe<FacebookPagesPagingOutput>;
};

export type GetFlowInput = {
  botId?: InputMaybe<Scalars["String"]>;
  flowId?: InputMaybe<Scalars["String"]>;
};

export type GetGeneralAnalyticsInput = {
  calendarInterval: AnalyticsCalendarInterval;
  period: PeriodInput;
};

export type GetInventoryDetailsOutput = {
  __typename?: "GetInventoryDetailsOutput";
  additionalEquipments?: Maybe<Scalars["String"]>;
  carfaxLink?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  imageLink?: Maybe<Scalars["String"]>;
  isSold?: Maybe<Scalars["Boolean"]>;
  status?: Maybe<InventoryStatus>;
};

export type GetInventoryInput = {
  filter?: InputMaybe<Scalars["String"]>;
  isAvailable?: InputMaybe<Scalars["Boolean"]>;
  isConflictingStatus?: InputMaybe<Scalars["Boolean"]>;
  isNew?: InputMaybe<Scalars["Boolean"]>;
  pagination?: InputMaybe<PaginationInput>;
  priceEnd?: InputMaybe<Scalars["Float"]>;
  priceStart?: InputMaybe<Scalars["Float"]>;
  statuses?: InputMaybe<Array<InputMaybe<InventoryStatus>>>;
  yearEnd?: InputMaybe<Scalars["Int"]>;
  yearStart?: InputMaybe<Scalars["Int"]>;
};

export type GetInventoryOutput = {
  __typename?: "GetInventoryOutput";
  inventory?: Maybe<Array<Maybe<InventoryOutput>>>;
  pagination?: Maybe<PaginationOutput>;
};

export type GetNodesAndEdgesInput = {
  botId?: InputMaybe<Scalars["String"]>;
  flowId?: InputMaybe<Scalars["String"]>;
};

export type GetOperatorsAnalyticsInput = {
  calendarInterval: AnalyticsCalendarInterval;
  operatorId?: InputMaybe<Scalars["String"]>;
  period: PeriodInput;
  teamId?: InputMaybe<Scalars["String"]>;
};

export type GetRoom2Output = {
  __typename?: "GetRoom2Output";
  error?: Maybe<Scalars["String"]>;
  room?: Maybe<RoomOutput2>;
};

export type GetRoomHistoryOrganizationOutput = {
  __typename?: "GetRoomHistoryOrganizationOutput";
  organizationName?: Maybe<Scalars["String"]>;
  teamId?: Maybe<Scalars["String"]>;
};

export type GetRoomHistoryOutput = {
  __typename?: "GetRoomHistoryOutput";
  createdAt?: Maybe<Scalars["String"]>;
  eventName?: Maybe<Scalars["String"]>;
  from?: Maybe<UserOutput>;
  operator?: Maybe<UserOutput>;
  organizations?: Maybe<Array<Maybe<GetRoomHistoryOrganizationOutput>>>;
  to?: Maybe<UserOutput>;
};

export type GetRoomInput = {
  id: Scalars["String"];
};

export type GetRooms2Output = {
  __typename?: "GetRooms2Output";
  error?: Maybe<Scalars["String"]>;
  hasUnreadMessages?: Maybe<Scalars["Boolean"]>;
  pagination?: Maybe<PaginationViaCursorOutput>;
  requestedStatus?: Maybe<RoomStatus>;
  rooms?: Maybe<Array<Maybe<RoomOutput2>>>;
};

export type GetRoomsInput = {
  carId?: InputMaybe<Scalars["ID"]>;
  filter?: InputMaybe<Scalars["String"]>;
  pagination?: InputMaybe<PaginationViaCursorInput>;
  status?: InputMaybe<RoomStatus>;
};

export type GetUsersInput = {
  channelsTypes?: InputMaybe<Array<InputMaybe<ChannelType>>>;
  filter?: InputMaybe<Scalars["String"]>;
  isActive?: InputMaybe<Scalars["Boolean"]>;
  pagination?: InputMaybe<PaginationInput>;
  sortBy?: InputMaybe<SortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  type: UserType;
  usersIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type GetUsersOutput = {
  __typename?: "GetUsersOutput";
  pagination?: Maybe<PaginationOutput>;
  users?: Maybe<Array<Maybe<UserOutput>>>;
};

export enum InitiatorType {
  Bot = "BOT",
  Client = "CLIENT",
  InternalUser = "INTERNAL_USER",
  System = "SYSTEM",
}

export type InquiryOutput = {
  __typename?: "InquiryOutput";
  channelId?: Maybe<Scalars["String"]>;
  channelIdSource?: Maybe<Scalars["String"]>;
  clientId?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  leadSource?: Maybe<Scalars["String"]>;
  vehicle?: Maybe<Scalars["String"]>;
};

export type InventoryOutput = {
  __typename?: "InventoryOutput";
  bodyType?: Maybe<Scalars["String"]>;
  carfaxLink?: Maybe<Scalars["String"]>;
  centsPrice?: Maybe<Scalars["Int"]>;
  exteriorColor?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  isAvailable?: Maybe<Scalars["Boolean"]>;
  isConflictingStatus?: Maybe<Scalars["Boolean"]>;
  isNew?: Maybe<Scalars["Boolean"]>;
  leadsCount?: Maybe<Scalars["Int"]>;
  make?: Maybe<Scalars["String"]>;
  mileage?: Maybe<Scalars["Float"]>;
  model?: Maybe<Scalars["String"]>;
  mpg?: Maybe<Scalars["String"]>;
  price?: Maybe<Scalars["Float"]>;
  priceHistory?: Maybe<Array<Maybe<PriceHistoryFields>>>;
  source?: Maybe<InventorySourceOutput>;
  status?: Maybe<InventoryStatus>;
  stockId?: Maybe<Scalars["String"]>;
  testDriveCount?: Maybe<Scalars["Int"]>;
  trim?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
  vin: Scalars["String"];
  year?: Maybe<Scalars["Int"]>;
};

export enum InventorySourceOutput {
  Autotrader = "AUTOTRADER",
  Cargurus = "CARGURUS",
  Manually = "MANUALLY",
  Marketcheck = "MARKETCHECK",
  Other = "OTHER",
  Stock = "STOCK",
}

export enum InventoryStatus {
  Available = "AVAILABLE",
  AvailableManually = "AVAILABLE_MANUALLY",
  Sold = "SOLD",
  SoldManually = "SOLD_MANUALLY",
}

export type Invoice = {
  __typename?: "Invoice";
  amount?: Maybe<Scalars["Int"]>;
  card?: Maybe<Card>;
  createdAt?: Maybe<Scalars["String"]>;
  finalizedAt?: Maybe<Scalars["String"]>;
  hostedInvoiceUrl?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  invoicePdf?: Maybe<Scalars["String"]>;
  package?: Maybe<OrganizationTariff>;
  products?: Maybe<Array<Maybe<Scalars["String"]>>>;
  quantity?: Maybe<Scalars["Int"]>;
  status?: Maybe<InvoiceStatus>;
};

export enum InvoiceSortBy {
  Amount = "AMOUNT",
  Date = "DATE",
  Leads = "LEADS",
}

export enum InvoiceStatus {
  Draft = "draft",
  Open = "open",
  Paid = "paid",
  Uncollectible = "uncollectible",
  Void = "void",
}

export type InvoicesOutput = {
  __typename?: "InvoicesOutput";
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  pagination?: Maybe<PaginationOutput>;
};

export enum LanguageCode_Iso_639_1 {
  Aa = "aa",
  Ab = "ab",
  Ae = "ae",
  Af = "af",
  Ak = "ak",
  Am = "am",
  An = "an",
  Ar = "ar",
  As = "as",
  Av = "av",
  Ay = "ay",
  Az = "az",
  Ba = "ba",
  Be = "be",
  Bg = "bg",
  Bh = "bh",
  Bi = "bi",
  Bm = "bm",
  Bn = "bn",
  Br = "br",
  Bs = "bs",
  Ca = "ca",
  Ce = "ce",
  Ch = "ch",
  Co = "co",
  Cr = "cr",
  Cs = "cs",
  Cu = "cu",
  Cv = "cv",
  Cy = "cy",
  Da = "da",
  De = "de",
  Dv = "dv",
  Dz = "dz",
  Ee = "ee",
  El = "el",
  En = "en",
  Eo = "eo",
  Es = "es",
  Et = "et",
  Eu = "eu",
  Fa = "fa",
  Ff = "ff",
  Fi = "fi",
  Fj = "fj",
  Fo = "fo",
  Fr = "fr",
  Fy = "fy",
  Ga = "ga",
  Gd = "gd",
  Gl = "gl",
  Gn = "gn",
  Gu = "gu",
  Gv = "gv",
  Ha = "ha",
  He = "he",
  Hi = "hi",
  Ho = "ho",
  Hr = "hr",
  Ht = "ht",
  Hu = "hu",
  Hy = "hy",
  Hz = "hz",
  Ia = "ia",
  Id = "id",
  Ie = "ie",
  Ig = "ig",
  Ii = "ii",
  Ik = "ik",
  Io = "io",
  Is = "is",
  It = "it",
  Iu = "iu",
  Ja = "ja",
  Jv = "jv",
  Ka = "ka",
  Kg = "kg",
  Ki = "ki",
  Kj = "kj",
  Kk = "kk",
  Kl = "kl",
  Km = "km",
  Kn = "kn",
  Ko = "ko",
  Kr = "kr",
  Ks = "ks",
  Ku = "ku",
  Kv = "kv",
  Kw = "kw",
  Ky = "ky",
  La = "la",
  Lb = "lb",
  Lg = "lg",
  Li = "li",
  Ln = "ln",
  Lo = "lo",
  Lt = "lt",
  Lu = "lu",
  Lv = "lv",
  Mg = "mg",
  Mh = "mh",
  Mi = "mi",
  Mk = "mk",
  Ml = "ml",
  Mn = "mn",
  Mr = "mr",
  Ms = "ms",
  Mt = "mt",
  My = "my",
  Na = "na",
  Nb = "nb",
  Nd = "nd",
  Ne = "ne",
  Ng = "ng",
  Nl = "nl",
  Nn = "nn",
  No = "no",
  Nr = "nr",
  Nv = "nv",
  Ny = "ny",
  Oc = "oc",
  Oj = "oj",
  Om = "om",
  Or = "or",
  Os = "os",
  Pa = "pa",
  Pi = "pi",
  Pl = "pl",
  Ps = "ps",
  Pt = "pt",
  Qu = "qu",
  Rm = "rm",
  Rn = "rn",
  Ro = "ro",
  Ru = "ru",
  Rw = "rw",
  Sa = "sa",
  Sc = "sc",
  Sd = "sd",
  Se = "se",
  Sg = "sg",
  Si = "si",
  Sk = "sk",
  Sl = "sl",
  Sm = "sm",
  Sn = "sn",
  So = "so",
  Sq = "sq",
  Sr = "sr",
  Ss = "ss",
  St = "st",
  Su = "su",
  Sv = "sv",
  Sw = "sw",
  Ta = "ta",
  Te = "te",
  Tg = "tg",
  Th = "th",
  Ti = "ti",
  Tk = "tk",
  Tl = "tl",
  Tn = "tn",
  To = "to",
  Tr = "tr",
  Ts = "ts",
  Tt = "tt",
  Tw = "tw",
  Ty = "ty",
  Ug = "ug",
  Uk = "uk",
  Ur = "ur",
  Uz = "uz",
  Ve = "ve",
  Vi = "vi",
  Vo = "vo",
  Wa = "wa",
  Wo = "wo",
  Xh = "xh",
  Yi = "yi",
  Yo = "yo",
  Za = "za",
  Zh = "zh",
  Zu = "zu",
}

export type LanguageMap = {
  __typename?: "LanguageMap";
  af?: Maybe<Scalars["String"]>;
  ar?: Maybe<Scalars["String"]>;
  az?: Maybe<Scalars["String"]>;
  bg?: Maybe<Scalars["String"]>;
  bn?: Maybe<Scalars["String"]>;
  ca?: Maybe<Scalars["String"]>;
  cs?: Maybe<Scalars["String"]>;
  da?: Maybe<Scalars["String"]>;
  de?: Maybe<Scalars["String"]>;
  el?: Maybe<Scalars["String"]>;
  en: Scalars["String"];
  es?: Maybe<Scalars["String"]>;
  et?: Maybe<Scalars["String"]>;
  fa?: Maybe<Scalars["String"]>;
  fi?: Maybe<Scalars["String"]>;
  fil?: Maybe<Scalars["String"]>;
  fr?: Maybe<Scalars["String"]>;
  ga?: Maybe<Scalars["String"]>;
  gu?: Maybe<Scalars["String"]>;
  ha?: Maybe<Scalars["String"]>;
  he?: Maybe<Scalars["String"]>;
  hi?: Maybe<Scalars["String"]>;
  hr?: Maybe<Scalars["String"]>;
  hu?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  it?: Maybe<Scalars["String"]>;
  ja?: Maybe<Scalars["String"]>;
  ka?: Maybe<Scalars["String"]>;
  kk?: Maybe<Scalars["String"]>;
  kn?: Maybe<Scalars["String"]>;
  ko?: Maybe<Scalars["String"]>;
  ky?: Maybe<Scalars["String"]>;
  lo?: Maybe<Scalars["String"]>;
  lt?: Maybe<Scalars["String"]>;
  lv?: Maybe<Scalars["String"]>;
  mk?: Maybe<Scalars["String"]>;
  ml?: Maybe<Scalars["String"]>;
  mr?: Maybe<Scalars["String"]>;
  ms?: Maybe<Scalars["String"]>;
  nb?: Maybe<Scalars["String"]>;
  nl?: Maybe<Scalars["String"]>;
  pa?: Maybe<Scalars["String"]>;
  pl?: Maybe<Scalars["String"]>;
  pt?: Maybe<Scalars["String"]>;
  ro?: Maybe<Scalars["String"]>;
  ru?: Maybe<Scalars["String"]>;
  rw?: Maybe<Scalars["String"]>;
  sk?: Maybe<Scalars["String"]>;
  sl?: Maybe<Scalars["String"]>;
  sq?: Maybe<Scalars["String"]>;
  sr?: Maybe<Scalars["String"]>;
  sv?: Maybe<Scalars["String"]>;
  sw?: Maybe<Scalars["String"]>;
  ta?: Maybe<Scalars["String"]>;
  te?: Maybe<Scalars["String"]>;
  th?: Maybe<Scalars["String"]>;
  tr?: Maybe<Scalars["String"]>;
  uk?: Maybe<Scalars["String"]>;
  ur?: Maybe<Scalars["String"]>;
  uz?: Maybe<Scalars["String"]>;
  vi?: Maybe<Scalars["String"]>;
  zh?: Maybe<Scalars["String"]>;
  zu?: Maybe<Scalars["String"]>;
};

export type LastMessageContentOutput = {
  __typename?: "LastMessageContentOutput";
  messageContent?: Maybe<Array<Maybe<MessageContentItemOutput>>>;
  messageText?: Maybe<Scalars["String"]>;
};

export type LineChart = {
  __typename?: "LineChart";
  series: Array<Maybe<LineChartSeries>>;
  xAxis: LineChartXAxisCategories;
};

export type LineChartSeries = {
  __typename?: "LineChartSeries";
  data: Array<Scalars["Int"]>;
  name: ChannelType;
};

export type LineChartXAxisCategories = {
  __typename?: "LineChartXAxisCategories";
  categories: Array<Maybe<Scalars["String"]>>;
};

export type LinkedRoomOutput = {
  __typename?: "LinkedRoomOutput";
  channel: ChannelOutput2;
  createdAt?: Maybe<Scalars["String"]>;
  hasClientMessage: Scalars["Boolean"];
  id: Scalars["ID"];
  langCode?: Maybe<LanguageCode_Iso_639_1>;
  lastClientMessageAt?: Maybe<Scalars["String"]>;
  lastMessageAt?: Maybe<Scalars["String"]>;
  lastMessageContent?: Maybe<LastMessageContentOutput>;
  lastTicketAt?: Maybe<Scalars["String"]>;
  unreadMessagesNumber: Scalars["Int"];
};

export enum MailingActionType {
  FinalMessage = "FINAL_MESSAGE",
  FirstMessage = "FIRST_MESSAGE",
  FollowUp = "FOLLOW_UP",
  Reengagement = "REENGAGEMENT",
  SpecialNotify = "SPECIAL_NOTIFY",
  Transfer = "TRANSFER",
}

export type MailingRecordOutput = {
  __typename?: "MailingRecordOutput";
  actionType?: Maybe<MailingActionType>;
  deletedAt?: Maybe<Scalars["String"]>;
  deleterName?: Maybe<Scalars["String"]>;
  leadId?: Maybe<Scalars["Int"]>;
  roomId: Scalars["ID"];
  sendAt?: Maybe<Scalars["String"]>;
  transferTo?: Maybe<MailingTransferEnum>;
};

export enum MailingTransferEnum {
  NonAccepted = "NON_ACCEPTED",
  NonResponded = "NON_RESPONDED",
}

export type MakeAppsInput = {
  appId: Scalars["ID"];
  installationId?: InputMaybe<Scalars["ID"]>;
  localId?: InputMaybe<Scalars["String"]>;
  method?: InputMaybe<MethodType>;
  settings?: InputMaybe<Scalars["String"]>;
  versionId: Scalars["ID"];
};

export type MakeBotInput = {
  botType: BotType;
  id?: InputMaybe<Scalars["String"]>;
  isActive?: InputMaybe<Scalars["Boolean"]>;
  methodType: MethodType;
  name?: InputMaybe<Scalars["String"]>;
  publishedAt?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<BotStatus>;
  teamsIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  templateId?: InputMaybe<Scalars["String"]>;
  userSettingsRaw?: InputMaybe<Scalars["String"]>;
};

export type MakeCalendarEventInput = {
  description?: InputMaybe<Scalars["String"]>;
  ends?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  inventoryId?: InputMaybe<Scalars["String"]>;
  isBot?: InputMaybe<Scalars["Boolean"]>;
  method: CustomFieldMethodType;
  operatorId?: InputMaybe<Scalars["String"]>;
  roomId?: InputMaybe<Scalars["String"]>;
  starts?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["String"]>;
};

export type MakeChannel2Input = {
  apiKey?: InputMaybe<Scalars["String"]>;
  botId?: InputMaybe<Scalars["String"]>;
  channelType?: InputMaybe<ChannelType>;
  id?: InputMaybe<Scalars["String"]>;
  methodType: MethodType;
  name?: InputMaybe<Scalars["String"]>;
  publicId?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<ChannelStatus>;
};

export type MakeCustomFieldInput = {
  dataType?: InputMaybe<CustomFieldDataType>;
  description?: InputMaybe<Scalars["String"]>;
  fieldName?: InputMaybe<Scalars["String"]>;
  fieldOrder?: InputMaybe<Scalars["Int"]>;
  id?: InputMaybe<Scalars["String"]>;
  methodType: CustomFieldMethodType;
};

export type MakeFlowInput = {
  botId?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  methodType: MethodType;
  name?: InputMaybe<Scalars["String"]>;
};

export type MakeInventoryInput = {
  additionalEquipments?: InputMaybe<Scalars["String"]>;
  carfaxLink?: InputMaybe<Scalars["String"]>;
  id: Scalars["ID"];
  imageLink?: InputMaybe<Scalars["String"]>;
  isSold?: InputMaybe<Scalars["Boolean"]>;
  status?: InputMaybe<MakeInventoryStatus>;
};

export enum MakeInventoryStatus {
  AvailableManually = "AVAILABLE_MANUALLY",
  SoldManually = "SOLD_MANUALLY",
}

export type MakeOrganizationInput = {
  address?: InputMaybe<Scalars["String"]>;
  contactCell?: InputMaybe<Scalars["String"]>;
  contactName?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  email?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  imageUrl?: InputMaybe<Scalars["String"]>;
  language?: InputMaybe<OrganizationLanguage>;
  managerName?: InputMaybe<Scalars["String"]>;
  managerPhone?: InputMaybe<Scalars["String"]>;
  method?: InputMaybe<MethodType>;
  name?: InputMaybe<Scalars["String"]>;
  onboardStatus?: InputMaybe<OnboardStatus>;
  phone?: InputMaybe<Scalars["String"]>;
  stateDealerNumber?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<OrganizationStatus>;
  tariff?: InputMaybe<OrganizationTariff>;
  tariffId?: InputMaybe<Scalars["String"]>;
  timezone?: InputMaybe<Scalars["String"]>;
  vautoDealerId?: InputMaybe<Scalars["String"]>;
  website?: InputMaybe<Scalars["String"]>;
};

export type MakeRooms2Input = {
  forTeamsIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  ids: Array<Scalars["String"]>;
  operatorId?: InputMaybe<Scalars["String"]>;
  status?: InputMaybe<RoomStatus>;
};

export type MakeRooms2Output = {
  __typename?: "MakeRooms2Output";
  error?: Maybe<Scalars["String"]>;
  rooms?: Maybe<Array<Maybe<RoomOutput2>>>;
};

export enum MakeTariffMethod {
  Activate = "ACTIVATE",
  Cancel = "CANCEL",
  Change = "CHANGE",
}

export type MakeUserInput = {
  customFields?: InputMaybe<Array<InputMaybe<UserCustomFieldsInput>>>;
  email?: InputMaybe<Scalars["String"]>;
  facebookMessengerPsid?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  instagramBsid?: InputMaybe<Scalars["String"]>;
  instagramProfile?: InputMaybe<Scalars["String"]>;
  isOnboard?: InputMaybe<Scalars["Boolean"]>;
  lastName?: InputMaybe<Scalars["String"]>;
  method: UsersMethodType;
  oid?: InputMaybe<Scalars["String"]>;
  password?: InputMaybe<Scalars["String"]>;
  phone?: InputMaybe<Scalars["String"]>;
  position?: InputMaybe<Scalars["String"]>;
  rid?: InputMaybe<Scalars["String"]>;
  roleId?: InputMaybe<Scalars["String"]>;
  sendgridUserEmail?: InputMaybe<Scalars["String"]>;
  teamsIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  telegramUsername?: InputMaybe<Scalars["String"]>;
  thirdParty?: InputMaybe<Scalars["String"]>;
  twilioSmsUserId?: InputMaybe<Scalars["String"]>;
  type: UserType;
  userpicUrl?: InputMaybe<Scalars["String"]>;
  vkUserId?: InputMaybe<Scalars["String"]>;
  whatsappProfile?: InputMaybe<Scalars["String"]>;
  whatsappUsername?: InputMaybe<Scalars["String"]>;
};

export type MessageContentImageDimension = {
  __typename?: "MessageContentImageDimension";
  height: Scalars["Int"];
  width: Scalars["Int"];
};

export type MessageContentItemOutput = {
  __typename?: "MessageContentItemOutput";
  category?: Maybe<Scalars["String"]>;
  dimensions?: Maybe<MessageContentImageDimension>;
  fileExtension?: Maybe<Scalars["String"]>;
  fileName?: Maybe<Scalars["String"]>;
  fileSize?: Maybe<Scalars["Int"]>;
  mimeType?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
};

export type MessageOutput = {
  __typename?: "MessageOutput";
  channelId?: Maybe<Scalars["String"]>;
  channelTypeName?: Maybe<ChannelType>;
  chatRoomId?: Maybe<Scalars["String"]>;
  chatRoomStatus?: Maybe<Scalars["String"]>;
  isFromBot: Scalars["Boolean"];
  isFromClient: Scalars["Boolean"];
  localMessageId?: Maybe<Scalars["String"]>;
  messageAuthorId?: Maybe<Scalars["String"]>;
  messageChannelId?: Maybe<Scalars["String"]>;
  messageContent?: Maybe<Scalars["String"]>;
  messageCreatedDateTime?: Maybe<Scalars["String"]>;
  messageDeletedDateTime?: Maybe<Scalars["String"]>;
  messageId?: Maybe<Scalars["String"]>;
  messageIsDelivered?: Maybe<Scalars["Boolean"]>;
  messageIsRead?: Maybe<Scalars["Boolean"]>;
  messageIsSent?: Maybe<Scalars["Boolean"]>;
  messageMetadata?: Maybe<Scalars["String"]>;
  messageText?: Maybe<Scalars["String"]>;
  messageUpdatedDateTime?: Maybe<Scalars["String"]>;
  textLangCode?: Maybe<LanguageCode_Iso_639_1>;
  translatedText?: Maybe<Scalars["String"]>;
  translatedTextLangCode?: Maybe<LanguageCode_Iso_639_1>;
};

export enum MessageStatusOutput {
  MessageIsDelivered = "MESSAGE_IS_DELIVERED",
  MessageIsRead = "MESSAGE_IS_READ",
  MessageIsSent = "MESSAGE_IS_SENT",
}

export enum MethodType {
  Create = "CREATE",
  Delete = "DELETE",
  Restore = "RESTORE",
  Update = "UPDATE",
}

export type Mutation = {
  __typename?: "Mutation";
  addSnippetToFavorites?: Maybe<ChatSnippetsFavoritesOutput>;
  changeTrialPeriod?: Maybe<Scalars["String"]>;
  createApiKey: ApiKey;
  createChatSnippet?: Maybe<ChatSnippetsOutput>;
  createChatSnippetsCategory?: Maybe<ChatSnippetsCategoriesOutput>;
  createCommentOnClient2?: Maybe<CommentOutput2>;
  createMessage?: Maybe<MessageOutput>;
  createTeam?: Maybe<TeamOutput>;
  createWABATemplate?: Maybe<WabaTemplateOutput>;
  deleteChatSnippet?: Maybe<ChatSnippetsOutput>;
  deleteChatSnippetsCategory?: Maybe<ChatSnippetsCategoriesOutput>;
  deleteComment?: Maybe<ResponseStatus>;
  deleteTeam?: Maybe<ResponseStatus>;
  deleteWABATemplate?: Maybe<ResponseStatus>;
  deployOrganization: DeployOrganizationOutput;
  duplicateBot?: Maybe<BotOutput>;
  makeApps?: Maybe<Array<Maybe<AppOutput>>>;
  makeBot?: Maybe<BotOutput>;
  makeCalendarEvent?: Maybe<CalendarEventOutput2>;
  makeChannel2?: Maybe<ChannelOutput2>;
  makeClientTodoTask?: Maybe<ClientTodoTasksOutput>;
  makeCustomField?: Maybe<CustomFieldOutput>;
  makeFlow?: Maybe<FlowOutput>;
  makeInventory?: Maybe<GetInventoryDetailsOutput>;
  makeMailingRecord?: Maybe<MailingRecordOutput>;
  makeOrganization?: Maybe<Organization>;
  makeRooms2?: Maybe<MakeRooms2Output>;
  makeTariff?: Maybe<ResponseStatus>;
  makeUser?: Maybe<UserOutput>;
  removeSnippetFromFavorite?: Maybe<ChatSnippetsFavoritesOutput>;
  renameApiKey: ApiKey;
  requestDealerExport?: Maybe<DealerExportRequest>;
  requestOrganizationErase?: Maybe<OrganizationEraseRequest>;
  revokeApiKey: ApiKeyId;
  setNodesAndEdges?: Maybe<SetNodesAndEdgesOutput>;
  setNotificationIsRead?: Maybe<NotificationOutput>;
  setOrganizationSettings?: Maybe<OrganizationSettings>;
  setPresenceStatus?: Maybe<UserPresenceStatusOutput>;
  switchOrganization?: Maybe<SwitchOrganizationOutput>;
  updateChatSnippet?: Maybe<ChatSnippetsOutput>;
  updateChatSnippetsCategory?: Maybe<ChatSnippetsCategoriesOutput>;
  updateMessageData?: Maybe<UpdateMessageDataOutput>;
  updateNotificationsSettings?: Maybe<NotificationSettingOutput>;
  updateTeam?: Maybe<TeamOutput>;
};

export type MutationAddSnippetToFavoritesArgs = {
  snippetId: Scalars["String"];
  userId: Scalars["String"];
};

export type MutationChangeTrialPeriodArgs = {
  organizationId: Scalars["String"];
  trialFinishAt: Scalars["String"];
};

export type MutationCreateChatSnippetArgs = {
  categoryId?: InputMaybe<Scalars["String"]>;
  snippet: Scalars["String"];
  teamsIds?: InputMaybe<Array<Scalars["String"]>>;
  userId: Scalars["String"];
};

export type MutationCreateChatSnippetsCategoryArgs = {
  categoryName: Scalars["String"];
  parentId?: InputMaybe<Scalars["String"]>;
  userId: Scalars["String"];
};

export type MutationCreateCommentOnClient2Args = {
  input?: InputMaybe<CreateCommentOnClientInput>;
};

export type MutationCreateMessageArgs = {
  input?: InputMaybe<CreateChatRoomMessageInput>;
};

export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};

export type MutationCreateWabaTemplateArgs = {
  input: WabaTemplateInput;
};

export type MutationDeleteChatSnippetArgs = {
  snippetId: Scalars["String"];
  userId: Scalars["String"];
};

export type MutationDeleteChatSnippetsCategoryArgs = {
  categoryId: Scalars["String"];
  userId: Scalars["String"];
};

export type MutationDeleteCommentArgs = {
  commentId: Scalars["String"];
};

export type MutationDeleteTeamArgs = {
  teamId: Scalars["String"];
};

export type MutationDeleteWabaTemplateArgs = {
  channelId: Scalars["String"];
  name: Scalars["String"];
};

export type MutationDeployOrganizationArgs = {
  dealershipType?: InputMaybe<DealershipType>;
  idToken?: InputMaybe<Scalars["String"]>;
  organizationAddress?: InputMaybe<Scalars["String"]>;
  organizationContactCell?: InputMaybe<Scalars["String"]>;
  organizationContactName?: InputMaybe<Scalars["String"]>;
  organizationCountry?: InputMaybe<Scalars["String"]>;
  organizationImageUrl?: InputMaybe<Scalars["String"]>;
  organizationLanguage?: InputMaybe<OrganizationLanguage>;
  organizationManagerName?: InputMaybe<Scalars["String"]>;
  organizationManagerPhone?: InputMaybe<Scalars["String"]>;
  organizationName?: InputMaybe<Scalars["String"]>;
  organizationPhone?: InputMaybe<Scalars["String"]>;
  organizationStateDealerNumber?: InputMaybe<Scalars["String"]>;
  organizationTariff?: InputMaybe<OrganizationTariff>;
  organizationTimezone?: InputMaybe<Scalars["String"]>;
  organizationWebsite?: InputMaybe<Scalars["String"]>;
  rootEmail?: InputMaybe<Scalars["String"]>;
  rootPassword?: InputMaybe<Scalars["String"]>;
  teamName?: InputMaybe<Scalars["String"]>;
};

export type MutationDuplicateBotArgs = {
  id: Scalars["String"];
  newName?: InputMaybe<Scalars["String"]>;
};

export type MutationMakeAppsArgs = {
  input?: InputMaybe<Array<InputMaybe<MakeAppsInput>>>;
};

export type MutationMakeBotArgs = {
  input?: InputMaybe<MakeBotInput>;
};

export type MutationMakeCalendarEventArgs = {
  input: MakeCalendarEventInput;
};

export type MutationMakeChannel2Args = {
  input: MakeChannel2Input;
};

export type MutationMakeClientTodoTaskArgs = {
  input: ClientTodoTasksInput;
};

export type MutationMakeCustomFieldArgs = {
  input?: InputMaybe<MakeCustomFieldInput>;
};

export type MutationMakeFlowArgs = {
  input?: InputMaybe<MakeFlowInput>;
};

export type MutationMakeInventoryArgs = {
  input: MakeInventoryInput;
};

export type MutationMakeMailingRecordArgs = {
  actionType?: InputMaybe<MailingActionType>;
  leadId?: InputMaybe<Scalars["Int"]>;
  roomId: Scalars["ID"];
  sendAt?: InputMaybe<Scalars["String"]>;
  type: CustomFieldMethodType;
};

export type MutationMakeOrganizationArgs = {
  input?: InputMaybe<MakeOrganizationInput>;
};

export type MutationMakeRooms2Args = {
  input?: InputMaybe<MakeRooms2Input>;
};

export type MutationMakeTariffArgs = {
  method: MakeTariffMethod;
  tariffId?: InputMaybe<Scalars["String"]>;
};

export type MutationMakeUserArgs = {
  input?: InputMaybe<MakeUserInput>;
};

export type MutationRemoveSnippetFromFavoriteArgs = {
  snippetId: Scalars["String"];
  userId: Scalars["String"];
};

export type MutationRenameApiKeyArgs = {
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type MutationRequestDealerExportArgs = {
  dateEnd?: InputMaybe<Scalars["String"]>;
  dateStart?: InputMaybe<Scalars["String"]>;
  kind: DealerExportKind;
  offsetMinutes?: InputMaybe<Scalars["Int"]>;
};

export type MutationRequestOrganizationEraseArgs = {
  confirmName: Scalars["String"];
  organizationId: Scalars["String"];
};

export type MutationRevokeApiKeyArgs = {
  id: Scalars["ID"];
};

export type MutationSetNodesAndEdgesArgs = {
  input?: InputMaybe<SetNodesAndEdgesInput>;
};

export type MutationSetNotificationIsReadArgs = {
  notificationId: Scalars["String"];
};

export type MutationSetOrganizationSettingsArgs = {
  input?: InputMaybe<OrganizationSettingsInput>;
};

export type MutationSetPresenceStatusArgs = {
  isManual?: InputMaybe<Scalars["Boolean"]>;
  presenceStatus: PresenceStatus;
  userId: Scalars["String"];
};

export type MutationSwitchOrganizationArgs = {
  toOID: Scalars["String"];
};

export type MutationUpdateChatSnippetArgs = {
  categoryId?: InputMaybe<Scalars["String"]>;
  snippet?: InputMaybe<Scalars["String"]>;
  snippetId: Scalars["String"];
  teamsIds?: InputMaybe<Array<Scalars["String"]>>;
  userId: Scalars["String"];
};

export type MutationUpdateChatSnippetsCategoryArgs = {
  categoryId: Scalars["String"];
  categoryName?: InputMaybe<Scalars["String"]>;
  parentId?: InputMaybe<Scalars["String"]>;
  userId: Scalars["String"];
};

export type MutationUpdateMessageDataArgs = {
  input?: InputMaybe<UpdateMessageDataInput>;
};

export type MutationUpdateNotificationsSettingsArgs = {
  enabled: Scalars["Boolean"];
  subtype: NotificationSubtype;
};

export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};

export type NodeInput = {
  appId?: InputMaybe<Scalars["ID"]>;
  appInstalledId?: InputMaybe<Scalars["ID"]>;
  appVersionId?: InputMaybe<Scalars["ID"]>;
  botId?: InputMaybe<Scalars["String"]>;
  buttons?: InputMaybe<Array<InputMaybe<ButtonInput>>>;
  childFlowId?: InputMaybe<Scalars["String"]>;
  coordinates?: InputMaybe<Array<InputMaybe<Scalars["Float"]>>>;
  exceptionText?: InputMaybe<Scalars["String"]>;
  fileUrl?: InputMaybe<Scalars["String"]>;
  flowId?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  imageUrl?: InputMaybe<Scalars["String"]>;
  isDelete?: InputMaybe<Scalars["Boolean"]>;
  localId?: InputMaybe<Scalars["String"]>;
  nodeType?: InputMaybe<NodeType>;
  saveTo?: InputMaybe<SaveTo>;
  teamsIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  text?: InputMaybe<Scalars["String"]>;
};

export type NodeOutput = {
  __typename?: "NodeOutput";
  app?: Maybe<AppOutput>;
  appId?: Maybe<Scalars["ID"]>;
  appInstalledId?: Maybe<Scalars["ID"]>;
  appVersionId?: Maybe<Scalars["ID"]>;
  botId?: Maybe<Scalars["String"]>;
  buttons?: Maybe<Array<Maybe<ButtonOutput>>>;
  childFlowId?: Maybe<Scalars["String"]>;
  coordinates?: Maybe<Array<Maybe<Scalars["Float"]>>>;
  errors?: Maybe<Array<Maybe<ValidateBot>>>;
  exceptionText?: Maybe<Scalars["String"]>;
  fileUrl?: Maybe<Scalars["String"]>;
  flowId?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  imageUrl?: Maybe<Scalars["String"]>;
  isDelete?: Maybe<Scalars["Boolean"]>;
  isSaveApp?: Maybe<Scalars["Boolean"]>;
  localId?: Maybe<Scalars["String"]>;
  nodeType?: Maybe<NodeType>;
  saveTo?: Maybe<SaveTo>;
  teamsIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  text?: Maybe<Scalars["String"]>;
};

export enum NodeType {
  AskNWait = "ASK_N_WAIT",
  GoToAnotherFlow = "GO_TO_ANOTHER_FLOW",
  Init = "INIT",
  Integration = "INTEGRATION",
  Message = "MESSAGE",
  TransferToTeams = "TRANSFER_TO_TEAMS",
}

export enum NonAcceptedTriggers {
  Exception = "EXCEPTION",
  MessageForManager = "MESSAGE_FOR_MANAGER",
  MessageLimit = "MESSAGE_LIMIT",
  VehicleStatusChanged = "VEHICLE_STATUS_CHANGED",
}

export type NotificationOutput = {
  __typename?: "NotificationOutput";
  body: Scalars["String"];
  createdAt: Scalars["String"];
  id: Scalars["String"];
  isRead?: Maybe<Scalars["Boolean"]>;
  metadata?: Maybe<Scalars["String"]>;
  subtype: NotificationSubtype;
  title: Scalars["String"];
};

export type NotificationSettingOutput = {
  __typename?: "NotificationSettingOutput";
  enabled: Scalars["Boolean"];
  subtype: NotificationSubtype;
};

export enum NotificationSubtype {
  CalendarEventCreated = "CALENDAR_EVENT_CREATED",
  CalendarEventReminded = "CALENDAR_EVENT_REMINDED",
  CalendarEventRemindedClient = "CALENDAR_EVENT_REMINDED_CLIENT",
  CalendarEventUpdated = "CALENDAR_EVENT_UPDATED",
  LeadMessage = "LEAD_MESSAGE",
  LeadMoved = "LEAD_MOVED",
  NewLead = "NEW_LEAD",
  TaskCreated = "TASK_CREATED",
  TaskReminded = "TASK_REMINDED",
}

export type NotificationsOutput = {
  __typename?: "NotificationsOutput";
  notifications?: Maybe<Array<Maybe<NotificationOutput>>>;
  pagingState?: Maybe<Scalars["String"]>;
  unreadCount?: Maybe<Scalars["Int"]>;
};

export enum OnboardStatus {
  AddPayment = "ADD_PAYMENT",
  ChooseTariff = "CHOOSE_TARIFF",
  Done = "DONE",
  SetPassword = "SET_PASSWORD",
  SignDocument = "SIGN_DOCUMENT",
  VerifyCode = "VERIFY_CODE",
}

export type OperatorsAnalyticsOutput = {
  __typename?: "OperatorsAnalyticsOutput";
  acceptedByOperatorsByPeriodMap: Array<Maybe<AnalyticsHeatMapSeriesItem>>;
  avgAccepted: Scalars["Float"];
  avgAcceptedToFirstMessage: Scalars["Float"];
  avgChatsPerOperatorPerDay: Scalars["Float"];
  operatorsMetricsTable: Array<Maybe<AnalyticsOperatorsMetricsTableRow>>;
};

export type Organization = {
  __typename?: "Organization";
  activeMembersCount?: Maybe<Scalars["Int"]>;
  address?: Maybe<Scalars["String"]>;
  contactCell?: Maybe<Scalars["String"]>;
  contactName?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["String"]>;
  daysUntilStale?: Maybe<Scalars["Int"]>;
  dealershipType?: Maybe<DealershipType>;
  deletedAt?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  imageUrl?: Maybe<Scalars["String"]>;
  invoices?: Maybe<OrganizationInvoices>;
  isCanceled?: Maybe<Scalars["Boolean"]>;
  isCurrent: Scalars["Boolean"];
  isPaymentFailed?: Maybe<Scalars["Boolean"]>;
  isPendingDeletion?: Maybe<Scalars["Boolean"]>;
  isStale?: Maybe<Scalars["Boolean"]>;
  isTrial?: Maybe<Scalars["Boolean"]>;
  language?: Maybe<OrganizationLanguage>;
  managerName?: Maybe<Scalars["String"]>;
  managerPhone?: Maybe<Scalars["String"]>;
  membersCount?: Maybe<Scalars["Int"]>;
  name: Scalars["String"];
  newTariffId?: Maybe<Scalars["String"]>;
  onboardStatus?: Maybe<OnboardStatus>;
  parentOID?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  rid: Scalars["String"];
  stateDealerNumber?: Maybe<Scalars["String"]>;
  status: OrganizationStatus;
  tariff?: Maybe<OrganizationTariff>;
  tariffId?: Maybe<Scalars["String"]>;
  timezone?: Maybe<Scalars["String"]>;
  trialFinishAt?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["String"]>;
  vautoDealerId?: Maybe<Scalars["String"]>;
  website?: Maybe<Scalars["String"]>;
};

export type OrganizationEraseRequest = {
  __typename?: "OrganizationEraseRequest";
  status: Scalars["String"];
};

export type OrganizationInvoices = {
  __typename?: "OrganizationInvoices";
  current?: Maybe<Invoice>;
  last?: Maybe<Invoice>;
  total?: Maybe<Invoice>;
};

export enum OrganizationLanguage {
  En = "en",
  Ru = "ru",
}

export type OrganizationSettings = {
  __typename?: "OrganizationSettings";
  canOperatorAssignAppointments?: Maybe<Scalars["Boolean"]>;
};

export type OrganizationSettingsInput = {
  canOperatorAssignAppointments?: InputMaybe<Scalars["Boolean"]>;
};

export enum OrganizationStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Inactive = "INACTIVE",
}

export enum OrganizationTariff {
  Business = "business",
  Enterprise = "enterprise",
  Free = "free",
  Individual = "individual",
  Premium = "premium",
  Standard = "standard",
  Standard1 = "standard1",
  Standard2 = "standard2",
  Trial = "trial",
  Unlimited = "unlimited",
}

export type OrganizationsCountByStatus = {
  __typename?: "OrganizationsCountByStatus";
  ACTIVE?: Maybe<Scalars["Int"]>;
  ARCHIVED?: Maybe<Scalars["Int"]>;
  DRAFT?: Maybe<Scalars["Int"]>;
  INACTIVE?: Maybe<Scalars["Int"]>;
};

export type OrganizationsOutput = {
  __typename?: "OrganizationsOutput";
  current?: Maybe<Organization>;
  parent?: Maybe<Organization>;
  subsidiaries: Array<Maybe<Organization>>;
  totalCountsByStatus?: Maybe<OrganizationsCountByStatus>;
};

export type PaginationInput = {
  itemsPerPage: Scalars["Int"];
  pageNumber: Scalars["Int"];
};

export type PaginationOutput = {
  __typename?: "PaginationOutput";
  itemsPerPage?: Maybe<Scalars["Int"]>;
  pageNumber?: Maybe<Scalars["Int"]>;
  totalItems?: Maybe<Scalars["Int"]>;
};

export type PaginationViaCursorInput = {
  limit: Scalars["Int"];
  nextCursor?: InputMaybe<Scalars["String"]>;
};

export type PaginationViaCursorOutput = {
  __typename?: "PaginationViaCursorOutput";
  nextCursor?: Maybe<Scalars["String"]>;
  totalItems: Scalars["Int"];
};

export type PeriodInput = {
  dateEnd: Scalars["String"];
  dateStart: Scalars["String"];
};

export enum PresenceStatus {
  Away = "AWAY",
  Offline = "OFFLINE",
  Online = "ONLINE",
}

export type Product = {
  __typename?: "Product";
  description?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  price?: Maybe<Scalars["Int"]>;
};

export type Query = {
  __typename?: "Query";
  checkCode?: Maybe<CheckCodeStatus>;
  checkEmailAvailability: EmailAvailability;
  evaluateFeatureFlags: Array<FeatureFlagEvaluation>;
  foundMessages?: Maybe<Array<MessageOutput>>;
  getAiBotTemplatesWithFields?: Maybe<
    Array<Maybe<AiBotTemplateWithFieldsOutput>>
  >;
  getAiBotUserSettings?: Maybe<AiBotUserSettingsOutput>;
  getApps?: Maybe<Array<Maybe<AppOutput>>>;
  getAvailableTwilioPhoneNumbers?: Maybe<Array<Maybe<Scalars["String"]>>>;
  getBot?: Maybe<BotOutput>;
  getBots?: Maybe<Array<Maybe<BotOutput>>>;
  getCalendarEvents2?: Maybe<GetCalendarEventsOutput>;
  getCard?: Maybe<Card>;
  getChannels2: Array<Maybe<ChannelOutput2>>;
  getChatRoomHistory?: Maybe<RoomHistoryOutput>;
  getChatRoomMessages?: Maybe<GetChatRoomMessagesOutput>;
  getChatSnippets?: Maybe<GetChatSnippets>;
  getChatSnippetsCategories?: Maybe<GetChatSnippetsCategories>;
  getChatSnippetsFavorites?: Maybe<GetChatSnippets>;
  getChatsAnalytics?: Maybe<ChatsAnalyticsOutput>;
  getClientTodoTasks?: Maybe<Array<Maybe<ClientTodoTasksOutput>>>;
  getCommentsOnClient2?: Maybe<GetCommentsOnClientOutput2>;
  getCustomFields?: Maybe<Array<Maybe<CustomFieldOutput>>>;
  getDownloads?: Maybe<Array<Maybe<FileItemOutput>>>;
  getEdges?: Maybe<Array<Maybe<EdgeOutput>>>;
  getFTPSyncStatus?: Maybe<FtpSyncStatusOutput>;
  getFlow?: Maybe<FlowOutput>;
  getFlows?: Maybe<Array<Maybe<FlowOutput>>>;
  getGeneralAnalytics?: Maybe<GeneralAnalyticsOutput>;
  getHiddenApiKeys: Array<Maybe<ApiKey>>;
  getInquiries?: Maybe<Array<Maybe<InquiryOutput>>>;
  getInventory?: Maybe<GetInventoryOutput>;
  getInventoryDetails?: Maybe<GetInventoryDetailsOutput>;
  getInvoices?: Maybe<InvoicesOutput>;
  getLinkToAddCard: Scalars["String"];
  getMailingRecord?: Maybe<MailingRecordOutput>;
  getNodes?: Maybe<Array<Maybe<NodeOutput>>>;
  getNotifications?: Maybe<NotificationsOutput>;
  getNotificationsSettings?: Maybe<Array<Maybe<NotificationSettingOutput>>>;
  getOperatorsAnalytics?: Maybe<OperatorsAnalyticsOutput>;
  getOrganizationSettings?: Maybe<OrganizationSettings>;
  getOrganizations?: Maybe<OrganizationsOutput>;
  getRoles?: Maybe<Array<Maybe<RoleOutput>>>;
  getRoom2?: Maybe<GetRoom2Output>;
  getRoomHistory?: Maybe<Array<Maybe<GetRoomHistoryOutput>>>;
  getRooms2?: Maybe<GetRooms2Output>;
  getRoomsForMobile?: Maybe<GetRooms2Output>;
  getSignedDocument?: Maybe<SignedDocumentOutput>;
  getSigningDocument?: Maybe<SigningDocumentOutput>;
  getTariffs?: Maybe<Array<Maybe<TariffOutput>>>;
  getTariffsByOID?: Maybe<Array<Maybe<TariffOutput>>>;
  getTeams?: Maybe<Array<Maybe<TeamOutput>>>;
  getTimezones: Array<Timezone>;
  getTranslation: TranslationOutput;
  getTrialFinishDate?: Maybe<Scalars["String"]>;
  getUser?: Maybe<UserOutput>;
  getUsers?: Maybe<GetUsersOutput>;
  getUsersPresenceStatuses?: Maybe<Array<Maybe<UserPresenceStatusOutput>>>;
  getWABATemplates?: Maybe<Array<Maybe<WabaTemplateOutput>>>;
  requestRoomsHistoryAsFile?: Maybe<FileItemOutput>;
  revealApiKey: ApiKeyShort;
  sendCode?: Maybe<ResponseStatus>;
  validateBot?: Maybe<Array<Maybe<ValidateBot>>>;
};

export type QueryCheckCodeArgs = {
  code: Scalars["String"];
  recipient: Scalars["String"];
};

export type QueryCheckEmailAvailabilityArgs = {
  email: Scalars["String"];
};

export type QueryEvaluateFeatureFlagsArgs = {
  flagIds: Array<Scalars["String"]>;
  traits?: InputMaybe<Array<FeatureFlagTraitInput>>;
};

export type QueryGetAiBotTemplatesWithFieldsArgs = {
  templateId?: InputMaybe<Scalars["ID"]>;
};

export type QueryGetAiBotUserSettingsArgs = {
  botId: Scalars["ID"];
};

export type QueryGetAppsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]>>>;
  isAvailableOnly?: InputMaybe<Scalars["Boolean"]>;
  isInstalledOnly?: InputMaybe<Scalars["Boolean"]>;
  types?: InputMaybe<Array<InputMaybe<AppType>>>;
};

export type QueryGetAvailableTwilioPhoneNumbersArgs = {
  areaCode: Scalars["Int"];
  limit?: InputMaybe<Scalars["Int"]>;
};

export type QueryGetBotArgs = {
  id: Scalars["String"];
};

export type QueryGetBotsArgs = {
  status: BotStatus;
};

export type QueryGetCalendarEvents2Args = {
  endsBefore?: InputMaybe<Scalars["String"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  startsAfter?: InputMaybe<Scalars["String"]>;
};

export type QueryGetChannels2Args = {
  isActiveOnly?: Scalars["Boolean"];
};

export type QueryGetChatRoomHistoryArgs = {
  roomId: Scalars["String"];
};

export type QueryGetChatRoomMessagesArgs = {
  chatRoomId: Scalars["String"];
  fetchSize: Scalars["Int"];
  pagingState?: InputMaybe<Scalars["String"]>;
};

export type QueryGetChatSnippetsArgs = {
  categoryId?: InputMaybe<Scalars["String"]>;
  snippetId?: InputMaybe<Scalars["String"]>;
  userId: Scalars["String"];
};

export type QueryGetChatSnippetsCategoriesArgs = {
  categoryId?: InputMaybe<Scalars["String"]>;
  parentId?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["String"]>;
};

export type QueryGetChatSnippetsFavoritesArgs = {
  userId: Scalars["String"];
};

export type QueryGetChatsAnalyticsArgs = {
  input: GetChatsAnalyticsInput;
};

export type QueryGetClientTodoTasksArgs = {
  clientId: Scalars["String"];
};

export type QueryGetCommentsOnClient2Args = {
  clientId: Scalars["String"];
};

export type QueryGetDownloadsArgs = {
  userId: Scalars["String"];
};

export type QueryGetEdgesArgs = {
  input?: InputMaybe<GetNodesAndEdgesInput>;
};

export type QueryGetFtpSyncStatusArgs = {
  organizationId?: InputMaybe<Scalars["String"]>;
};

export type QueryGetFlowArgs = {
  input?: InputMaybe<GetFlowInput>;
};

export type QueryGetFlowsArgs = {
  botId: Scalars["String"];
};

export type QueryGetGeneralAnalyticsArgs = {
  input: GetGeneralAnalyticsInput;
};

export type QueryGetInquiriesArgs = {
  clientId: Scalars["String"];
};

export type QueryGetInventoryArgs = {
  input?: InputMaybe<GetInventoryInput>;
};

export type QueryGetInventoryDetailsArgs = {
  id: Scalars["ID"];
};

export type QueryGetInvoicesArgs = {
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  organizationId?: InputMaybe<Scalars["String"]>;
  pageNumber?: InputMaybe<Scalars["Int"]>;
  sortBy?: InputMaybe<InvoiceSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QueryGetLinkToAddCardArgs = {
  successUrl: Scalars["String"];
};

export type QueryGetMailingRecordArgs = {
  roomId: Scalars["String"];
};

export type QueryGetNodesArgs = {
  input?: InputMaybe<GetNodesAndEdgesInput>;
};

export type QueryGetNotificationsArgs = {
  fetchSize: Scalars["Int"];
  onlyAppointments?: InputMaybe<Scalars["Boolean"]>;
  onlyTasks?: InputMaybe<Scalars["Boolean"]>;
  pagingState?: InputMaybe<Scalars["String"]>;
};

export type QueryGetOperatorsAnalyticsArgs = {
  input?: InputMaybe<GetOperatorsAnalyticsInput>;
};

export type QueryGetOrganizationsArgs = {
  isDeleted?: InputMaybe<Scalars["Boolean"]>;
  isWithInvoices?: InputMaybe<Scalars["Boolean"]>;
  search?: InputMaybe<Scalars["String"]>;
  statuses?: InputMaybe<Array<InputMaybe<OrganizationStatus>>>;
};

export type QueryGetRoom2Args = {
  input: GetRoomInput;
};

export type QueryGetRoomHistoryArgs = {
  roomId: Scalars["String"];
};

export type QueryGetRooms2Args = {
  input: GetRoomsInput;
};

export type QueryGetRoomsForMobileArgs = {
  filter?: InputMaybe<Scalars["String"]>;
  pagination?: InputMaybe<PaginationViaCursorInput>;
  status: RoomStatus;
};

export type QueryGetSignedDocumentArgs = {
  input: SignedDocumentInput;
};

export type QueryGetTranslationArgs = {
  textToTranslation: Scalars["String"];
  translateToCode?: InputMaybe<LanguageCode_Iso_639_1>;
};

export type QueryGetUserArgs = {
  userId?: InputMaybe<Scalars["String"]>;
};

export type QueryGetUsersArgs = {
  input: GetUsersInput;
};

export type QueryGetUsersPresenceStatusesArgs = {
  presenceStatus?: InputMaybe<PresenceStatus>;
};

export type QueryGetWabaTemplatesArgs = {
  channelId: Scalars["String"];
};

export type QueryRequestRoomsHistoryAsFileArgs = {
  dateEnd?: InputMaybe<Scalars["String"]>;
  dateStart?: InputMaybe<Scalars["String"]>;
  operatorId?: InputMaybe<Scalars["String"]>;
  reportType: ReportType;
  roomId?: InputMaybe<Scalars["String"]>;
  userId: Scalars["String"];
};

export type QueryRevealApiKeyArgs = {
  id: Scalars["ID"];
};

export type QuerySendCodeArgs = {
  channel: VerifyCodeStatus;
  recipient: Scalars["String"];
};

export type QueryValidateBotArgs = {
  id: Scalars["String"];
};

export enum ReportType {
  RoomHistory = "ROOM_HISTORY",
  RoomHistoryByOperator = "ROOM_HISTORY_BY_OPERATOR",
}

export type ResponseStatus = {
  __typename?: "ResponseStatus";
  status?: Maybe<Scalars["String"]>;
};

export type RoleOutput = {
  __typename?: "RoleOutput";
  roleDescription?: Maybe<Scalars["String"]>;
  roleId?: Maybe<Scalars["String"]>;
  rolePublicName?: Maybe<Scalars["String"]>;
  roleTechnicalName?: Maybe<Scalars["String"]>;
};

export enum RoomEventActionName {
  CreatedInvisible = "CREATED_INVISIBLE",
  CreatedNonAccepted = "CREATED_NON_ACCEPTED",
  FromAcceptedToAccepted = "FROM_ACCEPTED_TO_ACCEPTED",
  FromAcceptedToCompleted = "FROM_ACCEPTED_TO_COMPLETED",
  FromAcceptedToCompletedChannelDeletion = "FROM_ACCEPTED_TO_COMPLETED_CHANNEL_DELETION",
  FromAcceptedToCompletedTimeout = "FROM_ACCEPTED_TO_COMPLETED_TIMEOUT",
  FromAcceptedToInvisible = "FROM_ACCEPTED_TO_INVISIBLE",
  FromAcceptedToNonAccepted = "FROM_ACCEPTED_TO_NON_ACCEPTED",
  FromCompletedToAccepted = "FROM_COMPLETED_TO_ACCEPTED",
  FromCompletedToInvisible = "FROM_COMPLETED_TO_INVISIBLE",
  FromCompletedToNonAccepted = "FROM_COMPLETED_TO_NON_ACCEPTED",
  FromInvisibleToAccepted = "FROM_INVISIBLE_TO_ACCEPTED",
  FromInvisibleToCompleted = "FROM_INVISIBLE_TO_COMPLETED",
  FromInvisibleToCompletedBotDeletion = "FROM_INVISIBLE_TO_COMPLETED_BOT_DELETION",
  FromInvisibleToCompletedChannelDeletion = "FROM_INVISIBLE_TO_COMPLETED_CHANNEL_DELETION",
  FromInvisibleToCompletedTimeout = "FROM_INVISIBLE_TO_COMPLETED_TIMEOUT",
  FromInvisibleToCompletedVehicleStatusChanged = "FROM_INVISIBLE_TO_COMPLETED_VEHICLE_STATUS_CHANGED",
  FromInvisibleToNonAccepted = "FROM_INVISIBLE_TO_NON_ACCEPTED",
  FromInvisibleToNonAcceptedException = "FROM_INVISIBLE_TO_NON_ACCEPTED_EXCEPTION",
  FromInvisibleToNonAcceptedVehicleStatusChanged = "FROM_INVISIBLE_TO_NON_ACCEPTED_VEHICLE_STATUS_CHANGED",
  FromInvisibleToNonResponded = "FROM_INVISIBLE_TO_NON_RESPONDED",
  FromNonAcceptedToAccepted = "FROM_NON_ACCEPTED_TO_ACCEPTED",
  FromNonAcceptedToCompletedChannelDeletion = "FROM_NON_ACCEPTED_TO_COMPLETED_CHANNEL_DELETION",
  FromNonAcceptedToCompletedVehicleStatusChanged = "FROM_NON_ACCEPTED_TO_COMPLETED_VEHICLE_STATUS_CHANGED",
  FromNonAcceptedToInvisible = "FROM_NON_ACCEPTED_TO_INVISIBLE",
  FromNonAcceptedToNonAccepted = "FROM_NON_ACCEPTED_TO_NON_ACCEPTED",
  FromNonRespondedToAccepted = "FROM_NON_RESPONDED_TO_ACCEPTED",
  FromNonRespondedToInvisible = "FROM_NON_RESPONDED_TO_INVISIBLE",
  FromNonRespondedToNonAccepted = "FROM_NON_RESPONDED_TO_NON_ACCEPTED",
  Unknown = "UNKNOWN",
}

export type RoomEventOutput = {
  __typename?: "RoomEventOutput";
  actionName: RoomEventActionName;
  eventCreatedAt: Scalars["String"];
  eventInitiator: Scalars["String"];
  fromTeams?: Maybe<Array<Maybe<Scalars["String"]>>>;
  fromUser?: Maybe<Scalars["String"]>;
  initiatorType: InitiatorType;
  isFilled?: Maybe<Scalars["Boolean"]>;
  text?: Maybe<Scalars["String"]>;
  toTeams?: Maybe<Array<Maybe<Scalars["String"]>>>;
  toUser?: Maybe<Scalars["String"]>;
};

export type RoomHistoryOutput = {
  __typename?: "RoomHistoryOutput";
  chatRoomHistory: Array<Maybe<RoomEventOutput>>;
};

export type RoomLinkOutput = {
  __typename?: "RoomLinkOutput";
  channelType?: Maybe<ChannelType>;
  lastTicketAt?: Maybe<Scalars["String"]>;
  roomId?: Maybe<Scalars["String"]>;
  roomStatus?: Maybe<RoomStatus>;
  vehicle?: Maybe<Scalars["String"]>;
};

export type RoomOutput2 = {
  __typename?: "RoomOutput2";
  activeOperator?: Maybe<UserOutput>;
  channel: ChannelOutput2;
  client: UserOutput;
  createdAt?: Maybe<Scalars["String"]>;
  currentLangCode?: Maybe<LanguageCode_Iso_639_1>;
  id: Scalars["ID"];
  isExpired: Scalars["Boolean"];
  langCode?: Maybe<LanguageCode_Iso_639_1>;
  lastClientMessageAt?: Maybe<Scalars["String"]>;
  lastMessageAt?: Maybe<Scalars["String"]>;
  lastMessageContent?: Maybe<LastMessageContentOutput>;
  lastTicketAt?: Maybe<Scalars["String"]>;
  leadId: Scalars["Int"];
  linkedRooms: Array<LinkedRoomOutput>;
  nonAcceptedTrigger?: Maybe<NonAcceptedTriggers>;
  operators: Array<Maybe<UserOutput>>;
  previousStatus?: Maybe<RoomStatus>;
  previousTeamsIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
  status: RoomStatus;
  teamsIds: Array<Maybe<Scalars["String"]>>;
  unreadMessagesNumber: Scalars["Int"];
  vehicle?: Maybe<Scalars["String"]>;
};

export enum RoomStatus {
  Accepted = "ACCEPTED",
  Completed = "COMPLETED",
  Invisible = "INVISIBLE",
  NonAccepted = "NON_ACCEPTED",
  NonResponded = "NON_RESPONDED",
}

export enum SaveTo {
  Comments = "COMMENTS",
  Email = "EMAIL",
  FirstName = "FIRST_NAME",
  LastName = "LAST_NAME",
  Phone = "PHONE",
}

export type SeriesByChannelType = {
  __typename?: "SeriesByChannelType";
  EMAIL?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  SMS?: Maybe<Array<Maybe<Scalars["Int"]>>>;
};

export type SetNodesAndEdgesInput = {
  edges?: InputMaybe<Array<InputMaybe<EdgeInput>>>;
  nodes?: InputMaybe<Array<InputMaybe<NodeInput>>>;
};

export type SetNodesAndEdgesOutput = {
  __typename?: "SetNodesAndEdgesOutput";
  edges?: Maybe<Array<Maybe<EdgeOutput>>>;
  nodes?: Maybe<Array<Maybe<NodeOutput>>>;
};

export type SignedDocumentInput = {
  oid: Scalars["String"];
};

export type SignedDocumentOutput = {
  __typename?: "SignedDocumentOutput";
  link: Scalars["String"];
};

export type SigningDocumentOutput = {
  __typename?: "SigningDocumentOutput";
  signDocumentUrl: Scalars["String"];
};

export enum SortBy {
  CreatedAt = "CREATED_AT",
  LastTicketAt = "LAST_TICKET_AT",
  Name = "NAME",
}

export enum SortOrder {
  Asc = "ASC",
  Desc = "DESC",
}

export type Status = {
  __typename?: "Status";
  status?: Maybe<Scalars["Int"]>;
};

export type Subscription = {
  __typename?: "Subscription";
  onFeatureFlagsChanged: Array<FeatureFlagEvaluation>;
  watchBots?: Maybe<WatchBotsOutput>;
  watchCalendarEvents2?: Maybe<BaseCalendarEventOutput2>;
  watchChannels?: Maybe<WatchChannelOutput>;
  watchClientInquiries?: Maybe<WatchClientInquiriesOutput>;
  watchComments?: Maybe<WatchCommentOutput>;
  watchCreateMessage?: Maybe<MessageOutput>;
  watchDeleteMessage?: Maybe<DeleteMessageOutput>;
  watchDownloads?: Maybe<FileItemOutput>;
  watchMailing?: Maybe<WatchMailingOutput>;
  watchNotifications?: Maybe<NotificationOutput>;
  watchOnboardStatus?: Maybe<WatchOnboardStatusOutput>;
  watchOrganizationStatus?: Maybe<OrganizationStatus>;
  watchPushNotifications?: Maybe<NotificationOutput>;
  watchRooms2?: Maybe<MakeRooms2Output>;
  watchUpdateMessageData?: Maybe<UpdateMessageDataOutput>;
  watchUsers?: Maybe<WatchUsersOutput>;
};

export type SubscriptionOnFeatureFlagsChangedArgs = {
  flagIds: Array<Scalars["String"]>;
  traits?: InputMaybe<Array<FeatureFlagTraitInput>>;
};

export type SubscriptionWatchCalendarEvents2Args = {
  oid: Scalars["String"];
};

export type SubscriptionWatchClientInquiriesArgs = {
  oid: Scalars["String"];
};

export type SubscriptionWatchCreateMessageArgs = {
  channelType: ChannelType;
};

export type SubscriptionWatchDeleteMessageArgs = {
  channelType: ChannelType;
};

export type SubscriptionWatchDownloadsArgs = {
  userId: Scalars["String"];
};

export type SubscriptionWatchNotificationsArgs = {
  userId: Scalars["String"];
};

export type SubscriptionWatchOnboardStatusArgs = {
  oid: Scalars["String"];
};

export type SubscriptionWatchOrganizationStatusArgs = {
  oid: Scalars["String"];
};

export type SubscriptionWatchPushNotificationsArgs = {
  userId: Scalars["String"];
};

export type SubscriptionWatchRooms2Args = {
  teamId: Scalars["String"];
  userId: Scalars["String"];
};

export type SubscriptionWatchUpdateMessageDataArgs = {
  channelType: ChannelType;
};

export enum Success {
  Ok = "ok",
}

export type SwitchOrganizationOutput = {
  __typename?: "SwitchOrganizationOutput";
  newOID: Scalars["String"];
  userId: Scalars["ID"];
};

export type TariffOutput = {
  __typename?: "TariffOutput";
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  products?: Maybe<Array<Maybe<Product>>>;
};

export type TeamOutput = {
  __typename?: "TeamOutput";
  createdAt: Scalars["String"];
  deletedAt?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  name: Scalars["String"];
  updatedAt: Scalars["String"];
  users?: Maybe<Array<Maybe<UserOutput>>>;
};

export type Timezone = {
  __typename?: "Timezone";
  countryAlpha2Code: Scalars["String"];
  name: Scalars["String"];
};

export enum TodoTaskAction {
  TaskCreated = "taskCreated",
  TaskReminded = "taskReminded",
}

export type TranslationOutput = {
  __typename?: "TranslationOutput";
  fromCode: LanguageCode_Iso_639_1;
  isTranslated: Scalars["Boolean"];
  toCode: LanguageCode_Iso_639_1;
  translatedText: Scalars["String"];
};

export type UpdateMessageDataInput = {
  chatRoomId: Scalars["String"];
  isClient: Scalars["Boolean"];
  messageStatus: MessageStatusOutput;
  messagesIds: Array<Scalars["String"]>;
};

export type UpdateMessageDataOutput = {
  __typename?: "UpdateMessageDataOutput";
  channelId?: Maybe<Scalars["String"]>;
  channelTypeName?: Maybe<ChannelType>;
  chatRoomId?: Maybe<Scalars["String"]>;
  chatRoomMessages?: Maybe<Array<Maybe<MessageOutput>>>;
  chatRoomStatus?: Maybe<Scalars["String"]>;
  isClient?: Maybe<Scalars["Boolean"]>;
  unreadMessagesNumber?: Maybe<Scalars["Int"]>;
};

export type UpdateTeamInput = {
  id: Scalars["String"];
  name: Scalars["String"];
  usersIds?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
};

export type UserCustomFieldOutput = {
  __typename?: "UserCustomFieldOutput";
  dataType: CustomFieldDataType;
  description?: Maybe<Scalars["String"]>;
  fieldId: Scalars["ID"];
  fieldName: Scalars["String"];
  fieldOrder: Scalars["Int"];
  value: Scalars["String"];
};

export type UserCustomFieldsInput = {
  fieldId: Scalars["ID"];
  value: Scalars["String"];
};

export type UserOutput = {
  __typename?: "UserOutput";
  common?: Maybe<CommonUserFields>;
  customFields?: Maybe<Array<Maybe<UserCustomFieldOutput>>>;
  facebookMessengerPsid?: Maybe<Scalars["String"]>;
  id: Scalars["String"];
  instagramBsid?: Maybe<Scalars["String"]>;
  instagramProfile?: Maybe<Scalars["String"]>;
  isRoot?: Maybe<Scalars["Boolean"]>;
  lastTicketAt?: Maybe<Scalars["String"]>;
  mailgunUserEmail?: Maybe<Scalars["String"]>;
  nylasUserEmail?: Maybe<Scalars["String"]>;
  onlineStatus?: Maybe<UserPresenceStatusOutput>;
  optionalName: Scalars["String"];
  position?: Maybe<Scalars["String"]>;
  role?: Maybe<RoleOutput>;
  roleId?: Maybe<Scalars["String"]>;
  roomsLinks?: Maybe<Array<Maybe<RoomLinkOutput>>>;
  sendgridUserEmail?: Maybe<Scalars["String"]>;
  teams?: Maybe<Array<Maybe<TeamOutput>>>;
  telegramUserId?: Maybe<Scalars["String"]>;
  telegramUsername?: Maybe<Scalars["String"]>;
  thirdParty?: Maybe<Scalars["String"]>;
  twilioSmsUserId?: Maybe<Scalars["String"]>;
  vkUserId?: Maybe<Scalars["String"]>;
  whatsappProfile?: Maybe<Scalars["String"]>;
  whatsappUsername?: Maybe<Scalars["String"]>;
};

export type UserPresenceStatusOutput = {
  __typename?: "UserPresenceStatusOutput";
  presenceStatus?: Maybe<PresenceStatus>;
  userId?: Maybe<Scalars["String"]>;
};

export enum UserType {
  Client = "CLIENT",
  Internal = "INTERNAL",
}

export enum UsersMethodType {
  Create = "CREATE",
  Delete = "DELETE",
  Restore = "RESTORE",
  SendMagicLinkAgain = "SEND_MAGIC_LINK_AGAIN",
  Update = "UPDATE",
}

export type ValidateBot = {
  __typename?: "ValidateBot";
  errorMessage?: Maybe<Scalars["String"]>;
  flowId?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  isInCurrentFlow?: Maybe<Scalars["Boolean"]>;
  isInMain?: Maybe<Scalars["Boolean"]>;
  nodeType?: Maybe<NodeType>;
  statusCode?: Maybe<Scalars["Int"]>;
};

export enum VerifyCodeStatus {
  Call = "call",
  Email = "email",
  Sms = "sms",
  Whatsapp = "whatsapp",
}

export type WabaTemplateButton = {
  __typename?: "WABATemplateButton";
  example?: Maybe<Array<Maybe<Scalars["String"]>>>;
  phoneNumber?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
  type: WabaTemplateButtonType;
  url?: Maybe<Scalars["String"]>;
};

export type WabaTemplateButtonIn = {
  example?: InputMaybe<Array<InputMaybe<Scalars["String"]>>>;
  phoneNumber?: InputMaybe<Scalars["String"]>;
  text: Scalars["String"];
  type: WabaTemplateButtonType;
  url?: InputMaybe<Scalars["String"]>;
};

export enum WabaTemplateButtonType {
  CopyCode = "COPY_CODE",
  PhoneNumber = "PHONE_NUMBER",
  QuickReply = "QUICK_REPLY",
  Url = "URL",
}

export enum WabaTemplateCategory {
  Authentication = "AUTHENTICATION",
  Marketing = "MARKETING",
  Utility = "UTILITY",
}

export type WabaTemplateComponent = {
  __typename?: "WABATemplateComponent";
  buttons?: Maybe<Array<Maybe<WabaTemplateButton>>>;
  example?: Maybe<WabaTemplateComponentExampleComponent>;
  format?: Maybe<WabaTemplateComponentFormatType>;
  text?: Maybe<Scalars["String"]>;
  type: WabaTemplateComponentType;
};

export type WabaTemplateComponentExampleComponent = {
  __typename?: "WABATemplateComponentExampleComponent";
  bodyText?: Maybe<Array<Scalars["String"]>>;
  headerHandle?: Maybe<Array<Scalars["String"]>>;
  headerText?: Maybe<Array<Scalars["String"]>>;
};

export type WabaTemplateComponentExampleComponentIn = {
  bodyText?: InputMaybe<Array<Scalars["String"]>>;
  headerHandle?: InputMaybe<Array<Scalars["String"]>>;
  headerText?: InputMaybe<Array<Scalars["String"]>>;
};

export enum WabaTemplateComponentFormatType {
  Document = "DOCUMENT",
  Image = "IMAGE",
  Location = "LOCATION",
  Text = "TEXT",
  Video = "VIDEO",
}

export type WabaTemplateComponentIn = {
  buttons?: InputMaybe<Array<InputMaybe<WabaTemplateButtonIn>>>;
  example?: InputMaybe<WabaTemplateComponentExampleComponentIn>;
  format?: InputMaybe<WabaTemplateComponentFormatType>;
  text?: InputMaybe<Scalars["String"]>;
  type: WabaTemplateComponentType;
};

export enum WabaTemplateComponentType {
  Body = "BODY",
  Buttons = "BUTTONS",
  Footer = "FOOTER",
  Header = "HEADER",
}

export type WabaTemplateInput = {
  allowCategoryChange?: InputMaybe<Scalars["Boolean"]>;
  category: WabaTemplateCategory;
  channelId: Scalars["String"];
  components?: InputMaybe<Array<WabaTemplateComponentIn>>;
  language: WabaTemplateLanguage;
  name: Scalars["String"];
};

export enum WabaTemplateLanguage {
  Af = "af",
  Ar = "ar",
  Az = "az",
  Bg = "bg",
  Bn = "bn",
  Ca = "ca",
  Cs = "cs",
  Da = "da",
  De = "de",
  El = "el",
  En = "en",
  EnGb = "en_GB",
  EnUs = "en_US",
  Es = "es",
  EsAr = "es_AR",
  EsEs = "es_ES",
  EsMx = "es_MX",
  Et = "et",
  Fa = "fa",
  Fi = "fi",
  Fil = "fil",
  Fr = "fr",
  Ga = "ga",
  Gu = "gu",
  He = "he",
  Hi = "hi",
  Hr = "hr",
  Hu = "hu",
  Id = "id",
  It = "it",
  Ja = "ja",
  Kk = "kk",
  Kn = "kn",
  Ko = "ko",
  Lo = "lo",
  Lt = "lt",
  Lv = "lv",
  Mk = "mk",
  Mr = "mr",
  Ms = "ms",
  Nb = "nb",
  Nl = "nl",
  Pa = "pa",
  Pl = "pl",
  PtBr = "pt_BR",
  PtPt = "pt_PT",
  Ro = "ro",
  Ru = "ru",
  Sk = "sk",
  Sl = "sl",
  Sq = "sq",
  Sr = "sr",
  Sv = "sv",
  Sw = "sw",
  Ta = "ta",
  Te = "te",
  Th = "th",
  Tr = "tr",
  Uk = "uk",
  Ur = "ur",
  Uz = "uz",
  Vi = "vi",
  ZhCn = "zh_CN",
  ZhHk = "zh_HK",
  ZhTw = "zh_TW",
}

export type WabaTemplateOutput = {
  __typename?: "WABATemplateOutput";
  category: WabaTemplateCategory;
  components?: Maybe<Array<WabaTemplateComponent>>;
  language: WabaTemplateLanguage;
  name: Scalars["String"];
  namespace?: Maybe<Scalars["String"]>;
  rejected_reason?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
};

export type WatchBotsOutput = {
  __typename?: "WatchBotsOutput";
  bots?: Maybe<Array<Maybe<BotOutput>>>;
};

export type WatchChannelOutput = {
  __typename?: "WatchChannelOutput";
  channel?: Maybe<ChannelOutput2>;
  method?: Maybe<MethodType>;
};

export type WatchClientInquiriesOutput = {
  __typename?: "WatchClientInquiriesOutput";
  channelId?: Maybe<Scalars["String"]>;
  channelIdSource?: Maybe<Scalars["String"]>;
  clientId?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  leadSource?: Maybe<Scalars["String"]>;
  oid: Scalars["String"];
  vehicle?: Maybe<Scalars["String"]>;
};

export type WatchCommentOutput = {
  __typename?: "WatchCommentOutput";
  comment?: Maybe<CommentOutput2>;
  method?: Maybe<MethodType>;
};

export type WatchMailingOutput = {
  __typename?: "WatchMailingOutput";
  actionType?: Maybe<MailingActionType>;
  deletedAt?: Maybe<Scalars["String"]>;
  deleterName?: Maybe<Scalars["String"]>;
  leadId?: Maybe<Scalars["Int"]>;
  roomId: Scalars["ID"];
  sendAt?: Maybe<Scalars["String"]>;
  transferTo?: Maybe<MailingTransferEnum>;
  type: CustomFieldMethodType;
};

export type WatchOnboardStatusOutput = {
  __typename?: "WatchOnboardStatusOutput";
  oid: Scalars["String"];
  onboardStatus: OnboardStatus;
};

export type WatchUsersOutput = {
  __typename?: "WatchUsersOutput";
  method?: Maybe<MethodType>;
  user?: Maybe<UserOutput>;
};

export type ClientTodoTasksInput = {
  clientId?: InputMaybe<Scalars["String"]>;
  deadline?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
  isDone?: InputMaybe<Scalars["Boolean"]>;
  methodType?: InputMaybe<CustomFieldMethodType>;
  operatorId?: InputMaybe<Scalars["String"]>;
  text?: InputMaybe<Scalars["String"]>;
};

export type PriceHistoryFields = {
  __typename?: "priceHistoryFields";
  centsPrice?: Maybe<Scalars["Int"]>;
  createdAt?: Maybe<Scalars["String"]>;
  price?: Maybe<Scalars["Float"]>;
};

export type CoreRoleFieldsFragment = {
  __typename?: "RoleOutput";
  roleDescription?: string | null;
  roleId?: string | null;
  rolePublicName?: string | null;
  roleTechnicalName?: string | null;
};

export type CoreTeamFieldsFragment = {
  __typename?: "TeamOutput";
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
};

export type CoreRoomLinkFieldsFragment = {
  __typename?: "RoomLinkOutput";
  roomId?: string | null;
  roomStatus?: RoomStatus | null;
  channelType?: ChannelType | null;
  lastTicketAt?: string | null;
  vehicle?: string | null;
};

export type CoreUserFieldsFragment = {
  __typename?: "UserOutput";
  id: string;
  roleId?: string | null;
  isRoot?: boolean | null;
  optionalName: string;
  common?: {
    __typename?: "CommonUserFields";
    createdAt?: string | null;
    autoNickname?: string | null;
    userpicUrl?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
  } | null;
};

export type CoreUserCustomFieldFieldsFragment = {
  __typename?: "UserCustomFieldOutput";
  fieldId: string;
  fieldName: string;
  dataType: CustomFieldDataType;
  description?: string | null;
  fieldOrder: number;
  value: string;
};

export type ClientFieldsFragment = {
  __typename?: "UserOutput";
  whatsappUsername?: string | null;
  whatsappProfile?: string | null;
  telegramUsername?: string | null;
  telegramUserId?: string | null;
  facebookMessengerPsid?: string | null;
  vkUserId?: string | null;
  instagramBsid?: string | null;
  instagramProfile?: string | null;
  thirdParty?: string | null;
  twilioSmsUserId?: string | null;
  nylasUserEmail?: string | null;
  mailgunUserEmail?: string | null;
  sendgridUserEmail?: string | null;
  lastTicketAt?: string | null;
  roomsLinks?: Array<{
    __typename?: "RoomLinkOutput";
    roomId?: string | null;
    roomStatus?: RoomStatus | null;
    channelType?: ChannelType | null;
    lastTicketAt?: string | null;
    vehicle?: string | null;
  } | null> | null;
  customFields?: Array<{
    __typename?: "UserCustomFieldOutput";
    fieldId: string;
    fieldName: string;
    dataType: CustomFieldDataType;
    description?: string | null;
    fieldOrder: number;
    value: string;
  } | null> | null;
};

export type InternalUserFieldsFragment = {
  __typename?: "UserOutput";
  thirdParty?: string | null;
  position?: string | null;
  isRoot?: boolean | null;
  onlineStatus?: {
    __typename?: "UserPresenceStatusOutput";
    userId?: string | null;
    presenceStatus?: PresenceStatus | null;
  } | null;
  teams?: Array<{
    __typename?: "TeamOutput";
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
  } | null> | null;
  role?: {
    __typename?: "RoleOutput";
    roleDescription?: string | null;
    roleId?: string | null;
    rolePublicName?: string | null;
    roleTechnicalName?: string | null;
  } | null;
};

export type CoreCommentsFieldsFragment = {
  __typename?: "CommentOutput2";
  comment?: string | null;
  commentId?: string | null;
  createdAt?: string | null;
  clientId?: string | null;
  operator?: {
    __typename?: "UserOutput";
    id: string;
    roleId?: string | null;
    isRoot?: boolean | null;
    optionalName: string;
    common?: {
      __typename?: "CommonUserFields";
      createdAt?: string | null;
      autoNickname?: string | null;
      userpicUrl?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
    } | null;
  } | null;
};

export type ExtendedTeamFieldsFragment = {
  __typename?: "TeamOutput";
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  users?: Array<{
    __typename?: "UserOutput";
    id: string;
    roleId?: string | null;
    isRoot?: boolean | null;
    optionalName: string;
    thirdParty?: string | null;
    position?: string | null;
    common?: {
      __typename?: "CommonUserFields";
      createdAt?: string | null;
      autoNickname?: string | null;
      userpicUrl?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
    } | null;
    onlineStatus?: {
      __typename?: "UserPresenceStatusOutput";
      userId?: string | null;
      presenceStatus?: PresenceStatus | null;
    } | null;
    teams?: Array<{
      __typename?: "TeamOutput";
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
    } | null> | null;
    role?: {
      __typename?: "RoleOutput";
      roleDescription?: string | null;
      roleId?: string | null;
      rolePublicName?: string | null;
      roleTechnicalName?: string | null;
    } | null;
  } | null> | null;
};

export type CoreBotFieldsFragment = {
  __typename?: "BotOutput";
  id: string;
  name?: string | null;
};

export type CoreFlowFieldsFragment = {
  __typename?: "FlowOutput";
  id?: string | null;
  botId?: string | null;
  name?: string | null;
  createdAt?: string | null;
  isMain?: boolean | null;
  updatedAt?: string | null;
};

export type CoreChannelFieldsFragment = {
  __typename?: "ChannelOutput2";
  id: string;
  publicId: string;
  name: string;
  link: string;
  type: ChannelType;
  status: ChannelStatus;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  bot?: { __typename?: "BotOutput"; id: string; name?: string | null } | null;
};

export type ExtendedChannelFieldsFragment = {
  __typename?: "ChannelOutput2";
  id: string;
  publicId: string;
  name: string;
  link: string;
  type: ChannelType;
  status: ChannelStatus;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  bot?: { __typename?: "BotOutput"; id: string; name?: string | null } | null;
};

export type ExtendedBotFieldsFragment = {
  __typename?: "BotOutput";
  isActive?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  publishedAt?: string | null;
  status?: BotStatus | null;
  sessionsCount?: number | null;
  botType?: BotType | null;
  teamsIds?: Array<string | null> | null;
  id: string;
  name?: string | null;
  connectedChannels?: Array<{
    __typename?: "ChannelOutput2";
    id: string;
    publicId: string;
    name: string;
    link: string;
    type: ChannelType;
    status: ChannelStatus;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    bot?: { __typename?: "BotOutput"; id: string; name?: string | null } | null;
  } | null> | null;
};

export type CoreLinkedRoomFieldsFragment = {
  __typename?: "LinkedRoomOutput";
  id: string;
  lastMessageAt?: string | null;
  lastClientMessageAt?: string | null;
  lastTicketAt?: string | null;
  langCode?: LanguageCode_Iso_639_1 | null;
  unreadMessagesNumber: number;
  createdAt?: string | null;
  hasClientMessage: boolean;
  channel: {
    __typename?: "ChannelOutput2";
    id: string;
    publicId: string;
    name: string;
    link: string;
    type: ChannelType;
    status: ChannelStatus;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    bot?: { __typename?: "BotOutput"; id: string; name?: string | null } | null;
  };
  lastMessageContent?: {
    __typename?: "LastMessageContentOutput";
    messageText?: string | null;
    messageContent?: Array<{
      __typename?: "MessageContentItemOutput";
      category?: string | null;
      fileExtension?: string | null;
      mimeType?: string | null;
      url?: string | null;
      fileName?: string | null;
      fileSize?: number | null;
      dimensions?: {
        __typename?: "MessageContentImageDimension";
        width: number;
        height: number;
      } | null;
    } | null> | null;
  } | null;
};

export type CoreRoomFieldsFragment = {
  __typename?: "RoomOutput2";
  id: string;
  leadId: number;
  status: RoomStatus;
  previousStatus?: RoomStatus | null;
  teamsIds: Array<string | null>;
  previousTeamsIds?: Array<string | null> | null;
  lastMessageAt?: string | null;
  lastClientMessageAt?: string | null;
  lastTicketAt?: string | null;
  unreadMessagesNumber: number;
  createdAt?: string | null;
  vehicle?: string | null;
  langCode?: LanguageCode_Iso_639_1 | null;
  currentLangCode?: LanguageCode_Iso_639_1 | null;
  isExpired: boolean;
  nonAcceptedTrigger?: NonAcceptedTriggers | null;
  channel: {
    __typename?: "ChannelOutput2";
    id: string;
    publicId: string;
    name: string;
    link: string;
    type: ChannelType;
    status: ChannelStatus;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    bot?: { __typename?: "BotOutput"; id: string; name?: string | null } | null;
  };
  client: {
    __typename?: "UserOutput";
    id: string;
    roleId?: string | null;
    isRoot?: boolean | null;
    optionalName: string;
    whatsappUsername?: string | null;
    whatsappProfile?: string | null;
    telegramUsername?: string | null;
    telegramUserId?: string | null;
    facebookMessengerPsid?: string | null;
    vkUserId?: string | null;
    instagramBsid?: string | null;
    instagramProfile?: string | null;
    thirdParty?: string | null;
    twilioSmsUserId?: string | null;
    nylasUserEmail?: string | null;
    mailgunUserEmail?: string | null;
    sendgridUserEmail?: string | null;
    lastTicketAt?: string | null;
    common?: {
      __typename?: "CommonUserFields";
      createdAt?: string | null;
      autoNickname?: string | null;
      userpicUrl?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
    } | null;
    roomsLinks?: Array<{
      __typename?: "RoomLinkOutput";
      roomId?: string | null;
      roomStatus?: RoomStatus | null;
      channelType?: ChannelType | null;
      lastTicketAt?: string | null;
      vehicle?: string | null;
    } | null> | null;
    customFields?: Array<{
      __typename?: "UserCustomFieldOutput";
      fieldId: string;
      fieldName: string;
      dataType: CustomFieldDataType;
      description?: string | null;
      fieldOrder: number;
      value: string;
    } | null> | null;
  };
  activeOperator?: {
    __typename?: "UserOutput";
    id: string;
    roleId?: string | null;
    isRoot?: boolean | null;
    optionalName: string;
    thirdParty?: string | null;
    position?: string | null;
    common?: {
      __typename?: "CommonUserFields";
      createdAt?: string | null;
      autoNickname?: string | null;
      userpicUrl?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
    } | null;
    onlineStatus?: {
      __typename?: "UserPresenceStatusOutput";
      userId?: string | null;
      presenceStatus?: PresenceStatus | null;
    } | null;
    teams?: Array<{
      __typename?: "TeamOutput";
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
    } | null> | null;
    role?: {
      __typename?: "RoleOutput";
      roleDescription?: string | null;
      roleId?: string | null;
      rolePublicName?: string | null;
      roleTechnicalName?: string | null;
    } | null;
  } | null;
  operators: Array<{
    __typename?: "UserOutput";
    id: string;
    roleId?: string | null;
    isRoot?: boolean | null;
    optionalName: string;
    thirdParty?: string | null;
    position?: string | null;
    common?: {
      __typename?: "CommonUserFields";
      createdAt?: string | null;
      autoNickname?: string | null;
      userpicUrl?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
    } | null;
    onlineStatus?: {
      __typename?: "UserPresenceStatusOutput";
      userId?: string | null;
      presenceStatus?: PresenceStatus | null;
    } | null;
    teams?: Array<{
      __typename?: "TeamOutput";
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
    } | null> | null;
    role?: {
      __typename?: "RoleOutput";
      roleDescription?: string | null;
      roleId?: string | null;
      rolePublicName?: string | null;
      roleTechnicalName?: string | null;
    } | null;
  } | null>;
  lastMessageContent?: {
    __typename?: "LastMessageContentOutput";
    messageText?: string | null;
    messageContent?: Array<{
      __typename?: "MessageContentItemOutput";
      category?: string | null;
      fileExtension?: string | null;
      mimeType?: string | null;
      url?: string | null;
      fileName?: string | null;
      fileSize?: number | null;
      dimensions?: {
        __typename?: "MessageContentImageDimension";
        width: number;
        height: number;
      } | null;
    } | null> | null;
  } | null;
  linkedRooms: Array<{
    __typename?: "LinkedRoomOutput";
    id: string;
    lastMessageAt?: string | null;
    lastClientMessageAt?: string | null;
    lastTicketAt?: string | null;
    langCode?: LanguageCode_Iso_639_1 | null;
    unreadMessagesNumber: number;
    createdAt?: string | null;
    hasClientMessage: boolean;
    channel: {
      __typename?: "ChannelOutput2";
      id: string;
      publicId: string;
      name: string;
      link: string;
      type: ChannelType;
      status: ChannelStatus;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      bot?: {
        __typename?: "BotOutput";
        id: string;
        name?: string | null;
      } | null;
    };
    lastMessageContent?: {
      __typename?: "LastMessageContentOutput";
      messageText?: string | null;
      messageContent?: Array<{
        __typename?: "MessageContentItemOutput";
        category?: string | null;
        fileExtension?: string | null;
        mimeType?: string | null;
        url?: string | null;
        fileName?: string | null;
        fileSize?: number | null;
        dimensions?: {
          __typename?: "MessageContentImageDimension";
          width: number;
          height: number;
        } | null;
      } | null> | null;
    } | null;
  }>;
};

export type CoreMessageFieldsFragment = {
  __typename?: "MessageOutput";
  channelId?: string | null;
  channelTypeName?: ChannelType | null;
  chatRoomId?: string | null;
  chatRoomStatus?: string | null;
  messageAuthorId?: string | null;
  messageChannelId?: string | null;
  messageContent?: string | null;
  messageMetadata?: string | null;
  messageCreatedDateTime?: string | null;
  messageDeletedDateTime?: string | null;
  messageId?: string | null;
  messageIsDelivered?: boolean | null;
  messageIsRead?: boolean | null;
  messageIsSent?: boolean | null;
  messageText?: string | null;
  messageUpdatedDateTime?: string | null;
  textLangCode?: LanguageCode_Iso_639_1 | null;
  translatedText?: string | null;
  translatedTextLangCode?: LanguageCode_Iso_639_1 | null;
  localMessageId?: string | null;
  isFromClient: boolean;
  isFromBot: boolean;
};

export type CoreValidateBotFieldsFragment = {
  __typename?: "ValidateBot";
  id?: string | null;
  errorMessage?: string | null;
  statusCode?: number | null;
  nodeType?: NodeType | null;
  flowId?: string | null;
};

export type CoreButtonFieldsFragment = {
  __typename?: "ButtonOutput";
  id?: string | null;
  localId?: string | null;
  name?: string | null;
  nodeId?: string | null;
  localNodeId?: string | null;
  buttonOrder?: number | null;
  botId?: string | null;
};

export type CoreLanguageMapFieldsFragment = {
  __typename?: "LanguageMap";
  en: string;
  ru?: string | null;
  af?: string | null;
  sq?: string | null;
  ar?: string | null;
  az?: string | null;
  bn?: string | null;
  bg?: string | null;
  ca?: string | null;
  zh?: string | null;
  hr?: string | null;
  cs?: string | null;
  da?: string | null;
  nl?: string | null;
  et?: string | null;
  fil?: string | null;
  fi?: string | null;
  fr?: string | null;
  ka?: string | null;
  de?: string | null;
  el?: string | null;
  gu?: string | null;
  ha?: string | null;
  he?: string | null;
  hi?: string | null;
  hu?: string | null;
  id?: string | null;
  ga?: string | null;
  it?: string | null;
  ja?: string | null;
  kn?: string | null;
  kk?: string | null;
  rw?: string | null;
  ko?: string | null;
  ky?: string | null;
  lo?: string | null;
  lv?: string | null;
  lt?: string | null;
  mk?: string | null;
  ms?: string | null;
  ml?: string | null;
  mr?: string | null;
  nb?: string | null;
  fa?: string | null;
  pl?: string | null;
  pt?: string | null;
  pa?: string | null;
  ro?: string | null;
  sr?: string | null;
  sk?: string | null;
  sl?: string | null;
  es?: string | null;
  sw?: string | null;
  sv?: string | null;
  ta?: string | null;
  te?: string | null;
  th?: string | null;
  tr?: string | null;
  uk?: string | null;
  ur?: string | null;
  uz?: string | null;
  vi?: string | null;
  zu?: string | null;
};

export type CoreAppSettingsInnerFieldFragment = {
  __typename?: "AppSettingsFieldInner";
  tg: string;
  dt: AppFieldSettingsDataTypeType;
  v: string;
};

export type CoreAppSettingsInnerGroupFragment = {
  __typename?: "AppSettingsGroupInner";
  g: AppFieldsGroupType;
  c: Array<{
    __typename?: "AppSettingsFieldInner";
    tg: string;
    dt: AppFieldSettingsDataTypeType;
    v: string;
  }>;
};

export type CoreAppSettingsFieldFragment = {
  __typename?: "AppSettingsField";
  tg: string;
  dt: AppFieldSettingsDataTypeType;
  v: string;
  c?: Array<
    | {
        __typename?: "AppSettingsFieldInner";
        tg: string;
        dt: AppFieldSettingsDataTypeType;
        v: string;
      }
    | {
        __typename?: "AppSettingsGroupInner";
        g: AppFieldsGroupType;
        c: Array<{
          __typename?: "AppSettingsFieldInner";
          tg: string;
          dt: AppFieldSettingsDataTypeType;
          v: string;
        }>;
      }
  > | null;
};

export type CoreAppSettingsGroupFragment = {
  __typename?: "AppSettingsGroup";
  g: AppFieldsGroupType;
  c: Array<{
    __typename?: "AppSettingsField";
    tg: string;
    dt: AppFieldSettingsDataTypeType;
    v: string;
    c?: Array<
      | {
          __typename?: "AppSettingsFieldInner";
          tg: string;
          dt: AppFieldSettingsDataTypeType;
          v: string;
        }
      | {
          __typename?: "AppSettingsGroupInner";
          g: AppFieldsGroupType;
          c: Array<{
            __typename?: "AppSettingsFieldInner";
            tg: string;
            dt: AppFieldSettingsDataTypeType;
            v: string;
          }>;
        }
    > | null;
  }>;
};

export type CoreInstallationsFieldFragment = {
  __typename?: "AppInstallation";
  id: string;
  createdAt: string;
  method?: MethodType | null;
  localId?: string | null;
  settings?: Array<{
    __typename?: "AppSettingsGroup";
    g: AppFieldsGroupType;
    c: Array<{
      __typename?: "AppSettingsField";
      tg: string;
      dt: AppFieldSettingsDataTypeType;
      v: string;
      c?: Array<
        | {
            __typename?: "AppSettingsFieldInner";
            tg: string;
            dt: AppFieldSettingsDataTypeType;
            v: string;
          }
        | {
            __typename?: "AppSettingsGroupInner";
            g: AppFieldsGroupType;
            c: Array<{
              __typename?: "AppSettingsFieldInner";
              tg: string;
              dt: AppFieldSettingsDataTypeType;
              v: string;
            }>;
          }
      > | null;
    }>;
  } | null> | null;
};

export type CoreAppInnerFieldFragment = {
  __typename?: "AppFieldInner";
  t: AppFieldTypeType;
  tg: string;
  dt?: AppFieldDataTypeType | null;
  dts?: Array<AppFieldDataTypesType> | null;
  r?: boolean | null;
  mn?: number | null;
  mx?: number | null;
  v?: string | null;
  n: {
    __typename?: "LanguageMap";
    en: string;
    ru?: string | null;
    af?: string | null;
    sq?: string | null;
    ar?: string | null;
    az?: string | null;
    bn?: string | null;
    bg?: string | null;
    ca?: string | null;
    zh?: string | null;
    hr?: string | null;
    cs?: string | null;
    da?: string | null;
    nl?: string | null;
    et?: string | null;
    fil?: string | null;
    fi?: string | null;
    fr?: string | null;
    ka?: string | null;
    de?: string | null;
    el?: string | null;
    gu?: string | null;
    ha?: string | null;
    he?: string | null;
    hi?: string | null;
    hu?: string | null;
    id?: string | null;
    ga?: string | null;
    it?: string | null;
    ja?: string | null;
    kn?: string | null;
    kk?: string | null;
    rw?: string | null;
    ko?: string | null;
    ky?: string | null;
    lo?: string | null;
    lv?: string | null;
    lt?: string | null;
    mk?: string | null;
    ms?: string | null;
    ml?: string | null;
    mr?: string | null;
    nb?: string | null;
    fa?: string | null;
    pl?: string | null;
    pt?: string | null;
    pa?: string | null;
    ro?: string | null;
    sr?: string | null;
    sk?: string | null;
    sl?: string | null;
    es?: string | null;
    sw?: string | null;
    sv?: string | null;
    ta?: string | null;
    te?: string | null;
    th?: string | null;
    tr?: string | null;
    uk?: string | null;
    ur?: string | null;
    uz?: string | null;
    vi?: string | null;
    zu?: string | null;
  };
  p?: {
    __typename?: "LanguageMap";
    en: string;
    ru?: string | null;
    af?: string | null;
    sq?: string | null;
    ar?: string | null;
    az?: string | null;
    bn?: string | null;
    bg?: string | null;
    ca?: string | null;
    zh?: string | null;
    hr?: string | null;
    cs?: string | null;
    da?: string | null;
    nl?: string | null;
    et?: string | null;
    fil?: string | null;
    fi?: string | null;
    fr?: string | null;
    ka?: string | null;
    de?: string | null;
    el?: string | null;
    gu?: string | null;
    ha?: string | null;
    he?: string | null;
    hi?: string | null;
    hu?: string | null;
    id?: string | null;
    ga?: string | null;
    it?: string | null;
    ja?: string | null;
    kn?: string | null;
    kk?: string | null;
    rw?: string | null;
    ko?: string | null;
    ky?: string | null;
    lo?: string | null;
    lv?: string | null;
    lt?: string | null;
    mk?: string | null;
    ms?: string | null;
    ml?: string | null;
    mr?: string | null;
    nb?: string | null;
    fa?: string | null;
    pl?: string | null;
    pt?: string | null;
    pa?: string | null;
    ro?: string | null;
    sr?: string | null;
    sk?: string | null;
    sl?: string | null;
    es?: string | null;
    sw?: string | null;
    sv?: string | null;
    ta?: string | null;
    te?: string | null;
    th?: string | null;
    tr?: string | null;
    uk?: string | null;
    ur?: string | null;
    uz?: string | null;
    vi?: string | null;
    zu?: string | null;
  } | null;
  d?: {
    __typename?: "LanguageMap";
    en: string;
    ru?: string | null;
    af?: string | null;
    sq?: string | null;
    ar?: string | null;
    az?: string | null;
    bn?: string | null;
    bg?: string | null;
    ca?: string | null;
    zh?: string | null;
    hr?: string | null;
    cs?: string | null;
    da?: string | null;
    nl?: string | null;
    et?: string | null;
    fil?: string | null;
    fi?: string | null;
    fr?: string | null;
    ka?: string | null;
    de?: string | null;
    el?: string | null;
    gu?: string | null;
    ha?: string | null;
    he?: string | null;
    hi?: string | null;
    hu?: string | null;
    id?: string | null;
    ga?: string | null;
    it?: string | null;
    ja?: string | null;
    kn?: string | null;
    kk?: string | null;
    rw?: string | null;
    ko?: string | null;
    ky?: string | null;
    lo?: string | null;
    lv?: string | null;
    lt?: string | null;
    mk?: string | null;
    ms?: string | null;
    ml?: string | null;
    mr?: string | null;
    nb?: string | null;
    fa?: string | null;
    pl?: string | null;
    pt?: string | null;
    pa?: string | null;
    ro?: string | null;
    sr?: string | null;
    sk?: string | null;
    sl?: string | null;
    es?: string | null;
    sw?: string | null;
    sv?: string | null;
    ta?: string | null;
    te?: string | null;
    th?: string | null;
    tr?: string | null;
    uk?: string | null;
    ur?: string | null;
    uz?: string | null;
    vi?: string | null;
    zu?: string | null;
  } | null;
};

export type CoreAppInnerGroupFragment = {
  __typename?: "AppFieldsGroupInner";
  g: AppFieldsGroupType;
  c: Array<{
    __typename?: "AppFieldInner";
    t: AppFieldTypeType;
    tg: string;
    dt?: AppFieldDataTypeType | null;
    dts?: Array<AppFieldDataTypesType> | null;
    r?: boolean | null;
    mn?: number | null;
    mx?: number | null;
    v?: string | null;
    n: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    };
    p?: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    } | null;
    d?: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    } | null;
  }>;
};

type CoreAppFieldDetails_AppFieldInner_Fragment = {
  __typename?: "AppFieldInner";
  t: AppFieldTypeType;
  tg: string;
  dt?: AppFieldDataTypeType | null;
  dts?: Array<AppFieldDataTypesType> | null;
  r?: boolean | null;
  mn?: number | null;
  mx?: number | null;
  v?: string | null;
  n: {
    __typename?: "LanguageMap";
    en: string;
    ru?: string | null;
    af?: string | null;
    sq?: string | null;
    ar?: string | null;
    az?: string | null;
    bn?: string | null;
    bg?: string | null;
    ca?: string | null;
    zh?: string | null;
    hr?: string | null;
    cs?: string | null;
    da?: string | null;
    nl?: string | null;
    et?: string | null;
    fil?: string | null;
    fi?: string | null;
    fr?: string | null;
    ka?: string | null;
    de?: string | null;
    el?: string | null;
    gu?: string | null;
    ha?: string | null;
    he?: string | null;
    hi?: string | null;
    hu?: string | null;
    id?: string | null;
    ga?: string | null;
    it?: string | null;
    ja?: string | null;
    kn?: string | null;
    kk?: string | null;
    rw?: string | null;
    ko?: string | null;
    ky?: string | null;
    lo?: string | null;
    lv?: string | null;
    lt?: string | null;
    mk?: string | null;
    ms?: string | null;
    ml?: string | null;
    mr?: string | null;
    nb?: string | null;
    fa?: string | null;
    pl?: string | null;
    pt?: string | null;
    pa?: string | null;
    ro?: string | null;
    sr?: string | null;
    sk?: string | null;
    sl?: string | null;
    es?: string | null;
    sw?: string | null;
    sv?: string | null;
    ta?: string | null;
    te?: string | null;
    th?: string | null;
    tr?: string | null;
    uk?: string | null;
    ur?: string | null;
    uz?: string | null;
    vi?: string | null;
    zu?: string | null;
  };
  p?: {
    __typename?: "LanguageMap";
    en: string;
    ru?: string | null;
    af?: string | null;
    sq?: string | null;
    ar?: string | null;
    az?: string | null;
    bn?: string | null;
    bg?: string | null;
    ca?: string | null;
    zh?: string | null;
    hr?: string | null;
    cs?: string | null;
    da?: string | null;
    nl?: string | null;
    et?: string | null;
    fil?: string | null;
    fi?: string | null;
    fr?: string | null;
    ka?: string | null;
    de?: string | null;
    el?: string | null;
    gu?: string | null;
    ha?: string | null;
    he?: string | null;
    hi?: string | null;
    hu?: string | null;
    id?: string | null;
    ga?: string | null;
    it?: string | null;
    ja?: string | null;
    kn?: string | null;
    kk?: string | null;
    rw?: string | null;
    ko?: string | null;
    ky?: string | null;
    lo?: string | null;
    lv?: string | null;
    lt?: string | null;
    mk?: string | null;
    ms?: string | null;
    ml?: string | null;
    mr?: string | null;
    nb?: string | null;
    fa?: string | null;
    pl?: string | null;
    pt?: string | null;
    pa?: string | null;
    ro?: string | null;
    sr?: string | null;
    sk?: string | null;
    sl?: string | null;
    es?: string | null;
    sw?: string | null;
    sv?: string | null;
    ta?: string | null;
    te?: string | null;
    th?: string | null;
    tr?: string | null;
    uk?: string | null;
    ur?: string | null;
    uz?: string | null;
    vi?: string | null;
    zu?: string | null;
  } | null;
  d?: {
    __typename?: "LanguageMap";
    en: string;
    ru?: string | null;
    af?: string | null;
    sq?: string | null;
    ar?: string | null;
    az?: string | null;
    bn?: string | null;
    bg?: string | null;
    ca?: string | null;
    zh?: string | null;
    hr?: string | null;
    cs?: string | null;
    da?: string | null;
    nl?: string | null;
    et?: string | null;
    fil?: string | null;
    fi?: string | null;
    fr?: string | null;
    ka?: string | null;
    de?: string | null;
    el?: string | null;
    gu?: string | null;
    ha?: string | null;
    he?: string | null;
    hi?: string | null;
    hu?: string | null;
    id?: string | null;
    ga?: string | null;
    it?: string | null;
    ja?: string | null;
    kn?: string | null;
    kk?: string | null;
    rw?: string | null;
    ko?: string | null;
    ky?: string | null;
    lo?: string | null;
    lv?: string | null;
    lt?: string | null;
    mk?: string | null;
    ms?: string | null;
    ml?: string | null;
    mr?: string | null;
    nb?: string | null;
    fa?: string | null;
    pl?: string | null;
    pt?: string | null;
    pa?: string | null;
    ro?: string | null;
    sr?: string | null;
    sk?: string | null;
    sl?: string | null;
    es?: string | null;
    sw?: string | null;
    sv?: string | null;
    ta?: string | null;
    te?: string | null;
    th?: string | null;
    tr?: string | null;
    uk?: string | null;
    ur?: string | null;
    uz?: string | null;
    vi?: string | null;
    zu?: string | null;
  } | null;
};

type CoreAppFieldDetails_AppFieldsGroupInner_Fragment = {
  __typename?: "AppFieldsGroupInner";
  g: AppFieldsGroupType;
  c: Array<{
    __typename?: "AppFieldInner";
    t: AppFieldTypeType;
    tg: string;
    dt?: AppFieldDataTypeType | null;
    dts?: Array<AppFieldDataTypesType> | null;
    r?: boolean | null;
    mn?: number | null;
    mx?: number | null;
    v?: string | null;
    n: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    };
    p?: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    } | null;
    d?: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    } | null;
  }>;
};

export type CoreAppFieldDetailsFragment =
  | CoreAppFieldDetails_AppFieldInner_Fragment
  | CoreAppFieldDetails_AppFieldsGroupInner_Fragment;

export type CoreAppFieldFragment = {
  __typename?: "AppField";
  t: AppFieldTypeType;
  tg: string;
  dt?: AppFieldDataTypeType | null;
  dts?: Array<AppFieldDataTypesType> | null;
  r?: boolean | null;
  mn?: number | null;
  mx?: number | null;
  v?: string | null;
  n: {
    __typename?: "LanguageMap";
    en: string;
    ru?: string | null;
    af?: string | null;
    sq?: string | null;
    ar?: string | null;
    az?: string | null;
    bn?: string | null;
    bg?: string | null;
    ca?: string | null;
    zh?: string | null;
    hr?: string | null;
    cs?: string | null;
    da?: string | null;
    nl?: string | null;
    et?: string | null;
    fil?: string | null;
    fi?: string | null;
    fr?: string | null;
    ka?: string | null;
    de?: string | null;
    el?: string | null;
    gu?: string | null;
    ha?: string | null;
    he?: string | null;
    hi?: string | null;
    hu?: string | null;
    id?: string | null;
    ga?: string | null;
    it?: string | null;
    ja?: string | null;
    kn?: string | null;
    kk?: string | null;
    rw?: string | null;
    ko?: string | null;
    ky?: string | null;
    lo?: string | null;
    lv?: string | null;
    lt?: string | null;
    mk?: string | null;
    ms?: string | null;
    ml?: string | null;
    mr?: string | null;
    nb?: string | null;
    fa?: string | null;
    pl?: string | null;
    pt?: string | null;
    pa?: string | null;
    ro?: string | null;
    sr?: string | null;
    sk?: string | null;
    sl?: string | null;
    es?: string | null;
    sw?: string | null;
    sv?: string | null;
    ta?: string | null;
    te?: string | null;
    th?: string | null;
    tr?: string | null;
    uk?: string | null;
    ur?: string | null;
    uz?: string | null;
    vi?: string | null;
    zu?: string | null;
  };
  p?: {
    __typename?: "LanguageMap";
    en: string;
    ru?: string | null;
    af?: string | null;
    sq?: string | null;
    ar?: string | null;
    az?: string | null;
    bn?: string | null;
    bg?: string | null;
    ca?: string | null;
    zh?: string | null;
    hr?: string | null;
    cs?: string | null;
    da?: string | null;
    nl?: string | null;
    et?: string | null;
    fil?: string | null;
    fi?: string | null;
    fr?: string | null;
    ka?: string | null;
    de?: string | null;
    el?: string | null;
    gu?: string | null;
    ha?: string | null;
    he?: string | null;
    hi?: string | null;
    hu?: string | null;
    id?: string | null;
    ga?: string | null;
    it?: string | null;
    ja?: string | null;
    kn?: string | null;
    kk?: string | null;
    rw?: string | null;
    ko?: string | null;
    ky?: string | null;
    lo?: string | null;
    lv?: string | null;
    lt?: string | null;
    mk?: string | null;
    ms?: string | null;
    ml?: string | null;
    mr?: string | null;
    nb?: string | null;
    fa?: string | null;
    pl?: string | null;
    pt?: string | null;
    pa?: string | null;
    ro?: string | null;
    sr?: string | null;
    sk?: string | null;
    sl?: string | null;
    es?: string | null;
    sw?: string | null;
    sv?: string | null;
    ta?: string | null;
    te?: string | null;
    th?: string | null;
    tr?: string | null;
    uk?: string | null;
    ur?: string | null;
    uz?: string | null;
    vi?: string | null;
    zu?: string | null;
  } | null;
  d?: {
    __typename?: "LanguageMap";
    en: string;
    ru?: string | null;
    af?: string | null;
    sq?: string | null;
    ar?: string | null;
    az?: string | null;
    bn?: string | null;
    bg?: string | null;
    ca?: string | null;
    zh?: string | null;
    hr?: string | null;
    cs?: string | null;
    da?: string | null;
    nl?: string | null;
    et?: string | null;
    fil?: string | null;
    fi?: string | null;
    fr?: string | null;
    ka?: string | null;
    de?: string | null;
    el?: string | null;
    gu?: string | null;
    ha?: string | null;
    he?: string | null;
    hi?: string | null;
    hu?: string | null;
    id?: string | null;
    ga?: string | null;
    it?: string | null;
    ja?: string | null;
    kn?: string | null;
    kk?: string | null;
    rw?: string | null;
    ko?: string | null;
    ky?: string | null;
    lo?: string | null;
    lv?: string | null;
    lt?: string | null;
    mk?: string | null;
    ms?: string | null;
    ml?: string | null;
    mr?: string | null;
    nb?: string | null;
    fa?: string | null;
    pl?: string | null;
    pt?: string | null;
    pa?: string | null;
    ro?: string | null;
    sr?: string | null;
    sk?: string | null;
    sl?: string | null;
    es?: string | null;
    sw?: string | null;
    sv?: string | null;
    ta?: string | null;
    te?: string | null;
    th?: string | null;
    tr?: string | null;
    uk?: string | null;
    ur?: string | null;
    uz?: string | null;
    vi?: string | null;
    zu?: string | null;
  } | null;
  c?: Array<
    | {
        __typename?: "AppFieldInner";
        t: AppFieldTypeType;
        tg: string;
        dt?: AppFieldDataTypeType | null;
        dts?: Array<AppFieldDataTypesType> | null;
        r?: boolean | null;
        mn?: number | null;
        mx?: number | null;
        v?: string | null;
        n: {
          __typename?: "LanguageMap";
          en: string;
          ru?: string | null;
          af?: string | null;
          sq?: string | null;
          ar?: string | null;
          az?: string | null;
          bn?: string | null;
          bg?: string | null;
          ca?: string | null;
          zh?: string | null;
          hr?: string | null;
          cs?: string | null;
          da?: string | null;
          nl?: string | null;
          et?: string | null;
          fil?: string | null;
          fi?: string | null;
          fr?: string | null;
          ka?: string | null;
          de?: string | null;
          el?: string | null;
          gu?: string | null;
          ha?: string | null;
          he?: string | null;
          hi?: string | null;
          hu?: string | null;
          id?: string | null;
          ga?: string | null;
          it?: string | null;
          ja?: string | null;
          kn?: string | null;
          kk?: string | null;
          rw?: string | null;
          ko?: string | null;
          ky?: string | null;
          lo?: string | null;
          lv?: string | null;
          lt?: string | null;
          mk?: string | null;
          ms?: string | null;
          ml?: string | null;
          mr?: string | null;
          nb?: string | null;
          fa?: string | null;
          pl?: string | null;
          pt?: string | null;
          pa?: string | null;
          ro?: string | null;
          sr?: string | null;
          sk?: string | null;
          sl?: string | null;
          es?: string | null;
          sw?: string | null;
          sv?: string | null;
          ta?: string | null;
          te?: string | null;
          th?: string | null;
          tr?: string | null;
          uk?: string | null;
          ur?: string | null;
          uz?: string | null;
          vi?: string | null;
          zu?: string | null;
        };
        p?: {
          __typename?: "LanguageMap";
          en: string;
          ru?: string | null;
          af?: string | null;
          sq?: string | null;
          ar?: string | null;
          az?: string | null;
          bn?: string | null;
          bg?: string | null;
          ca?: string | null;
          zh?: string | null;
          hr?: string | null;
          cs?: string | null;
          da?: string | null;
          nl?: string | null;
          et?: string | null;
          fil?: string | null;
          fi?: string | null;
          fr?: string | null;
          ka?: string | null;
          de?: string | null;
          el?: string | null;
          gu?: string | null;
          ha?: string | null;
          he?: string | null;
          hi?: string | null;
          hu?: string | null;
          id?: string | null;
          ga?: string | null;
          it?: string | null;
          ja?: string | null;
          kn?: string | null;
          kk?: string | null;
          rw?: string | null;
          ko?: string | null;
          ky?: string | null;
          lo?: string | null;
          lv?: string | null;
          lt?: string | null;
          mk?: string | null;
          ms?: string | null;
          ml?: string | null;
          mr?: string | null;
          nb?: string | null;
          fa?: string | null;
          pl?: string | null;
          pt?: string | null;
          pa?: string | null;
          ro?: string | null;
          sr?: string | null;
          sk?: string | null;
          sl?: string | null;
          es?: string | null;
          sw?: string | null;
          sv?: string | null;
          ta?: string | null;
          te?: string | null;
          th?: string | null;
          tr?: string | null;
          uk?: string | null;
          ur?: string | null;
          uz?: string | null;
          vi?: string | null;
          zu?: string | null;
        } | null;
        d?: {
          __typename?: "LanguageMap";
          en: string;
          ru?: string | null;
          af?: string | null;
          sq?: string | null;
          ar?: string | null;
          az?: string | null;
          bn?: string | null;
          bg?: string | null;
          ca?: string | null;
          zh?: string | null;
          hr?: string | null;
          cs?: string | null;
          da?: string | null;
          nl?: string | null;
          et?: string | null;
          fil?: string | null;
          fi?: string | null;
          fr?: string | null;
          ka?: string | null;
          de?: string | null;
          el?: string | null;
          gu?: string | null;
          ha?: string | null;
          he?: string | null;
          hi?: string | null;
          hu?: string | null;
          id?: string | null;
          ga?: string | null;
          it?: string | null;
          ja?: string | null;
          kn?: string | null;
          kk?: string | null;
          rw?: string | null;
          ko?: string | null;
          ky?: string | null;
          lo?: string | null;
          lv?: string | null;
          lt?: string | null;
          mk?: string | null;
          ms?: string | null;
          ml?: string | null;
          mr?: string | null;
          nb?: string | null;
          fa?: string | null;
          pl?: string | null;
          pt?: string | null;
          pa?: string | null;
          ro?: string | null;
          sr?: string | null;
          sk?: string | null;
          sl?: string | null;
          es?: string | null;
          sw?: string | null;
          sv?: string | null;
          ta?: string | null;
          te?: string | null;
          th?: string | null;
          tr?: string | null;
          uk?: string | null;
          ur?: string | null;
          uz?: string | null;
          vi?: string | null;
          zu?: string | null;
        } | null;
      }
    | {
        __typename?: "AppFieldsGroupInner";
        g: AppFieldsGroupType;
        c: Array<{
          __typename?: "AppFieldInner";
          t: AppFieldTypeType;
          tg: string;
          dt?: AppFieldDataTypeType | null;
          dts?: Array<AppFieldDataTypesType> | null;
          r?: boolean | null;
          mn?: number | null;
          mx?: number | null;
          v?: string | null;
          n: {
            __typename?: "LanguageMap";
            en: string;
            ru?: string | null;
            af?: string | null;
            sq?: string | null;
            ar?: string | null;
            az?: string | null;
            bn?: string | null;
            bg?: string | null;
            ca?: string | null;
            zh?: string | null;
            hr?: string | null;
            cs?: string | null;
            da?: string | null;
            nl?: string | null;
            et?: string | null;
            fil?: string | null;
            fi?: string | null;
            fr?: string | null;
            ka?: string | null;
            de?: string | null;
            el?: string | null;
            gu?: string | null;
            ha?: string | null;
            he?: string | null;
            hi?: string | null;
            hu?: string | null;
            id?: string | null;
            ga?: string | null;
            it?: string | null;
            ja?: string | null;
            kn?: string | null;
            kk?: string | null;
            rw?: string | null;
            ko?: string | null;
            ky?: string | null;
            lo?: string | null;
            lv?: string | null;
            lt?: string | null;
            mk?: string | null;
            ms?: string | null;
            ml?: string | null;
            mr?: string | null;
            nb?: string | null;
            fa?: string | null;
            pl?: string | null;
            pt?: string | null;
            pa?: string | null;
            ro?: string | null;
            sr?: string | null;
            sk?: string | null;
            sl?: string | null;
            es?: string | null;
            sw?: string | null;
            sv?: string | null;
            ta?: string | null;
            te?: string | null;
            th?: string | null;
            tr?: string | null;
            uk?: string | null;
            ur?: string | null;
            uz?: string | null;
            vi?: string | null;
            zu?: string | null;
          };
          p?: {
            __typename?: "LanguageMap";
            en: string;
            ru?: string | null;
            af?: string | null;
            sq?: string | null;
            ar?: string | null;
            az?: string | null;
            bn?: string | null;
            bg?: string | null;
            ca?: string | null;
            zh?: string | null;
            hr?: string | null;
            cs?: string | null;
            da?: string | null;
            nl?: string | null;
            et?: string | null;
            fil?: string | null;
            fi?: string | null;
            fr?: string | null;
            ka?: string | null;
            de?: string | null;
            el?: string | null;
            gu?: string | null;
            ha?: string | null;
            he?: string | null;
            hi?: string | null;
            hu?: string | null;
            id?: string | null;
            ga?: string | null;
            it?: string | null;
            ja?: string | null;
            kn?: string | null;
            kk?: string | null;
            rw?: string | null;
            ko?: string | null;
            ky?: string | null;
            lo?: string | null;
            lv?: string | null;
            lt?: string | null;
            mk?: string | null;
            ms?: string | null;
            ml?: string | null;
            mr?: string | null;
            nb?: string | null;
            fa?: string | null;
            pl?: string | null;
            pt?: string | null;
            pa?: string | null;
            ro?: string | null;
            sr?: string | null;
            sk?: string | null;
            sl?: string | null;
            es?: string | null;
            sw?: string | null;
            sv?: string | null;
            ta?: string | null;
            te?: string | null;
            th?: string | null;
            tr?: string | null;
            uk?: string | null;
            ur?: string | null;
            uz?: string | null;
            vi?: string | null;
            zu?: string | null;
          } | null;
          d?: {
            __typename?: "LanguageMap";
            en: string;
            ru?: string | null;
            af?: string | null;
            sq?: string | null;
            ar?: string | null;
            az?: string | null;
            bn?: string | null;
            bg?: string | null;
            ca?: string | null;
            zh?: string | null;
            hr?: string | null;
            cs?: string | null;
            da?: string | null;
            nl?: string | null;
            et?: string | null;
            fil?: string | null;
            fi?: string | null;
            fr?: string | null;
            ka?: string | null;
            de?: string | null;
            el?: string | null;
            gu?: string | null;
            ha?: string | null;
            he?: string | null;
            hi?: string | null;
            hu?: string | null;
            id?: string | null;
            ga?: string | null;
            it?: string | null;
            ja?: string | null;
            kn?: string | null;
            kk?: string | null;
            rw?: string | null;
            ko?: string | null;
            ky?: string | null;
            lo?: string | null;
            lv?: string | null;
            lt?: string | null;
            mk?: string | null;
            ms?: string | null;
            ml?: string | null;
            mr?: string | null;
            nb?: string | null;
            fa?: string | null;
            pl?: string | null;
            pt?: string | null;
            pa?: string | null;
            ro?: string | null;
            sr?: string | null;
            sk?: string | null;
            sl?: string | null;
            es?: string | null;
            sw?: string | null;
            sv?: string | null;
            ta?: string | null;
            te?: string | null;
            th?: string | null;
            tr?: string | null;
            uk?: string | null;
            ur?: string | null;
            uz?: string | null;
            vi?: string | null;
            zu?: string | null;
          } | null;
        }>;
      }
  > | null;
};

export type CoreGroupFieldsFragment = {
  __typename?: "AppFieldsGroup";
  g: AppFieldsGroupType;
  c: Array<{
    __typename?: "AppField";
    t: AppFieldTypeType;
    tg: string;
    dt?: AppFieldDataTypeType | null;
    dts?: Array<AppFieldDataTypesType> | null;
    r?: boolean | null;
    mn?: number | null;
    mx?: number | null;
    v?: string | null;
    n: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    };
    p?: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    } | null;
    d?: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    } | null;
    c?: Array<
      | {
          __typename?: "AppFieldInner";
          t: AppFieldTypeType;
          tg: string;
          dt?: AppFieldDataTypeType | null;
          dts?: Array<AppFieldDataTypesType> | null;
          r?: boolean | null;
          mn?: number | null;
          mx?: number | null;
          v?: string | null;
          n: {
            __typename?: "LanguageMap";
            en: string;
            ru?: string | null;
            af?: string | null;
            sq?: string | null;
            ar?: string | null;
            az?: string | null;
            bn?: string | null;
            bg?: string | null;
            ca?: string | null;
            zh?: string | null;
            hr?: string | null;
            cs?: string | null;
            da?: string | null;
            nl?: string | null;
            et?: string | null;
            fil?: string | null;
            fi?: string | null;
            fr?: string | null;
            ka?: string | null;
            de?: string | null;
            el?: string | null;
            gu?: string | null;
            ha?: string | null;
            he?: string | null;
            hi?: string | null;
            hu?: string | null;
            id?: string | null;
            ga?: string | null;
            it?: string | null;
            ja?: string | null;
            kn?: string | null;
            kk?: string | null;
            rw?: string | null;
            ko?: string | null;
            ky?: string | null;
            lo?: string | null;
            lv?: string | null;
            lt?: string | null;
            mk?: string | null;
            ms?: string | null;
            ml?: string | null;
            mr?: string | null;
            nb?: string | null;
            fa?: string | null;
            pl?: string | null;
            pt?: string | null;
            pa?: string | null;
            ro?: string | null;
            sr?: string | null;
            sk?: string | null;
            sl?: string | null;
            es?: string | null;
            sw?: string | null;
            sv?: string | null;
            ta?: string | null;
            te?: string | null;
            th?: string | null;
            tr?: string | null;
            uk?: string | null;
            ur?: string | null;
            uz?: string | null;
            vi?: string | null;
            zu?: string | null;
          };
          p?: {
            __typename?: "LanguageMap";
            en: string;
            ru?: string | null;
            af?: string | null;
            sq?: string | null;
            ar?: string | null;
            az?: string | null;
            bn?: string | null;
            bg?: string | null;
            ca?: string | null;
            zh?: string | null;
            hr?: string | null;
            cs?: string | null;
            da?: string | null;
            nl?: string | null;
            et?: string | null;
            fil?: string | null;
            fi?: string | null;
            fr?: string | null;
            ka?: string | null;
            de?: string | null;
            el?: string | null;
            gu?: string | null;
            ha?: string | null;
            he?: string | null;
            hi?: string | null;
            hu?: string | null;
            id?: string | null;
            ga?: string | null;
            it?: string | null;
            ja?: string | null;
            kn?: string | null;
            kk?: string | null;
            rw?: string | null;
            ko?: string | null;
            ky?: string | null;
            lo?: string | null;
            lv?: string | null;
            lt?: string | null;
            mk?: string | null;
            ms?: string | null;
            ml?: string | null;
            mr?: string | null;
            nb?: string | null;
            fa?: string | null;
            pl?: string | null;
            pt?: string | null;
            pa?: string | null;
            ro?: string | null;
            sr?: string | null;
            sk?: string | null;
            sl?: string | null;
            es?: string | null;
            sw?: string | null;
            sv?: string | null;
            ta?: string | null;
            te?: string | null;
            th?: string | null;
            tr?: string | null;
            uk?: string | null;
            ur?: string | null;
            uz?: string | null;
            vi?: string | null;
            zu?: string | null;
          } | null;
          d?: {
            __typename?: "LanguageMap";
            en: string;
            ru?: string | null;
            af?: string | null;
            sq?: string | null;
            ar?: string | null;
            az?: string | null;
            bn?: string | null;
            bg?: string | null;
            ca?: string | null;
            zh?: string | null;
            hr?: string | null;
            cs?: string | null;
            da?: string | null;
            nl?: string | null;
            et?: string | null;
            fil?: string | null;
            fi?: string | null;
            fr?: string | null;
            ka?: string | null;
            de?: string | null;
            el?: string | null;
            gu?: string | null;
            ha?: string | null;
            he?: string | null;
            hi?: string | null;
            hu?: string | null;
            id?: string | null;
            ga?: string | null;
            it?: string | null;
            ja?: string | null;
            kn?: string | null;
            kk?: string | null;
            rw?: string | null;
            ko?: string | null;
            ky?: string | null;
            lo?: string | null;
            lv?: string | null;
            lt?: string | null;
            mk?: string | null;
            ms?: string | null;
            ml?: string | null;
            mr?: string | null;
            nb?: string | null;
            fa?: string | null;
            pl?: string | null;
            pt?: string | null;
            pa?: string | null;
            ro?: string | null;
            sr?: string | null;
            sk?: string | null;
            sl?: string | null;
            es?: string | null;
            sw?: string | null;
            sv?: string | null;
            ta?: string | null;
            te?: string | null;
            th?: string | null;
            tr?: string | null;
            uk?: string | null;
            ur?: string | null;
            uz?: string | null;
            vi?: string | null;
            zu?: string | null;
          } | null;
        }
      | {
          __typename?: "AppFieldsGroupInner";
          g: AppFieldsGroupType;
          c: Array<{
            __typename?: "AppFieldInner";
            t: AppFieldTypeType;
            tg: string;
            dt?: AppFieldDataTypeType | null;
            dts?: Array<AppFieldDataTypesType> | null;
            r?: boolean | null;
            mn?: number | null;
            mx?: number | null;
            v?: string | null;
            n: {
              __typename?: "LanguageMap";
              en: string;
              ru?: string | null;
              af?: string | null;
              sq?: string | null;
              ar?: string | null;
              az?: string | null;
              bn?: string | null;
              bg?: string | null;
              ca?: string | null;
              zh?: string | null;
              hr?: string | null;
              cs?: string | null;
              da?: string | null;
              nl?: string | null;
              et?: string | null;
              fil?: string | null;
              fi?: string | null;
              fr?: string | null;
              ka?: string | null;
              de?: string | null;
              el?: string | null;
              gu?: string | null;
              ha?: string | null;
              he?: string | null;
              hi?: string | null;
              hu?: string | null;
              id?: string | null;
              ga?: string | null;
              it?: string | null;
              ja?: string | null;
              kn?: string | null;
              kk?: string | null;
              rw?: string | null;
              ko?: string | null;
              ky?: string | null;
              lo?: string | null;
              lv?: string | null;
              lt?: string | null;
              mk?: string | null;
              ms?: string | null;
              ml?: string | null;
              mr?: string | null;
              nb?: string | null;
              fa?: string | null;
              pl?: string | null;
              pt?: string | null;
              pa?: string | null;
              ro?: string | null;
              sr?: string | null;
              sk?: string | null;
              sl?: string | null;
              es?: string | null;
              sw?: string | null;
              sv?: string | null;
              ta?: string | null;
              te?: string | null;
              th?: string | null;
              tr?: string | null;
              uk?: string | null;
              ur?: string | null;
              uz?: string | null;
              vi?: string | null;
              zu?: string | null;
            };
            p?: {
              __typename?: "LanguageMap";
              en: string;
              ru?: string | null;
              af?: string | null;
              sq?: string | null;
              ar?: string | null;
              az?: string | null;
              bn?: string | null;
              bg?: string | null;
              ca?: string | null;
              zh?: string | null;
              hr?: string | null;
              cs?: string | null;
              da?: string | null;
              nl?: string | null;
              et?: string | null;
              fil?: string | null;
              fi?: string | null;
              fr?: string | null;
              ka?: string | null;
              de?: string | null;
              el?: string | null;
              gu?: string | null;
              ha?: string | null;
              he?: string | null;
              hi?: string | null;
              hu?: string | null;
              id?: string | null;
              ga?: string | null;
              it?: string | null;
              ja?: string | null;
              kn?: string | null;
              kk?: string | null;
              rw?: string | null;
              ko?: string | null;
              ky?: string | null;
              lo?: string | null;
              lv?: string | null;
              lt?: string | null;
              mk?: string | null;
              ms?: string | null;
              ml?: string | null;
              mr?: string | null;
              nb?: string | null;
              fa?: string | null;
              pl?: string | null;
              pt?: string | null;
              pa?: string | null;
              ro?: string | null;
              sr?: string | null;
              sk?: string | null;
              sl?: string | null;
              es?: string | null;
              sw?: string | null;
              sv?: string | null;
              ta?: string | null;
              te?: string | null;
              th?: string | null;
              tr?: string | null;
              uk?: string | null;
              ur?: string | null;
              uz?: string | null;
              vi?: string | null;
              zu?: string | null;
            } | null;
            d?: {
              __typename?: "LanguageMap";
              en: string;
              ru?: string | null;
              af?: string | null;
              sq?: string | null;
              ar?: string | null;
              az?: string | null;
              bn?: string | null;
              bg?: string | null;
              ca?: string | null;
              zh?: string | null;
              hr?: string | null;
              cs?: string | null;
              da?: string | null;
              nl?: string | null;
              et?: string | null;
              fil?: string | null;
              fi?: string | null;
              fr?: string | null;
              ka?: string | null;
              de?: string | null;
              el?: string | null;
              gu?: string | null;
              ha?: string | null;
              he?: string | null;
              hi?: string | null;
              hu?: string | null;
              id?: string | null;
              ga?: string | null;
              it?: string | null;
              ja?: string | null;
              kn?: string | null;
              kk?: string | null;
              rw?: string | null;
              ko?: string | null;
              ky?: string | null;
              lo?: string | null;
              lv?: string | null;
              lt?: string | null;
              mk?: string | null;
              ms?: string | null;
              ml?: string | null;
              mr?: string | null;
              nb?: string | null;
              fa?: string | null;
              pl?: string | null;
              pt?: string | null;
              pa?: string | null;
              ro?: string | null;
              sr?: string | null;
              sk?: string | null;
              sl?: string | null;
              es?: string | null;
              sw?: string | null;
              sv?: string | null;
              ta?: string | null;
              te?: string | null;
              th?: string | null;
              tr?: string | null;
              uk?: string | null;
              ur?: string | null;
              uz?: string | null;
              vi?: string | null;
              zu?: string | null;
            } | null;
          }>;
        }
    > | null;
  }>;
};

export type CoreVersionFieldsFragment = {
  __typename?: "AppVersion";
  version: string;
  createdAt: string;
  id: string;
  isInstalled: boolean;
  fields: Array<{
    __typename?: "AppFieldsGroup";
    g: AppFieldsGroupType;
    c: Array<{
      __typename?: "AppField";
      t: AppFieldTypeType;
      tg: string;
      dt?: AppFieldDataTypeType | null;
      dts?: Array<AppFieldDataTypesType> | null;
      r?: boolean | null;
      mn?: number | null;
      mx?: number | null;
      v?: string | null;
      n: {
        __typename?: "LanguageMap";
        en: string;
        ru?: string | null;
        af?: string | null;
        sq?: string | null;
        ar?: string | null;
        az?: string | null;
        bn?: string | null;
        bg?: string | null;
        ca?: string | null;
        zh?: string | null;
        hr?: string | null;
        cs?: string | null;
        da?: string | null;
        nl?: string | null;
        et?: string | null;
        fil?: string | null;
        fi?: string | null;
        fr?: string | null;
        ka?: string | null;
        de?: string | null;
        el?: string | null;
        gu?: string | null;
        ha?: string | null;
        he?: string | null;
        hi?: string | null;
        hu?: string | null;
        id?: string | null;
        ga?: string | null;
        it?: string | null;
        ja?: string | null;
        kn?: string | null;
        kk?: string | null;
        rw?: string | null;
        ko?: string | null;
        ky?: string | null;
        lo?: string | null;
        lv?: string | null;
        lt?: string | null;
        mk?: string | null;
        ms?: string | null;
        ml?: string | null;
        mr?: string | null;
        nb?: string | null;
        fa?: string | null;
        pl?: string | null;
        pt?: string | null;
        pa?: string | null;
        ro?: string | null;
        sr?: string | null;
        sk?: string | null;
        sl?: string | null;
        es?: string | null;
        sw?: string | null;
        sv?: string | null;
        ta?: string | null;
        te?: string | null;
        th?: string | null;
        tr?: string | null;
        uk?: string | null;
        ur?: string | null;
        uz?: string | null;
        vi?: string | null;
        zu?: string | null;
      };
      p?: {
        __typename?: "LanguageMap";
        en: string;
        ru?: string | null;
        af?: string | null;
        sq?: string | null;
        ar?: string | null;
        az?: string | null;
        bn?: string | null;
        bg?: string | null;
        ca?: string | null;
        zh?: string | null;
        hr?: string | null;
        cs?: string | null;
        da?: string | null;
        nl?: string | null;
        et?: string | null;
        fil?: string | null;
        fi?: string | null;
        fr?: string | null;
        ka?: string | null;
        de?: string | null;
        el?: string | null;
        gu?: string | null;
        ha?: string | null;
        he?: string | null;
        hi?: string | null;
        hu?: string | null;
        id?: string | null;
        ga?: string | null;
        it?: string | null;
        ja?: string | null;
        kn?: string | null;
        kk?: string | null;
        rw?: string | null;
        ko?: string | null;
        ky?: string | null;
        lo?: string | null;
        lv?: string | null;
        lt?: string | null;
        mk?: string | null;
        ms?: string | null;
        ml?: string | null;
        mr?: string | null;
        nb?: string | null;
        fa?: string | null;
        pl?: string | null;
        pt?: string | null;
        pa?: string | null;
        ro?: string | null;
        sr?: string | null;
        sk?: string | null;
        sl?: string | null;
        es?: string | null;
        sw?: string | null;
        sv?: string | null;
        ta?: string | null;
        te?: string | null;
        th?: string | null;
        tr?: string | null;
        uk?: string | null;
        ur?: string | null;
        uz?: string | null;
        vi?: string | null;
        zu?: string | null;
      } | null;
      d?: {
        __typename?: "LanguageMap";
        en: string;
        ru?: string | null;
        af?: string | null;
        sq?: string | null;
        ar?: string | null;
        az?: string | null;
        bn?: string | null;
        bg?: string | null;
        ca?: string | null;
        zh?: string | null;
        hr?: string | null;
        cs?: string | null;
        da?: string | null;
        nl?: string | null;
        et?: string | null;
        fil?: string | null;
        fi?: string | null;
        fr?: string | null;
        ka?: string | null;
        de?: string | null;
        el?: string | null;
        gu?: string | null;
        ha?: string | null;
        he?: string | null;
        hi?: string | null;
        hu?: string | null;
        id?: string | null;
        ga?: string | null;
        it?: string | null;
        ja?: string | null;
        kn?: string | null;
        kk?: string | null;
        rw?: string | null;
        ko?: string | null;
        ky?: string | null;
        lo?: string | null;
        lv?: string | null;
        lt?: string | null;
        mk?: string | null;
        ms?: string | null;
        ml?: string | null;
        mr?: string | null;
        nb?: string | null;
        fa?: string | null;
        pl?: string | null;
        pt?: string | null;
        pa?: string | null;
        ro?: string | null;
        sr?: string | null;
        sk?: string | null;
        sl?: string | null;
        es?: string | null;
        sw?: string | null;
        sv?: string | null;
        ta?: string | null;
        te?: string | null;
        th?: string | null;
        tr?: string | null;
        uk?: string | null;
        ur?: string | null;
        uz?: string | null;
        vi?: string | null;
        zu?: string | null;
      } | null;
      c?: Array<
        | {
            __typename?: "AppFieldInner";
            t: AppFieldTypeType;
            tg: string;
            dt?: AppFieldDataTypeType | null;
            dts?: Array<AppFieldDataTypesType> | null;
            r?: boolean | null;
            mn?: number | null;
            mx?: number | null;
            v?: string | null;
            n: {
              __typename?: "LanguageMap";
              en: string;
              ru?: string | null;
              af?: string | null;
              sq?: string | null;
              ar?: string | null;
              az?: string | null;
              bn?: string | null;
              bg?: string | null;
              ca?: string | null;
              zh?: string | null;
              hr?: string | null;
              cs?: string | null;
              da?: string | null;
              nl?: string | null;
              et?: string | null;
              fil?: string | null;
              fi?: string | null;
              fr?: string | null;
              ka?: string | null;
              de?: string | null;
              el?: string | null;
              gu?: string | null;
              ha?: string | null;
              he?: string | null;
              hi?: string | null;
              hu?: string | null;
              id?: string | null;
              ga?: string | null;
              it?: string | null;
              ja?: string | null;
              kn?: string | null;
              kk?: string | null;
              rw?: string | null;
              ko?: string | null;
              ky?: string | null;
              lo?: string | null;
              lv?: string | null;
              lt?: string | null;
              mk?: string | null;
              ms?: string | null;
              ml?: string | null;
              mr?: string | null;
              nb?: string | null;
              fa?: string | null;
              pl?: string | null;
              pt?: string | null;
              pa?: string | null;
              ro?: string | null;
              sr?: string | null;
              sk?: string | null;
              sl?: string | null;
              es?: string | null;
              sw?: string | null;
              sv?: string | null;
              ta?: string | null;
              te?: string | null;
              th?: string | null;
              tr?: string | null;
              uk?: string | null;
              ur?: string | null;
              uz?: string | null;
              vi?: string | null;
              zu?: string | null;
            };
            p?: {
              __typename?: "LanguageMap";
              en: string;
              ru?: string | null;
              af?: string | null;
              sq?: string | null;
              ar?: string | null;
              az?: string | null;
              bn?: string | null;
              bg?: string | null;
              ca?: string | null;
              zh?: string | null;
              hr?: string | null;
              cs?: string | null;
              da?: string | null;
              nl?: string | null;
              et?: string | null;
              fil?: string | null;
              fi?: string | null;
              fr?: string | null;
              ka?: string | null;
              de?: string | null;
              el?: string | null;
              gu?: string | null;
              ha?: string | null;
              he?: string | null;
              hi?: string | null;
              hu?: string | null;
              id?: string | null;
              ga?: string | null;
              it?: string | null;
              ja?: string | null;
              kn?: string | null;
              kk?: string | null;
              rw?: string | null;
              ko?: string | null;
              ky?: string | null;
              lo?: string | null;
              lv?: string | null;
              lt?: string | null;
              mk?: string | null;
              ms?: string | null;
              ml?: string | null;
              mr?: string | null;
              nb?: string | null;
              fa?: string | null;
              pl?: string | null;
              pt?: string | null;
              pa?: string | null;
              ro?: string | null;
              sr?: string | null;
              sk?: string | null;
              sl?: string | null;
              es?: string | null;
              sw?: string | null;
              sv?: string | null;
              ta?: string | null;
              te?: string | null;
              th?: string | null;
              tr?: string | null;
              uk?: string | null;
              ur?: string | null;
              uz?: string | null;
              vi?: string | null;
              zu?: string | null;
            } | null;
            d?: {
              __typename?: "LanguageMap";
              en: string;
              ru?: string | null;
              af?: string | null;
              sq?: string | null;
              ar?: string | null;
              az?: string | null;
              bn?: string | null;
              bg?: string | null;
              ca?: string | null;
              zh?: string | null;
              hr?: string | null;
              cs?: string | null;
              da?: string | null;
              nl?: string | null;
              et?: string | null;
              fil?: string | null;
              fi?: string | null;
              fr?: string | null;
              ka?: string | null;
              de?: string | null;
              el?: string | null;
              gu?: string | null;
              ha?: string | null;
              he?: string | null;
              hi?: string | null;
              hu?: string | null;
              id?: string | null;
              ga?: string | null;
              it?: string | null;
              ja?: string | null;
              kn?: string | null;
              kk?: string | null;
              rw?: string | null;
              ko?: string | null;
              ky?: string | null;
              lo?: string | null;
              lv?: string | null;
              lt?: string | null;
              mk?: string | null;
              ms?: string | null;
              ml?: string | null;
              mr?: string | null;
              nb?: string | null;
              fa?: string | null;
              pl?: string | null;
              pt?: string | null;
              pa?: string | null;
              ro?: string | null;
              sr?: string | null;
              sk?: string | null;
              sl?: string | null;
              es?: string | null;
              sw?: string | null;
              sv?: string | null;
              ta?: string | null;
              te?: string | null;
              th?: string | null;
              tr?: string | null;
              uk?: string | null;
              ur?: string | null;
              uz?: string | null;
              vi?: string | null;
              zu?: string | null;
            } | null;
          }
        | {
            __typename?: "AppFieldsGroupInner";
            g: AppFieldsGroupType;
            c: Array<{
              __typename?: "AppFieldInner";
              t: AppFieldTypeType;
              tg: string;
              dt?: AppFieldDataTypeType | null;
              dts?: Array<AppFieldDataTypesType> | null;
              r?: boolean | null;
              mn?: number | null;
              mx?: number | null;
              v?: string | null;
              n: {
                __typename?: "LanguageMap";
                en: string;
                ru?: string | null;
                af?: string | null;
                sq?: string | null;
                ar?: string | null;
                az?: string | null;
                bn?: string | null;
                bg?: string | null;
                ca?: string | null;
                zh?: string | null;
                hr?: string | null;
                cs?: string | null;
                da?: string | null;
                nl?: string | null;
                et?: string | null;
                fil?: string | null;
                fi?: string | null;
                fr?: string | null;
                ka?: string | null;
                de?: string | null;
                el?: string | null;
                gu?: string | null;
                ha?: string | null;
                he?: string | null;
                hi?: string | null;
                hu?: string | null;
                id?: string | null;
                ga?: string | null;
                it?: string | null;
                ja?: string | null;
                kn?: string | null;
                kk?: string | null;
                rw?: string | null;
                ko?: string | null;
                ky?: string | null;
                lo?: string | null;
                lv?: string | null;
                lt?: string | null;
                mk?: string | null;
                ms?: string | null;
                ml?: string | null;
                mr?: string | null;
                nb?: string | null;
                fa?: string | null;
                pl?: string | null;
                pt?: string | null;
                pa?: string | null;
                ro?: string | null;
                sr?: string | null;
                sk?: string | null;
                sl?: string | null;
                es?: string | null;
                sw?: string | null;
                sv?: string | null;
                ta?: string | null;
                te?: string | null;
                th?: string | null;
                tr?: string | null;
                uk?: string | null;
                ur?: string | null;
                uz?: string | null;
                vi?: string | null;
                zu?: string | null;
              };
              p?: {
                __typename?: "LanguageMap";
                en: string;
                ru?: string | null;
                af?: string | null;
                sq?: string | null;
                ar?: string | null;
                az?: string | null;
                bn?: string | null;
                bg?: string | null;
                ca?: string | null;
                zh?: string | null;
                hr?: string | null;
                cs?: string | null;
                da?: string | null;
                nl?: string | null;
                et?: string | null;
                fil?: string | null;
                fi?: string | null;
                fr?: string | null;
                ka?: string | null;
                de?: string | null;
                el?: string | null;
                gu?: string | null;
                ha?: string | null;
                he?: string | null;
                hi?: string | null;
                hu?: string | null;
                id?: string | null;
                ga?: string | null;
                it?: string | null;
                ja?: string | null;
                kn?: string | null;
                kk?: string | null;
                rw?: string | null;
                ko?: string | null;
                ky?: string | null;
                lo?: string | null;
                lv?: string | null;
                lt?: string | null;
                mk?: string | null;
                ms?: string | null;
                ml?: string | null;
                mr?: string | null;
                nb?: string | null;
                fa?: string | null;
                pl?: string | null;
                pt?: string | null;
                pa?: string | null;
                ro?: string | null;
                sr?: string | null;
                sk?: string | null;
                sl?: string | null;
                es?: string | null;
                sw?: string | null;
                sv?: string | null;
                ta?: string | null;
                te?: string | null;
                th?: string | null;
                tr?: string | null;
                uk?: string | null;
                ur?: string | null;
                uz?: string | null;
                vi?: string | null;
                zu?: string | null;
              } | null;
              d?: {
                __typename?: "LanguageMap";
                en: string;
                ru?: string | null;
                af?: string | null;
                sq?: string | null;
                ar?: string | null;
                az?: string | null;
                bn?: string | null;
                bg?: string | null;
                ca?: string | null;
                zh?: string | null;
                hr?: string | null;
                cs?: string | null;
                da?: string | null;
                nl?: string | null;
                et?: string | null;
                fil?: string | null;
                fi?: string | null;
                fr?: string | null;
                ka?: string | null;
                de?: string | null;
                el?: string | null;
                gu?: string | null;
                ha?: string | null;
                he?: string | null;
                hi?: string | null;
                hu?: string | null;
                id?: string | null;
                ga?: string | null;
                it?: string | null;
                ja?: string | null;
                kn?: string | null;
                kk?: string | null;
                rw?: string | null;
                ko?: string | null;
                ky?: string | null;
                lo?: string | null;
                lv?: string | null;
                lt?: string | null;
                mk?: string | null;
                ms?: string | null;
                ml?: string | null;
                mr?: string | null;
                nb?: string | null;
                fa?: string | null;
                pl?: string | null;
                pt?: string | null;
                pa?: string | null;
                ro?: string | null;
                sr?: string | null;
                sk?: string | null;
                sl?: string | null;
                es?: string | null;
                sw?: string | null;
                sv?: string | null;
                ta?: string | null;
                te?: string | null;
                th?: string | null;
                tr?: string | null;
                uk?: string | null;
                ur?: string | null;
                uz?: string | null;
                vi?: string | null;
                zu?: string | null;
              } | null;
            }>;
          }
      > | null;
    }>;
  } | null>;
  installations: Array<{
    __typename?: "AppInstallation";
    id: string;
    createdAt: string;
    method?: MethodType | null;
    localId?: string | null;
    settings?: Array<{
      __typename?: "AppSettingsGroup";
      g: AppFieldsGroupType;
      c: Array<{
        __typename?: "AppSettingsField";
        tg: string;
        dt: AppFieldSettingsDataTypeType;
        v: string;
        c?: Array<
          | {
              __typename?: "AppSettingsFieldInner";
              tg: string;
              dt: AppFieldSettingsDataTypeType;
              v: string;
            }
          | {
              __typename?: "AppSettingsGroupInner";
              g: AppFieldsGroupType;
              c: Array<{
                __typename?: "AppSettingsFieldInner";
                tg: string;
                dt: AppFieldSettingsDataTypeType;
                v: string;
              }>;
            }
        > | null;
      }>;
    } | null> | null;
  } | null>;
};

export type CoreAppFieldsFragment = {
  __typename?: "AppOutput";
  id: string;
  iconUrl: string;
  gallery?: string | null;
  type: AppType;
  tag: string;
  latestVersion: string;
  createdAt: string;
  isAvailable: boolean;
  isInstalled: boolean;
  name: {
    __typename?: "LanguageMap";
    en: string;
    ru?: string | null;
    af?: string | null;
    sq?: string | null;
    ar?: string | null;
    az?: string | null;
    bn?: string | null;
    bg?: string | null;
    ca?: string | null;
    zh?: string | null;
    hr?: string | null;
    cs?: string | null;
    da?: string | null;
    nl?: string | null;
    et?: string | null;
    fil?: string | null;
    fi?: string | null;
    fr?: string | null;
    ka?: string | null;
    de?: string | null;
    el?: string | null;
    gu?: string | null;
    ha?: string | null;
    he?: string | null;
    hi?: string | null;
    hu?: string | null;
    id?: string | null;
    ga?: string | null;
    it?: string | null;
    ja?: string | null;
    kn?: string | null;
    kk?: string | null;
    rw?: string | null;
    ko?: string | null;
    ky?: string | null;
    lo?: string | null;
    lv?: string | null;
    lt?: string | null;
    mk?: string | null;
    ms?: string | null;
    ml?: string | null;
    mr?: string | null;
    nb?: string | null;
    fa?: string | null;
    pl?: string | null;
    pt?: string | null;
    pa?: string | null;
    ro?: string | null;
    sr?: string | null;
    sk?: string | null;
    sl?: string | null;
    es?: string | null;
    sw?: string | null;
    sv?: string | null;
    ta?: string | null;
    te?: string | null;
    th?: string | null;
    tr?: string | null;
    uk?: string | null;
    ur?: string | null;
    uz?: string | null;
    vi?: string | null;
    zu?: string | null;
  };
  description?: {
    __typename?: "LanguageMap";
    en: string;
    ru?: string | null;
    af?: string | null;
    sq?: string | null;
    ar?: string | null;
    az?: string | null;
    bn?: string | null;
    bg?: string | null;
    ca?: string | null;
    zh?: string | null;
    hr?: string | null;
    cs?: string | null;
    da?: string | null;
    nl?: string | null;
    et?: string | null;
    fil?: string | null;
    fi?: string | null;
    fr?: string | null;
    ka?: string | null;
    de?: string | null;
    el?: string | null;
    gu?: string | null;
    ha?: string | null;
    he?: string | null;
    hi?: string | null;
    hu?: string | null;
    id?: string | null;
    ga?: string | null;
    it?: string | null;
    ja?: string | null;
    kn?: string | null;
    kk?: string | null;
    rw?: string | null;
    ko?: string | null;
    ky?: string | null;
    lo?: string | null;
    lv?: string | null;
    lt?: string | null;
    mk?: string | null;
    ms?: string | null;
    ml?: string | null;
    mr?: string | null;
    nb?: string | null;
    fa?: string | null;
    pl?: string | null;
    pt?: string | null;
    pa?: string | null;
    ro?: string | null;
    sr?: string | null;
    sk?: string | null;
    sl?: string | null;
    es?: string | null;
    sw?: string | null;
    sv?: string | null;
    ta?: string | null;
    te?: string | null;
    th?: string | null;
    tr?: string | null;
    uk?: string | null;
    ur?: string | null;
    uz?: string | null;
    vi?: string | null;
    zu?: string | null;
  } | null;
  instructions?: {
    __typename?: "LanguageMap";
    en: string;
    ru?: string | null;
    af?: string | null;
    sq?: string | null;
    ar?: string | null;
    az?: string | null;
    bn?: string | null;
    bg?: string | null;
    ca?: string | null;
    zh?: string | null;
    hr?: string | null;
    cs?: string | null;
    da?: string | null;
    nl?: string | null;
    et?: string | null;
    fil?: string | null;
    fi?: string | null;
    fr?: string | null;
    ka?: string | null;
    de?: string | null;
    el?: string | null;
    gu?: string | null;
    ha?: string | null;
    he?: string | null;
    hi?: string | null;
    hu?: string | null;
    id?: string | null;
    ga?: string | null;
    it?: string | null;
    ja?: string | null;
    kn?: string | null;
    kk?: string | null;
    rw?: string | null;
    ko?: string | null;
    ky?: string | null;
    lo?: string | null;
    lv?: string | null;
    lt?: string | null;
    mk?: string | null;
    ms?: string | null;
    ml?: string | null;
    mr?: string | null;
    nb?: string | null;
    fa?: string | null;
    pl?: string | null;
    pt?: string | null;
    pa?: string | null;
    ro?: string | null;
    sr?: string | null;
    sk?: string | null;
    sl?: string | null;
    es?: string | null;
    sw?: string | null;
    sv?: string | null;
    ta?: string | null;
    te?: string | null;
    th?: string | null;
    tr?: string | null;
    uk?: string | null;
    ur?: string | null;
    uz?: string | null;
    vi?: string | null;
    zu?: string | null;
  } | null;
  versions: Array<{
    __typename?: "AppVersion";
    version: string;
    createdAt: string;
    id: string;
    isInstalled: boolean;
    fields: Array<{
      __typename?: "AppFieldsGroup";
      g: AppFieldsGroupType;
      c: Array<{
        __typename?: "AppField";
        t: AppFieldTypeType;
        tg: string;
        dt?: AppFieldDataTypeType | null;
        dts?: Array<AppFieldDataTypesType> | null;
        r?: boolean | null;
        mn?: number | null;
        mx?: number | null;
        v?: string | null;
        n: {
          __typename?: "LanguageMap";
          en: string;
          ru?: string | null;
          af?: string | null;
          sq?: string | null;
          ar?: string | null;
          az?: string | null;
          bn?: string | null;
          bg?: string | null;
          ca?: string | null;
          zh?: string | null;
          hr?: string | null;
          cs?: string | null;
          da?: string | null;
          nl?: string | null;
          et?: string | null;
          fil?: string | null;
          fi?: string | null;
          fr?: string | null;
          ka?: string | null;
          de?: string | null;
          el?: string | null;
          gu?: string | null;
          ha?: string | null;
          he?: string | null;
          hi?: string | null;
          hu?: string | null;
          id?: string | null;
          ga?: string | null;
          it?: string | null;
          ja?: string | null;
          kn?: string | null;
          kk?: string | null;
          rw?: string | null;
          ko?: string | null;
          ky?: string | null;
          lo?: string | null;
          lv?: string | null;
          lt?: string | null;
          mk?: string | null;
          ms?: string | null;
          ml?: string | null;
          mr?: string | null;
          nb?: string | null;
          fa?: string | null;
          pl?: string | null;
          pt?: string | null;
          pa?: string | null;
          ro?: string | null;
          sr?: string | null;
          sk?: string | null;
          sl?: string | null;
          es?: string | null;
          sw?: string | null;
          sv?: string | null;
          ta?: string | null;
          te?: string | null;
          th?: string | null;
          tr?: string | null;
          uk?: string | null;
          ur?: string | null;
          uz?: string | null;
          vi?: string | null;
          zu?: string | null;
        };
        p?: {
          __typename?: "LanguageMap";
          en: string;
          ru?: string | null;
          af?: string | null;
          sq?: string | null;
          ar?: string | null;
          az?: string | null;
          bn?: string | null;
          bg?: string | null;
          ca?: string | null;
          zh?: string | null;
          hr?: string | null;
          cs?: string | null;
          da?: string | null;
          nl?: string | null;
          et?: string | null;
          fil?: string | null;
          fi?: string | null;
          fr?: string | null;
          ka?: string | null;
          de?: string | null;
          el?: string | null;
          gu?: string | null;
          ha?: string | null;
          he?: string | null;
          hi?: string | null;
          hu?: string | null;
          id?: string | null;
          ga?: string | null;
          it?: string | null;
          ja?: string | null;
          kn?: string | null;
          kk?: string | null;
          rw?: string | null;
          ko?: string | null;
          ky?: string | null;
          lo?: string | null;
          lv?: string | null;
          lt?: string | null;
          mk?: string | null;
          ms?: string | null;
          ml?: string | null;
          mr?: string | null;
          nb?: string | null;
          fa?: string | null;
          pl?: string | null;
          pt?: string | null;
          pa?: string | null;
          ro?: string | null;
          sr?: string | null;
          sk?: string | null;
          sl?: string | null;
          es?: string | null;
          sw?: string | null;
          sv?: string | null;
          ta?: string | null;
          te?: string | null;
          th?: string | null;
          tr?: string | null;
          uk?: string | null;
          ur?: string | null;
          uz?: string | null;
          vi?: string | null;
          zu?: string | null;
        } | null;
        d?: {
          __typename?: "LanguageMap";
          en: string;
          ru?: string | null;
          af?: string | null;
          sq?: string | null;
          ar?: string | null;
          az?: string | null;
          bn?: string | null;
          bg?: string | null;
          ca?: string | null;
          zh?: string | null;
          hr?: string | null;
          cs?: string | null;
          da?: string | null;
          nl?: string | null;
          et?: string | null;
          fil?: string | null;
          fi?: string | null;
          fr?: string | null;
          ka?: string | null;
          de?: string | null;
          el?: string | null;
          gu?: string | null;
          ha?: string | null;
          he?: string | null;
          hi?: string | null;
          hu?: string | null;
          id?: string | null;
          ga?: string | null;
          it?: string | null;
          ja?: string | null;
          kn?: string | null;
          kk?: string | null;
          rw?: string | null;
          ko?: string | null;
          ky?: string | null;
          lo?: string | null;
          lv?: string | null;
          lt?: string | null;
          mk?: string | null;
          ms?: string | null;
          ml?: string | null;
          mr?: string | null;
          nb?: string | null;
          fa?: string | null;
          pl?: string | null;
          pt?: string | null;
          pa?: string | null;
          ro?: string | null;
          sr?: string | null;
          sk?: string | null;
          sl?: string | null;
          es?: string | null;
          sw?: string | null;
          sv?: string | null;
          ta?: string | null;
          te?: string | null;
          th?: string | null;
          tr?: string | null;
          uk?: string | null;
          ur?: string | null;
          uz?: string | null;
          vi?: string | null;
          zu?: string | null;
        } | null;
        c?: Array<
          | {
              __typename?: "AppFieldInner";
              t: AppFieldTypeType;
              tg: string;
              dt?: AppFieldDataTypeType | null;
              dts?: Array<AppFieldDataTypesType> | null;
              r?: boolean | null;
              mn?: number | null;
              mx?: number | null;
              v?: string | null;
              n: {
                __typename?: "LanguageMap";
                en: string;
                ru?: string | null;
                af?: string | null;
                sq?: string | null;
                ar?: string | null;
                az?: string | null;
                bn?: string | null;
                bg?: string | null;
                ca?: string | null;
                zh?: string | null;
                hr?: string | null;
                cs?: string | null;
                da?: string | null;
                nl?: string | null;
                et?: string | null;
                fil?: string | null;
                fi?: string | null;
                fr?: string | null;
                ka?: string | null;
                de?: string | null;
                el?: string | null;
                gu?: string | null;
                ha?: string | null;
                he?: string | null;
                hi?: string | null;
                hu?: string | null;
                id?: string | null;
                ga?: string | null;
                it?: string | null;
                ja?: string | null;
                kn?: string | null;
                kk?: string | null;
                rw?: string | null;
                ko?: string | null;
                ky?: string | null;
                lo?: string | null;
                lv?: string | null;
                lt?: string | null;
                mk?: string | null;
                ms?: string | null;
                ml?: string | null;
                mr?: string | null;
                nb?: string | null;
                fa?: string | null;
                pl?: string | null;
                pt?: string | null;
                pa?: string | null;
                ro?: string | null;
                sr?: string | null;
                sk?: string | null;
                sl?: string | null;
                es?: string | null;
                sw?: string | null;
                sv?: string | null;
                ta?: string | null;
                te?: string | null;
                th?: string | null;
                tr?: string | null;
                uk?: string | null;
                ur?: string | null;
                uz?: string | null;
                vi?: string | null;
                zu?: string | null;
              };
              p?: {
                __typename?: "LanguageMap";
                en: string;
                ru?: string | null;
                af?: string | null;
                sq?: string | null;
                ar?: string | null;
                az?: string | null;
                bn?: string | null;
                bg?: string | null;
                ca?: string | null;
                zh?: string | null;
                hr?: string | null;
                cs?: string | null;
                da?: string | null;
                nl?: string | null;
                et?: string | null;
                fil?: string | null;
                fi?: string | null;
                fr?: string | null;
                ka?: string | null;
                de?: string | null;
                el?: string | null;
                gu?: string | null;
                ha?: string | null;
                he?: string | null;
                hi?: string | null;
                hu?: string | null;
                id?: string | null;
                ga?: string | null;
                it?: string | null;
                ja?: string | null;
                kn?: string | null;
                kk?: string | null;
                rw?: string | null;
                ko?: string | null;
                ky?: string | null;
                lo?: string | null;
                lv?: string | null;
                lt?: string | null;
                mk?: string | null;
                ms?: string | null;
                ml?: string | null;
                mr?: string | null;
                nb?: string | null;
                fa?: string | null;
                pl?: string | null;
                pt?: string | null;
                pa?: string | null;
                ro?: string | null;
                sr?: string | null;
                sk?: string | null;
                sl?: string | null;
                es?: string | null;
                sw?: string | null;
                sv?: string | null;
                ta?: string | null;
                te?: string | null;
                th?: string | null;
                tr?: string | null;
                uk?: string | null;
                ur?: string | null;
                uz?: string | null;
                vi?: string | null;
                zu?: string | null;
              } | null;
              d?: {
                __typename?: "LanguageMap";
                en: string;
                ru?: string | null;
                af?: string | null;
                sq?: string | null;
                ar?: string | null;
                az?: string | null;
                bn?: string | null;
                bg?: string | null;
                ca?: string | null;
                zh?: string | null;
                hr?: string | null;
                cs?: string | null;
                da?: string | null;
                nl?: string | null;
                et?: string | null;
                fil?: string | null;
                fi?: string | null;
                fr?: string | null;
                ka?: string | null;
                de?: string | null;
                el?: string | null;
                gu?: string | null;
                ha?: string | null;
                he?: string | null;
                hi?: string | null;
                hu?: string | null;
                id?: string | null;
                ga?: string | null;
                it?: string | null;
                ja?: string | null;
                kn?: string | null;
                kk?: string | null;
                rw?: string | null;
                ko?: string | null;
                ky?: string | null;
                lo?: string | null;
                lv?: string | null;
                lt?: string | null;
                mk?: string | null;
                ms?: string | null;
                ml?: string | null;
                mr?: string | null;
                nb?: string | null;
                fa?: string | null;
                pl?: string | null;
                pt?: string | null;
                pa?: string | null;
                ro?: string | null;
                sr?: string | null;
                sk?: string | null;
                sl?: string | null;
                es?: string | null;
                sw?: string | null;
                sv?: string | null;
                ta?: string | null;
                te?: string | null;
                th?: string | null;
                tr?: string | null;
                uk?: string | null;
                ur?: string | null;
                uz?: string | null;
                vi?: string | null;
                zu?: string | null;
              } | null;
            }
          | {
              __typename?: "AppFieldsGroupInner";
              g: AppFieldsGroupType;
              c: Array<{
                __typename?: "AppFieldInner";
                t: AppFieldTypeType;
                tg: string;
                dt?: AppFieldDataTypeType | null;
                dts?: Array<AppFieldDataTypesType> | null;
                r?: boolean | null;
                mn?: number | null;
                mx?: number | null;
                v?: string | null;
                n: {
                  __typename?: "LanguageMap";
                  en: string;
                  ru?: string | null;
                  af?: string | null;
                  sq?: string | null;
                  ar?: string | null;
                  az?: string | null;
                  bn?: string | null;
                  bg?: string | null;
                  ca?: string | null;
                  zh?: string | null;
                  hr?: string | null;
                  cs?: string | null;
                  da?: string | null;
                  nl?: string | null;
                  et?: string | null;
                  fil?: string | null;
                  fi?: string | null;
                  fr?: string | null;
                  ka?: string | null;
                  de?: string | null;
                  el?: string | null;
                  gu?: string | null;
                  ha?: string | null;
                  he?: string | null;
                  hi?: string | null;
                  hu?: string | null;
                  id?: string | null;
                  ga?: string | null;
                  it?: string | null;
                  ja?: string | null;
                  kn?: string | null;
                  kk?: string | null;
                  rw?: string | null;
                  ko?: string | null;
                  ky?: string | null;
                  lo?: string | null;
                  lv?: string | null;
                  lt?: string | null;
                  mk?: string | null;
                  ms?: string | null;
                  ml?: string | null;
                  mr?: string | null;
                  nb?: string | null;
                  fa?: string | null;
                  pl?: string | null;
                  pt?: string | null;
                  pa?: string | null;
                  ro?: string | null;
                  sr?: string | null;
                  sk?: string | null;
                  sl?: string | null;
                  es?: string | null;
                  sw?: string | null;
                  sv?: string | null;
                  ta?: string | null;
                  te?: string | null;
                  th?: string | null;
                  tr?: string | null;
                  uk?: string | null;
                  ur?: string | null;
                  uz?: string | null;
                  vi?: string | null;
                  zu?: string | null;
                };
                p?: {
                  __typename?: "LanguageMap";
                  en: string;
                  ru?: string | null;
                  af?: string | null;
                  sq?: string | null;
                  ar?: string | null;
                  az?: string | null;
                  bn?: string | null;
                  bg?: string | null;
                  ca?: string | null;
                  zh?: string | null;
                  hr?: string | null;
                  cs?: string | null;
                  da?: string | null;
                  nl?: string | null;
                  et?: string | null;
                  fil?: string | null;
                  fi?: string | null;
                  fr?: string | null;
                  ka?: string | null;
                  de?: string | null;
                  el?: string | null;
                  gu?: string | null;
                  ha?: string | null;
                  he?: string | null;
                  hi?: string | null;
                  hu?: string | null;
                  id?: string | null;
                  ga?: string | null;
                  it?: string | null;
                  ja?: string | null;
                  kn?: string | null;
                  kk?: string | null;
                  rw?: string | null;
                  ko?: string | null;
                  ky?: string | null;
                  lo?: string | null;
                  lv?: string | null;
                  lt?: string | null;
                  mk?: string | null;
                  ms?: string | null;
                  ml?: string | null;
                  mr?: string | null;
                  nb?: string | null;
                  fa?: string | null;
                  pl?: string | null;
                  pt?: string | null;
                  pa?: string | null;
                  ro?: string | null;
                  sr?: string | null;
                  sk?: string | null;
                  sl?: string | null;
                  es?: string | null;
                  sw?: string | null;
                  sv?: string | null;
                  ta?: string | null;
                  te?: string | null;
                  th?: string | null;
                  tr?: string | null;
                  uk?: string | null;
                  ur?: string | null;
                  uz?: string | null;
                  vi?: string | null;
                  zu?: string | null;
                } | null;
                d?: {
                  __typename?: "LanguageMap";
                  en: string;
                  ru?: string | null;
                  af?: string | null;
                  sq?: string | null;
                  ar?: string | null;
                  az?: string | null;
                  bn?: string | null;
                  bg?: string | null;
                  ca?: string | null;
                  zh?: string | null;
                  hr?: string | null;
                  cs?: string | null;
                  da?: string | null;
                  nl?: string | null;
                  et?: string | null;
                  fil?: string | null;
                  fi?: string | null;
                  fr?: string | null;
                  ka?: string | null;
                  de?: string | null;
                  el?: string | null;
                  gu?: string | null;
                  ha?: string | null;
                  he?: string | null;
                  hi?: string | null;
                  hu?: string | null;
                  id?: string | null;
                  ga?: string | null;
                  it?: string | null;
                  ja?: string | null;
                  kn?: string | null;
                  kk?: string | null;
                  rw?: string | null;
                  ko?: string | null;
                  ky?: string | null;
                  lo?: string | null;
                  lv?: string | null;
                  lt?: string | null;
                  mk?: string | null;
                  ms?: string | null;
                  ml?: string | null;
                  mr?: string | null;
                  nb?: string | null;
                  fa?: string | null;
                  pl?: string | null;
                  pt?: string | null;
                  pa?: string | null;
                  ro?: string | null;
                  sr?: string | null;
                  sk?: string | null;
                  sl?: string | null;
                  es?: string | null;
                  sw?: string | null;
                  sv?: string | null;
                  ta?: string | null;
                  te?: string | null;
                  th?: string | null;
                  tr?: string | null;
                  uk?: string | null;
                  ur?: string | null;
                  uz?: string | null;
                  vi?: string | null;
                  zu?: string | null;
                } | null;
              }>;
            }
        > | null;
      }>;
    } | null>;
    installations: Array<{
      __typename?: "AppInstallation";
      id: string;
      createdAt: string;
      method?: MethodType | null;
      localId?: string | null;
      settings?: Array<{
        __typename?: "AppSettingsGroup";
        g: AppFieldsGroupType;
        c: Array<{
          __typename?: "AppSettingsField";
          tg: string;
          dt: AppFieldSettingsDataTypeType;
          v: string;
          c?: Array<
            | {
                __typename?: "AppSettingsFieldInner";
                tg: string;
                dt: AppFieldSettingsDataTypeType;
                v: string;
              }
            | {
                __typename?: "AppSettingsGroupInner";
                g: AppFieldsGroupType;
                c: Array<{
                  __typename?: "AppSettingsFieldInner";
                  tg: string;
                  dt: AppFieldSettingsDataTypeType;
                  v: string;
                }>;
              }
          > | null;
        }>;
      } | null> | null;
    } | null>;
  } | null>;
};

export type CoreNodeFieldsFragment = {
  __typename?: "NodeOutput";
  id?: string | null;
  localId?: string | null;
  flowId?: string | null;
  coordinates?: Array<number | null> | null;
  nodeType?: NodeType | null;
  fileUrl?: string | null;
  imageUrl?: string | null;
  text?: string | null;
  childFlowId?: string | null;
  isDelete?: boolean | null;
  teamsIds?: Array<string | null> | null;
  botId?: string | null;
  exceptionText?: string | null;
  saveTo?: SaveTo | null;
  appId?: string | null;
  appVersionId?: string | null;
  appInstalledId?: string | null;
  buttons?: Array<{
    __typename?: "ButtonOutput";
    id?: string | null;
    localId?: string | null;
    name?: string | null;
    nodeId?: string | null;
    localNodeId?: string | null;
    buttonOrder?: number | null;
    botId?: string | null;
  } | null> | null;
};

export type CoreEdgeFieldsFragment = {
  __typename?: "EdgeOutput";
  id?: string | null;
  localId?: string | null;
  botId?: string | null;
  flowId?: string | null;
  childId?: string | null;
  localChildId?: string | null;
  parentId?: string | null;
  localParentId?: string | null;
  handleParentId?: string | null;
  localHandleParentId?: string | null;
  isDelete?: boolean | null;
};

export type CoreSnippetCategoryFieldsFragment = {
  __typename?: "ChatSnippetsCategoriesOutput";
  categoryId?: string | null;
  categoryName?: string | null;
  parentId?: string | null;
  userId?: string | null;
  totalSnippetsCount?: number | null;
};

export type CoreSnippetFieldsFragment = {
  __typename?: "ChatSnippetsOutput";
  snippetId?: string | null;
  userId?: string | null;
  categoryId?: string | null;
  snippet?: string | null;
  teamsIds?: Array<string | null> | null;
  isFavorite: boolean;
};

export type CoreSnippetFavoriteFieldsFragment = {
  __typename?: "ChatSnippetsFavoritesOutput";
  snippetId?: string | null;
  userId?: string | null;
  isFavorite: boolean;
};

export type CoreRoomEventFieldsFragment = {
  __typename?: "RoomEventOutput";
  eventCreatedAt: string;
  eventInitiator: string;
  initiatorType: InitiatorType;
  toUser?: string | null;
  fromUser?: string | null;
  toTeams?: Array<string | null> | null;
  fromTeams?: Array<string | null> | null;
  actionName: RoomEventActionName;
  text?: string | null;
};

export type CoreCalendarEventFields2Fragment = {
  __typename?: "CalendarEventOutput2";
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  title: string;
  description: string;
  starts?: string | null;
  ends?: string | null;
  isBot: boolean;
  userId?: string | null;
  roomId?: string | null;
  operatorId?: string | null;
  isNonWorking?: boolean | null;
};

export type CoreCustomFieldFieldsFragment = {
  __typename?: "CustomFieldOutput";
  id: string;
  fieldName: string;
  dataType: CustomFieldDataType;
  description?: string | null;
  fieldOrder: number;
};

export type CoreCardFieldsFragment = {
  __typename?: "Card";
  brand?: string | null;
  expMonth?: number | null;
  expYear?: number | null;
  last4?: string | null;
};

export type CoreInvoicesFieldsFragment = {
  __typename?: "Invoice";
  amount?: number | null;
  products?: Array<string | null> | null;
  quantity?: number | null;
  status?: InvoiceStatus | null;
  createdAt?: string | null;
  finalizedAt?: string | null;
  invoicePdf?: string | null;
  hostedInvoiceUrl?: string | null;
  package?: OrganizationTariff | null;
  card?: {
    __typename?: "Card";
    brand?: string | null;
    expMonth?: number | null;
    expYear?: number | null;
    last4?: string | null;
  } | null;
};

export type CoreOrganizationFieldsFragment = {
  __typename?: "Organization";
  id: string;
  parentOID?: string | null;
  name: string;
  phone?: string | null;
  email?: string | null;
  tariffId?: string | null;
  newTariffId?: string | null;
  country?: string | null;
  timezone?: string | null;
  language?: OrganizationLanguage | null;
  activeMembersCount?: number | null;
  membersCount?: number | null;
  imageUrl?: string | null;
  address?: string | null;
  contactName?: string | null;
  contactCell?: string | null;
  stateDealerNumber?: string | null;
  website?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  isPendingDeletion?: boolean | null;
  isStale?: boolean | null;
  daysUntilStale?: number | null;
  isCurrent: boolean;
  rid: string;
  onboardStatus?: OnboardStatus | null;
  status: OrganizationStatus;
  isTrial?: boolean | null;
  isCanceled?: boolean | null;
  isPaymentFailed?: boolean | null;
  managerName?: string | null;
  managerPhone?: string | null;
  deletedAt?: string | null;
  trialFinishAt?: string | null;
  dealershipType?: DealershipType | null;
  vautoDealerId?: string | null;
  invoices?: {
    __typename?: "OrganizationInvoices";
    current?: {
      __typename?: "Invoice";
      amount?: number | null;
      products?: Array<string | null> | null;
      quantity?: number | null;
      status?: InvoiceStatus | null;
      createdAt?: string | null;
      finalizedAt?: string | null;
      invoicePdf?: string | null;
      hostedInvoiceUrl?: string | null;
      package?: OrganizationTariff | null;
      card?: {
        __typename?: "Card";
        brand?: string | null;
        expMonth?: number | null;
        expYear?: number | null;
        last4?: string | null;
      } | null;
    } | null;
    last?: {
      __typename?: "Invoice";
      amount?: number | null;
      products?: Array<string | null> | null;
      quantity?: number | null;
      status?: InvoiceStatus | null;
      createdAt?: string | null;
      finalizedAt?: string | null;
      invoicePdf?: string | null;
      hostedInvoiceUrl?: string | null;
      package?: OrganizationTariff | null;
      card?: {
        __typename?: "Card";
        brand?: string | null;
        expMonth?: number | null;
        expYear?: number | null;
        last4?: string | null;
      } | null;
    } | null;
    total?: {
      __typename?: "Invoice";
      amount?: number | null;
      products?: Array<string | null> | null;
      quantity?: number | null;
      status?: InvoiceStatus | null;
      createdAt?: string | null;
      finalizedAt?: string | null;
      invoicePdf?: string | null;
      hostedInvoiceUrl?: string | null;
      package?: OrganizationTariff | null;
      card?: {
        __typename?: "Card";
        brand?: string | null;
        expMonth?: number | null;
        expYear?: number | null;
        last4?: string | null;
      } | null;
    } | null;
  } | null;
};

export type CoreClientTodoFieldsFragment = {
  __typename?: "ClientTodoTasksOutput";
  id: string;
  text?: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  deadline?: string | null;
  isDone: boolean;
  operatorId?: string | null;
};

export type CoreInquiryFieldsFragment = {
  __typename?: "InquiryOutput";
  id?: string | null;
  createdAt?: string | null;
  clientId?: string | null;
  channelIdSource?: string | null;
  channelId?: string | null;
  leadSource?: string | null;
  vehicle?: string | null;
};

export type CoreNotificationsFieldsFragment = {
  __typename?: "NotificationOutput";
  subtype: NotificationSubtype;
  createdAt: string;
  title: string;
  body: string;
  metadata?: string | null;
  isRead?: boolean | null;
  id: string;
};

export type CoreGeneralAnalyticsFieldsFragment = {
  __typename?: "GeneralAnalyticsOutput";
  totalContacts: number;
  totalChats: number;
  nonAcceptedChats: number;
  calendarAppointments: {
    __typename?: "AppointmentsDistribution";
    labels: Array<AnalyticsAppointmentsDistributionLabels>;
    series: Array<number>;
  };
  leadsByMarketplace: {
    __typename?: "DataByLabelsType";
    labels: Array<string | null>;
    series: Array<number | null>;
  };
  chatsByChannels: {
    __typename?: "DataByChannelType";
    labels: Array<string | null>;
    series: {
      __typename?: "SeriesByChannelType";
      EMAIL?: Array<number | null> | null;
      SMS?: Array<number | null> | null;
    };
  };
  appointmentsNonWorking: {
    __typename?: "DataByLabelsType";
    labels: Array<string | null>;
    series: Array<number | null>;
  };
  leadsNonWorking: {
    __typename?: "DataByLabelsType";
    labels: Array<string | null>;
    series: Array<number | null>;
  };
};

export type CoreChatsAnalyticsFieldsFragment = {
  __typename?: "ChatsAnalyticsOutput";
  invisibleChats: number;
  nonAcceptedChats: number;
  nonRespondedChats: number;
  acceptedChats: number;
  calendarAppointments: {
    __typename?: "AppointmentsDistribution";
    labels: Array<AnalyticsAppointmentsDistributionLabels>;
    series: Array<number>;
  };
  newChats7d: {
    __typename?: "LineChart";
    series: Array<{
      __typename?: "LineChartSeries";
      name: ChannelType;
      data: Array<number>;
    } | null>;
    xAxis: {
      __typename?: "LineChartXAxisCategories";
      categories: Array<string | null>;
    };
  };
};

export type CoreOperatorsAnalyticsFieldsFragment = {
  __typename?: "OperatorsAnalyticsOutput";
  avgChatsPerOperatorPerDay: number;
  avgAcceptedToFirstMessage: number;
  avgAccepted: number;
  acceptedByOperatorsByPeriodMap: Array<{
    __typename?: "AnalyticsHeatMapSeriesItem";
    name: string;
    data: Array<{
      __typename?: "AnalyticsHeatMapSeriesDataItem";
      x: string;
      y: number;
    } | null>;
  } | null>;
  operatorsMetricsTable: Array<{
    __typename?: "AnalyticsOperatorsMetricsTableRow";
    operatorName: string;
    completedChats: number;
    avgFirstMessageSec: number;
    avgAcceptedSec: number;
  } | null>;
};

export type CoreTariffFieldsFragment = {
  __typename?: "TariffOutput";
  id: string;
  name: string;
  description?: string | null;
  products?: Array<{
    __typename?: "Product";
    name: string;
    description?: string | null;
    price?: number | null;
  } | null> | null;
};

export type CoreInventoryDetailsFieldsFragment = {
  __typename?: "GetInventoryDetailsOutput";
  id: string;
  carfaxLink?: string | null;
  imageLink?: string | null;
  additionalEquipments?: string | null;
  isSold?: boolean | null;
  status?: InventoryStatus | null;
};

export type CoreMailingRecordFieldsFragment = {
  __typename?: "MailingRecordOutput";
  roomId: string;
  leadId?: number | null;
  sendAt?: string | null;
  actionType?: MailingActionType | null;
  deletedAt?: string | null;
  deleterName?: string | null;
  transferTo?: MailingTransferEnum | null;
};

export type MakeOrganizationMutationVariables = Exact<{
  input?: InputMaybe<MakeOrganizationInput>;
}>;

export type MakeOrganizationMutation = {
  __typename?: "Mutation";
  makeOrganization?: {
    __typename?: "Organization";
    id: string;
    parentOID?: string | null;
    name: string;
    phone?: string | null;
    email?: string | null;
    tariffId?: string | null;
    newTariffId?: string | null;
    country?: string | null;
    timezone?: string | null;
    language?: OrganizationLanguage | null;
    activeMembersCount?: number | null;
    membersCount?: number | null;
    imageUrl?: string | null;
    address?: string | null;
    contactName?: string | null;
    contactCell?: string | null;
    stateDealerNumber?: string | null;
    website?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    isPendingDeletion?: boolean | null;
    isStale?: boolean | null;
    daysUntilStale?: number | null;
    isCurrent: boolean;
    rid: string;
    onboardStatus?: OnboardStatus | null;
    status: OrganizationStatus;
    isTrial?: boolean | null;
    isCanceled?: boolean | null;
    isPaymentFailed?: boolean | null;
    managerName?: string | null;
    managerPhone?: string | null;
    deletedAt?: string | null;
    trialFinishAt?: string | null;
    dealershipType?: DealershipType | null;
    vautoDealerId?: string | null;
    invoices?: {
      __typename?: "OrganizationInvoices";
      current?: {
        __typename?: "Invoice";
        amount?: number | null;
        products?: Array<string | null> | null;
        quantity?: number | null;
        status?: InvoiceStatus | null;
        createdAt?: string | null;
        finalizedAt?: string | null;
        invoicePdf?: string | null;
        hostedInvoiceUrl?: string | null;
        package?: OrganizationTariff | null;
        card?: {
          __typename?: "Card";
          brand?: string | null;
          expMonth?: number | null;
          expYear?: number | null;
          last4?: string | null;
        } | null;
      } | null;
      last?: {
        __typename?: "Invoice";
        amount?: number | null;
        products?: Array<string | null> | null;
        quantity?: number | null;
        status?: InvoiceStatus | null;
        createdAt?: string | null;
        finalizedAt?: string | null;
        invoicePdf?: string | null;
        hostedInvoiceUrl?: string | null;
        package?: OrganizationTariff | null;
        card?: {
          __typename?: "Card";
          brand?: string | null;
          expMonth?: number | null;
          expYear?: number | null;
          last4?: string | null;
        } | null;
      } | null;
      total?: {
        __typename?: "Invoice";
        amount?: number | null;
        products?: Array<string | null> | null;
        quantity?: number | null;
        status?: InvoiceStatus | null;
        createdAt?: string | null;
        finalizedAt?: string | null;
        invoicePdf?: string | null;
        hostedInvoiceUrl?: string | null;
        package?: OrganizationTariff | null;
        card?: {
          __typename?: "Card";
          brand?: string | null;
          expMonth?: number | null;
          expYear?: number | null;
          last4?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type MakeUserMutationVariables = Exact<{
  input?: InputMaybe<MakeUserInput>;
}>;

export type MakeUserMutation = {
  __typename?: "Mutation";
  makeUser?: {
    __typename?: "UserOutput";
    id: string;
    roleId?: string | null;
    isRoot?: boolean | null;
    optionalName: string;
    thirdParty?: string | null;
    position?: string | null;
    whatsappUsername?: string | null;
    whatsappProfile?: string | null;
    telegramUsername?: string | null;
    telegramUserId?: string | null;
    facebookMessengerPsid?: string | null;
    vkUserId?: string | null;
    instagramBsid?: string | null;
    instagramProfile?: string | null;
    twilioSmsUserId?: string | null;
    nylasUserEmail?: string | null;
    mailgunUserEmail?: string | null;
    sendgridUserEmail?: string | null;
    lastTicketAt?: string | null;
    common?: {
      __typename?: "CommonUserFields";
      createdAt?: string | null;
      autoNickname?: string | null;
      userpicUrl?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
    } | null;
    onlineStatus?: {
      __typename?: "UserPresenceStatusOutput";
      userId?: string | null;
      presenceStatus?: PresenceStatus | null;
    } | null;
    teams?: Array<{
      __typename?: "TeamOutput";
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
    } | null> | null;
    role?: {
      __typename?: "RoleOutput";
      roleDescription?: string | null;
      roleId?: string | null;
      rolePublicName?: string | null;
      roleTechnicalName?: string | null;
    } | null;
    roomsLinks?: Array<{
      __typename?: "RoomLinkOutput";
      roomId?: string | null;
      roomStatus?: RoomStatus | null;
      channelType?: ChannelType | null;
      lastTicketAt?: string | null;
      vehicle?: string | null;
    } | null> | null;
    customFields?: Array<{
      __typename?: "UserCustomFieldOutput";
      fieldId: string;
      fieldName: string;
      dataType: CustomFieldDataType;
      description?: string | null;
      fieldOrder: number;
      value: string;
    } | null> | null;
  } | null;
};

export type MakeChannel2MutationVariables = Exact<{
  input: MakeChannel2Input;
}>;

export type MakeChannel2Mutation = {
  __typename?: "Mutation";
  makeChannel2?: {
    __typename?: "ChannelOutput2";
    id: string;
    publicId: string;
    name: string;
    link: string;
    type: ChannelType;
    status: ChannelStatus;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    bot?: { __typename?: "BotOutput"; id: string; name?: string | null } | null;
  } | null;
};

export type MakeBotMutationVariables = Exact<{
  input?: InputMaybe<MakeBotInput>;
}>;

export type MakeBotMutation = {
  __typename?: "Mutation";
  makeBot?: {
    __typename?: "BotOutput";
    isActive?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    status?: BotStatus | null;
    sessionsCount?: number | null;
    botType?: BotType | null;
    teamsIds?: Array<string | null> | null;
    id: string;
    name?: string | null;
    connectedChannels?: Array<{
      __typename?: "ChannelOutput2";
      id: string;
      publicId: string;
      name: string;
      link: string;
      type: ChannelType;
      status: ChannelStatus;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      bot?: {
        __typename?: "BotOutput";
        id: string;
        name?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type MakeFlowMutationVariables = Exact<{
  input?: InputMaybe<MakeFlowInput>;
}>;

export type MakeFlowMutation = {
  __typename?: "Mutation";
  makeFlow?: {
    __typename?: "FlowOutput";
    id?: string | null;
    botId?: string | null;
    name?: string | null;
    createdAt?: string | null;
    isMain?: boolean | null;
    updatedAt?: string | null;
  } | null;
};

export type DuplicateBotMutationVariables = Exact<{
  id: Scalars["String"];
  newName?: InputMaybe<Scalars["String"]>;
}>;

export type DuplicateBotMutation = {
  __typename?: "Mutation";
  duplicateBot?: {
    __typename?: "BotOutput";
    isActive?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    status?: BotStatus | null;
    sessionsCount?: number | null;
    botType?: BotType | null;
    teamsIds?: Array<string | null> | null;
    id: string;
    name?: string | null;
    connectedChannels?: Array<{
      __typename?: "ChannelOutput2";
      id: string;
      publicId: string;
      name: string;
      link: string;
      type: ChannelType;
      status: ChannelStatus;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      bot?: {
        __typename?: "BotOutput";
        id: string;
        name?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type MakeRooms2MutationVariables = Exact<{
  input?: InputMaybe<MakeRooms2Input>;
}>;

export type MakeRooms2Mutation = {
  __typename?: "Mutation";
  makeRooms2?: {
    __typename?: "MakeRooms2Output";
    error?: string | null;
    rooms?: Array<{
      __typename?: "RoomOutput2";
      id: string;
      leadId: number;
      status: RoomStatus;
      previousStatus?: RoomStatus | null;
      teamsIds: Array<string | null>;
      previousTeamsIds?: Array<string | null> | null;
      lastMessageAt?: string | null;
      lastClientMessageAt?: string | null;
      lastTicketAt?: string | null;
      unreadMessagesNumber: number;
      createdAt?: string | null;
      vehicle?: string | null;
      langCode?: LanguageCode_Iso_639_1 | null;
      currentLangCode?: LanguageCode_Iso_639_1 | null;
      isExpired: boolean;
      nonAcceptedTrigger?: NonAcceptedTriggers | null;
      channel: {
        __typename?: "ChannelOutput2";
        id: string;
        publicId: string;
        name: string;
        link: string;
        type: ChannelType;
        status: ChannelStatus;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        bot?: {
          __typename?: "BotOutput";
          id: string;
          name?: string | null;
        } | null;
      };
      client: {
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        whatsappUsername?: string | null;
        whatsappProfile?: string | null;
        telegramUsername?: string | null;
        telegramUserId?: string | null;
        facebookMessengerPsid?: string | null;
        vkUserId?: string | null;
        instagramBsid?: string | null;
        instagramProfile?: string | null;
        thirdParty?: string | null;
        twilioSmsUserId?: string | null;
        nylasUserEmail?: string | null;
        mailgunUserEmail?: string | null;
        sendgridUserEmail?: string | null;
        lastTicketAt?: string | null;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
        roomsLinks?: Array<{
          __typename?: "RoomLinkOutput";
          roomId?: string | null;
          roomStatus?: RoomStatus | null;
          channelType?: ChannelType | null;
          lastTicketAt?: string | null;
          vehicle?: string | null;
        } | null> | null;
        customFields?: Array<{
          __typename?: "UserCustomFieldOutput";
          fieldId: string;
          fieldName: string;
          dataType: CustomFieldDataType;
          description?: string | null;
          fieldOrder: number;
          value: string;
        } | null> | null;
      };
      activeOperator?: {
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        thirdParty?: string | null;
        position?: string | null;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
        onlineStatus?: {
          __typename?: "UserPresenceStatusOutput";
          userId?: string | null;
          presenceStatus?: PresenceStatus | null;
        } | null;
        teams?: Array<{
          __typename?: "TeamOutput";
          id: string;
          name: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
        } | null> | null;
        role?: {
          __typename?: "RoleOutput";
          roleDescription?: string | null;
          roleId?: string | null;
          rolePublicName?: string | null;
          roleTechnicalName?: string | null;
        } | null;
      } | null;
      operators: Array<{
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        thirdParty?: string | null;
        position?: string | null;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
        onlineStatus?: {
          __typename?: "UserPresenceStatusOutput";
          userId?: string | null;
          presenceStatus?: PresenceStatus | null;
        } | null;
        teams?: Array<{
          __typename?: "TeamOutput";
          id: string;
          name: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
        } | null> | null;
        role?: {
          __typename?: "RoleOutput";
          roleDescription?: string | null;
          roleId?: string | null;
          rolePublicName?: string | null;
          roleTechnicalName?: string | null;
        } | null;
      } | null>;
      lastMessageContent?: {
        __typename?: "LastMessageContentOutput";
        messageText?: string | null;
        messageContent?: Array<{
          __typename?: "MessageContentItemOutput";
          category?: string | null;
          fileExtension?: string | null;
          mimeType?: string | null;
          url?: string | null;
          fileName?: string | null;
          fileSize?: number | null;
          dimensions?: {
            __typename?: "MessageContentImageDimension";
            width: number;
            height: number;
          } | null;
        } | null> | null;
      } | null;
      linkedRooms: Array<{
        __typename?: "LinkedRoomOutput";
        id: string;
        lastMessageAt?: string | null;
        lastClientMessageAt?: string | null;
        lastTicketAt?: string | null;
        langCode?: LanguageCode_Iso_639_1 | null;
        unreadMessagesNumber: number;
        createdAt?: string | null;
        hasClientMessage: boolean;
        channel: {
          __typename?: "ChannelOutput2";
          id: string;
          publicId: string;
          name: string;
          link: string;
          type: ChannelType;
          status: ChannelStatus;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          bot?: {
            __typename?: "BotOutput";
            id: string;
            name?: string | null;
          } | null;
        };
        lastMessageContent?: {
          __typename?: "LastMessageContentOutput";
          messageText?: string | null;
          messageContent?: Array<{
            __typename?: "MessageContentItemOutput";
            category?: string | null;
            fileExtension?: string | null;
            mimeType?: string | null;
            url?: string | null;
            fileName?: string | null;
            fileSize?: number | null;
            dimensions?: {
              __typename?: "MessageContentImageDimension";
              width: number;
              height: number;
            } | null;
          } | null> | null;
        } | null;
      }>;
    } | null> | null;
  } | null;
};

export type UpdateMessageDataMutationVariables = Exact<{
  input?: InputMaybe<UpdateMessageDataInput>;
}>;

export type UpdateMessageDataMutation = {
  __typename?: "Mutation";
  updateMessageData?: {
    __typename?: "UpdateMessageDataOutput";
    channelId?: string | null;
    channelTypeName?: ChannelType | null;
    chatRoomId?: string | null;
    chatRoomStatus?: string | null;
    isClient?: boolean | null;
    unreadMessagesNumber?: number | null;
    chatRoomMessages?: Array<{
      __typename?: "MessageOutput";
      channelId?: string | null;
      channelTypeName?: ChannelType | null;
      chatRoomId?: string | null;
      chatRoomStatus?: string | null;
      messageAuthorId?: string | null;
      messageChannelId?: string | null;
      messageContent?: string | null;
      messageMetadata?: string | null;
      messageCreatedDateTime?: string | null;
      messageDeletedDateTime?: string | null;
      messageId?: string | null;
      messageIsDelivered?: boolean | null;
      messageIsRead?: boolean | null;
      messageIsSent?: boolean | null;
      messageText?: string | null;
      messageUpdatedDateTime?: string | null;
      textLangCode?: LanguageCode_Iso_639_1 | null;
      translatedText?: string | null;
      translatedTextLangCode?: LanguageCode_Iso_639_1 | null;
      localMessageId?: string | null;
      isFromClient: boolean;
      isFromBot: boolean;
    } | null> | null;
  } | null;
};

export type CreateMessageMutationVariables = Exact<{
  input?: InputMaybe<CreateChatRoomMessageInput>;
}>;

export type CreateMessageMutation = {
  __typename?: "Mutation";
  createMessage?: {
    __typename?: "MessageOutput";
    channelId?: string | null;
    channelTypeName?: ChannelType | null;
    chatRoomId?: string | null;
    chatRoomStatus?: string | null;
    messageAuthorId?: string | null;
    messageChannelId?: string | null;
    messageContent?: string | null;
    messageMetadata?: string | null;
    messageCreatedDateTime?: string | null;
    messageDeletedDateTime?: string | null;
    messageId?: string | null;
    messageIsDelivered?: boolean | null;
    messageIsRead?: boolean | null;
    messageIsSent?: boolean | null;
    messageText?: string | null;
    messageUpdatedDateTime?: string | null;
    textLangCode?: LanguageCode_Iso_639_1 | null;
    translatedText?: string | null;
    translatedTextLangCode?: LanguageCode_Iso_639_1 | null;
    localMessageId?: string | null;
    isFromClient: boolean;
    isFromBot: boolean;
  } | null;
};

export type CreateCommentOnClient2MutationVariables = Exact<{
  input?: InputMaybe<CreateCommentOnClientInput>;
}>;

export type CreateCommentOnClient2Mutation = {
  __typename?: "Mutation";
  createCommentOnClient2?: {
    __typename?: "CommentOutput2";
    comment?: string | null;
    commentId?: string | null;
    createdAt?: string | null;
    clientId?: string | null;
    operator?: {
      __typename?: "UserOutput";
      id: string;
      roleId?: string | null;
      isRoot?: boolean | null;
      optionalName: string;
      common?: {
        __typename?: "CommonUserFields";
        createdAt?: string | null;
        autoNickname?: string | null;
        userpicUrl?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
      } | null;
    } | null;
  } | null;
};

export type DeleteCommentMutationVariables = Exact<{
  commentId: Scalars["String"];
}>;

export type DeleteCommentMutation = {
  __typename?: "Mutation";
  deleteComment?: {
    __typename?: "ResponseStatus";
    status?: string | null;
  } | null;
};

export type SetNodesAndEdgesMutationVariables = Exact<{
  input?: InputMaybe<SetNodesAndEdgesInput>;
}>;

export type SetNodesAndEdgesMutation = {
  __typename?: "Mutation";
  setNodesAndEdges?: {
    __typename?: "SetNodesAndEdgesOutput";
    nodes?: Array<{
      __typename?: "NodeOutput";
      id?: string | null;
      localId?: string | null;
      flowId?: string | null;
      coordinates?: Array<number | null> | null;
      nodeType?: NodeType | null;
      fileUrl?: string | null;
      imageUrl?: string | null;
      text?: string | null;
      childFlowId?: string | null;
      isDelete?: boolean | null;
      teamsIds?: Array<string | null> | null;
      botId?: string | null;
      exceptionText?: string | null;
      saveTo?: SaveTo | null;
      appId?: string | null;
      appVersionId?: string | null;
      appInstalledId?: string | null;
      buttons?: Array<{
        __typename?: "ButtonOutput";
        id?: string | null;
        localId?: string | null;
        name?: string | null;
        nodeId?: string | null;
        localNodeId?: string | null;
        buttonOrder?: number | null;
        botId?: string | null;
      } | null> | null;
    } | null> | null;
    edges?: Array<{
      __typename?: "EdgeOutput";
      id?: string | null;
      localId?: string | null;
      botId?: string | null;
      flowId?: string | null;
      childId?: string | null;
      localChildId?: string | null;
      parentId?: string | null;
      localParentId?: string | null;
      handleParentId?: string | null;
      localHandleParentId?: string | null;
      isDelete?: boolean | null;
    } | null> | null;
  } | null;
};

export type CreateChatSnippetMutationVariables = Exact<{
  userId: Scalars["String"];
  snippet: Scalars["String"];
  categoryId?: InputMaybe<Scalars["String"]>;
  teamsIds?: InputMaybe<Array<Scalars["String"]> | Scalars["String"]>;
}>;

export type CreateChatSnippetMutation = {
  __typename?: "Mutation";
  createChatSnippet?: {
    __typename?: "ChatSnippetsOutput";
    snippetId?: string | null;
    userId?: string | null;
    categoryId?: string | null;
    snippet?: string | null;
    teamsIds?: Array<string | null> | null;
    isFavorite: boolean;
  } | null;
};

export type UpdateChatSnippetMutationVariables = Exact<{
  snippetId: Scalars["String"];
  userId: Scalars["String"];
  snippet?: InputMaybe<Scalars["String"]>;
  categoryId?: InputMaybe<Scalars["String"]>;
  teamsIds?: InputMaybe<Array<Scalars["String"]> | Scalars["String"]>;
}>;

export type UpdateChatSnippetMutation = {
  __typename?: "Mutation";
  updateChatSnippet?: {
    __typename?: "ChatSnippetsOutput";
    snippetId?: string | null;
    userId?: string | null;
    categoryId?: string | null;
    snippet?: string | null;
    teamsIds?: Array<string | null> | null;
    isFavorite: boolean;
  } | null;
};

export type CreateChatSnippetsCategoryMutationVariables = Exact<{
  userId: Scalars["String"];
  categoryName: Scalars["String"];
  parentId?: InputMaybe<Scalars["String"]>;
}>;

export type CreateChatSnippetsCategoryMutation = {
  __typename?: "Mutation";
  createChatSnippetsCategory?: {
    __typename?: "ChatSnippetsCategoriesOutput";
    categoryId?: string | null;
    categoryName?: string | null;
    parentId?: string | null;
    userId?: string | null;
    totalSnippetsCount?: number | null;
  } | null;
};

export type UpdateChatSnippetsCategoryMutationVariables = Exact<{
  categoryId: Scalars["String"];
  userId: Scalars["String"];
  categoryName?: InputMaybe<Scalars["String"]>;
  parentId?: InputMaybe<Scalars["String"]>;
}>;

export type UpdateChatSnippetsCategoryMutation = {
  __typename?: "Mutation";
  updateChatSnippetsCategory?: {
    __typename?: "ChatSnippetsCategoriesOutput";
    categoryId?: string | null;
    categoryName?: string | null;
    parentId?: string | null;
    userId?: string | null;
    totalSnippetsCount?: number | null;
  } | null;
};

export type DeleteChatSnippetsCategoryMutationVariables = Exact<{
  userId: Scalars["String"];
  categoryId: Scalars["String"];
}>;

export type DeleteChatSnippetsCategoryMutation = {
  __typename?: "Mutation";
  deleteChatSnippetsCategory?: {
    __typename?: "ChatSnippetsCategoriesOutput";
    categoryId?: string | null;
    categoryName?: string | null;
    parentId?: string | null;
    userId?: string | null;
    totalSnippetsCount?: number | null;
  } | null;
};

export type AddSnippetToFavoritesMutationVariables = Exact<{
  userId: Scalars["String"];
  snippetId: Scalars["String"];
}>;

export type AddSnippetToFavoritesMutation = {
  __typename?: "Mutation";
  addSnippetToFavorites?: {
    __typename?: "ChatSnippetsFavoritesOutput";
    snippetId?: string | null;
    userId?: string | null;
    isFavorite: boolean;
  } | null;
};

export type RemoveSnippetFromFavoriteMutationVariables = Exact<{
  userId: Scalars["String"];
  snippetId: Scalars["String"];
}>;

export type RemoveSnippetFromFavoriteMutation = {
  __typename?: "Mutation";
  removeSnippetFromFavorite?: {
    __typename?: "ChatSnippetsFavoritesOutput";
    snippetId?: string | null;
    userId?: string | null;
    isFavorite: boolean;
  } | null;
};

export type DeleteChatSnippetMutationVariables = Exact<{
  userId: Scalars["String"];
  snippetId: Scalars["String"];
}>;

export type DeleteChatSnippetMutation = {
  __typename?: "Mutation";
  deleteChatSnippet?: {
    __typename?: "ChatSnippetsOutput";
    snippetId?: string | null;
    userId?: string | null;
    categoryId?: string | null;
    snippet?: string | null;
    teamsIds?: Array<string | null> | null;
    isFavorite: boolean;
  } | null;
};

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;

export type CreateTeamMutation = {
  __typename?: "Mutation";
  createTeam?: {
    __typename?: "TeamOutput";
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    users?: Array<{
      __typename?: "UserOutput";
      id: string;
      roleId?: string | null;
      isRoot?: boolean | null;
      optionalName: string;
      thirdParty?: string | null;
      position?: string | null;
      common?: {
        __typename?: "CommonUserFields";
        createdAt?: string | null;
        autoNickname?: string | null;
        userpicUrl?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
      } | null;
      onlineStatus?: {
        __typename?: "UserPresenceStatusOutput";
        userId?: string | null;
        presenceStatus?: PresenceStatus | null;
      } | null;
      teams?: Array<{
        __typename?: "TeamOutput";
        id: string;
        name: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
      } | null> | null;
      role?: {
        __typename?: "RoleOutput";
        roleDescription?: string | null;
        roleId?: string | null;
        rolePublicName?: string | null;
        roleTechnicalName?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;

export type UpdateTeamMutation = {
  __typename?: "Mutation";
  updateTeam?: {
    __typename?: "TeamOutput";
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    users?: Array<{
      __typename?: "UserOutput";
      id: string;
      roleId?: string | null;
      isRoot?: boolean | null;
      optionalName: string;
      thirdParty?: string | null;
      position?: string | null;
      common?: {
        __typename?: "CommonUserFields";
        createdAt?: string | null;
        autoNickname?: string | null;
        userpicUrl?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
      } | null;
      onlineStatus?: {
        __typename?: "UserPresenceStatusOutput";
        userId?: string | null;
        presenceStatus?: PresenceStatus | null;
      } | null;
      teams?: Array<{
        __typename?: "TeamOutput";
        id: string;
        name: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
      } | null> | null;
      role?: {
        __typename?: "RoleOutput";
        roleDescription?: string | null;
        roleId?: string | null;
        rolePublicName?: string | null;
        roleTechnicalName?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type DeleteTeamMutationVariables = Exact<{
  teamId: Scalars["String"];
}>;

export type DeleteTeamMutation = {
  __typename?: "Mutation";
  deleteTeam?: { __typename?: "ResponseStatus"; status?: string | null } | null;
};

export type MakeAppsMutationVariables = Exact<{
  input?: InputMaybe<
    Array<InputMaybe<MakeAppsInput>> | InputMaybe<MakeAppsInput>
  >;
}>;

export type MakeAppsMutation = {
  __typename?: "Mutation";
  makeApps?: Array<{
    __typename?: "AppOutput";
    id: string;
    iconUrl: string;
    gallery?: string | null;
    type: AppType;
    tag: string;
    latestVersion: string;
    createdAt: string;
    isAvailable: boolean;
    isInstalled: boolean;
    name: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    };
    description?: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    } | null;
    instructions?: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    } | null;
    versions: Array<{
      __typename?: "AppVersion";
      version: string;
      createdAt: string;
      id: string;
      isInstalled: boolean;
      fields: Array<{
        __typename?: "AppFieldsGroup";
        g: AppFieldsGroupType;
        c: Array<{
          __typename?: "AppField";
          t: AppFieldTypeType;
          tg: string;
          dt?: AppFieldDataTypeType | null;
          dts?: Array<AppFieldDataTypesType> | null;
          r?: boolean | null;
          mn?: number | null;
          mx?: number | null;
          v?: string | null;
          n: {
            __typename?: "LanguageMap";
            en: string;
            ru?: string | null;
            af?: string | null;
            sq?: string | null;
            ar?: string | null;
            az?: string | null;
            bn?: string | null;
            bg?: string | null;
            ca?: string | null;
            zh?: string | null;
            hr?: string | null;
            cs?: string | null;
            da?: string | null;
            nl?: string | null;
            et?: string | null;
            fil?: string | null;
            fi?: string | null;
            fr?: string | null;
            ka?: string | null;
            de?: string | null;
            el?: string | null;
            gu?: string | null;
            ha?: string | null;
            he?: string | null;
            hi?: string | null;
            hu?: string | null;
            id?: string | null;
            ga?: string | null;
            it?: string | null;
            ja?: string | null;
            kn?: string | null;
            kk?: string | null;
            rw?: string | null;
            ko?: string | null;
            ky?: string | null;
            lo?: string | null;
            lv?: string | null;
            lt?: string | null;
            mk?: string | null;
            ms?: string | null;
            ml?: string | null;
            mr?: string | null;
            nb?: string | null;
            fa?: string | null;
            pl?: string | null;
            pt?: string | null;
            pa?: string | null;
            ro?: string | null;
            sr?: string | null;
            sk?: string | null;
            sl?: string | null;
            es?: string | null;
            sw?: string | null;
            sv?: string | null;
            ta?: string | null;
            te?: string | null;
            th?: string | null;
            tr?: string | null;
            uk?: string | null;
            ur?: string | null;
            uz?: string | null;
            vi?: string | null;
            zu?: string | null;
          };
          p?: {
            __typename?: "LanguageMap";
            en: string;
            ru?: string | null;
            af?: string | null;
            sq?: string | null;
            ar?: string | null;
            az?: string | null;
            bn?: string | null;
            bg?: string | null;
            ca?: string | null;
            zh?: string | null;
            hr?: string | null;
            cs?: string | null;
            da?: string | null;
            nl?: string | null;
            et?: string | null;
            fil?: string | null;
            fi?: string | null;
            fr?: string | null;
            ka?: string | null;
            de?: string | null;
            el?: string | null;
            gu?: string | null;
            ha?: string | null;
            he?: string | null;
            hi?: string | null;
            hu?: string | null;
            id?: string | null;
            ga?: string | null;
            it?: string | null;
            ja?: string | null;
            kn?: string | null;
            kk?: string | null;
            rw?: string | null;
            ko?: string | null;
            ky?: string | null;
            lo?: string | null;
            lv?: string | null;
            lt?: string | null;
            mk?: string | null;
            ms?: string | null;
            ml?: string | null;
            mr?: string | null;
            nb?: string | null;
            fa?: string | null;
            pl?: string | null;
            pt?: string | null;
            pa?: string | null;
            ro?: string | null;
            sr?: string | null;
            sk?: string | null;
            sl?: string | null;
            es?: string | null;
            sw?: string | null;
            sv?: string | null;
            ta?: string | null;
            te?: string | null;
            th?: string | null;
            tr?: string | null;
            uk?: string | null;
            ur?: string | null;
            uz?: string | null;
            vi?: string | null;
            zu?: string | null;
          } | null;
          d?: {
            __typename?: "LanguageMap";
            en: string;
            ru?: string | null;
            af?: string | null;
            sq?: string | null;
            ar?: string | null;
            az?: string | null;
            bn?: string | null;
            bg?: string | null;
            ca?: string | null;
            zh?: string | null;
            hr?: string | null;
            cs?: string | null;
            da?: string | null;
            nl?: string | null;
            et?: string | null;
            fil?: string | null;
            fi?: string | null;
            fr?: string | null;
            ka?: string | null;
            de?: string | null;
            el?: string | null;
            gu?: string | null;
            ha?: string | null;
            he?: string | null;
            hi?: string | null;
            hu?: string | null;
            id?: string | null;
            ga?: string | null;
            it?: string | null;
            ja?: string | null;
            kn?: string | null;
            kk?: string | null;
            rw?: string | null;
            ko?: string | null;
            ky?: string | null;
            lo?: string | null;
            lv?: string | null;
            lt?: string | null;
            mk?: string | null;
            ms?: string | null;
            ml?: string | null;
            mr?: string | null;
            nb?: string | null;
            fa?: string | null;
            pl?: string | null;
            pt?: string | null;
            pa?: string | null;
            ro?: string | null;
            sr?: string | null;
            sk?: string | null;
            sl?: string | null;
            es?: string | null;
            sw?: string | null;
            sv?: string | null;
            ta?: string | null;
            te?: string | null;
            th?: string | null;
            tr?: string | null;
            uk?: string | null;
            ur?: string | null;
            uz?: string | null;
            vi?: string | null;
            zu?: string | null;
          } | null;
          c?: Array<
            | {
                __typename?: "AppFieldInner";
                t: AppFieldTypeType;
                tg: string;
                dt?: AppFieldDataTypeType | null;
                dts?: Array<AppFieldDataTypesType> | null;
                r?: boolean | null;
                mn?: number | null;
                mx?: number | null;
                v?: string | null;
                n: {
                  __typename?: "LanguageMap";
                  en: string;
                  ru?: string | null;
                  af?: string | null;
                  sq?: string | null;
                  ar?: string | null;
                  az?: string | null;
                  bn?: string | null;
                  bg?: string | null;
                  ca?: string | null;
                  zh?: string | null;
                  hr?: string | null;
                  cs?: string | null;
                  da?: string | null;
                  nl?: string | null;
                  et?: string | null;
                  fil?: string | null;
                  fi?: string | null;
                  fr?: string | null;
                  ka?: string | null;
                  de?: string | null;
                  el?: string | null;
                  gu?: string | null;
                  ha?: string | null;
                  he?: string | null;
                  hi?: string | null;
                  hu?: string | null;
                  id?: string | null;
                  ga?: string | null;
                  it?: string | null;
                  ja?: string | null;
                  kn?: string | null;
                  kk?: string | null;
                  rw?: string | null;
                  ko?: string | null;
                  ky?: string | null;
                  lo?: string | null;
                  lv?: string | null;
                  lt?: string | null;
                  mk?: string | null;
                  ms?: string | null;
                  ml?: string | null;
                  mr?: string | null;
                  nb?: string | null;
                  fa?: string | null;
                  pl?: string | null;
                  pt?: string | null;
                  pa?: string | null;
                  ro?: string | null;
                  sr?: string | null;
                  sk?: string | null;
                  sl?: string | null;
                  es?: string | null;
                  sw?: string | null;
                  sv?: string | null;
                  ta?: string | null;
                  te?: string | null;
                  th?: string | null;
                  tr?: string | null;
                  uk?: string | null;
                  ur?: string | null;
                  uz?: string | null;
                  vi?: string | null;
                  zu?: string | null;
                };
                p?: {
                  __typename?: "LanguageMap";
                  en: string;
                  ru?: string | null;
                  af?: string | null;
                  sq?: string | null;
                  ar?: string | null;
                  az?: string | null;
                  bn?: string | null;
                  bg?: string | null;
                  ca?: string | null;
                  zh?: string | null;
                  hr?: string | null;
                  cs?: string | null;
                  da?: string | null;
                  nl?: string | null;
                  et?: string | null;
                  fil?: string | null;
                  fi?: string | null;
                  fr?: string | null;
                  ka?: string | null;
                  de?: string | null;
                  el?: string | null;
                  gu?: string | null;
                  ha?: string | null;
                  he?: string | null;
                  hi?: string | null;
                  hu?: string | null;
                  id?: string | null;
                  ga?: string | null;
                  it?: string | null;
                  ja?: string | null;
                  kn?: string | null;
                  kk?: string | null;
                  rw?: string | null;
                  ko?: string | null;
                  ky?: string | null;
                  lo?: string | null;
                  lv?: string | null;
                  lt?: string | null;
                  mk?: string | null;
                  ms?: string | null;
                  ml?: string | null;
                  mr?: string | null;
                  nb?: string | null;
                  fa?: string | null;
                  pl?: string | null;
                  pt?: string | null;
                  pa?: string | null;
                  ro?: string | null;
                  sr?: string | null;
                  sk?: string | null;
                  sl?: string | null;
                  es?: string | null;
                  sw?: string | null;
                  sv?: string | null;
                  ta?: string | null;
                  te?: string | null;
                  th?: string | null;
                  tr?: string | null;
                  uk?: string | null;
                  ur?: string | null;
                  uz?: string | null;
                  vi?: string | null;
                  zu?: string | null;
                } | null;
                d?: {
                  __typename?: "LanguageMap";
                  en: string;
                  ru?: string | null;
                  af?: string | null;
                  sq?: string | null;
                  ar?: string | null;
                  az?: string | null;
                  bn?: string | null;
                  bg?: string | null;
                  ca?: string | null;
                  zh?: string | null;
                  hr?: string | null;
                  cs?: string | null;
                  da?: string | null;
                  nl?: string | null;
                  et?: string | null;
                  fil?: string | null;
                  fi?: string | null;
                  fr?: string | null;
                  ka?: string | null;
                  de?: string | null;
                  el?: string | null;
                  gu?: string | null;
                  ha?: string | null;
                  he?: string | null;
                  hi?: string | null;
                  hu?: string | null;
                  id?: string | null;
                  ga?: string | null;
                  it?: string | null;
                  ja?: string | null;
                  kn?: string | null;
                  kk?: string | null;
                  rw?: string | null;
                  ko?: string | null;
                  ky?: string | null;
                  lo?: string | null;
                  lv?: string | null;
                  lt?: string | null;
                  mk?: string | null;
                  ms?: string | null;
                  ml?: string | null;
                  mr?: string | null;
                  nb?: string | null;
                  fa?: string | null;
                  pl?: string | null;
                  pt?: string | null;
                  pa?: string | null;
                  ro?: string | null;
                  sr?: string | null;
                  sk?: string | null;
                  sl?: string | null;
                  es?: string | null;
                  sw?: string | null;
                  sv?: string | null;
                  ta?: string | null;
                  te?: string | null;
                  th?: string | null;
                  tr?: string | null;
                  uk?: string | null;
                  ur?: string | null;
                  uz?: string | null;
                  vi?: string | null;
                  zu?: string | null;
                } | null;
              }
            | {
                __typename?: "AppFieldsGroupInner";
                g: AppFieldsGroupType;
                c: Array<{
                  __typename?: "AppFieldInner";
                  t: AppFieldTypeType;
                  tg: string;
                  dt?: AppFieldDataTypeType | null;
                  dts?: Array<AppFieldDataTypesType> | null;
                  r?: boolean | null;
                  mn?: number | null;
                  mx?: number | null;
                  v?: string | null;
                  n: {
                    __typename?: "LanguageMap";
                    en: string;
                    ru?: string | null;
                    af?: string | null;
                    sq?: string | null;
                    ar?: string | null;
                    az?: string | null;
                    bn?: string | null;
                    bg?: string | null;
                    ca?: string | null;
                    zh?: string | null;
                    hr?: string | null;
                    cs?: string | null;
                    da?: string | null;
                    nl?: string | null;
                    et?: string | null;
                    fil?: string | null;
                    fi?: string | null;
                    fr?: string | null;
                    ka?: string | null;
                    de?: string | null;
                    el?: string | null;
                    gu?: string | null;
                    ha?: string | null;
                    he?: string | null;
                    hi?: string | null;
                    hu?: string | null;
                    id?: string | null;
                    ga?: string | null;
                    it?: string | null;
                    ja?: string | null;
                    kn?: string | null;
                    kk?: string | null;
                    rw?: string | null;
                    ko?: string | null;
                    ky?: string | null;
                    lo?: string | null;
                    lv?: string | null;
                    lt?: string | null;
                    mk?: string | null;
                    ms?: string | null;
                    ml?: string | null;
                    mr?: string | null;
                    nb?: string | null;
                    fa?: string | null;
                    pl?: string | null;
                    pt?: string | null;
                    pa?: string | null;
                    ro?: string | null;
                    sr?: string | null;
                    sk?: string | null;
                    sl?: string | null;
                    es?: string | null;
                    sw?: string | null;
                    sv?: string | null;
                    ta?: string | null;
                    te?: string | null;
                    th?: string | null;
                    tr?: string | null;
                    uk?: string | null;
                    ur?: string | null;
                    uz?: string | null;
                    vi?: string | null;
                    zu?: string | null;
                  };
                  p?: {
                    __typename?: "LanguageMap";
                    en: string;
                    ru?: string | null;
                    af?: string | null;
                    sq?: string | null;
                    ar?: string | null;
                    az?: string | null;
                    bn?: string | null;
                    bg?: string | null;
                    ca?: string | null;
                    zh?: string | null;
                    hr?: string | null;
                    cs?: string | null;
                    da?: string | null;
                    nl?: string | null;
                    et?: string | null;
                    fil?: string | null;
                    fi?: string | null;
                    fr?: string | null;
                    ka?: string | null;
                    de?: string | null;
                    el?: string | null;
                    gu?: string | null;
                    ha?: string | null;
                    he?: string | null;
                    hi?: string | null;
                    hu?: string | null;
                    id?: string | null;
                    ga?: string | null;
                    it?: string | null;
                    ja?: string | null;
                    kn?: string | null;
                    kk?: string | null;
                    rw?: string | null;
                    ko?: string | null;
                    ky?: string | null;
                    lo?: string | null;
                    lv?: string | null;
                    lt?: string | null;
                    mk?: string | null;
                    ms?: string | null;
                    ml?: string | null;
                    mr?: string | null;
                    nb?: string | null;
                    fa?: string | null;
                    pl?: string | null;
                    pt?: string | null;
                    pa?: string | null;
                    ro?: string | null;
                    sr?: string | null;
                    sk?: string | null;
                    sl?: string | null;
                    es?: string | null;
                    sw?: string | null;
                    sv?: string | null;
                    ta?: string | null;
                    te?: string | null;
                    th?: string | null;
                    tr?: string | null;
                    uk?: string | null;
                    ur?: string | null;
                    uz?: string | null;
                    vi?: string | null;
                    zu?: string | null;
                  } | null;
                  d?: {
                    __typename?: "LanguageMap";
                    en: string;
                    ru?: string | null;
                    af?: string | null;
                    sq?: string | null;
                    ar?: string | null;
                    az?: string | null;
                    bn?: string | null;
                    bg?: string | null;
                    ca?: string | null;
                    zh?: string | null;
                    hr?: string | null;
                    cs?: string | null;
                    da?: string | null;
                    nl?: string | null;
                    et?: string | null;
                    fil?: string | null;
                    fi?: string | null;
                    fr?: string | null;
                    ka?: string | null;
                    de?: string | null;
                    el?: string | null;
                    gu?: string | null;
                    ha?: string | null;
                    he?: string | null;
                    hi?: string | null;
                    hu?: string | null;
                    id?: string | null;
                    ga?: string | null;
                    it?: string | null;
                    ja?: string | null;
                    kn?: string | null;
                    kk?: string | null;
                    rw?: string | null;
                    ko?: string | null;
                    ky?: string | null;
                    lo?: string | null;
                    lv?: string | null;
                    lt?: string | null;
                    mk?: string | null;
                    ms?: string | null;
                    ml?: string | null;
                    mr?: string | null;
                    nb?: string | null;
                    fa?: string | null;
                    pl?: string | null;
                    pt?: string | null;
                    pa?: string | null;
                    ro?: string | null;
                    sr?: string | null;
                    sk?: string | null;
                    sl?: string | null;
                    es?: string | null;
                    sw?: string | null;
                    sv?: string | null;
                    ta?: string | null;
                    te?: string | null;
                    th?: string | null;
                    tr?: string | null;
                    uk?: string | null;
                    ur?: string | null;
                    uz?: string | null;
                    vi?: string | null;
                    zu?: string | null;
                  } | null;
                }>;
              }
          > | null;
        }>;
      } | null>;
      installations: Array<{
        __typename?: "AppInstallation";
        id: string;
        createdAt: string;
        method?: MethodType | null;
        localId?: string | null;
        settings?: Array<{
          __typename?: "AppSettingsGroup";
          g: AppFieldsGroupType;
          c: Array<{
            __typename?: "AppSettingsField";
            tg: string;
            dt: AppFieldSettingsDataTypeType;
            v: string;
            c?: Array<
              | {
                  __typename?: "AppSettingsFieldInner";
                  tg: string;
                  dt: AppFieldSettingsDataTypeType;
                  v: string;
                }
              | {
                  __typename?: "AppSettingsGroupInner";
                  g: AppFieldsGroupType;
                  c: Array<{
                    __typename?: "AppSettingsFieldInner";
                    tg: string;
                    dt: AppFieldSettingsDataTypeType;
                    v: string;
                  }>;
                }
            > | null;
          }>;
        } | null> | null;
      } | null>;
    } | null>;
  } | null> | null;
};

export type MakeCalendarEventMutationVariables = Exact<{
  input: MakeCalendarEventInput;
}>;

export type MakeCalendarEventMutation = {
  __typename?: "Mutation";
  makeCalendarEvent?: {
    __typename?: "CalendarEventOutput2";
    id: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    title: string;
    description: string;
    starts?: string | null;
    ends?: string | null;
    isBot: boolean;
    userId?: string | null;
    roomId?: string | null;
    operatorId?: string | null;
    isNonWorking?: boolean | null;
  } | null;
};

export type MakeCustomFieldMutationVariables = Exact<{
  input?: InputMaybe<MakeCustomFieldInput>;
}>;

export type MakeCustomFieldMutation = {
  __typename?: "Mutation";
  makeCustomField?: {
    __typename?: "CustomFieldOutput";
    id: string;
    fieldName: string;
    dataType: CustomFieldDataType;
    description?: string | null;
    fieldOrder: number;
  } | null;
};

export type DeployOrganizationMutationVariables = Exact<{
  idToken?: InputMaybe<Scalars["String"]>;
  organizationName?: InputMaybe<Scalars["String"]>;
  organizationCountry?: InputMaybe<Scalars["String"]>;
  organizationTimezone?: InputMaybe<Scalars["String"]>;
  organizationLanguage?: InputMaybe<OrganizationLanguage>;
  organizationImageUrl?: InputMaybe<Scalars["String"]>;
  organizationPhone?: InputMaybe<Scalars["String"]>;
  organizationAddress?: InputMaybe<Scalars["String"]>;
  organizationContactName?: InputMaybe<Scalars["String"]>;
  organizationContactCell?: InputMaybe<Scalars["String"]>;
  organizationStateDealerNumber?: InputMaybe<Scalars["String"]>;
  organizationWebsite?: InputMaybe<Scalars["String"]>;
  organizationManagerName?: InputMaybe<Scalars["String"]>;
  organizationManagerPhone?: InputMaybe<Scalars["String"]>;
  dealershipType?: InputMaybe<DealershipType>;
  teamName?: InputMaybe<Scalars["String"]>;
  rootEmail?: InputMaybe<Scalars["String"]>;
  rootPassword?: InputMaybe<Scalars["String"]>;
}>;

export type DeployOrganizationMutation = {
  __typename?: "Mutation";
  deployOrganization: { __typename?: "DeployOrganizationOutput"; oid: string };
};

export type SwitchOrganizationMutationVariables = Exact<{
  toOID: Scalars["String"];
}>;

export type SwitchOrganizationMutation = {
  __typename?: "Mutation";
  switchOrganization?: {
    __typename?: "SwitchOrganizationOutput";
    userId: string;
    newOID: string;
  } | null;
};

export type MakeClientTodoTaskMutationVariables = Exact<{
  input: ClientTodoTasksInput;
}>;

export type MakeClientTodoTaskMutation = {
  __typename?: "Mutation";
  makeClientTodoTask?: {
    __typename?: "ClientTodoTasksOutput";
    id: string;
    text?: string | null;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    deadline?: string | null;
    isDone: boolean;
    operatorId?: string | null;
  } | null;
};

export type UpdateNotificationsSettingsMutationVariables = Exact<{
  subtype: NotificationSubtype;
  enabled: Scalars["Boolean"];
}>;

export type UpdateNotificationsSettingsMutation = {
  __typename?: "Mutation";
  updateNotificationsSettings?: {
    __typename?: "NotificationSettingOutput";
    subtype: NotificationSubtype;
    enabled: boolean;
  } | null;
};

export type RequestDealerExportMutationVariables = Exact<{
  kind: DealerExportKind;
  dateStart?: InputMaybe<Scalars["String"]>;
  dateEnd?: InputMaybe<Scalars["String"]>;
  offsetMinutes?: InputMaybe<Scalars["Int"]>;
}>;

export type RequestDealerExportMutation = {
  __typename?: "Mutation";
  requestDealerExport?: {
    __typename?: "DealerExportRequest";
    status: string;
    email?: string | null;
  } | null;
};

export type RequestOrganizationEraseMutationVariables = Exact<{
  organizationId: Scalars["String"];
  confirmName: Scalars["String"];
}>;

export type RequestOrganizationEraseMutation = {
  __typename?: "Mutation";
  requestOrganizationErase?: {
    __typename?: "OrganizationEraseRequest";
    status: string;
  } | null;
};

export type MakeTariffMutationVariables = Exact<{
  method: MakeTariffMethod;
  tariffId?: InputMaybe<Scalars["String"]>;
}>;

export type MakeTariffMutation = {
  __typename?: "Mutation";
  makeTariff?: { __typename?: "ResponseStatus"; status?: string | null } | null;
};

export type MakeInventoryMutationVariables = Exact<{
  input: MakeInventoryInput;
}>;

export type MakeInventoryMutation = {
  __typename?: "Mutation";
  makeInventory?: {
    __typename?: "GetInventoryDetailsOutput";
    id: string;
    carfaxLink?: string | null;
    imageLink?: string | null;
    additionalEquipments?: string | null;
    isSold?: boolean | null;
    status?: InventoryStatus | null;
  } | null;
};

export type MakeMailingRecordMutationVariables = Exact<{
  type: CustomFieldMethodType;
  roomId: Scalars["ID"];
  leadId?: InputMaybe<Scalars["Int"]>;
  sendAt?: InputMaybe<Scalars["String"]>;
  actionType?: InputMaybe<MailingActionType>;
}>;

export type MakeMailingRecordMutation = {
  __typename?: "Mutation";
  makeMailingRecord?: {
    __typename?: "MailingRecordOutput";
    roomId: string;
    leadId?: number | null;
    sendAt?: string | null;
    actionType?: MailingActionType | null;
    deletedAt?: string | null;
    deleterName?: string | null;
    transferTo?: MailingTransferEnum | null;
  } | null;
};

export type ChangeTrialPeriodMutationVariables = Exact<{
  organizationId: Scalars["String"];
  trialFinishAt: Scalars["String"];
}>;

export type ChangeTrialPeriodMutation = {
  __typename?: "Mutation";
  changeTrialPeriod?: string | null;
};

export type SetNotificationIsReadMutationVariables = Exact<{
  notificationId: Scalars["String"];
}>;

export type SetNotificationIsReadMutation = {
  __typename?: "Mutation";
  setNotificationIsRead?: {
    __typename?: "NotificationOutput";
    subtype: NotificationSubtype;
    createdAt: string;
    title: string;
    body: string;
    metadata?: string | null;
    isRead?: boolean | null;
    id: string;
  } | null;
};

export type SetOrganizationSettingsMutationVariables = Exact<{
  input: OrganizationSettingsInput;
}>;

export type SetOrganizationSettingsMutation = {
  __typename?: "Mutation";
  setOrganizationSettings?: {
    __typename?: "OrganizationSettings";
    canOperatorAssignAppointments?: boolean | null;
  } | null;
};

export type GetRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetRolesQuery = {
  __typename?: "Query";
  getRoles?: Array<{
    __typename?: "RoleOutput";
    roleDescription?: string | null;
    roleId?: string | null;
    rolePublicName?: string | null;
    roleTechnicalName?: string | null;
  } | null> | null;
};

export type GetUserQueryVariables = Exact<{
  userId?: InputMaybe<Scalars["String"]>;
}>;

export type GetUserQuery = {
  __typename?: "Query";
  getUser?: {
    __typename?: "UserOutput";
    id: string;
    roleId?: string | null;
    isRoot?: boolean | null;
    optionalName: string;
    thirdParty?: string | null;
    position?: string | null;
    common?: {
      __typename?: "CommonUserFields";
      createdAt?: string | null;
      autoNickname?: string | null;
      userpicUrl?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      phone?: string | null;
    } | null;
    onlineStatus?: {
      __typename?: "UserPresenceStatusOutput";
      userId?: string | null;
      presenceStatus?: PresenceStatus | null;
    } | null;
    teams?: Array<{
      __typename?: "TeamOutput";
      id: string;
      name: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
    } | null> | null;
    role?: {
      __typename?: "RoleOutput";
      roleDescription?: string | null;
      roleId?: string | null;
      rolePublicName?: string | null;
      roleTechnicalName?: string | null;
    } | null;
  } | null;
};

export type CheckEmailAvailabilityQueryVariables = Exact<{
  email: Scalars["String"];
}>;

export type CheckEmailAvailabilityQuery = {
  __typename?: "Query";
  checkEmailAvailability: { __typename?: "EmailAvailability"; taken: boolean };
};

export type GetCommentsOnClient2QueryVariables = Exact<{
  clientId: Scalars["String"];
}>;

export type GetCommentsOnClient2Query = {
  __typename?: "Query";
  getCommentsOnClient2?: {
    __typename?: "GetCommentsOnClientOutput2";
    commentCount?: number | null;
    comments?: Array<{
      __typename?: "CommentOutput2";
      comment?: string | null;
      commentId?: string | null;
      createdAt?: string | null;
      clientId?: string | null;
      operator?: {
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetUsersQueryVariables = Exact<{
  input: GetUsersInput;
}>;

export type GetUsersQuery = {
  __typename?: "Query";
  getUsers?: {
    __typename?: "GetUsersOutput";
    users?: Array<{
      __typename?: "UserOutput";
      id: string;
      roleId?: string | null;
      isRoot?: boolean | null;
      optionalName: string;
      whatsappUsername?: string | null;
      whatsappProfile?: string | null;
      telegramUsername?: string | null;
      telegramUserId?: string | null;
      facebookMessengerPsid?: string | null;
      vkUserId?: string | null;
      instagramBsid?: string | null;
      instagramProfile?: string | null;
      thirdParty?: string | null;
      twilioSmsUserId?: string | null;
      nylasUserEmail?: string | null;
      mailgunUserEmail?: string | null;
      sendgridUserEmail?: string | null;
      lastTicketAt?: string | null;
      position?: string | null;
      common?: {
        __typename?: "CommonUserFields";
        createdAt?: string | null;
        autoNickname?: string | null;
        userpicUrl?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
      } | null;
      roomsLinks?: Array<{
        __typename?: "RoomLinkOutput";
        roomId?: string | null;
        roomStatus?: RoomStatus | null;
        channelType?: ChannelType | null;
        lastTicketAt?: string | null;
        vehicle?: string | null;
      } | null> | null;
      customFields?: Array<{
        __typename?: "UserCustomFieldOutput";
        fieldId: string;
        fieldName: string;
        dataType: CustomFieldDataType;
        description?: string | null;
        fieldOrder: number;
        value: string;
      } | null> | null;
      onlineStatus?: {
        __typename?: "UserPresenceStatusOutput";
        userId?: string | null;
        presenceStatus?: PresenceStatus | null;
      } | null;
      teams?: Array<{
        __typename?: "TeamOutput";
        id: string;
        name: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
      } | null> | null;
      role?: {
        __typename?: "RoleOutput";
        roleDescription?: string | null;
        roleId?: string | null;
        rolePublicName?: string | null;
        roleTechnicalName?: string | null;
      } | null;
    } | null> | null;
    pagination?: {
      __typename?: "PaginationOutput";
      itemsPerPage?: number | null;
      pageNumber?: number | null;
      totalItems?: number | null;
    } | null;
  } | null;
};

export type GetChannels2QueryVariables = Exact<{
  isActiveOnly?: Scalars["Boolean"];
}>;

export type GetChannels2Query = {
  __typename?: "Query";
  getChannels2: Array<{
    __typename?: "ChannelOutput2";
    id: string;
    publicId: string;
    name: string;
    link: string;
    type: ChannelType;
    status: ChannelStatus;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    bot?: { __typename?: "BotOutput"; id: string; name?: string | null } | null;
  } | null>;
};

export type GetBotsQueryVariables = Exact<{
  status: BotStatus;
}>;

export type GetBotsQuery = {
  __typename?: "Query";
  getBots?: Array<{
    __typename?: "BotOutput";
    isActive?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    status?: BotStatus | null;
    sessionsCount?: number | null;
    botType?: BotType | null;
    teamsIds?: Array<string | null> | null;
    id: string;
    name?: string | null;
    connectedChannels?: Array<{
      __typename?: "ChannelOutput2";
      id: string;
      publicId: string;
      name: string;
      link: string;
      type: ChannelType;
      status: ChannelStatus;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      bot?: {
        __typename?: "BotOutput";
        id: string;
        name?: string | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type GetBotQueryVariables = Exact<{
  id: Scalars["String"];
}>;

export type GetBotQuery = {
  __typename?: "Query";
  getBot?: {
    __typename?: "BotOutput";
    isActive?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    publishedAt?: string | null;
    status?: BotStatus | null;
    sessionsCount?: number | null;
    botType?: BotType | null;
    teamsIds?: Array<string | null> | null;
    id: string;
    name?: string | null;
    connectedChannels?: Array<{
      __typename?: "ChannelOutput2";
      id: string;
      publicId: string;
      name: string;
      link: string;
      type: ChannelType;
      status: ChannelStatus;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      bot?: {
        __typename?: "BotOutput";
        id: string;
        name?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetFlowsQueryVariables = Exact<{
  botId: Scalars["String"];
}>;

export type GetFlowsQuery = {
  __typename?: "Query";
  getFlows?: Array<{
    __typename?: "FlowOutput";
    id?: string | null;
    botId?: string | null;
    name?: string | null;
    createdAt?: string | null;
    isMain?: boolean | null;
    updatedAt?: string | null;
  } | null> | null;
};

export type GetFlowQueryVariables = Exact<{
  input?: InputMaybe<GetFlowInput>;
}>;

export type GetFlowQuery = {
  __typename?: "Query";
  getFlow?: {
    __typename?: "FlowOutput";
    id?: string | null;
    botId?: string | null;
    name?: string | null;
    createdAt?: string | null;
    isMain?: boolean | null;
    updatedAt?: string | null;
  } | null;
};

export type GetTeamsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTeamsQuery = {
  __typename?: "Query";
  getTeams?: Array<{
    __typename?: "TeamOutput";
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    users?: Array<{
      __typename?: "UserOutput";
      id: string;
      roleId?: string | null;
      isRoot?: boolean | null;
      optionalName: string;
      thirdParty?: string | null;
      position?: string | null;
      common?: {
        __typename?: "CommonUserFields";
        createdAt?: string | null;
        autoNickname?: string | null;
        userpicUrl?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
      } | null;
      onlineStatus?: {
        __typename?: "UserPresenceStatusOutput";
        userId?: string | null;
        presenceStatus?: PresenceStatus | null;
      } | null;
      teams?: Array<{
        __typename?: "TeamOutput";
        id: string;
        name: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
      } | null> | null;
      role?: {
        __typename?: "RoleOutput";
        roleDescription?: string | null;
        roleId?: string | null;
        rolePublicName?: string | null;
        roleTechnicalName?: string | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type GetRooms2QueryVariables = Exact<{
  input: GetRoomsInput;
}>;

export type GetRooms2Query = {
  __typename?: "Query";
  getRooms2?: {
    __typename?: "GetRooms2Output";
    hasUnreadMessages?: boolean | null;
    requestedStatus?: RoomStatus | null;
    error?: string | null;
    rooms?: Array<{
      __typename?: "RoomOutput2";
      id: string;
      leadId: number;
      status: RoomStatus;
      previousStatus?: RoomStatus | null;
      teamsIds: Array<string | null>;
      previousTeamsIds?: Array<string | null> | null;
      lastMessageAt?: string | null;
      lastClientMessageAt?: string | null;
      lastTicketAt?: string | null;
      unreadMessagesNumber: number;
      createdAt?: string | null;
      vehicle?: string | null;
      langCode?: LanguageCode_Iso_639_1 | null;
      currentLangCode?: LanguageCode_Iso_639_1 | null;
      isExpired: boolean;
      nonAcceptedTrigger?: NonAcceptedTriggers | null;
      channel: {
        __typename?: "ChannelOutput2";
        id: string;
        publicId: string;
        name: string;
        link: string;
        type: ChannelType;
        status: ChannelStatus;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        bot?: {
          __typename?: "BotOutput";
          id: string;
          name?: string | null;
        } | null;
      };
      client: {
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        whatsappUsername?: string | null;
        whatsappProfile?: string | null;
        telegramUsername?: string | null;
        telegramUserId?: string | null;
        facebookMessengerPsid?: string | null;
        vkUserId?: string | null;
        instagramBsid?: string | null;
        instagramProfile?: string | null;
        thirdParty?: string | null;
        twilioSmsUserId?: string | null;
        nylasUserEmail?: string | null;
        mailgunUserEmail?: string | null;
        sendgridUserEmail?: string | null;
        lastTicketAt?: string | null;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
        roomsLinks?: Array<{
          __typename?: "RoomLinkOutput";
          roomId?: string | null;
          roomStatus?: RoomStatus | null;
          channelType?: ChannelType | null;
          lastTicketAt?: string | null;
          vehicle?: string | null;
        } | null> | null;
        customFields?: Array<{
          __typename?: "UserCustomFieldOutput";
          fieldId: string;
          fieldName: string;
          dataType: CustomFieldDataType;
          description?: string | null;
          fieldOrder: number;
          value: string;
        } | null> | null;
      };
      activeOperator?: {
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        thirdParty?: string | null;
        position?: string | null;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
        onlineStatus?: {
          __typename?: "UserPresenceStatusOutput";
          userId?: string | null;
          presenceStatus?: PresenceStatus | null;
        } | null;
        teams?: Array<{
          __typename?: "TeamOutput";
          id: string;
          name: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
        } | null> | null;
        role?: {
          __typename?: "RoleOutput";
          roleDescription?: string | null;
          roleId?: string | null;
          rolePublicName?: string | null;
          roleTechnicalName?: string | null;
        } | null;
      } | null;
      operators: Array<{
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        thirdParty?: string | null;
        position?: string | null;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
        onlineStatus?: {
          __typename?: "UserPresenceStatusOutput";
          userId?: string | null;
          presenceStatus?: PresenceStatus | null;
        } | null;
        teams?: Array<{
          __typename?: "TeamOutput";
          id: string;
          name: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
        } | null> | null;
        role?: {
          __typename?: "RoleOutput";
          roleDescription?: string | null;
          roleId?: string | null;
          rolePublicName?: string | null;
          roleTechnicalName?: string | null;
        } | null;
      } | null>;
      lastMessageContent?: {
        __typename?: "LastMessageContentOutput";
        messageText?: string | null;
        messageContent?: Array<{
          __typename?: "MessageContentItemOutput";
          category?: string | null;
          fileExtension?: string | null;
          mimeType?: string | null;
          url?: string | null;
          fileName?: string | null;
          fileSize?: number | null;
          dimensions?: {
            __typename?: "MessageContentImageDimension";
            width: number;
            height: number;
          } | null;
        } | null> | null;
      } | null;
      linkedRooms: Array<{
        __typename?: "LinkedRoomOutput";
        id: string;
        lastMessageAt?: string | null;
        lastClientMessageAt?: string | null;
        lastTicketAt?: string | null;
        langCode?: LanguageCode_Iso_639_1 | null;
        unreadMessagesNumber: number;
        createdAt?: string | null;
        hasClientMessage: boolean;
        channel: {
          __typename?: "ChannelOutput2";
          id: string;
          publicId: string;
          name: string;
          link: string;
          type: ChannelType;
          status: ChannelStatus;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          bot?: {
            __typename?: "BotOutput";
            id: string;
            name?: string | null;
          } | null;
        };
        lastMessageContent?: {
          __typename?: "LastMessageContentOutput";
          messageText?: string | null;
          messageContent?: Array<{
            __typename?: "MessageContentItemOutput";
            category?: string | null;
            fileExtension?: string | null;
            mimeType?: string | null;
            url?: string | null;
            fileName?: string | null;
            fileSize?: number | null;
            dimensions?: {
              __typename?: "MessageContentImageDimension";
              width: number;
              height: number;
            } | null;
          } | null> | null;
        } | null;
      }>;
    } | null> | null;
    pagination?: {
      __typename?: "PaginationViaCursorOutput";
      totalItems: number;
      nextCursor?: string | null;
    } | null;
  } | null;
};

export type GetRoom2QueryVariables = Exact<{
  input: GetRoomInput;
}>;

export type GetRoom2Query = {
  __typename?: "Query";
  getRoom2?: {
    __typename?: "GetRoom2Output";
    error?: string | null;
    room?: {
      __typename?: "RoomOutput2";
      id: string;
      leadId: number;
      status: RoomStatus;
      previousStatus?: RoomStatus | null;
      teamsIds: Array<string | null>;
      previousTeamsIds?: Array<string | null> | null;
      lastMessageAt?: string | null;
      lastClientMessageAt?: string | null;
      lastTicketAt?: string | null;
      unreadMessagesNumber: number;
      createdAt?: string | null;
      vehicle?: string | null;
      langCode?: LanguageCode_Iso_639_1 | null;
      currentLangCode?: LanguageCode_Iso_639_1 | null;
      isExpired: boolean;
      nonAcceptedTrigger?: NonAcceptedTriggers | null;
      channel: {
        __typename?: "ChannelOutput2";
        id: string;
        publicId: string;
        name: string;
        link: string;
        type: ChannelType;
        status: ChannelStatus;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        bot?: {
          __typename?: "BotOutput";
          id: string;
          name?: string | null;
        } | null;
      };
      client: {
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        whatsappUsername?: string | null;
        whatsappProfile?: string | null;
        telegramUsername?: string | null;
        telegramUserId?: string | null;
        facebookMessengerPsid?: string | null;
        vkUserId?: string | null;
        instagramBsid?: string | null;
        instagramProfile?: string | null;
        thirdParty?: string | null;
        twilioSmsUserId?: string | null;
        nylasUserEmail?: string | null;
        mailgunUserEmail?: string | null;
        sendgridUserEmail?: string | null;
        lastTicketAt?: string | null;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
        roomsLinks?: Array<{
          __typename?: "RoomLinkOutput";
          roomId?: string | null;
          roomStatus?: RoomStatus | null;
          channelType?: ChannelType | null;
          lastTicketAt?: string | null;
          vehicle?: string | null;
        } | null> | null;
        customFields?: Array<{
          __typename?: "UserCustomFieldOutput";
          fieldId: string;
          fieldName: string;
          dataType: CustomFieldDataType;
          description?: string | null;
          fieldOrder: number;
          value: string;
        } | null> | null;
      };
      activeOperator?: {
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        thirdParty?: string | null;
        position?: string | null;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
        onlineStatus?: {
          __typename?: "UserPresenceStatusOutput";
          userId?: string | null;
          presenceStatus?: PresenceStatus | null;
        } | null;
        teams?: Array<{
          __typename?: "TeamOutput";
          id: string;
          name: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
        } | null> | null;
        role?: {
          __typename?: "RoleOutput";
          roleDescription?: string | null;
          roleId?: string | null;
          rolePublicName?: string | null;
          roleTechnicalName?: string | null;
        } | null;
      } | null;
      operators: Array<{
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        thirdParty?: string | null;
        position?: string | null;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
        onlineStatus?: {
          __typename?: "UserPresenceStatusOutput";
          userId?: string | null;
          presenceStatus?: PresenceStatus | null;
        } | null;
        teams?: Array<{
          __typename?: "TeamOutput";
          id: string;
          name: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
        } | null> | null;
        role?: {
          __typename?: "RoleOutput";
          roleDescription?: string | null;
          roleId?: string | null;
          rolePublicName?: string | null;
          roleTechnicalName?: string | null;
        } | null;
      } | null>;
      lastMessageContent?: {
        __typename?: "LastMessageContentOutput";
        messageText?: string | null;
        messageContent?: Array<{
          __typename?: "MessageContentItemOutput";
          category?: string | null;
          fileExtension?: string | null;
          mimeType?: string | null;
          url?: string | null;
          fileName?: string | null;
          fileSize?: number | null;
          dimensions?: {
            __typename?: "MessageContentImageDimension";
            width: number;
            height: number;
          } | null;
        } | null> | null;
      } | null;
      linkedRooms: Array<{
        __typename?: "LinkedRoomOutput";
        id: string;
        lastMessageAt?: string | null;
        lastClientMessageAt?: string | null;
        lastTicketAt?: string | null;
        langCode?: LanguageCode_Iso_639_1 | null;
        unreadMessagesNumber: number;
        createdAt?: string | null;
        hasClientMessage: boolean;
        channel: {
          __typename?: "ChannelOutput2";
          id: string;
          publicId: string;
          name: string;
          link: string;
          type: ChannelType;
          status: ChannelStatus;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          bot?: {
            __typename?: "BotOutput";
            id: string;
            name?: string | null;
          } | null;
        };
        lastMessageContent?: {
          __typename?: "LastMessageContentOutput";
          messageText?: string | null;
          messageContent?: Array<{
            __typename?: "MessageContentItemOutput";
            category?: string | null;
            fileExtension?: string | null;
            mimeType?: string | null;
            url?: string | null;
            fileName?: string | null;
            fileSize?: number | null;
            dimensions?: {
              __typename?: "MessageContentImageDimension";
              width: number;
              height: number;
            } | null;
          } | null> | null;
        } | null;
      }>;
    } | null;
  } | null;
};

export type GetChatRoomMessagesQueryVariables = Exact<{
  chatRoomId: Scalars["String"];
  fetchSize: Scalars["Int"];
  pagingState?: InputMaybe<Scalars["String"]>;
}>;

export type GetChatRoomMessagesQuery = {
  __typename?: "Query";
  getChatRoomMessages?: {
    __typename?: "GetChatRoomMessagesOutput";
    roomId?: string | null;
    pagingState?: string | null;
    chatRoomMessages?: Array<{
      __typename?: "MessageOutput";
      channelId?: string | null;
      channelTypeName?: ChannelType | null;
      chatRoomId?: string | null;
      chatRoomStatus?: string | null;
      messageAuthorId?: string | null;
      messageChannelId?: string | null;
      messageContent?: string | null;
      messageMetadata?: string | null;
      messageCreatedDateTime?: string | null;
      messageDeletedDateTime?: string | null;
      messageId?: string | null;
      messageIsDelivered?: boolean | null;
      messageIsRead?: boolean | null;
      messageIsSent?: boolean | null;
      messageText?: string | null;
      messageUpdatedDateTime?: string | null;
      textLangCode?: LanguageCode_Iso_639_1 | null;
      translatedText?: string | null;
      translatedTextLangCode?: LanguageCode_Iso_639_1 | null;
      localMessageId?: string | null;
      isFromClient: boolean;
      isFromBot: boolean;
    } | null> | null;
  } | null;
};

export type GetFoundMessagesQueryVariables = Exact<{
  chatRoomId: Scalars["String"];
  search: Scalars["String"];
}>;

export type GetFoundMessagesQuery = {
  __typename?: "Query";
  foundMessages?: Array<{
    __typename?: "MessageOutput";
    channelId?: string | null;
    channelTypeName?: ChannelType | null;
    chatRoomId?: string | null;
    chatRoomStatus?: string | null;
    messageAuthorId?: string | null;
    messageChannelId?: string | null;
    messageContent?: string | null;
    messageMetadata?: string | null;
    messageCreatedDateTime?: string | null;
    messageDeletedDateTime?: string | null;
    messageId?: string | null;
    messageIsDelivered?: boolean | null;
    messageIsRead?: boolean | null;
    messageIsSent?: boolean | null;
    messageText?: string | null;
    messageUpdatedDateTime?: string | null;
    textLangCode?: LanguageCode_Iso_639_1 | null;
    translatedText?: string | null;
    translatedTextLangCode?: LanguageCode_Iso_639_1 | null;
    localMessageId?: string | null;
    isFromClient: boolean;
    isFromBot: boolean;
  }> | null;
};

export type GetNodesQueryVariables = Exact<{
  input?: InputMaybe<GetNodesAndEdgesInput>;
}>;

export type GetNodesQuery = {
  __typename?: "Query";
  getNodes?: Array<{
    __typename?: "NodeOutput";
    id?: string | null;
    localId?: string | null;
    flowId?: string | null;
    coordinates?: Array<number | null> | null;
    nodeType?: NodeType | null;
    fileUrl?: string | null;
    imageUrl?: string | null;
    text?: string | null;
    childFlowId?: string | null;
    isDelete?: boolean | null;
    teamsIds?: Array<string | null> | null;
    botId?: string | null;
    exceptionText?: string | null;
    saveTo?: SaveTo | null;
    appId?: string | null;
    appVersionId?: string | null;
    appInstalledId?: string | null;
    buttons?: Array<{
      __typename?: "ButtonOutput";
      id?: string | null;
      localId?: string | null;
      name?: string | null;
      nodeId?: string | null;
      localNodeId?: string | null;
      buttonOrder?: number | null;
      botId?: string | null;
    } | null> | null;
  } | null> | null;
};

export type GetEdgesQueryVariables = Exact<{
  input?: InputMaybe<GetNodesAndEdgesInput>;
}>;

export type GetEdgesQuery = {
  __typename?: "Query";
  getEdges?: Array<{
    __typename?: "EdgeOutput";
    id?: string | null;
    localId?: string | null;
    botId?: string | null;
    flowId?: string | null;
    childId?: string | null;
    localChildId?: string | null;
    parentId?: string | null;
    localParentId?: string | null;
    handleParentId?: string | null;
    localHandleParentId?: string | null;
    isDelete?: boolean | null;
  } | null> | null;
};

export type GetChatSnippetsQueryVariables = Exact<{
  snippetId?: InputMaybe<Scalars["String"]>;
  categoryId?: InputMaybe<Scalars["String"]>;
  userId: Scalars["String"];
}>;

export type GetChatSnippetsQuery = {
  __typename?: "Query";
  getChatSnippets?: {
    __typename?: "GetChatSnippets";
    totalNumberOfSnippets?: number | null;
    snippets?: Array<{
      __typename?: "ChatSnippetsOutput";
      snippetId?: string | null;
      userId?: string | null;
      categoryId?: string | null;
      snippet?: string | null;
      teamsIds?: Array<string | null> | null;
      isFavorite: boolean;
    } | null> | null;
  } | null;
};

export type GetChatSnippetsFavoritesQueryVariables = Exact<{
  userId: Scalars["String"];
}>;

export type GetChatSnippetsFavoritesQuery = {
  __typename?: "Query";
  getChatSnippetsFavorites?: {
    __typename?: "GetChatSnippets";
    totalNumberOfSnippets?: number | null;
    snippets?: Array<{
      __typename?: "ChatSnippetsOutput";
      snippetId?: string | null;
      userId?: string | null;
      categoryId?: string | null;
      snippet?: string | null;
      teamsIds?: Array<string | null> | null;
      isFavorite: boolean;
    } | null> | null;
  } | null;
};

export type GetChatSnippetsCategoriesQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars["String"]>;
  categoryId?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["String"]>;
}>;

export type GetChatSnippetsCategoriesQuery = {
  __typename?: "Query";
  getChatSnippetsCategories?: {
    __typename?: "GetChatSnippetsCategories";
    totalNumberOfCategories?: number | null;
    categories?: Array<{
      __typename?: "ChatSnippetsCategoriesOutput";
      categoryId?: string | null;
      categoryName?: string | null;
      parentId?: string | null;
      userId?: string | null;
      totalSnippetsCount?: number | null;
    } | null> | null;
  } | null;
};

export type RequestRoomsHistoryAsFileQueryVariables = Exact<{
  reportType: ReportType;
  userId: Scalars["String"];
  roomId?: InputMaybe<Scalars["String"]>;
  operatorId?: InputMaybe<Scalars["String"]>;
  dateStart?: InputMaybe<Scalars["String"]>;
  dateEnd?: InputMaybe<Scalars["String"]>;
}>;

export type RequestRoomsHistoryAsFileQuery = {
  __typename?: "Query";
  requestRoomsHistoryAsFile?: {
    __typename?: "FileItemOutput";
    id?: string | null;
    userId?: string | null;
    name?: string | null;
    url?: string | null;
    status?: FileStatus | null;
    createdAt?: string | null;
  } | null;
};

export type ValidateBotQueryVariables = Exact<{
  id: Scalars["String"];
}>;

export type ValidateBotQuery = {
  __typename?: "Query";
  validateBot?: Array<{
    __typename?: "ValidateBot";
    id?: string | null;
    errorMessage?: string | null;
    statusCode?: number | null;
    nodeType?: NodeType | null;
    flowId?: string | null;
  } | null> | null;
};

export type GetGeneralAnalyticsQueryVariables = Exact<{
  input: GetGeneralAnalyticsInput;
}>;

export type GetGeneralAnalyticsQuery = {
  __typename?: "Query";
  getGeneralAnalytics?: {
    __typename?: "GeneralAnalyticsOutput";
    totalContacts: number;
    totalChats: number;
    nonAcceptedChats: number;
    calendarAppointments: {
      __typename?: "AppointmentsDistribution";
      labels: Array<AnalyticsAppointmentsDistributionLabels>;
      series: Array<number>;
    };
    leadsByMarketplace: {
      __typename?: "DataByLabelsType";
      labels: Array<string | null>;
      series: Array<number | null>;
    };
    chatsByChannels: {
      __typename?: "DataByChannelType";
      labels: Array<string | null>;
      series: {
        __typename?: "SeriesByChannelType";
        EMAIL?: Array<number | null> | null;
        SMS?: Array<number | null> | null;
      };
    };
    appointmentsNonWorking: {
      __typename?: "DataByLabelsType";
      labels: Array<string | null>;
      series: Array<number | null>;
    };
    leadsNonWorking: {
      __typename?: "DataByLabelsType";
      labels: Array<string | null>;
      series: Array<number | null>;
    };
  } | null;
};

export type GetChatsAnalyticsQueryVariables = Exact<{
  input: GetChatsAnalyticsInput;
}>;

export type GetChatsAnalyticsQuery = {
  __typename?: "Query";
  getChatsAnalytics?: {
    __typename?: "ChatsAnalyticsOutput";
    invisibleChats: number;
    nonAcceptedChats: number;
    nonRespondedChats: number;
    acceptedChats: number;
    calendarAppointments: {
      __typename?: "AppointmentsDistribution";
      labels: Array<AnalyticsAppointmentsDistributionLabels>;
      series: Array<number>;
    };
    newChats7d: {
      __typename?: "LineChart";
      series: Array<{
        __typename?: "LineChartSeries";
        name: ChannelType;
        data: Array<number>;
      } | null>;
      xAxis: {
        __typename?: "LineChartXAxisCategories";
        categories: Array<string | null>;
      };
    };
  } | null;
};

export type GetOperatorsAnalyticsQueryVariables = Exact<{
  input?: InputMaybe<GetOperatorsAnalyticsInput>;
}>;

export type GetOperatorsAnalyticsQuery = {
  __typename?: "Query";
  getOperatorsAnalytics?: {
    __typename?: "OperatorsAnalyticsOutput";
    avgChatsPerOperatorPerDay: number;
    avgAcceptedToFirstMessage: number;
    avgAccepted: number;
    acceptedByOperatorsByPeriodMap: Array<{
      __typename?: "AnalyticsHeatMapSeriesItem";
      name: string;
      data: Array<{
        __typename?: "AnalyticsHeatMapSeriesDataItem";
        x: string;
        y: number;
      } | null>;
    } | null>;
    operatorsMetricsTable: Array<{
      __typename?: "AnalyticsOperatorsMetricsTableRow";
      operatorName: string;
      completedChats: number;
      avgFirstMessageSec: number;
      avgAcceptedSec: number;
    } | null>;
  } | null;
};

export type GetAppsQueryVariables = Exact<{
  ids?: InputMaybe<
    Array<InputMaybe<Scalars["ID"]>> | InputMaybe<Scalars["ID"]>
  >;
  types?: InputMaybe<Array<InputMaybe<AppType>> | InputMaybe<AppType>>;
  isAvailableOnly?: InputMaybe<Scalars["Boolean"]>;
  isInstalledOnly?: InputMaybe<Scalars["Boolean"]>;
}>;

export type GetAppsQuery = {
  __typename?: "Query";
  getApps?: Array<{
    __typename?: "AppOutput";
    id: string;
    iconUrl: string;
    gallery?: string | null;
    type: AppType;
    tag: string;
    latestVersion: string;
    createdAt: string;
    isAvailable: boolean;
    isInstalled: boolean;
    name: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    };
    description?: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    } | null;
    instructions?: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    } | null;
    versions: Array<{
      __typename?: "AppVersion";
      version: string;
      createdAt: string;
      id: string;
      isInstalled: boolean;
      fields: Array<{
        __typename?: "AppFieldsGroup";
        g: AppFieldsGroupType;
        c: Array<{
          __typename?: "AppField";
          t: AppFieldTypeType;
          tg: string;
          dt?: AppFieldDataTypeType | null;
          dts?: Array<AppFieldDataTypesType> | null;
          r?: boolean | null;
          mn?: number | null;
          mx?: number | null;
          v?: string | null;
          n: {
            __typename?: "LanguageMap";
            en: string;
            ru?: string | null;
            af?: string | null;
            sq?: string | null;
            ar?: string | null;
            az?: string | null;
            bn?: string | null;
            bg?: string | null;
            ca?: string | null;
            zh?: string | null;
            hr?: string | null;
            cs?: string | null;
            da?: string | null;
            nl?: string | null;
            et?: string | null;
            fil?: string | null;
            fi?: string | null;
            fr?: string | null;
            ka?: string | null;
            de?: string | null;
            el?: string | null;
            gu?: string | null;
            ha?: string | null;
            he?: string | null;
            hi?: string | null;
            hu?: string | null;
            id?: string | null;
            ga?: string | null;
            it?: string | null;
            ja?: string | null;
            kn?: string | null;
            kk?: string | null;
            rw?: string | null;
            ko?: string | null;
            ky?: string | null;
            lo?: string | null;
            lv?: string | null;
            lt?: string | null;
            mk?: string | null;
            ms?: string | null;
            ml?: string | null;
            mr?: string | null;
            nb?: string | null;
            fa?: string | null;
            pl?: string | null;
            pt?: string | null;
            pa?: string | null;
            ro?: string | null;
            sr?: string | null;
            sk?: string | null;
            sl?: string | null;
            es?: string | null;
            sw?: string | null;
            sv?: string | null;
            ta?: string | null;
            te?: string | null;
            th?: string | null;
            tr?: string | null;
            uk?: string | null;
            ur?: string | null;
            uz?: string | null;
            vi?: string | null;
            zu?: string | null;
          };
          p?: {
            __typename?: "LanguageMap";
            en: string;
            ru?: string | null;
            af?: string | null;
            sq?: string | null;
            ar?: string | null;
            az?: string | null;
            bn?: string | null;
            bg?: string | null;
            ca?: string | null;
            zh?: string | null;
            hr?: string | null;
            cs?: string | null;
            da?: string | null;
            nl?: string | null;
            et?: string | null;
            fil?: string | null;
            fi?: string | null;
            fr?: string | null;
            ka?: string | null;
            de?: string | null;
            el?: string | null;
            gu?: string | null;
            ha?: string | null;
            he?: string | null;
            hi?: string | null;
            hu?: string | null;
            id?: string | null;
            ga?: string | null;
            it?: string | null;
            ja?: string | null;
            kn?: string | null;
            kk?: string | null;
            rw?: string | null;
            ko?: string | null;
            ky?: string | null;
            lo?: string | null;
            lv?: string | null;
            lt?: string | null;
            mk?: string | null;
            ms?: string | null;
            ml?: string | null;
            mr?: string | null;
            nb?: string | null;
            fa?: string | null;
            pl?: string | null;
            pt?: string | null;
            pa?: string | null;
            ro?: string | null;
            sr?: string | null;
            sk?: string | null;
            sl?: string | null;
            es?: string | null;
            sw?: string | null;
            sv?: string | null;
            ta?: string | null;
            te?: string | null;
            th?: string | null;
            tr?: string | null;
            uk?: string | null;
            ur?: string | null;
            uz?: string | null;
            vi?: string | null;
            zu?: string | null;
          } | null;
          d?: {
            __typename?: "LanguageMap";
            en: string;
            ru?: string | null;
            af?: string | null;
            sq?: string | null;
            ar?: string | null;
            az?: string | null;
            bn?: string | null;
            bg?: string | null;
            ca?: string | null;
            zh?: string | null;
            hr?: string | null;
            cs?: string | null;
            da?: string | null;
            nl?: string | null;
            et?: string | null;
            fil?: string | null;
            fi?: string | null;
            fr?: string | null;
            ka?: string | null;
            de?: string | null;
            el?: string | null;
            gu?: string | null;
            ha?: string | null;
            he?: string | null;
            hi?: string | null;
            hu?: string | null;
            id?: string | null;
            ga?: string | null;
            it?: string | null;
            ja?: string | null;
            kn?: string | null;
            kk?: string | null;
            rw?: string | null;
            ko?: string | null;
            ky?: string | null;
            lo?: string | null;
            lv?: string | null;
            lt?: string | null;
            mk?: string | null;
            ms?: string | null;
            ml?: string | null;
            mr?: string | null;
            nb?: string | null;
            fa?: string | null;
            pl?: string | null;
            pt?: string | null;
            pa?: string | null;
            ro?: string | null;
            sr?: string | null;
            sk?: string | null;
            sl?: string | null;
            es?: string | null;
            sw?: string | null;
            sv?: string | null;
            ta?: string | null;
            te?: string | null;
            th?: string | null;
            tr?: string | null;
            uk?: string | null;
            ur?: string | null;
            uz?: string | null;
            vi?: string | null;
            zu?: string | null;
          } | null;
          c?: Array<
            | {
                __typename?: "AppFieldInner";
                t: AppFieldTypeType;
                tg: string;
                dt?: AppFieldDataTypeType | null;
                dts?: Array<AppFieldDataTypesType> | null;
                r?: boolean | null;
                mn?: number | null;
                mx?: number | null;
                v?: string | null;
                n: {
                  __typename?: "LanguageMap";
                  en: string;
                  ru?: string | null;
                  af?: string | null;
                  sq?: string | null;
                  ar?: string | null;
                  az?: string | null;
                  bn?: string | null;
                  bg?: string | null;
                  ca?: string | null;
                  zh?: string | null;
                  hr?: string | null;
                  cs?: string | null;
                  da?: string | null;
                  nl?: string | null;
                  et?: string | null;
                  fil?: string | null;
                  fi?: string | null;
                  fr?: string | null;
                  ka?: string | null;
                  de?: string | null;
                  el?: string | null;
                  gu?: string | null;
                  ha?: string | null;
                  he?: string | null;
                  hi?: string | null;
                  hu?: string | null;
                  id?: string | null;
                  ga?: string | null;
                  it?: string | null;
                  ja?: string | null;
                  kn?: string | null;
                  kk?: string | null;
                  rw?: string | null;
                  ko?: string | null;
                  ky?: string | null;
                  lo?: string | null;
                  lv?: string | null;
                  lt?: string | null;
                  mk?: string | null;
                  ms?: string | null;
                  ml?: string | null;
                  mr?: string | null;
                  nb?: string | null;
                  fa?: string | null;
                  pl?: string | null;
                  pt?: string | null;
                  pa?: string | null;
                  ro?: string | null;
                  sr?: string | null;
                  sk?: string | null;
                  sl?: string | null;
                  es?: string | null;
                  sw?: string | null;
                  sv?: string | null;
                  ta?: string | null;
                  te?: string | null;
                  th?: string | null;
                  tr?: string | null;
                  uk?: string | null;
                  ur?: string | null;
                  uz?: string | null;
                  vi?: string | null;
                  zu?: string | null;
                };
                p?: {
                  __typename?: "LanguageMap";
                  en: string;
                  ru?: string | null;
                  af?: string | null;
                  sq?: string | null;
                  ar?: string | null;
                  az?: string | null;
                  bn?: string | null;
                  bg?: string | null;
                  ca?: string | null;
                  zh?: string | null;
                  hr?: string | null;
                  cs?: string | null;
                  da?: string | null;
                  nl?: string | null;
                  et?: string | null;
                  fil?: string | null;
                  fi?: string | null;
                  fr?: string | null;
                  ka?: string | null;
                  de?: string | null;
                  el?: string | null;
                  gu?: string | null;
                  ha?: string | null;
                  he?: string | null;
                  hi?: string | null;
                  hu?: string | null;
                  id?: string | null;
                  ga?: string | null;
                  it?: string | null;
                  ja?: string | null;
                  kn?: string | null;
                  kk?: string | null;
                  rw?: string | null;
                  ko?: string | null;
                  ky?: string | null;
                  lo?: string | null;
                  lv?: string | null;
                  lt?: string | null;
                  mk?: string | null;
                  ms?: string | null;
                  ml?: string | null;
                  mr?: string | null;
                  nb?: string | null;
                  fa?: string | null;
                  pl?: string | null;
                  pt?: string | null;
                  pa?: string | null;
                  ro?: string | null;
                  sr?: string | null;
                  sk?: string | null;
                  sl?: string | null;
                  es?: string | null;
                  sw?: string | null;
                  sv?: string | null;
                  ta?: string | null;
                  te?: string | null;
                  th?: string | null;
                  tr?: string | null;
                  uk?: string | null;
                  ur?: string | null;
                  uz?: string | null;
                  vi?: string | null;
                  zu?: string | null;
                } | null;
                d?: {
                  __typename?: "LanguageMap";
                  en: string;
                  ru?: string | null;
                  af?: string | null;
                  sq?: string | null;
                  ar?: string | null;
                  az?: string | null;
                  bn?: string | null;
                  bg?: string | null;
                  ca?: string | null;
                  zh?: string | null;
                  hr?: string | null;
                  cs?: string | null;
                  da?: string | null;
                  nl?: string | null;
                  et?: string | null;
                  fil?: string | null;
                  fi?: string | null;
                  fr?: string | null;
                  ka?: string | null;
                  de?: string | null;
                  el?: string | null;
                  gu?: string | null;
                  ha?: string | null;
                  he?: string | null;
                  hi?: string | null;
                  hu?: string | null;
                  id?: string | null;
                  ga?: string | null;
                  it?: string | null;
                  ja?: string | null;
                  kn?: string | null;
                  kk?: string | null;
                  rw?: string | null;
                  ko?: string | null;
                  ky?: string | null;
                  lo?: string | null;
                  lv?: string | null;
                  lt?: string | null;
                  mk?: string | null;
                  ms?: string | null;
                  ml?: string | null;
                  mr?: string | null;
                  nb?: string | null;
                  fa?: string | null;
                  pl?: string | null;
                  pt?: string | null;
                  pa?: string | null;
                  ro?: string | null;
                  sr?: string | null;
                  sk?: string | null;
                  sl?: string | null;
                  es?: string | null;
                  sw?: string | null;
                  sv?: string | null;
                  ta?: string | null;
                  te?: string | null;
                  th?: string | null;
                  tr?: string | null;
                  uk?: string | null;
                  ur?: string | null;
                  uz?: string | null;
                  vi?: string | null;
                  zu?: string | null;
                } | null;
              }
            | {
                __typename?: "AppFieldsGroupInner";
                g: AppFieldsGroupType;
                c: Array<{
                  __typename?: "AppFieldInner";
                  t: AppFieldTypeType;
                  tg: string;
                  dt?: AppFieldDataTypeType | null;
                  dts?: Array<AppFieldDataTypesType> | null;
                  r?: boolean | null;
                  mn?: number | null;
                  mx?: number | null;
                  v?: string | null;
                  n: {
                    __typename?: "LanguageMap";
                    en: string;
                    ru?: string | null;
                    af?: string | null;
                    sq?: string | null;
                    ar?: string | null;
                    az?: string | null;
                    bn?: string | null;
                    bg?: string | null;
                    ca?: string | null;
                    zh?: string | null;
                    hr?: string | null;
                    cs?: string | null;
                    da?: string | null;
                    nl?: string | null;
                    et?: string | null;
                    fil?: string | null;
                    fi?: string | null;
                    fr?: string | null;
                    ka?: string | null;
                    de?: string | null;
                    el?: string | null;
                    gu?: string | null;
                    ha?: string | null;
                    he?: string | null;
                    hi?: string | null;
                    hu?: string | null;
                    id?: string | null;
                    ga?: string | null;
                    it?: string | null;
                    ja?: string | null;
                    kn?: string | null;
                    kk?: string | null;
                    rw?: string | null;
                    ko?: string | null;
                    ky?: string | null;
                    lo?: string | null;
                    lv?: string | null;
                    lt?: string | null;
                    mk?: string | null;
                    ms?: string | null;
                    ml?: string | null;
                    mr?: string | null;
                    nb?: string | null;
                    fa?: string | null;
                    pl?: string | null;
                    pt?: string | null;
                    pa?: string | null;
                    ro?: string | null;
                    sr?: string | null;
                    sk?: string | null;
                    sl?: string | null;
                    es?: string | null;
                    sw?: string | null;
                    sv?: string | null;
                    ta?: string | null;
                    te?: string | null;
                    th?: string | null;
                    tr?: string | null;
                    uk?: string | null;
                    ur?: string | null;
                    uz?: string | null;
                    vi?: string | null;
                    zu?: string | null;
                  };
                  p?: {
                    __typename?: "LanguageMap";
                    en: string;
                    ru?: string | null;
                    af?: string | null;
                    sq?: string | null;
                    ar?: string | null;
                    az?: string | null;
                    bn?: string | null;
                    bg?: string | null;
                    ca?: string | null;
                    zh?: string | null;
                    hr?: string | null;
                    cs?: string | null;
                    da?: string | null;
                    nl?: string | null;
                    et?: string | null;
                    fil?: string | null;
                    fi?: string | null;
                    fr?: string | null;
                    ka?: string | null;
                    de?: string | null;
                    el?: string | null;
                    gu?: string | null;
                    ha?: string | null;
                    he?: string | null;
                    hi?: string | null;
                    hu?: string | null;
                    id?: string | null;
                    ga?: string | null;
                    it?: string | null;
                    ja?: string | null;
                    kn?: string | null;
                    kk?: string | null;
                    rw?: string | null;
                    ko?: string | null;
                    ky?: string | null;
                    lo?: string | null;
                    lv?: string | null;
                    lt?: string | null;
                    mk?: string | null;
                    ms?: string | null;
                    ml?: string | null;
                    mr?: string | null;
                    nb?: string | null;
                    fa?: string | null;
                    pl?: string | null;
                    pt?: string | null;
                    pa?: string | null;
                    ro?: string | null;
                    sr?: string | null;
                    sk?: string | null;
                    sl?: string | null;
                    es?: string | null;
                    sw?: string | null;
                    sv?: string | null;
                    ta?: string | null;
                    te?: string | null;
                    th?: string | null;
                    tr?: string | null;
                    uk?: string | null;
                    ur?: string | null;
                    uz?: string | null;
                    vi?: string | null;
                    zu?: string | null;
                  } | null;
                  d?: {
                    __typename?: "LanguageMap";
                    en: string;
                    ru?: string | null;
                    af?: string | null;
                    sq?: string | null;
                    ar?: string | null;
                    az?: string | null;
                    bn?: string | null;
                    bg?: string | null;
                    ca?: string | null;
                    zh?: string | null;
                    hr?: string | null;
                    cs?: string | null;
                    da?: string | null;
                    nl?: string | null;
                    et?: string | null;
                    fil?: string | null;
                    fi?: string | null;
                    fr?: string | null;
                    ka?: string | null;
                    de?: string | null;
                    el?: string | null;
                    gu?: string | null;
                    ha?: string | null;
                    he?: string | null;
                    hi?: string | null;
                    hu?: string | null;
                    id?: string | null;
                    ga?: string | null;
                    it?: string | null;
                    ja?: string | null;
                    kn?: string | null;
                    kk?: string | null;
                    rw?: string | null;
                    ko?: string | null;
                    ky?: string | null;
                    lo?: string | null;
                    lv?: string | null;
                    lt?: string | null;
                    mk?: string | null;
                    ms?: string | null;
                    ml?: string | null;
                    mr?: string | null;
                    nb?: string | null;
                    fa?: string | null;
                    pl?: string | null;
                    pt?: string | null;
                    pa?: string | null;
                    ro?: string | null;
                    sr?: string | null;
                    sk?: string | null;
                    sl?: string | null;
                    es?: string | null;
                    sw?: string | null;
                    sv?: string | null;
                    ta?: string | null;
                    te?: string | null;
                    th?: string | null;
                    tr?: string | null;
                    uk?: string | null;
                    ur?: string | null;
                    uz?: string | null;
                    vi?: string | null;
                    zu?: string | null;
                  } | null;
                }>;
              }
          > | null;
        }>;
      } | null>;
      installations: Array<{
        __typename?: "AppInstallation";
        id: string;
        createdAt: string;
        method?: MethodType | null;
        localId?: string | null;
        settings?: Array<{
          __typename?: "AppSettingsGroup";
          g: AppFieldsGroupType;
          c: Array<{
            __typename?: "AppSettingsField";
            tg: string;
            dt: AppFieldSettingsDataTypeType;
            v: string;
            c?: Array<
              | {
                  __typename?: "AppSettingsFieldInner";
                  tg: string;
                  dt: AppFieldSettingsDataTypeType;
                  v: string;
                }
              | {
                  __typename?: "AppSettingsGroupInner";
                  g: AppFieldsGroupType;
                  c: Array<{
                    __typename?: "AppSettingsFieldInner";
                    tg: string;
                    dt: AppFieldSettingsDataTypeType;
                    v: string;
                  }>;
                }
            > | null;
          }>;
        } | null> | null;
      } | null>;
    } | null>;
  } | null> | null;
};

export type GetChatRoomHistoryQueryVariables = Exact<{
  roomId: Scalars["String"];
}>;

export type GetChatRoomHistoryQuery = {
  __typename?: "Query";
  getChatRoomHistory?: {
    __typename?: "RoomHistoryOutput";
    chatRoomHistory: Array<{
      __typename?: "RoomEventOutput";
      eventCreatedAt: string;
      eventInitiator: string;
      initiatorType: InitiatorType;
      toUser?: string | null;
      fromUser?: string | null;
      toTeams?: Array<string | null> | null;
      fromTeams?: Array<string | null> | null;
      actionName: RoomEventActionName;
      text?: string | null;
    } | null>;
  } | null;
};

export type GetAvailableTwilioPhoneNumbersQueryVariables = Exact<{
  areaCode: Scalars["Int"];
  limit?: InputMaybe<Scalars["Int"]>;
}>;

export type GetAvailableTwilioPhoneNumbersQuery = {
  __typename?: "Query";
  getAvailableTwilioPhoneNumbers?: Array<string | null> | null;
};

export type GetCalendarEvents2QueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
  startsAfter?: InputMaybe<Scalars["String"]>;
  endsBefore?: InputMaybe<Scalars["String"]>;
}>;

export type GetCalendarEvents2Query = {
  __typename?: "Query";
  getCalendarEvents2?: {
    __typename?: "GetCalendarEventsOutput";
    total?: number | null;
    events?: Array<{
      __typename?: "CalendarEventOutput2";
      id: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      title: string;
      description: string;
      starts?: string | null;
      ends?: string | null;
      isBot: boolean;
      userId?: string | null;
      roomId?: string | null;
      operatorId?: string | null;
      isNonWorking?: boolean | null;
    } | null> | null;
  } | null;
};

export type GetAiBotTemplatesWithFieldsQueryVariables = Exact<{
  templateId?: InputMaybe<Scalars["ID"]>;
}>;

export type GetAiBotTemplatesWithFieldsQuery = {
  __typename?: "Query";
  getAiBotTemplatesWithFields?: Array<{
    __typename?: "AiBotTemplateWithFieldsOutput";
    id: string;
    createdAt: string;
    fields: string;
    name: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    };
    description?: {
      __typename?: "LanguageMap";
      en: string;
      ru?: string | null;
      af?: string | null;
      sq?: string | null;
      ar?: string | null;
      az?: string | null;
      bn?: string | null;
      bg?: string | null;
      ca?: string | null;
      zh?: string | null;
      hr?: string | null;
      cs?: string | null;
      da?: string | null;
      nl?: string | null;
      et?: string | null;
      fil?: string | null;
      fi?: string | null;
      fr?: string | null;
      ka?: string | null;
      de?: string | null;
      el?: string | null;
      gu?: string | null;
      ha?: string | null;
      he?: string | null;
      hi?: string | null;
      hu?: string | null;
      id?: string | null;
      ga?: string | null;
      it?: string | null;
      ja?: string | null;
      kn?: string | null;
      kk?: string | null;
      rw?: string | null;
      ko?: string | null;
      ky?: string | null;
      lo?: string | null;
      lv?: string | null;
      lt?: string | null;
      mk?: string | null;
      ms?: string | null;
      ml?: string | null;
      mr?: string | null;
      nb?: string | null;
      fa?: string | null;
      pl?: string | null;
      pt?: string | null;
      pa?: string | null;
      ro?: string | null;
      sr?: string | null;
      sk?: string | null;
      sl?: string | null;
      es?: string | null;
      sw?: string | null;
      sv?: string | null;
      ta?: string | null;
      te?: string | null;
      th?: string | null;
      tr?: string | null;
      uk?: string | null;
      ur?: string | null;
      uz?: string | null;
      vi?: string | null;
      zu?: string | null;
    } | null;
  } | null> | null;
};

export type GetAiBotUserSettingsQueryVariables = Exact<{
  botId: Scalars["ID"];
}>;

export type GetAiBotUserSettingsQuery = {
  __typename?: "Query";
  getAiBotUserSettings?: {
    __typename?: "AiBotUserSettingsOutput";
    id: string;
    createdAt: string;
    updatedAt: string;
    templateId: string;
    botId: string;
    userSettings?: string | null;
  } | null;
};

export type GetOrganizationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]>;
  statuses?: InputMaybe<
    Array<InputMaybe<OrganizationStatus>> | InputMaybe<OrganizationStatus>
  >;
  isWithInvoices?: InputMaybe<Scalars["Boolean"]>;
  isDeleted?: InputMaybe<Scalars["Boolean"]>;
}>;

export type GetOrganizationsQuery = {
  __typename?: "Query";
  getOrganizations?: {
    __typename?: "OrganizationsOutput";
    current?: {
      __typename?: "Organization";
      id: string;
      parentOID?: string | null;
      name: string;
      phone?: string | null;
      email?: string | null;
      tariffId?: string | null;
      newTariffId?: string | null;
      country?: string | null;
      timezone?: string | null;
      language?: OrganizationLanguage | null;
      activeMembersCount?: number | null;
      membersCount?: number | null;
      imageUrl?: string | null;
      address?: string | null;
      contactName?: string | null;
      contactCell?: string | null;
      stateDealerNumber?: string | null;
      website?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      isPendingDeletion?: boolean | null;
      isStale?: boolean | null;
      daysUntilStale?: number | null;
      isCurrent: boolean;
      rid: string;
      onboardStatus?: OnboardStatus | null;
      status: OrganizationStatus;
      isTrial?: boolean | null;
      isCanceled?: boolean | null;
      isPaymentFailed?: boolean | null;
      managerName?: string | null;
      managerPhone?: string | null;
      deletedAt?: string | null;
      trialFinishAt?: string | null;
      dealershipType?: DealershipType | null;
      vautoDealerId?: string | null;
      invoices?: {
        __typename?: "OrganizationInvoices";
        current?: {
          __typename?: "Invoice";
          amount?: number | null;
          products?: Array<string | null> | null;
          quantity?: number | null;
          status?: InvoiceStatus | null;
          createdAt?: string | null;
          finalizedAt?: string | null;
          invoicePdf?: string | null;
          hostedInvoiceUrl?: string | null;
          package?: OrganizationTariff | null;
          card?: {
            __typename?: "Card";
            brand?: string | null;
            expMonth?: number | null;
            expYear?: number | null;
            last4?: string | null;
          } | null;
        } | null;
        last?: {
          __typename?: "Invoice";
          amount?: number | null;
          products?: Array<string | null> | null;
          quantity?: number | null;
          status?: InvoiceStatus | null;
          createdAt?: string | null;
          finalizedAt?: string | null;
          invoicePdf?: string | null;
          hostedInvoiceUrl?: string | null;
          package?: OrganizationTariff | null;
          card?: {
            __typename?: "Card";
            brand?: string | null;
            expMonth?: number | null;
            expYear?: number | null;
            last4?: string | null;
          } | null;
        } | null;
        total?: {
          __typename?: "Invoice";
          amount?: number | null;
          products?: Array<string | null> | null;
          quantity?: number | null;
          status?: InvoiceStatus | null;
          createdAt?: string | null;
          finalizedAt?: string | null;
          invoicePdf?: string | null;
          hostedInvoiceUrl?: string | null;
          package?: OrganizationTariff | null;
          card?: {
            __typename?: "Card";
            brand?: string | null;
            expMonth?: number | null;
            expYear?: number | null;
            last4?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    parent?: {
      __typename?: "Organization";
      id: string;
      parentOID?: string | null;
      name: string;
      phone?: string | null;
      email?: string | null;
      tariffId?: string | null;
      newTariffId?: string | null;
      country?: string | null;
      timezone?: string | null;
      language?: OrganizationLanguage | null;
      activeMembersCount?: number | null;
      membersCount?: number | null;
      imageUrl?: string | null;
      address?: string | null;
      contactName?: string | null;
      contactCell?: string | null;
      stateDealerNumber?: string | null;
      website?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      isPendingDeletion?: boolean | null;
      isStale?: boolean | null;
      daysUntilStale?: number | null;
      isCurrent: boolean;
      rid: string;
      onboardStatus?: OnboardStatus | null;
      status: OrganizationStatus;
      isTrial?: boolean | null;
      isCanceled?: boolean | null;
      isPaymentFailed?: boolean | null;
      managerName?: string | null;
      managerPhone?: string | null;
      deletedAt?: string | null;
      trialFinishAt?: string | null;
      dealershipType?: DealershipType | null;
      vautoDealerId?: string | null;
      invoices?: {
        __typename?: "OrganizationInvoices";
        current?: {
          __typename?: "Invoice";
          amount?: number | null;
          products?: Array<string | null> | null;
          quantity?: number | null;
          status?: InvoiceStatus | null;
          createdAt?: string | null;
          finalizedAt?: string | null;
          invoicePdf?: string | null;
          hostedInvoiceUrl?: string | null;
          package?: OrganizationTariff | null;
          card?: {
            __typename?: "Card";
            brand?: string | null;
            expMonth?: number | null;
            expYear?: number | null;
            last4?: string | null;
          } | null;
        } | null;
        last?: {
          __typename?: "Invoice";
          amount?: number | null;
          products?: Array<string | null> | null;
          quantity?: number | null;
          status?: InvoiceStatus | null;
          createdAt?: string | null;
          finalizedAt?: string | null;
          invoicePdf?: string | null;
          hostedInvoiceUrl?: string | null;
          package?: OrganizationTariff | null;
          card?: {
            __typename?: "Card";
            brand?: string | null;
            expMonth?: number | null;
            expYear?: number | null;
            last4?: string | null;
          } | null;
        } | null;
        total?: {
          __typename?: "Invoice";
          amount?: number | null;
          products?: Array<string | null> | null;
          quantity?: number | null;
          status?: InvoiceStatus | null;
          createdAt?: string | null;
          finalizedAt?: string | null;
          invoicePdf?: string | null;
          hostedInvoiceUrl?: string | null;
          package?: OrganizationTariff | null;
          card?: {
            __typename?: "Card";
            brand?: string | null;
            expMonth?: number | null;
            expYear?: number | null;
            last4?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    subsidiaries: Array<{
      __typename?: "Organization";
      id: string;
      parentOID?: string | null;
      name: string;
      phone?: string | null;
      email?: string | null;
      tariffId?: string | null;
      newTariffId?: string | null;
      country?: string | null;
      timezone?: string | null;
      language?: OrganizationLanguage | null;
      activeMembersCount?: number | null;
      membersCount?: number | null;
      imageUrl?: string | null;
      address?: string | null;
      contactName?: string | null;
      contactCell?: string | null;
      stateDealerNumber?: string | null;
      website?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      isPendingDeletion?: boolean | null;
      isStale?: boolean | null;
      daysUntilStale?: number | null;
      isCurrent: boolean;
      rid: string;
      onboardStatus?: OnboardStatus | null;
      status: OrganizationStatus;
      isTrial?: boolean | null;
      isCanceled?: boolean | null;
      isPaymentFailed?: boolean | null;
      managerName?: string | null;
      managerPhone?: string | null;
      deletedAt?: string | null;
      trialFinishAt?: string | null;
      dealershipType?: DealershipType | null;
      vautoDealerId?: string | null;
      invoices?: {
        __typename?: "OrganizationInvoices";
        current?: {
          __typename?: "Invoice";
          amount?: number | null;
          products?: Array<string | null> | null;
          quantity?: number | null;
          status?: InvoiceStatus | null;
          createdAt?: string | null;
          finalizedAt?: string | null;
          invoicePdf?: string | null;
          hostedInvoiceUrl?: string | null;
          package?: OrganizationTariff | null;
          card?: {
            __typename?: "Card";
            brand?: string | null;
            expMonth?: number | null;
            expYear?: number | null;
            last4?: string | null;
          } | null;
        } | null;
        last?: {
          __typename?: "Invoice";
          amount?: number | null;
          products?: Array<string | null> | null;
          quantity?: number | null;
          status?: InvoiceStatus | null;
          createdAt?: string | null;
          finalizedAt?: string | null;
          invoicePdf?: string | null;
          hostedInvoiceUrl?: string | null;
          package?: OrganizationTariff | null;
          card?: {
            __typename?: "Card";
            brand?: string | null;
            expMonth?: number | null;
            expYear?: number | null;
            last4?: string | null;
          } | null;
        } | null;
        total?: {
          __typename?: "Invoice";
          amount?: number | null;
          products?: Array<string | null> | null;
          quantity?: number | null;
          status?: InvoiceStatus | null;
          createdAt?: string | null;
          finalizedAt?: string | null;
          invoicePdf?: string | null;
          hostedInvoiceUrl?: string | null;
          package?: OrganizationTariff | null;
          card?: {
            __typename?: "Card";
            brand?: string | null;
            expMonth?: number | null;
            expYear?: number | null;
            last4?: string | null;
          } | null;
        } | null;
      } | null;
    } | null>;
    totalCountsByStatus?: {
      __typename?: "OrganizationsCountByStatus";
      ACTIVE?: number | null;
      INACTIVE?: number | null;
      DRAFT?: number | null;
      ARCHIVED?: number | null;
    } | null;
  } | null;
};

export type GetCustomFieldsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomFieldsQuery = {
  __typename?: "Query";
  getCustomFields?: Array<{
    __typename?: "CustomFieldOutput";
    id: string;
    fieldName: string;
    dataType: CustomFieldDataType;
    description?: string | null;
    fieldOrder: number;
  } | null> | null;
};

export type GetClientTodoTasksQueryVariables = Exact<{
  clientId: Scalars["String"];
}>;

export type GetClientTodoTasksQuery = {
  __typename?: "Query";
  getClientTodoTasks?: Array<{
    __typename?: "ClientTodoTasksOutput";
    id: string;
    text?: string | null;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
    deadline?: string | null;
    isDone: boolean;
    operatorId?: string | null;
  } | null> | null;
};

export type SendCodeQueryVariables = Exact<{
  recipient: Scalars["String"];
  channel: VerifyCodeStatus;
}>;

export type SendCodeQuery = {
  __typename?: "Query";
  sendCode?: { __typename?: "ResponseStatus"; status?: string | null } | null;
};

export type CheckCodeQueryVariables = Exact<{
  recipient: Scalars["String"];
  code: Scalars["String"];
}>;

export type CheckCodeQuery = {
  __typename?: "Query";
  checkCode?: CheckCodeStatus | null;
};

export type GetLinkToAddCardQueryVariables = Exact<{
  successUrl: Scalars["String"];
}>;

export type GetLinkToAddCardQuery = {
  __typename?: "Query";
  getLinkToAddCard: string;
};

export type GetSigningDocumentQueryVariables = Exact<{ [key: string]: never }>;

export type GetSigningDocumentQuery = {
  __typename?: "Query";
  getSigningDocument?: {
    __typename?: "SigningDocumentOutput";
    signDocumentUrl: string;
  } | null;
};

export type GetInvoicesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars["String"]>;
  sortOrder?: InputMaybe<SortOrder>;
  sortBy?: InputMaybe<InvoiceSortBy>;
  itemsPerPage?: InputMaybe<Scalars["Int"]>;
  pageNumber?: InputMaybe<Scalars["Int"]>;
}>;

export type GetInvoicesQuery = {
  __typename?: "Query";
  getInvoices?: {
    __typename?: "InvoicesOutput";
    invoices?: Array<{
      __typename?: "Invoice";
      amount?: number | null;
      products?: Array<string | null> | null;
      quantity?: number | null;
      status?: InvoiceStatus | null;
      createdAt?: string | null;
      finalizedAt?: string | null;
      invoicePdf?: string | null;
      hostedInvoiceUrl?: string | null;
      package?: OrganizationTariff | null;
      card?: {
        __typename?: "Card";
        brand?: string | null;
        expMonth?: number | null;
        expYear?: number | null;
        last4?: string | null;
      } | null;
    } | null> | null;
    pagination?: {
      __typename?: "PaginationOutput";
      itemsPerPage?: number | null;
      pageNumber?: number | null;
      totalItems?: number | null;
    } | null;
  } | null;
};

export type GetCardQueryVariables = Exact<{ [key: string]: never }>;

export type GetCardQuery = {
  __typename?: "Query";
  getCard?: {
    __typename?: "Card";
    brand?: string | null;
    expMonth?: number | null;
    expYear?: number | null;
    last4?: string | null;
  } | null;
};

export type GetInquiriesQueryVariables = Exact<{
  clientId: Scalars["String"];
}>;

export type GetInquiriesQuery = {
  __typename?: "Query";
  getInquiries?: Array<{
    __typename?: "InquiryOutput";
    id?: string | null;
    createdAt?: string | null;
    clientId?: string | null;
    channelIdSource?: string | null;
    channelId?: string | null;
    leadSource?: string | null;
    vehicle?: string | null;
  } | null> | null;
};

export type GetNotificationsQueryVariables = Exact<{
  fetchSize: Scalars["Int"];
  pagingState?: InputMaybe<Scalars["String"]>;
  onlyTasks?: InputMaybe<Scalars["Boolean"]>;
  onlyAppointments?: InputMaybe<Scalars["Boolean"]>;
}>;

export type GetNotificationsQuery = {
  __typename?: "Query";
  getNotifications?: {
    __typename?: "NotificationsOutput";
    pagingState?: string | null;
    unreadCount?: number | null;
    notifications?: Array<{
      __typename?: "NotificationOutput";
      subtype: NotificationSubtype;
      createdAt: string;
      title: string;
      body: string;
      metadata?: string | null;
      isRead?: boolean | null;
      id: string;
    } | null> | null;
  } | null;
};

export type GetNotificationsSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetNotificationsSettingsQuery = {
  __typename?: "Query";
  getNotificationsSettings?: Array<{
    __typename?: "NotificationSettingOutput";
    subtype: NotificationSubtype;
    enabled: boolean;
  } | null> | null;
};

export type GetSignedDocumentQueryVariables = Exact<{
  input: SignedDocumentInput;
}>;

export type GetSignedDocumentQuery = {
  __typename?: "Query";
  getSignedDocument?: {
    __typename?: "SignedDocumentOutput";
    link: string;
  } | null;
};

export type GetInventoryQueryVariables = Exact<{
  input: GetInventoryInput;
}>;

export type GetInventoryQuery = {
  __typename?: "Query";
  getInventory?: {
    __typename?: "GetInventoryOutput";
    inventory?: Array<{
      __typename?: "InventoryOutput";
      id: string;
      year?: number | null;
      make?: string | null;
      model?: string | null;
      price?: number | null;
      centsPrice?: number | null;
      bodyType?: string | null;
      exteriorColor?: string | null;
      mileage?: number | null;
      trim?: string | null;
      mpg?: string | null;
      isAvailable?: boolean | null;
      vin: string;
      url?: string | null;
      carfaxLink?: string | null;
      leadsCount?: number | null;
      testDriveCount?: number | null;
      stockId?: string | null;
      source?: InventorySourceOutput | null;
      isNew?: boolean | null;
      status?: InventoryStatus | null;
      isConflictingStatus?: boolean | null;
      priceHistory?: Array<{
        __typename?: "priceHistoryFields";
        price?: number | null;
        createdAt?: string | null;
      } | null> | null;
    } | null> | null;
    pagination?: {
      __typename?: "PaginationOutput";
      itemsPerPage?: number | null;
      pageNumber?: number | null;
      totalItems?: number | null;
    } | null;
  } | null;
};

export type GetTranslationQueryVariables = Exact<{
  textToTranslation: Scalars["String"];
  translateToCode?: InputMaybe<LanguageCode_Iso_639_1>;
}>;

export type GetTranslationQuery = {
  __typename?: "Query";
  getTranslation: {
    __typename?: "TranslationOutput";
    isTranslated: boolean;
    translatedText: string;
    fromCode: LanguageCode_Iso_639_1;
    toCode: LanguageCode_Iso_639_1;
  };
};

export type GetTariffsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTariffsQuery = {
  __typename?: "Query";
  getTariffs?: Array<{
    __typename?: "TariffOutput";
    id: string;
    name: string;
    description?: string | null;
    products?: Array<{
      __typename?: "Product";
      name: string;
      description?: string | null;
      price?: number | null;
    } | null> | null;
  } | null> | null;
};

export type GetTariffsByOidQueryVariables = Exact<{ [key: string]: never }>;

export type GetTariffsByOidQuery = {
  __typename?: "Query";
  getTariffsByOID?: Array<{
    __typename?: "TariffOutput";
    id: string;
    name: string;
    description?: string | null;
    products?: Array<{
      __typename?: "Product";
      name: string;
      description?: string | null;
      price?: number | null;
    } | null> | null;
  } | null> | null;
};

export type GetTrialFinishDateQueryVariables = Exact<{ [key: string]: never }>;

export type GetTrialFinishDateQuery = {
  __typename?: "Query";
  getTrialFinishDate?: string | null;
};

export type GetInventoryDetailsQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetInventoryDetailsQuery = {
  __typename?: "Query";
  getInventoryDetails?: {
    __typename?: "GetInventoryDetailsOutput";
    id: string;
    carfaxLink?: string | null;
    imageLink?: string | null;
    additionalEquipments?: string | null;
    isSold?: boolean | null;
    status?: InventoryStatus | null;
  } | null;
};

export type GetMailingRecordQueryVariables = Exact<{
  roomId: Scalars["String"];
}>;

export type GetMailingRecordQuery = {
  __typename?: "Query";
  getMailingRecord?: {
    __typename?: "MailingRecordOutput";
    roomId: string;
    leadId?: number | null;
    sendAt?: string | null;
    actionType?: MailingActionType | null;
    deletedAt?: string | null;
    deleterName?: string | null;
    transferTo?: MailingTransferEnum | null;
  } | null;
};

export type GetFtpSyncStatusQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars["String"]>;
}>;

export type GetFtpSyncStatusQuery = {
  __typename?: "Query";
  getFTPSyncStatus?: {
    __typename?: "FTPSyncStatusOutput";
    lastSyncAt?: string | null;
    lastSyncStatus?: FtpSyncStatus | null;
  } | null;
};

export type GetOrganizationSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOrganizationSettingsQuery = {
  __typename?: "Query";
  getOrganizationSettings?: {
    __typename?: "OrganizationSettings";
    canOperatorAssignAppointments?: boolean | null;
  } | null;
};

export type EvaluateFeatureFlagsQueryVariables = Exact<{
  flagIds: Array<Scalars["String"]> | Scalars["String"];
  traits?: InputMaybe<Array<FeatureFlagTraitInput> | FeatureFlagTraitInput>;
}>;

export type EvaluateFeatureFlagsQuery = {
  __typename?: "Query";
  evaluateFeatureFlags: Array<{
    __typename?: "FeatureFlagEvaluation";
    flagId: string;
    enabled: boolean;
    value?: string | null;
  }>;
};

export type WatchUsersSubscriptionVariables = Exact<{ [key: string]: never }>;

export type WatchUsersSubscription = {
  __typename?: "Subscription";
  watchUsers?: {
    __typename?: "WatchUsersOutput";
    method?: MethodType | null;
    user?: {
      __typename?: "UserOutput";
      id: string;
      roleId?: string | null;
      isRoot?: boolean | null;
      optionalName: string;
      thirdParty?: string | null;
      position?: string | null;
      common?: {
        __typename?: "CommonUserFields";
        createdAt?: string | null;
        autoNickname?: string | null;
        userpicUrl?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phone?: string | null;
      } | null;
      onlineStatus?: {
        __typename?: "UserPresenceStatusOutput";
        userId?: string | null;
        presenceStatus?: PresenceStatus | null;
      } | null;
      teams?: Array<{
        __typename?: "TeamOutput";
        id: string;
        name: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
      } | null> | null;
      role?: {
        __typename?: "RoleOutput";
        roleDescription?: string | null;
        roleId?: string | null;
        rolePublicName?: string | null;
        roleTechnicalName?: string | null;
      } | null;
    } | null;
  } | null;
};

export type WatchRooms2SubscriptionVariables = Exact<{
  teamId: Scalars["String"];
  userId: Scalars["String"];
}>;

export type WatchRooms2Subscription = {
  __typename?: "Subscription";
  watchRooms2?: {
    __typename?: "MakeRooms2Output";
    error?: string | null;
    rooms?: Array<{
      __typename?: "RoomOutput2";
      id: string;
      leadId: number;
      status: RoomStatus;
      previousStatus?: RoomStatus | null;
      teamsIds: Array<string | null>;
      previousTeamsIds?: Array<string | null> | null;
      lastMessageAt?: string | null;
      lastClientMessageAt?: string | null;
      lastTicketAt?: string | null;
      unreadMessagesNumber: number;
      createdAt?: string | null;
      vehicle?: string | null;
      langCode?: LanguageCode_Iso_639_1 | null;
      currentLangCode?: LanguageCode_Iso_639_1 | null;
      isExpired: boolean;
      nonAcceptedTrigger?: NonAcceptedTriggers | null;
      channel: {
        __typename?: "ChannelOutput2";
        id: string;
        publicId: string;
        name: string;
        link: string;
        type: ChannelType;
        status: ChannelStatus;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        bot?: {
          __typename?: "BotOutput";
          id: string;
          name?: string | null;
        } | null;
      };
      client: {
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        whatsappUsername?: string | null;
        whatsappProfile?: string | null;
        telegramUsername?: string | null;
        telegramUserId?: string | null;
        facebookMessengerPsid?: string | null;
        vkUserId?: string | null;
        instagramBsid?: string | null;
        instagramProfile?: string | null;
        thirdParty?: string | null;
        twilioSmsUserId?: string | null;
        nylasUserEmail?: string | null;
        mailgunUserEmail?: string | null;
        sendgridUserEmail?: string | null;
        lastTicketAt?: string | null;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
        roomsLinks?: Array<{
          __typename?: "RoomLinkOutput";
          roomId?: string | null;
          roomStatus?: RoomStatus | null;
          channelType?: ChannelType | null;
          lastTicketAt?: string | null;
          vehicle?: string | null;
        } | null> | null;
        customFields?: Array<{
          __typename?: "UserCustomFieldOutput";
          fieldId: string;
          fieldName: string;
          dataType: CustomFieldDataType;
          description?: string | null;
          fieldOrder: number;
          value: string;
        } | null> | null;
      };
      activeOperator?: {
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        thirdParty?: string | null;
        position?: string | null;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
        onlineStatus?: {
          __typename?: "UserPresenceStatusOutput";
          userId?: string | null;
          presenceStatus?: PresenceStatus | null;
        } | null;
        teams?: Array<{
          __typename?: "TeamOutput";
          id: string;
          name: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
        } | null> | null;
        role?: {
          __typename?: "RoleOutput";
          roleDescription?: string | null;
          roleId?: string | null;
          rolePublicName?: string | null;
          roleTechnicalName?: string | null;
        } | null;
      } | null;
      operators: Array<{
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        thirdParty?: string | null;
        position?: string | null;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
        onlineStatus?: {
          __typename?: "UserPresenceStatusOutput";
          userId?: string | null;
          presenceStatus?: PresenceStatus | null;
        } | null;
        teams?: Array<{
          __typename?: "TeamOutput";
          id: string;
          name: string;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
        } | null> | null;
        role?: {
          __typename?: "RoleOutput";
          roleDescription?: string | null;
          roleId?: string | null;
          rolePublicName?: string | null;
          roleTechnicalName?: string | null;
        } | null;
      } | null>;
      lastMessageContent?: {
        __typename?: "LastMessageContentOutput";
        messageText?: string | null;
        messageContent?: Array<{
          __typename?: "MessageContentItemOutput";
          category?: string | null;
          fileExtension?: string | null;
          mimeType?: string | null;
          url?: string | null;
          fileName?: string | null;
          fileSize?: number | null;
          dimensions?: {
            __typename?: "MessageContentImageDimension";
            width: number;
            height: number;
          } | null;
        } | null> | null;
      } | null;
      linkedRooms: Array<{
        __typename?: "LinkedRoomOutput";
        id: string;
        lastMessageAt?: string | null;
        lastClientMessageAt?: string | null;
        lastTicketAt?: string | null;
        langCode?: LanguageCode_Iso_639_1 | null;
        unreadMessagesNumber: number;
        createdAt?: string | null;
        hasClientMessage: boolean;
        channel: {
          __typename?: "ChannelOutput2";
          id: string;
          publicId: string;
          name: string;
          link: string;
          type: ChannelType;
          status: ChannelStatus;
          createdAt: string;
          updatedAt: string;
          deletedAt?: string | null;
          bot?: {
            __typename?: "BotOutput";
            id: string;
            name?: string | null;
          } | null;
        };
        lastMessageContent?: {
          __typename?: "LastMessageContentOutput";
          messageText?: string | null;
          messageContent?: Array<{
            __typename?: "MessageContentItemOutput";
            category?: string | null;
            fileExtension?: string | null;
            mimeType?: string | null;
            url?: string | null;
            fileName?: string | null;
            fileSize?: number | null;
            dimensions?: {
              __typename?: "MessageContentImageDimension";
              width: number;
              height: number;
            } | null;
          } | null> | null;
        } | null;
      }>;
    } | null> | null;
  } | null;
};

export type WatchCreateMessageSubscriptionVariables = Exact<{
  channelType: ChannelType;
}>;

export type WatchCreateMessageSubscription = {
  __typename?: "Subscription";
  watchCreateMessage?: {
    __typename?: "MessageOutput";
    channelId?: string | null;
    channelTypeName?: ChannelType | null;
    chatRoomId?: string | null;
    chatRoomStatus?: string | null;
    messageAuthorId?: string | null;
    messageChannelId?: string | null;
    messageContent?: string | null;
    messageMetadata?: string | null;
    messageCreatedDateTime?: string | null;
    messageDeletedDateTime?: string | null;
    messageId?: string | null;
    messageIsDelivered?: boolean | null;
    messageIsRead?: boolean | null;
    messageIsSent?: boolean | null;
    messageText?: string | null;
    messageUpdatedDateTime?: string | null;
    textLangCode?: LanguageCode_Iso_639_1 | null;
    translatedText?: string | null;
    translatedTextLangCode?: LanguageCode_Iso_639_1 | null;
    localMessageId?: string | null;
    isFromClient: boolean;
    isFromBot: boolean;
  } | null;
};

export type WatchUpdateMessageDataSubscriptionVariables = Exact<{
  channelType: ChannelType;
}>;

export type WatchUpdateMessageDataSubscription = {
  __typename?: "Subscription";
  watchUpdateMessageData?: {
    __typename?: "UpdateMessageDataOutput";
    channelId?: string | null;
    channelTypeName?: ChannelType | null;
    chatRoomId?: string | null;
    chatRoomStatus?: string | null;
    isClient?: boolean | null;
    unreadMessagesNumber?: number | null;
    chatRoomMessages?: Array<{
      __typename?: "MessageOutput";
      channelId?: string | null;
      channelTypeName?: ChannelType | null;
      chatRoomId?: string | null;
      chatRoomStatus?: string | null;
      messageAuthorId?: string | null;
      messageChannelId?: string | null;
      messageContent?: string | null;
      messageMetadata?: string | null;
      messageCreatedDateTime?: string | null;
      messageDeletedDateTime?: string | null;
      messageId?: string | null;
      messageIsDelivered?: boolean | null;
      messageIsRead?: boolean | null;
      messageIsSent?: boolean | null;
      messageText?: string | null;
      messageUpdatedDateTime?: string | null;
      textLangCode?: LanguageCode_Iso_639_1 | null;
      translatedText?: string | null;
      translatedTextLangCode?: LanguageCode_Iso_639_1 | null;
      localMessageId?: string | null;
      isFromClient: boolean;
      isFromBot: boolean;
    } | null> | null;
  } | null;
};

export type WatchDeleteMessageSubscriptionVariables = Exact<{
  channelType: ChannelType;
}>;

export type WatchDeleteMessageSubscription = {
  __typename?: "Subscription";
  watchDeleteMessage?: {
    __typename?: "DeleteMessageOutput";
    channelType?: ChannelType | null;
    channelId?: string | null;
    chatRoomId?: string | null;
    messageId?: string | null;
  } | null;
};

export type WatchChannelsSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type WatchChannelsSubscription = {
  __typename?: "Subscription";
  watchChannels?: {
    __typename?: "WatchChannelOutput";
    method?: MethodType | null;
    channel?: {
      __typename?: "ChannelOutput2";
      id: string;
      publicId: string;
      name: string;
      link: string;
      type: ChannelType;
      status: ChannelStatus;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      bot?: {
        __typename?: "BotOutput";
        id: string;
        name?: string | null;
      } | null;
    } | null;
  } | null;
};

export type WatchCommentsSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type WatchCommentsSubscription = {
  __typename?: "Subscription";
  watchComments?: {
    __typename?: "WatchCommentOutput";
    method?: MethodType | null;
    comment?: {
      __typename?: "CommentOutput2";
      comment?: string | null;
      commentId?: string | null;
      createdAt?: string | null;
      clientId?: string | null;
      operator?: {
        __typename?: "UserOutput";
        id: string;
        roleId?: string | null;
        isRoot?: boolean | null;
        optionalName: string;
        common?: {
          __typename?: "CommonUserFields";
          createdAt?: string | null;
          autoNickname?: string | null;
          userpicUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type WatchBotsSubscriptionVariables = Exact<{ [key: string]: never }>;

export type WatchBotsSubscription = {
  __typename?: "Subscription";
  watchBots?: {
    __typename?: "WatchBotsOutput";
    bots?: Array<{
      __typename?: "BotOutput";
      isActive?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      publishedAt?: string | null;
      status?: BotStatus | null;
      sessionsCount?: number | null;
      botType?: BotType | null;
      teamsIds?: Array<string | null> | null;
      id: string;
      name?: string | null;
      connectedChannels?: Array<{
        __typename?: "ChannelOutput2";
        id: string;
        publicId: string;
        name: string;
        link: string;
        type: ChannelType;
        status: ChannelStatus;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        bot?: {
          __typename?: "BotOutput";
          id: string;
          name?: string | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type WatchCalendarEvents2SubscriptionVariables = Exact<{
  oid: Scalars["String"];
}>;

export type WatchCalendarEvents2Subscription = {
  __typename?: "Subscription";
  watchCalendarEvents2?: {
    __typename?: "BaseCalendarEventOutput2";
    actionType?: CalendarEventActionType | null;
    event?: {
      __typename?: "CalendarEventOutput2";
      id: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      title: string;
      description: string;
      starts?: string | null;
      ends?: string | null;
      isBot: boolean;
      userId?: string | null;
      roomId?: string | null;
      operatorId?: string | null;
      isNonWorking?: boolean | null;
    } | null;
  } | null;
};

export type WatchOnboardStatusSubscriptionVariables = Exact<{
  oid: Scalars["String"];
}>;

export type WatchOnboardStatusSubscription = {
  __typename?: "Subscription";
  watchOnboardStatus?: {
    __typename?: "WatchOnboardStatusOutput";
    oid: string;
    onboardStatus: OnboardStatus;
  } | null;
};

export type WatchClientInquiriesSubscriptionVariables = Exact<{
  oid: Scalars["String"];
}>;

export type WatchClientInquiriesSubscription = {
  __typename?: "Subscription";
  watchClientInquiries?: {
    __typename?: "WatchClientInquiriesOutput";
    oid: string;
    id?: string | null;
    createdAt?: string | null;
    clientId?: string | null;
    channelIdSource?: string | null;
    channelId?: string | null;
    leadSource?: string | null;
    vehicle?: string | null;
  } | null;
};

export type WatchNotificationsSubscriptionVariables = Exact<{
  userId: Scalars["String"];
}>;

export type WatchNotificationsSubscription = {
  __typename?: "Subscription";
  watchNotifications?: {
    __typename?: "NotificationOutput";
    subtype: NotificationSubtype;
    createdAt: string;
    title: string;
    body: string;
    metadata?: string | null;
    isRead?: boolean | null;
    id: string;
  } | null;
};

export type WatchPushNotificationsSubscriptionVariables = Exact<{
  userId: Scalars["String"];
}>;

export type WatchPushNotificationsSubscription = {
  __typename?: "Subscription";
  watchPushNotifications?: {
    __typename?: "NotificationOutput";
    subtype: NotificationSubtype;
    createdAt: string;
    title: string;
    body: string;
    metadata?: string | null;
    isRead?: boolean | null;
    id: string;
  } | null;
};

export type WatchOrganizationStatusSubscriptionVariables = Exact<{
  oid: Scalars["String"];
}>;

export type WatchOrganizationStatusSubscription = {
  __typename?: "Subscription";
  watchOrganizationStatus?: OrganizationStatus | null;
};

export type WatchMailingSubscriptionVariables = Exact<{ [key: string]: never }>;

export type WatchMailingSubscription = {
  __typename?: "Subscription";
  watchMailing?: {
    __typename?: "WatchMailingOutput";
    type: CustomFieldMethodType;
    roomId: string;
    leadId?: number | null;
    sendAt?: string | null;
    actionType?: MailingActionType | null;
    deletedAt?: string | null;
    deleterName?: string | null;
    transferTo?: MailingTransferEnum | null;
  } | null;
};

export type OnFeatureFlagsChangedSubscriptionVariables = Exact<{
  flagIds: Array<Scalars["String"]> | Scalars["String"];
  traits?: InputMaybe<Array<FeatureFlagTraitInput> | FeatureFlagTraitInput>;
}>;

export type OnFeatureFlagsChangedSubscription = {
  __typename?: "Subscription";
  onFeatureFlagsChanged: Array<{
    __typename?: "FeatureFlagEvaluation";
    flagId: string;
    enabled: boolean;
    value?: string | null;
  }>;
};

export const CoreUserFieldsFragmentDoc = gql`
  fragment CoreUserFields on UserOutput {
    id
    common {
      createdAt
      autoNickname
      userpicUrl
      firstName
      lastName
      email
      phone
    }
    roleId
    isRoot
    optionalName @client
  }
`;
export const CoreCommentsFieldsFragmentDoc = gql`
  fragment CoreCommentsFields on CommentOutput2 {
    comment
    commentId
    createdAt
    clientId
    operator {
      ...CoreUserFields
    }
  }
  ${CoreUserFieldsFragmentDoc}
`;
export const CoreTeamFieldsFragmentDoc = gql`
  fragment CoreTeamFields on TeamOutput {
    id
    name
    createdAt
    updatedAt
    deletedAt
  }
`;
export const CoreRoleFieldsFragmentDoc = gql`
  fragment CoreRoleFields on RoleOutput {
    roleDescription
    roleId
    rolePublicName
    roleTechnicalName
  }
`;
export const InternalUserFieldsFragmentDoc = gql`
  fragment InternalUserFields on UserOutput {
    thirdParty
    onlineStatus {
      userId
      presenceStatus
    }
    teams {
      ...CoreTeamFields
    }
    position
    role @client {
      ...CoreRoleFields
    }
    isRoot
  }
  ${CoreTeamFieldsFragmentDoc}
  ${CoreRoleFieldsFragmentDoc}
`;
export const ExtendedTeamFieldsFragmentDoc = gql`
  fragment ExtendedTeamFields on TeamOutput {
    ...CoreTeamFields
    users {
      ...CoreUserFields
      ...InternalUserFields
    }
  }
  ${CoreTeamFieldsFragmentDoc}
  ${CoreUserFieldsFragmentDoc}
  ${InternalUserFieldsFragmentDoc}
`;
export const CoreFlowFieldsFragmentDoc = gql`
  fragment CoreFlowFields on FlowOutput {
    id
    botId
    name
    createdAt
    isMain
    updatedAt
  }
`;
export const CoreBotFieldsFragmentDoc = gql`
  fragment CoreBotFields on BotOutput {
    id
    name
  }
`;
export const CoreChannelFieldsFragmentDoc = gql`
  fragment CoreChannelFields on ChannelOutput2 {
    id
    publicId
    bot {
      ...CoreBotFields
    }
    name
    link
    type
    status
    createdAt
    updatedAt
    deletedAt
  }
  ${CoreBotFieldsFragmentDoc}
`;
export const ExtendedChannelFieldsFragmentDoc = gql`
  fragment ExtendedChannelFields on ChannelOutput2 {
    ...CoreChannelFields
    bot {
      ...CoreBotFields
    }
  }
  ${CoreChannelFieldsFragmentDoc}
  ${CoreBotFieldsFragmentDoc}
`;
export const ExtendedBotFieldsFragmentDoc = gql`
  fragment ExtendedBotFields on BotOutput {
    ...CoreBotFields
    isActive
    createdAt
    updatedAt
    publishedAt
    status
    sessionsCount
    botType
    teamsIds
    connectedChannels @client {
      ...CoreChannelFields
    }
  }
  ${CoreBotFieldsFragmentDoc}
  ${CoreChannelFieldsFragmentDoc}
`;
export const CoreRoomLinkFieldsFragmentDoc = gql`
  fragment CoreRoomLinkFields on RoomLinkOutput {
    roomId
    roomStatus
    channelType
    lastTicketAt
    vehicle
  }
`;
export const CoreUserCustomFieldFieldsFragmentDoc = gql`
  fragment CoreUserCustomFieldFields on UserCustomFieldOutput {
    fieldId
    fieldName
    dataType
    description
    fieldOrder
    value
  }
`;
export const ClientFieldsFragmentDoc = gql`
  fragment ClientFields on UserOutput {
    whatsappUsername
    whatsappProfile
    telegramUsername
    telegramUserId
    facebookMessengerPsid
    vkUserId
    instagramBsid
    instagramProfile
    thirdParty
    twilioSmsUserId
    nylasUserEmail
    mailgunUserEmail
    sendgridUserEmail
    roomsLinks {
      ...CoreRoomLinkFields
    }
    customFields {
      ...CoreUserCustomFieldFields
    }
    lastTicketAt @client
  }
  ${CoreRoomLinkFieldsFragmentDoc}
  ${CoreUserCustomFieldFieldsFragmentDoc}
`;
export const CoreLinkedRoomFieldsFragmentDoc = gql`
  fragment CoreLinkedRoomFields on LinkedRoomOutput {
    id
    channel {
      ...CoreChannelFields
    }
    lastMessageContent {
      messageText
      messageContent {
        category
        fileExtension
        mimeType
        url
        fileName
        fileSize
        dimensions {
          width
          height
        }
      }
    }
    lastMessageAt
    lastClientMessageAt
    lastTicketAt
    langCode
    unreadMessagesNumber
    createdAt
    hasClientMessage
  }
  ${CoreChannelFieldsFragmentDoc}
`;
export const CoreRoomFieldsFragmentDoc = gql`
  fragment CoreRoomFields on RoomOutput2 {
    id
    leadId
    status
    previousStatus
    channel {
      ...CoreChannelFields
    }
    client {
      ...CoreUserFields
      ...ClientFields
    }
    teamsIds
    previousTeamsIds
    activeOperator {
      ...CoreUserFields
      ...InternalUserFields
    }
    operators {
      ...CoreUserFields
      ...InternalUserFields
    }
    lastMessageContent {
      messageText
      messageContent {
        category
        fileExtension
        mimeType
        url
        fileName
        fileSize
        dimensions {
          width
          height
        }
      }
    }
    lastMessageAt
    lastClientMessageAt
    lastTicketAt
    unreadMessagesNumber
    createdAt
    linkedRooms {
      ...CoreLinkedRoomFields
    }
    vehicle
    langCode
    createdAt
    currentLangCode @client
    isExpired @client
    nonAcceptedTrigger
  }
  ${CoreChannelFieldsFragmentDoc}
  ${CoreUserFieldsFragmentDoc}
  ${ClientFieldsFragmentDoc}
  ${InternalUserFieldsFragmentDoc}
  ${CoreLinkedRoomFieldsFragmentDoc}
`;
export const CoreMessageFieldsFragmentDoc = gql`
  fragment CoreMessageFields on MessageOutput {
    channelId
    channelTypeName
    chatRoomId
    chatRoomStatus
    messageAuthorId
    messageChannelId
    messageContent
    messageMetadata
    messageCreatedDateTime
    messageDeletedDateTime
    messageId
    messageIsDelivered
    messageIsRead
    messageIsSent
    messageText
    messageUpdatedDateTime
    textLangCode
    translatedText
    translatedTextLangCode
    localMessageId
    isFromClient @client
    isFromBot @client
  }
`;
export const CoreValidateBotFieldsFragmentDoc = gql`
  fragment CoreValidateBotFields on ValidateBot {
    id
    errorMessage
    statusCode
    nodeType
    flowId
  }
`;
export const CoreLanguageMapFieldsFragmentDoc = gql`
  fragment CoreLanguageMapFields on LanguageMap {
    en
    ru
    af
    sq
    ar
    az
    bn
    bg
    ca
    zh
    hr
    cs
    da
    nl
    et
    fil
    fi
    fr
    ka
    de
    el
    gu
    ha
    he
    hi
    hu
    id
    ga
    it
    ja
    kn
    kk
    rw
    ko
    ky
    lo
    lv
    lt
    mk
    ms
    ml
    mr
    nb
    fa
    pl
    pt
    pa
    ro
    sr
    sk
    sl
    es
    sw
    sv
    ta
    te
    th
    tr
    uk
    ur
    uz
    vi
    zu
  }
`;
export const CoreAppInnerFieldFragmentDoc = gql`
  fragment CoreAppInnerField on AppFieldInner {
    t
    tg
    dt
    dts
    n {
      ...CoreLanguageMapFields
    }
    p {
      ...CoreLanguageMapFields
    }
    d {
      ...CoreLanguageMapFields
    }
    r
    mn
    mx
    v @client
  }
  ${CoreLanguageMapFieldsFragmentDoc}
`;
export const CoreAppInnerGroupFragmentDoc = gql`
  fragment CoreAppInnerGroup on AppFieldsGroupInner {
    g
    c {
      ...CoreAppInnerField
    }
  }
  ${CoreAppInnerFieldFragmentDoc}
`;
export const CoreAppFieldDetailsFragmentDoc = gql`
  fragment CoreAppFieldDetails on AppFieldDetails {
    ... on AppFieldInner {
      ...CoreAppInnerField
    }
    ... on AppFieldsGroupInner {
      ...CoreAppInnerGroup
    }
  }
  ${CoreAppInnerFieldFragmentDoc}
  ${CoreAppInnerGroupFragmentDoc}
`;
export const CoreAppFieldFragmentDoc = gql`
  fragment CoreAppField on AppField {
    t
    tg
    dt
    dts
    n {
      ...CoreLanguageMapFields
    }
    p {
      ...CoreLanguageMapFields
    }
    d {
      ...CoreLanguageMapFields
    }
    r
    mn
    mx
    c {
      ... on AppFieldInner {
        ...CoreAppInnerField
      }
      ... on AppFieldsGroupInner {
        ...CoreAppInnerGroup
      }
    }
    v @client
  }
  ${CoreLanguageMapFieldsFragmentDoc}
  ${CoreAppInnerFieldFragmentDoc}
  ${CoreAppInnerGroupFragmentDoc}
`;
export const CoreGroupFieldsFragmentDoc = gql`
  fragment CoreGroupFields on AppFieldsGroup {
    g
    c {
      ...CoreAppField
    }
  }
  ${CoreAppFieldFragmentDoc}
`;
export const CoreAppSettingsInnerFieldFragmentDoc = gql`
  fragment CoreAppSettingsInnerField on AppSettingsFieldInner {
    tg
    dt
    v
  }
`;
export const CoreAppSettingsInnerGroupFragmentDoc = gql`
  fragment CoreAppSettingsInnerGroup on AppSettingsGroupInner {
    g
    c {
      ...CoreAppSettingsInnerField
    }
  }
  ${CoreAppSettingsInnerFieldFragmentDoc}
`;
export const CoreAppSettingsFieldFragmentDoc = gql`
  fragment CoreAppSettingsField on AppSettingsField {
    tg
    dt
    v
    c {
      ... on AppSettingsFieldInner {
        ...CoreAppSettingsInnerField
      }
      ... on AppSettingsGroupInner {
        ...CoreAppSettingsInnerGroup
      }
    }
  }
  ${CoreAppSettingsInnerFieldFragmentDoc}
  ${CoreAppSettingsInnerGroupFragmentDoc}
`;
export const CoreAppSettingsGroupFragmentDoc = gql`
  fragment CoreAppSettingsGroup on AppSettingsGroup {
    g
    c {
      ...CoreAppSettingsField
    }
  }
  ${CoreAppSettingsFieldFragmentDoc}
`;
export const CoreInstallationsFieldFragmentDoc = gql`
  fragment CoreInstallationsField on AppInstallation {
    id
    createdAt
    method
    localId
    settings {
      ...CoreAppSettingsGroup
    }
  }
  ${CoreAppSettingsGroupFragmentDoc}
`;
export const CoreVersionFieldsFragmentDoc = gql`
  fragment CoreVersionFields on AppVersion {
    version
    createdAt
    id
    fields {
      ...CoreGroupFields
    }
    installations {
      ...CoreInstallationsField
    }
    isInstalled
  }
  ${CoreGroupFieldsFragmentDoc}
  ${CoreInstallationsFieldFragmentDoc}
`;
export const CoreAppFieldsFragmentDoc = gql`
  fragment CoreAppFields on AppOutput {
    id
    name {
      ...CoreLanguageMapFields
    }
    iconUrl
    gallery
    description {
      ...CoreLanguageMapFields
    }
    instructions {
      ...CoreLanguageMapFields
    }
    type
    tag
    latestVersion
    createdAt
    isAvailable
    isInstalled
    versions {
      ...CoreVersionFields
    }
  }
  ${CoreLanguageMapFieldsFragmentDoc}
  ${CoreVersionFieldsFragmentDoc}
`;
export const CoreButtonFieldsFragmentDoc = gql`
  fragment CoreButtonFields on ButtonOutput {
    id
    localId
    name
    nodeId
    localNodeId
    buttonOrder
    botId
  }
`;
export const CoreNodeFieldsFragmentDoc = gql`
  fragment CoreNodeFields on NodeOutput {
    id
    localId
    flowId
    coordinates
    nodeType
    fileUrl
    imageUrl
    text
    childFlowId
    isDelete
    teamsIds
    buttons {
      ...CoreButtonFields
    }
    botId
    exceptionText
    saveTo
    appId
    appVersionId
    appInstalledId
  }
  ${CoreButtonFieldsFragmentDoc}
`;
export const CoreEdgeFieldsFragmentDoc = gql`
  fragment CoreEdgeFields on EdgeOutput {
    id
    localId
    botId
    flowId
    childId
    localChildId
    parentId
    localParentId
    handleParentId
    localHandleParentId
    isDelete
  }
`;
export const CoreSnippetCategoryFieldsFragmentDoc = gql`
  fragment CoreSnippetCategoryFields on ChatSnippetsCategoriesOutput {
    categoryId
    categoryName
    parentId
    userId
    totalSnippetsCount
  }
`;
export const CoreSnippetFieldsFragmentDoc = gql`
  fragment CoreSnippetFields on ChatSnippetsOutput {
    snippetId
    userId
    categoryId
    snippet
    teamsIds
    isFavorite @client
  }
`;
export const CoreSnippetFavoriteFieldsFragmentDoc = gql`
  fragment CoreSnippetFavoriteFields on ChatSnippetsFavoritesOutput {
    snippetId
    userId
    isFavorite @client
  }
`;
export const CoreRoomEventFieldsFragmentDoc = gql`
  fragment CoreRoomEventFields on RoomEventOutput {
    eventCreatedAt
    eventInitiator
    initiatorType
    toUser
    fromUser
    toTeams
    fromTeams
    actionName
    text @client
  }
`;
export const CoreCalendarEventFields2FragmentDoc = gql`
  fragment CoreCalendarEventFields2 on CalendarEventOutput2 {
    id
    createdAt
    updatedAt
    deletedAt
    title
    description
    starts
    ends
    isBot
    userId
    roomId
    operatorId
    isNonWorking
  }
`;
export const CoreCustomFieldFieldsFragmentDoc = gql`
  fragment CoreCustomFieldFields on CustomFieldOutput {
    id
    fieldName
    dataType
    description
    fieldOrder
  }
`;
export const CoreCardFieldsFragmentDoc = gql`
  fragment CoreCardFields on Card {
    brand
    expMonth
    expYear
    last4
  }
`;
export const CoreInvoicesFieldsFragmentDoc = gql`
  fragment CoreInvoicesFields on Invoice {
    amount
    products
    quantity
    status
    createdAt
    finalizedAt
    card {
      ...CoreCardFields
    }
    invoicePdf
    hostedInvoiceUrl
    package
  }
  ${CoreCardFieldsFragmentDoc}
`;
export const CoreOrganizationFieldsFragmentDoc = gql`
  fragment CoreOrganizationFields on Organization {
    id
    parentOID
    name
    phone
    email
    tariffId
    newTariffId
    country
    timezone
    language
    activeMembersCount
    membersCount
    imageUrl
    address
    contactName
    contactCell
    stateDealerNumber
    website
    createdAt
    updatedAt
    isPendingDeletion
    isStale
    daysUntilStale
    isCurrent
    rid
    onboardStatus
    status
    invoices {
      current {
        ...CoreInvoicesFields
      }
      last {
        ...CoreInvoicesFields
      }
      total {
        ...CoreInvoicesFields
      }
    }
    isTrial
    isCanceled
    isPaymentFailed
    managerName
    managerPhone
    deletedAt
    trialFinishAt
    dealershipType
    vautoDealerId
  }
  ${CoreInvoicesFieldsFragmentDoc}
`;
export const CoreClientTodoFieldsFragmentDoc = gql`
  fragment CoreClientTodoFields on ClientTodoTasksOutput {
    id
    text
    createdAt
    updatedAt
    deletedAt
    deadline
    isDone
    operatorId
  }
`;
export const CoreInquiryFieldsFragmentDoc = gql`
  fragment CoreInquiryFields on InquiryOutput {
    id
    createdAt
    clientId
    channelIdSource
    channelId
    leadSource
    vehicle
  }
`;
export const CoreNotificationsFieldsFragmentDoc = gql`
  fragment CoreNotificationsFields on NotificationOutput {
    subtype
    createdAt
    title
    body
    metadata
    isRead
    id
  }
`;
export const CoreGeneralAnalyticsFieldsFragmentDoc = gql`
  fragment CoreGeneralAnalyticsFields on GeneralAnalyticsOutput {
    totalContacts
    totalChats
    calendarAppointments {
      labels
      series
    }
    leadsByMarketplace {
      labels
      series
    }
    chatsByChannels {
      labels
      series {
        EMAIL
        SMS
      }
    }
    nonAcceptedChats
    appointmentsNonWorking {
      labels
      series
    }
    leadsNonWorking {
      labels
      series
    }
  }
`;
export const CoreChatsAnalyticsFieldsFragmentDoc = gql`
  fragment CoreChatsAnalyticsFields on ChatsAnalyticsOutput {
    invisibleChats
    nonAcceptedChats
    nonRespondedChats
    acceptedChats
    calendarAppointments {
      labels
      series
    }
    newChats7d {
      series {
        name
        data
      }
      xAxis {
        categories
      }
    }
  }
`;
export const CoreOperatorsAnalyticsFieldsFragmentDoc = gql`
  fragment CoreOperatorsAnalyticsFields on OperatorsAnalyticsOutput {
    avgChatsPerOperatorPerDay
    avgAcceptedToFirstMessage
    avgAccepted
    acceptedByOperatorsByPeriodMap {
      name
      data {
        x
        y
      }
    }
    operatorsMetricsTable {
      operatorName
      completedChats
      avgFirstMessageSec
      avgAcceptedSec
    }
  }
`;
export const CoreTariffFieldsFragmentDoc = gql`
  fragment CoreTariffFields on TariffOutput {
    id
    name
    description
    products {
      name
      description
      price
    }
  }
`;
export const CoreInventoryDetailsFieldsFragmentDoc = gql`
  fragment CoreInventoryDetailsFields on GetInventoryDetailsOutput {
    id
    carfaxLink
    imageLink
    additionalEquipments
    isSold
    status
  }
`;
export const CoreMailingRecordFieldsFragmentDoc = gql`
  fragment CoreMailingRecordFields on MailingRecordOutput {
    roomId
    leadId
    sendAt
    actionType
    deletedAt
    deleterName
    transferTo
  }
`;
export const MakeOrganizationDocument = gql`
  mutation MakeOrganization($input: MakeOrganizationInput) {
    makeOrganization(input: $input) {
      ...CoreOrganizationFields
    }
  }
  ${CoreOrganizationFieldsFragmentDoc}
`;
export type MakeOrganizationMutationFn = Apollo.MutationFunction<
  MakeOrganizationMutation,
  MakeOrganizationMutationVariables
>;

/**
 * __useMakeOrganizationMutation__
 *
 * To run a mutation, you first call `useMakeOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeOrganizationMutation, { data, loading, error }] = useMakeOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeOrganizationMutation,
    MakeOrganizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MakeOrganizationMutation,
    MakeOrganizationMutationVariables
  >(MakeOrganizationDocument, options);
}
export type MakeOrganizationMutationHookResult = ReturnType<
  typeof useMakeOrganizationMutation
>;
export type MakeOrganizationMutationResult =
  Apollo.MutationResult<MakeOrganizationMutation>;
export type MakeOrganizationMutationOptions = Apollo.BaseMutationOptions<
  MakeOrganizationMutation,
  MakeOrganizationMutationVariables
>;
export const MakeUserDocument = gql`
  mutation MakeUser($input: MakeUserInput) {
    makeUser(input: $input) {
      ...CoreUserFields
      ...InternalUserFields
      ...ClientFields
    }
  }
  ${CoreUserFieldsFragmentDoc}
  ${InternalUserFieldsFragmentDoc}
  ${ClientFieldsFragmentDoc}
`;
export type MakeUserMutationFn = Apollo.MutationFunction<
  MakeUserMutation,
  MakeUserMutationVariables
>;

/**
 * __useMakeUserMutation__
 *
 * To run a mutation, you first call `useMakeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeUserMutation, { data, loading, error }] = useMakeUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeUserMutation,
    MakeUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MakeUserMutation, MakeUserMutationVariables>(
    MakeUserDocument,
    options
  );
}
export type MakeUserMutationHookResult = ReturnType<typeof useMakeUserMutation>;
export type MakeUserMutationResult = Apollo.MutationResult<MakeUserMutation>;
export type MakeUserMutationOptions = Apollo.BaseMutationOptions<
  MakeUserMutation,
  MakeUserMutationVariables
>;
export const MakeChannel2Document = gql`
  mutation MakeChannel2($input: MakeChannel2Input!) {
    makeChannel2(input: $input) {
      ...ExtendedChannelFields
    }
  }
  ${ExtendedChannelFieldsFragmentDoc}
`;
export type MakeChannel2MutationFn = Apollo.MutationFunction<
  MakeChannel2Mutation,
  MakeChannel2MutationVariables
>;

/**
 * __useMakeChannel2Mutation__
 *
 * To run a mutation, you first call `useMakeChannel2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeChannel2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeChannel2Mutation, { data, loading, error }] = useMakeChannel2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeChannel2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeChannel2Mutation,
    MakeChannel2MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MakeChannel2Mutation,
    MakeChannel2MutationVariables
  >(MakeChannel2Document, options);
}
export type MakeChannel2MutationHookResult = ReturnType<
  typeof useMakeChannel2Mutation
>;
export type MakeChannel2MutationResult =
  Apollo.MutationResult<MakeChannel2Mutation>;
export type MakeChannel2MutationOptions = Apollo.BaseMutationOptions<
  MakeChannel2Mutation,
  MakeChannel2MutationVariables
>;
export const MakeBotDocument = gql`
  mutation MakeBot($input: MakeBotInput) {
    makeBot(input: $input) {
      ...ExtendedBotFields
    }
  }
  ${ExtendedBotFieldsFragmentDoc}
`;
export type MakeBotMutationFn = Apollo.MutationFunction<
  MakeBotMutation,
  MakeBotMutationVariables
>;

/**
 * __useMakeBotMutation__
 *
 * To run a mutation, you first call `useMakeBotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeBotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeBotMutation, { data, loading, error }] = useMakeBotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeBotMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeBotMutation,
    MakeBotMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MakeBotMutation, MakeBotMutationVariables>(
    MakeBotDocument,
    options
  );
}
export type MakeBotMutationHookResult = ReturnType<typeof useMakeBotMutation>;
export type MakeBotMutationResult = Apollo.MutationResult<MakeBotMutation>;
export type MakeBotMutationOptions = Apollo.BaseMutationOptions<
  MakeBotMutation,
  MakeBotMutationVariables
>;
export const MakeFlowDocument = gql`
  mutation MakeFlow($input: MakeFlowInput) {
    makeFlow(input: $input) {
      ...CoreFlowFields
    }
  }
  ${CoreFlowFieldsFragmentDoc}
`;
export type MakeFlowMutationFn = Apollo.MutationFunction<
  MakeFlowMutation,
  MakeFlowMutationVariables
>;

/**
 * __useMakeFlowMutation__
 *
 * To run a mutation, you first call `useMakeFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeFlowMutation, { data, loading, error }] = useMakeFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeFlowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeFlowMutation,
    MakeFlowMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MakeFlowMutation, MakeFlowMutationVariables>(
    MakeFlowDocument,
    options
  );
}
export type MakeFlowMutationHookResult = ReturnType<typeof useMakeFlowMutation>;
export type MakeFlowMutationResult = Apollo.MutationResult<MakeFlowMutation>;
export type MakeFlowMutationOptions = Apollo.BaseMutationOptions<
  MakeFlowMutation,
  MakeFlowMutationVariables
>;
export const DuplicateBotDocument = gql`
  mutation DuplicateBot($id: String!, $newName: String) {
    duplicateBot(id: $id, newName: $newName) {
      ...ExtendedBotFields
    }
  }
  ${ExtendedBotFieldsFragmentDoc}
`;
export type DuplicateBotMutationFn = Apollo.MutationFunction<
  DuplicateBotMutation,
  DuplicateBotMutationVariables
>;

/**
 * __useDuplicateBotMutation__
 *
 * To run a mutation, you first call `useDuplicateBotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateBotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateBotMutation, { data, loading, error }] = useDuplicateBotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useDuplicateBotMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateBotMutation,
    DuplicateBotMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DuplicateBotMutation,
    DuplicateBotMutationVariables
  >(DuplicateBotDocument, options);
}
export type DuplicateBotMutationHookResult = ReturnType<
  typeof useDuplicateBotMutation
>;
export type DuplicateBotMutationResult =
  Apollo.MutationResult<DuplicateBotMutation>;
export type DuplicateBotMutationOptions = Apollo.BaseMutationOptions<
  DuplicateBotMutation,
  DuplicateBotMutationVariables
>;
export const MakeRooms2Document = gql`
  mutation MakeRooms2($input: MakeRooms2Input) {
    makeRooms2(input: $input) {
      rooms {
        ...CoreRoomFields
      }
      error
    }
  }
  ${CoreRoomFieldsFragmentDoc}
`;
export type MakeRooms2MutationFn = Apollo.MutationFunction<
  MakeRooms2Mutation,
  MakeRooms2MutationVariables
>;

/**
 * __useMakeRooms2Mutation__
 *
 * To run a mutation, you first call `useMakeRooms2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeRooms2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeRooms2Mutation, { data, loading, error }] = useMakeRooms2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeRooms2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeRooms2Mutation,
    MakeRooms2MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MakeRooms2Mutation, MakeRooms2MutationVariables>(
    MakeRooms2Document,
    options
  );
}
export type MakeRooms2MutationHookResult = ReturnType<
  typeof useMakeRooms2Mutation
>;
export type MakeRooms2MutationResult =
  Apollo.MutationResult<MakeRooms2Mutation>;
export type MakeRooms2MutationOptions = Apollo.BaseMutationOptions<
  MakeRooms2Mutation,
  MakeRooms2MutationVariables
>;
export const UpdateMessageDataDocument = gql`
  mutation UpdateMessageData($input: UpdateMessageDataInput) {
    updateMessageData(input: $input) {
      channelId
      channelTypeName
      chatRoomId
      chatRoomMessages {
        ...CoreMessageFields
      }
      chatRoomStatus
      isClient
      unreadMessagesNumber
    }
  }
  ${CoreMessageFieldsFragmentDoc}
`;
export type UpdateMessageDataMutationFn = Apollo.MutationFunction<
  UpdateMessageDataMutation,
  UpdateMessageDataMutationVariables
>;

/**
 * __useUpdateMessageDataMutation__
 *
 * To run a mutation, you first call `useUpdateMessageDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageDataMutation, { data, loading, error }] = useUpdateMessageDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessageDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMessageDataMutation,
    UpdateMessageDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMessageDataMutation,
    UpdateMessageDataMutationVariables
  >(UpdateMessageDataDocument, options);
}
export type UpdateMessageDataMutationHookResult = ReturnType<
  typeof useUpdateMessageDataMutation
>;
export type UpdateMessageDataMutationResult =
  Apollo.MutationResult<UpdateMessageDataMutation>;
export type UpdateMessageDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateMessageDataMutation,
  UpdateMessageDataMutationVariables
>;
export const CreateMessageDocument = gql`
  mutation CreateMessage($input: CreateChatRoomMessageInput) {
    createMessage(input: $input) {
      ...CoreMessageFields
    }
  }
  ${CoreMessageFieldsFragmentDoc}
`;
export type CreateMessageMutationFn = Apollo.MutationFunction<
  CreateMessageMutation,
  CreateMessageMutationVariables
>;

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMessageMutation,
    CreateMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMessageMutation,
    CreateMessageMutationVariables
  >(CreateMessageDocument, options);
}
export type CreateMessageMutationHookResult = ReturnType<
  typeof useCreateMessageMutation
>;
export type CreateMessageMutationResult =
  Apollo.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<
  CreateMessageMutation,
  CreateMessageMutationVariables
>;
export const CreateCommentOnClient2Document = gql`
  mutation CreateCommentOnClient2($input: CreateCommentOnClientInput) {
    createCommentOnClient2(input: $input) {
      ...CoreCommentsFields
    }
  }
  ${CoreCommentsFieldsFragmentDoc}
`;
export type CreateCommentOnClient2MutationFn = Apollo.MutationFunction<
  CreateCommentOnClient2Mutation,
  CreateCommentOnClient2MutationVariables
>;

/**
 * __useCreateCommentOnClient2Mutation__
 *
 * To run a mutation, you first call `useCreateCommentOnClient2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentOnClient2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentOnClient2Mutation, { data, loading, error }] = useCreateCommentOnClient2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentOnClient2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCommentOnClient2Mutation,
    CreateCommentOnClient2MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCommentOnClient2Mutation,
    CreateCommentOnClient2MutationVariables
  >(CreateCommentOnClient2Document, options);
}
export type CreateCommentOnClient2MutationHookResult = ReturnType<
  typeof useCreateCommentOnClient2Mutation
>;
export type CreateCommentOnClient2MutationResult =
  Apollo.MutationResult<CreateCommentOnClient2Mutation>;
export type CreateCommentOnClient2MutationOptions = Apollo.BaseMutationOptions<
  CreateCommentOnClient2Mutation,
  CreateCommentOnClient2MutationVariables
>;
export const DeleteCommentDocument = gql`
  mutation DeleteComment($commentId: String!) {
    deleteComment(commentId: $commentId) {
      status
    }
  }
`;
export type DeleteCommentMutationFn = Apollo.MutationFunction<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCommentMutation,
    DeleteCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCommentMutation,
    DeleteCommentMutationVariables
  >(DeleteCommentDocument, options);
}
export type DeleteCommentMutationHookResult = ReturnType<
  typeof useDeleteCommentMutation
>;
export type DeleteCommentMutationResult =
  Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>;
export const SetNodesAndEdgesDocument = gql`
  mutation SetNodesAndEdges($input: SetNodesAndEdgesInput) {
    setNodesAndEdges(input: $input) {
      nodes {
        ...CoreNodeFields
      }
      edges {
        ...CoreEdgeFields
      }
    }
  }
  ${CoreNodeFieldsFragmentDoc}
  ${CoreEdgeFieldsFragmentDoc}
`;
export type SetNodesAndEdgesMutationFn = Apollo.MutationFunction<
  SetNodesAndEdgesMutation,
  SetNodesAndEdgesMutationVariables
>;

/**
 * __useSetNodesAndEdgesMutation__
 *
 * To run a mutation, you first call `useSetNodesAndEdgesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNodesAndEdgesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNodesAndEdgesMutation, { data, loading, error }] = useSetNodesAndEdgesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetNodesAndEdgesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetNodesAndEdgesMutation,
    SetNodesAndEdgesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetNodesAndEdgesMutation,
    SetNodesAndEdgesMutationVariables
  >(SetNodesAndEdgesDocument, options);
}
export type SetNodesAndEdgesMutationHookResult = ReturnType<
  typeof useSetNodesAndEdgesMutation
>;
export type SetNodesAndEdgesMutationResult =
  Apollo.MutationResult<SetNodesAndEdgesMutation>;
export type SetNodesAndEdgesMutationOptions = Apollo.BaseMutationOptions<
  SetNodesAndEdgesMutation,
  SetNodesAndEdgesMutationVariables
>;
export const CreateChatSnippetDocument = gql`
  mutation CreateChatSnippet(
    $userId: String!
    $snippet: String!
    $categoryId: String
    $teamsIds: [String!]
  ) {
    createChatSnippet(
      userId: $userId
      snippet: $snippet
      categoryId: $categoryId
      teamsIds: $teamsIds
    ) {
      ...CoreSnippetFields
    }
  }
  ${CoreSnippetFieldsFragmentDoc}
`;
export type CreateChatSnippetMutationFn = Apollo.MutationFunction<
  CreateChatSnippetMutation,
  CreateChatSnippetMutationVariables
>;

/**
 * __useCreateChatSnippetMutation__
 *
 * To run a mutation, you first call `useCreateChatSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatSnippetMutation, { data, loading, error }] = useCreateChatSnippetMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      snippet: // value for 'snippet'
 *      categoryId: // value for 'categoryId'
 *      teamsIds: // value for 'teamsIds'
 *   },
 * });
 */
export function useCreateChatSnippetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChatSnippetMutation,
    CreateChatSnippetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateChatSnippetMutation,
    CreateChatSnippetMutationVariables
  >(CreateChatSnippetDocument, options);
}
export type CreateChatSnippetMutationHookResult = ReturnType<
  typeof useCreateChatSnippetMutation
>;
export type CreateChatSnippetMutationResult =
  Apollo.MutationResult<CreateChatSnippetMutation>;
export type CreateChatSnippetMutationOptions = Apollo.BaseMutationOptions<
  CreateChatSnippetMutation,
  CreateChatSnippetMutationVariables
>;
export const UpdateChatSnippetDocument = gql`
  mutation UpdateChatSnippet(
    $snippetId: String!
    $userId: String!
    $snippet: String
    $categoryId: String
    $teamsIds: [String!]
  ) {
    updateChatSnippet(
      snippetId: $snippetId
      userId: $userId
      snippet: $snippet
      categoryId: $categoryId
      teamsIds: $teamsIds
    ) {
      ...CoreSnippetFields
    }
  }
  ${CoreSnippetFieldsFragmentDoc}
`;
export type UpdateChatSnippetMutationFn = Apollo.MutationFunction<
  UpdateChatSnippetMutation,
  UpdateChatSnippetMutationVariables
>;

/**
 * __useUpdateChatSnippetMutation__
 *
 * To run a mutation, you first call `useUpdateChatSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatSnippetMutation, { data, loading, error }] = useUpdateChatSnippetMutation({
 *   variables: {
 *      snippetId: // value for 'snippetId'
 *      userId: // value for 'userId'
 *      snippet: // value for 'snippet'
 *      categoryId: // value for 'categoryId'
 *      teamsIds: // value for 'teamsIds'
 *   },
 * });
 */
export function useUpdateChatSnippetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChatSnippetMutation,
    UpdateChatSnippetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateChatSnippetMutation,
    UpdateChatSnippetMutationVariables
  >(UpdateChatSnippetDocument, options);
}
export type UpdateChatSnippetMutationHookResult = ReturnType<
  typeof useUpdateChatSnippetMutation
>;
export type UpdateChatSnippetMutationResult =
  Apollo.MutationResult<UpdateChatSnippetMutation>;
export type UpdateChatSnippetMutationOptions = Apollo.BaseMutationOptions<
  UpdateChatSnippetMutation,
  UpdateChatSnippetMutationVariables
>;
export const CreateChatSnippetsCategoryDocument = gql`
  mutation CreateChatSnippetsCategory(
    $userId: String!
    $categoryName: String!
    $parentId: String
  ) {
    createChatSnippetsCategory(
      userId: $userId
      categoryName: $categoryName
      parentId: $parentId
    ) {
      ...CoreSnippetCategoryFields
    }
  }
  ${CoreSnippetCategoryFieldsFragmentDoc}
`;
export type CreateChatSnippetsCategoryMutationFn = Apollo.MutationFunction<
  CreateChatSnippetsCategoryMutation,
  CreateChatSnippetsCategoryMutationVariables
>;

/**
 * __useCreateChatSnippetsCategoryMutation__
 *
 * To run a mutation, you first call `useCreateChatSnippetsCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatSnippetsCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatSnippetsCategoryMutation, { data, loading, error }] = useCreateChatSnippetsCategoryMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      categoryName: // value for 'categoryName'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCreateChatSnippetsCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChatSnippetsCategoryMutation,
    CreateChatSnippetsCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateChatSnippetsCategoryMutation,
    CreateChatSnippetsCategoryMutationVariables
  >(CreateChatSnippetsCategoryDocument, options);
}
export type CreateChatSnippetsCategoryMutationHookResult = ReturnType<
  typeof useCreateChatSnippetsCategoryMutation
>;
export type CreateChatSnippetsCategoryMutationResult =
  Apollo.MutationResult<CreateChatSnippetsCategoryMutation>;
export type CreateChatSnippetsCategoryMutationOptions =
  Apollo.BaseMutationOptions<
    CreateChatSnippetsCategoryMutation,
    CreateChatSnippetsCategoryMutationVariables
  >;
export const UpdateChatSnippetsCategoryDocument = gql`
  mutation UpdateChatSnippetsCategory(
    $categoryId: String!
    $userId: String!
    $categoryName: String
    $parentId: String
  ) {
    updateChatSnippetsCategory(
      userId: $userId
      categoryName: $categoryName
      parentId: $parentId
      categoryId: $categoryId
    ) {
      ...CoreSnippetCategoryFields
    }
  }
  ${CoreSnippetCategoryFieldsFragmentDoc}
`;
export type UpdateChatSnippetsCategoryMutationFn = Apollo.MutationFunction<
  UpdateChatSnippetsCategoryMutation,
  UpdateChatSnippetsCategoryMutationVariables
>;

/**
 * __useUpdateChatSnippetsCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateChatSnippetsCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatSnippetsCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatSnippetsCategoryMutation, { data, loading, error }] = useUpdateChatSnippetsCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      userId: // value for 'userId'
 *      categoryName: // value for 'categoryName'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useUpdateChatSnippetsCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChatSnippetsCategoryMutation,
    UpdateChatSnippetsCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateChatSnippetsCategoryMutation,
    UpdateChatSnippetsCategoryMutationVariables
  >(UpdateChatSnippetsCategoryDocument, options);
}
export type UpdateChatSnippetsCategoryMutationHookResult = ReturnType<
  typeof useUpdateChatSnippetsCategoryMutation
>;
export type UpdateChatSnippetsCategoryMutationResult =
  Apollo.MutationResult<UpdateChatSnippetsCategoryMutation>;
export type UpdateChatSnippetsCategoryMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateChatSnippetsCategoryMutation,
    UpdateChatSnippetsCategoryMutationVariables
  >;
export const DeleteChatSnippetsCategoryDocument = gql`
  mutation DeleteChatSnippetsCategory($userId: String!, $categoryId: String!) {
    deleteChatSnippetsCategory(userId: $userId, categoryId: $categoryId) {
      ...CoreSnippetCategoryFields
    }
  }
  ${CoreSnippetCategoryFieldsFragmentDoc}
`;
export type DeleteChatSnippetsCategoryMutationFn = Apollo.MutationFunction<
  DeleteChatSnippetsCategoryMutation,
  DeleteChatSnippetsCategoryMutationVariables
>;

/**
 * __useDeleteChatSnippetsCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteChatSnippetsCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatSnippetsCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatSnippetsCategoryMutation, { data, loading, error }] = useDeleteChatSnippetsCategoryMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useDeleteChatSnippetsCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteChatSnippetsCategoryMutation,
    DeleteChatSnippetsCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteChatSnippetsCategoryMutation,
    DeleteChatSnippetsCategoryMutationVariables
  >(DeleteChatSnippetsCategoryDocument, options);
}
export type DeleteChatSnippetsCategoryMutationHookResult = ReturnType<
  typeof useDeleteChatSnippetsCategoryMutation
>;
export type DeleteChatSnippetsCategoryMutationResult =
  Apollo.MutationResult<DeleteChatSnippetsCategoryMutation>;
export type DeleteChatSnippetsCategoryMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteChatSnippetsCategoryMutation,
    DeleteChatSnippetsCategoryMutationVariables
  >;
export const AddSnippetToFavoritesDocument = gql`
  mutation AddSnippetToFavorites($userId: String!, $snippetId: String!) {
    addSnippetToFavorites(userId: $userId, snippetId: $snippetId) {
      ...CoreSnippetFavoriteFields
    }
  }
  ${CoreSnippetFavoriteFieldsFragmentDoc}
`;
export type AddSnippetToFavoritesMutationFn = Apollo.MutationFunction<
  AddSnippetToFavoritesMutation,
  AddSnippetToFavoritesMutationVariables
>;

/**
 * __useAddSnippetToFavoritesMutation__
 *
 * To run a mutation, you first call `useAddSnippetToFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSnippetToFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSnippetToFavoritesMutation, { data, loading, error }] = useAddSnippetToFavoritesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      snippetId: // value for 'snippetId'
 *   },
 * });
 */
export function useAddSnippetToFavoritesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSnippetToFavoritesMutation,
    AddSnippetToFavoritesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddSnippetToFavoritesMutation,
    AddSnippetToFavoritesMutationVariables
  >(AddSnippetToFavoritesDocument, options);
}
export type AddSnippetToFavoritesMutationHookResult = ReturnType<
  typeof useAddSnippetToFavoritesMutation
>;
export type AddSnippetToFavoritesMutationResult =
  Apollo.MutationResult<AddSnippetToFavoritesMutation>;
export type AddSnippetToFavoritesMutationOptions = Apollo.BaseMutationOptions<
  AddSnippetToFavoritesMutation,
  AddSnippetToFavoritesMutationVariables
>;
export const RemoveSnippetFromFavoriteDocument = gql`
  mutation RemoveSnippetFromFavorite($userId: String!, $snippetId: String!) {
    removeSnippetFromFavorite(userId: $userId, snippetId: $snippetId) {
      ...CoreSnippetFavoriteFields
    }
  }
  ${CoreSnippetFavoriteFieldsFragmentDoc}
`;
export type RemoveSnippetFromFavoriteMutationFn = Apollo.MutationFunction<
  RemoveSnippetFromFavoriteMutation,
  RemoveSnippetFromFavoriteMutationVariables
>;

/**
 * __useRemoveSnippetFromFavoriteMutation__
 *
 * To run a mutation, you first call `useRemoveSnippetFromFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSnippetFromFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSnippetFromFavoriteMutation, { data, loading, error }] = useRemoveSnippetFromFavoriteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      snippetId: // value for 'snippetId'
 *   },
 * });
 */
export function useRemoveSnippetFromFavoriteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSnippetFromFavoriteMutation,
    RemoveSnippetFromFavoriteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveSnippetFromFavoriteMutation,
    RemoveSnippetFromFavoriteMutationVariables
  >(RemoveSnippetFromFavoriteDocument, options);
}
export type RemoveSnippetFromFavoriteMutationHookResult = ReturnType<
  typeof useRemoveSnippetFromFavoriteMutation
>;
export type RemoveSnippetFromFavoriteMutationResult =
  Apollo.MutationResult<RemoveSnippetFromFavoriteMutation>;
export type RemoveSnippetFromFavoriteMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveSnippetFromFavoriteMutation,
    RemoveSnippetFromFavoriteMutationVariables
  >;
export const DeleteChatSnippetDocument = gql`
  mutation DeleteChatSnippet($userId: String!, $snippetId: String!) {
    deleteChatSnippet(userId: $userId, snippetId: $snippetId) {
      ...CoreSnippetFields
    }
  }
  ${CoreSnippetFieldsFragmentDoc}
`;
export type DeleteChatSnippetMutationFn = Apollo.MutationFunction<
  DeleteChatSnippetMutation,
  DeleteChatSnippetMutationVariables
>;

/**
 * __useDeleteChatSnippetMutation__
 *
 * To run a mutation, you first call `useDeleteChatSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatSnippetMutation, { data, loading, error }] = useDeleteChatSnippetMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      snippetId: // value for 'snippetId'
 *   },
 * });
 */
export function useDeleteChatSnippetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteChatSnippetMutation,
    DeleteChatSnippetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteChatSnippetMutation,
    DeleteChatSnippetMutationVariables
  >(DeleteChatSnippetDocument, options);
}
export type DeleteChatSnippetMutationHookResult = ReturnType<
  typeof useDeleteChatSnippetMutation
>;
export type DeleteChatSnippetMutationResult =
  Apollo.MutationResult<DeleteChatSnippetMutation>;
export type DeleteChatSnippetMutationOptions = Apollo.BaseMutationOptions<
  DeleteChatSnippetMutation,
  DeleteChatSnippetMutationVariables
>;
export const CreateTeamDocument = gql`
  mutation CreateTeam($input: CreateTeamInput!) {
    createTeam(input: $input) {
      ...ExtendedTeamFields
    }
  }
  ${ExtendedTeamFieldsFragmentDoc}
`;
export type CreateTeamMutationFn = Apollo.MutationFunction<
  CreateTeamMutation,
  CreateTeamMutationVariables
>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTeamMutation,
    CreateTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(
    CreateTeamDocument,
    options
  );
}
export type CreateTeamMutationHookResult = ReturnType<
  typeof useCreateTeamMutation
>;
export type CreateTeamMutationResult =
  Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<
  CreateTeamMutation,
  CreateTeamMutationVariables
>;
export const UpdateTeamDocument = gql`
  mutation UpdateTeam($input: UpdateTeamInput!) {
    updateTeam(input: $input) {
      ...ExtendedTeamFields
    }
  }
  ${ExtendedTeamFieldsFragmentDoc}
`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<
  UpdateTeamMutation,
  UpdateTeamMutationVariables
>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeamMutation,
    UpdateTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(
    UpdateTeamDocument,
    options
  );
}
export type UpdateTeamMutationHookResult = ReturnType<
  typeof useUpdateTeamMutation
>;
export type UpdateTeamMutationResult =
  Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeamMutation,
  UpdateTeamMutationVariables
>;
export const DeleteTeamDocument = gql`
  mutation DeleteTeam($teamId: String!) {
    deleteTeam(teamId: $teamId) {
      status
    }
  }
`;
export type DeleteTeamMutationFn = Apollo.MutationFunction<
  DeleteTeamMutation,
  DeleteTeamMutationVariables
>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTeamMutation,
    DeleteTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(
    DeleteTeamDocument,
    options
  );
}
export type DeleteTeamMutationHookResult = ReturnType<
  typeof useDeleteTeamMutation
>;
export type DeleteTeamMutationResult =
  Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<
  DeleteTeamMutation,
  DeleteTeamMutationVariables
>;
export const MakeAppsDocument = gql`
  mutation MakeApps($input: [MakeAppsInput]) {
    makeApps(input: $input) {
      ...CoreAppFields
    }
  }
  ${CoreAppFieldsFragmentDoc}
`;
export type MakeAppsMutationFn = Apollo.MutationFunction<
  MakeAppsMutation,
  MakeAppsMutationVariables
>;

/**
 * __useMakeAppsMutation__
 *
 * To run a mutation, you first call `useMakeAppsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeAppsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeAppsMutation, { data, loading, error }] = useMakeAppsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeAppsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeAppsMutation,
    MakeAppsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MakeAppsMutation, MakeAppsMutationVariables>(
    MakeAppsDocument,
    options
  );
}
export type MakeAppsMutationHookResult = ReturnType<typeof useMakeAppsMutation>;
export type MakeAppsMutationResult = Apollo.MutationResult<MakeAppsMutation>;
export type MakeAppsMutationOptions = Apollo.BaseMutationOptions<
  MakeAppsMutation,
  MakeAppsMutationVariables
>;
export const MakeCalendarEventDocument = gql`
  mutation MakeCalendarEvent($input: MakeCalendarEventInput!) {
    makeCalendarEvent(input: $input) {
      ...CoreCalendarEventFields2
    }
  }
  ${CoreCalendarEventFields2FragmentDoc}
`;
export type MakeCalendarEventMutationFn = Apollo.MutationFunction<
  MakeCalendarEventMutation,
  MakeCalendarEventMutationVariables
>;

/**
 * __useMakeCalendarEventMutation__
 *
 * To run a mutation, you first call `useMakeCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeCalendarEventMutation, { data, loading, error }] = useMakeCalendarEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeCalendarEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeCalendarEventMutation,
    MakeCalendarEventMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MakeCalendarEventMutation,
    MakeCalendarEventMutationVariables
  >(MakeCalendarEventDocument, options);
}
export type MakeCalendarEventMutationHookResult = ReturnType<
  typeof useMakeCalendarEventMutation
>;
export type MakeCalendarEventMutationResult =
  Apollo.MutationResult<MakeCalendarEventMutation>;
export type MakeCalendarEventMutationOptions = Apollo.BaseMutationOptions<
  MakeCalendarEventMutation,
  MakeCalendarEventMutationVariables
>;
export const MakeCustomFieldDocument = gql`
  mutation MakeCustomField($input: MakeCustomFieldInput) {
    makeCustomField(input: $input) {
      ...CoreCustomFieldFields
    }
  }
  ${CoreCustomFieldFieldsFragmentDoc}
`;
export type MakeCustomFieldMutationFn = Apollo.MutationFunction<
  MakeCustomFieldMutation,
  MakeCustomFieldMutationVariables
>;

/**
 * __useMakeCustomFieldMutation__
 *
 * To run a mutation, you first call `useMakeCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeCustomFieldMutation, { data, loading, error }] = useMakeCustomFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeCustomFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeCustomFieldMutation,
    MakeCustomFieldMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MakeCustomFieldMutation,
    MakeCustomFieldMutationVariables
  >(MakeCustomFieldDocument, options);
}
export type MakeCustomFieldMutationHookResult = ReturnType<
  typeof useMakeCustomFieldMutation
>;
export type MakeCustomFieldMutationResult =
  Apollo.MutationResult<MakeCustomFieldMutation>;
export type MakeCustomFieldMutationOptions = Apollo.BaseMutationOptions<
  MakeCustomFieldMutation,
  MakeCustomFieldMutationVariables
>;
export const DeployOrganizationDocument = gql`
  mutation DeployOrganization(
    $idToken: String
    $organizationName: String
    $organizationCountry: String
    $organizationTimezone: String
    $organizationLanguage: OrganizationLanguage
    $organizationImageUrl: String
    $organizationPhone: String
    $organizationAddress: String
    $organizationContactName: String
    $organizationContactCell: String
    $organizationStateDealerNumber: String
    $organizationWebsite: String
    $organizationManagerName: String
    $organizationManagerPhone: String
    $dealershipType: DealershipType
    $teamName: String
    $rootEmail: String
    $rootPassword: String
  ) {
    deployOrganization(
      idToken: $idToken
      organizationName: $organizationName
      organizationCountry: $organizationCountry
      organizationTimezone: $organizationTimezone
      organizationLanguage: $organizationLanguage
      organizationImageUrl: $organizationImageUrl
      organizationPhone: $organizationPhone
      organizationAddress: $organizationAddress
      organizationContactName: $organizationContactName
      organizationContactCell: $organizationContactCell
      organizationStateDealerNumber: $organizationStateDealerNumber
      organizationWebsite: $organizationWebsite
      organizationManagerName: $organizationManagerName
      organizationManagerPhone: $organizationManagerPhone
      dealershipType: $dealershipType
      teamName: $teamName
      rootEmail: $rootEmail
      rootPassword: $rootPassword
    ) {
      oid
    }
  }
`;
export type DeployOrganizationMutationFn = Apollo.MutationFunction<
  DeployOrganizationMutation,
  DeployOrganizationMutationVariables
>;

/**
 * __useDeployOrganizationMutation__
 *
 * To run a mutation, you first call `useDeployOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployOrganizationMutation, { data, loading, error }] = useDeployOrganizationMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *      organizationName: // value for 'organizationName'
 *      organizationCountry: // value for 'organizationCountry'
 *      organizationTimezone: // value for 'organizationTimezone'
 *      organizationLanguage: // value for 'organizationLanguage'
 *      organizationImageUrl: // value for 'organizationImageUrl'
 *      organizationPhone: // value for 'organizationPhone'
 *      organizationAddress: // value for 'organizationAddress'
 *      organizationContactName: // value for 'organizationContactName'
 *      organizationContactCell: // value for 'organizationContactCell'
 *      organizationStateDealerNumber: // value for 'organizationStateDealerNumber'
 *      organizationWebsite: // value for 'organizationWebsite'
 *      organizationManagerName: // value for 'organizationManagerName'
 *      organizationManagerPhone: // value for 'organizationManagerPhone'
 *      dealershipType: // value for 'dealershipType'
 *      teamName: // value for 'teamName'
 *      rootEmail: // value for 'rootEmail'
 *      rootPassword: // value for 'rootPassword'
 *   },
 * });
 */
export function useDeployOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeployOrganizationMutation,
    DeployOrganizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeployOrganizationMutation,
    DeployOrganizationMutationVariables
  >(DeployOrganizationDocument, options);
}
export type DeployOrganizationMutationHookResult = ReturnType<
  typeof useDeployOrganizationMutation
>;
export type DeployOrganizationMutationResult =
  Apollo.MutationResult<DeployOrganizationMutation>;
export type DeployOrganizationMutationOptions = Apollo.BaseMutationOptions<
  DeployOrganizationMutation,
  DeployOrganizationMutationVariables
>;
export const SwitchOrganizationDocument = gql`
  mutation SwitchOrganization($toOID: String!) {
    switchOrganization(toOID: $toOID) {
      userId
      newOID
    }
  }
`;
export type SwitchOrganizationMutationFn = Apollo.MutationFunction<
  SwitchOrganizationMutation,
  SwitchOrganizationMutationVariables
>;

/**
 * __useSwitchOrganizationMutation__
 *
 * To run a mutation, you first call `useSwitchOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchOrganizationMutation, { data, loading, error }] = useSwitchOrganizationMutation({
 *   variables: {
 *      toOID: // value for 'toOID'
 *   },
 * });
 */
export function useSwitchOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SwitchOrganizationMutation,
    SwitchOrganizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SwitchOrganizationMutation,
    SwitchOrganizationMutationVariables
  >(SwitchOrganizationDocument, options);
}
export type SwitchOrganizationMutationHookResult = ReturnType<
  typeof useSwitchOrganizationMutation
>;
export type SwitchOrganizationMutationResult =
  Apollo.MutationResult<SwitchOrganizationMutation>;
export type SwitchOrganizationMutationOptions = Apollo.BaseMutationOptions<
  SwitchOrganizationMutation,
  SwitchOrganizationMutationVariables
>;
export const MakeClientTodoTaskDocument = gql`
  mutation MakeClientTodoTask($input: clientTodoTasksInput!) {
    makeClientTodoTask(input: $input) {
      ...CoreClientTodoFields
    }
  }
  ${CoreClientTodoFieldsFragmentDoc}
`;
export type MakeClientTodoTaskMutationFn = Apollo.MutationFunction<
  MakeClientTodoTaskMutation,
  MakeClientTodoTaskMutationVariables
>;

/**
 * __useMakeClientTodoTaskMutation__
 *
 * To run a mutation, you first call `useMakeClientTodoTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeClientTodoTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeClientTodoTaskMutation, { data, loading, error }] = useMakeClientTodoTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeClientTodoTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeClientTodoTaskMutation,
    MakeClientTodoTaskMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MakeClientTodoTaskMutation,
    MakeClientTodoTaskMutationVariables
  >(MakeClientTodoTaskDocument, options);
}
export type MakeClientTodoTaskMutationHookResult = ReturnType<
  typeof useMakeClientTodoTaskMutation
>;
export type MakeClientTodoTaskMutationResult =
  Apollo.MutationResult<MakeClientTodoTaskMutation>;
export type MakeClientTodoTaskMutationOptions = Apollo.BaseMutationOptions<
  MakeClientTodoTaskMutation,
  MakeClientTodoTaskMutationVariables
>;
export const UpdateNotificationsSettingsDocument = gql`
  mutation updateNotificationsSettings(
    $subtype: NotificationSubtype!
    $enabled: Boolean!
  ) {
    updateNotificationsSettings(subtype: $subtype, enabled: $enabled) {
      subtype
      enabled
    }
  }
`;
export type UpdateNotificationsSettingsMutationFn = Apollo.MutationFunction<
  UpdateNotificationsSettingsMutation,
  UpdateNotificationsSettingsMutationVariables
>;

/**
 * __useUpdateNotificationsSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsSettingsMutation, { data, loading, error }] = useUpdateNotificationsSettingsMutation({
 *   variables: {
 *      subtype: // value for 'subtype'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateNotificationsSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNotificationsSettingsMutation,
    UpdateNotificationsSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateNotificationsSettingsMutation,
    UpdateNotificationsSettingsMutationVariables
  >(UpdateNotificationsSettingsDocument, options);
}
export type UpdateNotificationsSettingsMutationHookResult = ReturnType<
  typeof useUpdateNotificationsSettingsMutation
>;
export type UpdateNotificationsSettingsMutationResult =
  Apollo.MutationResult<UpdateNotificationsSettingsMutation>;
export type UpdateNotificationsSettingsMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateNotificationsSettingsMutation,
    UpdateNotificationsSettingsMutationVariables
  >;
export const RequestDealerExportDocument = gql`
  mutation RequestDealerExport(
    $kind: DealerExportKind!
    $dateStart: String
    $dateEnd: String
    $offsetMinutes: Int
  ) {
    requestDealerExport(
      kind: $kind
      dateStart: $dateStart
      dateEnd: $dateEnd
      offsetMinutes: $offsetMinutes
    ) {
      status
      email
    }
  }
`;
export type RequestDealerExportMutationFn = Apollo.MutationFunction<
  RequestDealerExportMutation,
  RequestDealerExportMutationVariables
>;

/**
 * __useRequestDealerExportMutation__
 *
 * To run a mutation, you first call `useRequestDealerExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDealerExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDealerExportMutation, { data, loading, error }] = useRequestDealerExportMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *      dateStart: // value for 'dateStart'
 *      dateEnd: // value for 'dateEnd'
 *      offsetMinutes: // value for 'offsetMinutes'
 *   },
 * });
 */
export function useRequestDealerExportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestDealerExportMutation,
    RequestDealerExportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestDealerExportMutation,
    RequestDealerExportMutationVariables
  >(RequestDealerExportDocument, options);
}
export type RequestDealerExportMutationHookResult = ReturnType<
  typeof useRequestDealerExportMutation
>;
export type RequestDealerExportMutationResult =
  Apollo.MutationResult<RequestDealerExportMutation>;
export type RequestDealerExportMutationOptions = Apollo.BaseMutationOptions<
  RequestDealerExportMutation,
  RequestDealerExportMutationVariables
>;
export const RequestOrganizationEraseDocument = gql`
  mutation RequestOrganizationErase(
    $organizationId: String!
    $confirmName: String!
  ) {
    requestOrganizationErase(
      organizationId: $organizationId
      confirmName: $confirmName
    ) {
      status
    }
  }
`;
export type RequestOrganizationEraseMutationFn = Apollo.MutationFunction<
  RequestOrganizationEraseMutation,
  RequestOrganizationEraseMutationVariables
>;

/**
 * __useRequestOrganizationEraseMutation__
 *
 * To run a mutation, you first call `useRequestOrganizationEraseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOrganizationEraseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOrganizationEraseMutation, { data, loading, error }] = useRequestOrganizationEraseMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      confirmName: // value for 'confirmName'
 *   },
 * });
 */
export function useRequestOrganizationEraseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestOrganizationEraseMutation,
    RequestOrganizationEraseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestOrganizationEraseMutation,
    RequestOrganizationEraseMutationVariables
  >(RequestOrganizationEraseDocument, options);
}
export type RequestOrganizationEraseMutationHookResult = ReturnType<
  typeof useRequestOrganizationEraseMutation
>;
export type RequestOrganizationEraseMutationResult =
  Apollo.MutationResult<RequestOrganizationEraseMutation>;
export type RequestOrganizationEraseMutationOptions =
  Apollo.BaseMutationOptions<
    RequestOrganizationEraseMutation,
    RequestOrganizationEraseMutationVariables
  >;
export const MakeTariffDocument = gql`
  mutation MakeTariff($method: MakeTariffMethod!, $tariffId: String) {
    makeTariff(method: $method, tariffId: $tariffId) {
      status
    }
  }
`;
export type MakeTariffMutationFn = Apollo.MutationFunction<
  MakeTariffMutation,
  MakeTariffMutationVariables
>;

/**
 * __useMakeTariffMutation__
 *
 * To run a mutation, you first call `useMakeTariffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeTariffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeTariffMutation, { data, loading, error }] = useMakeTariffMutation({
 *   variables: {
 *      method: // value for 'method'
 *      tariffId: // value for 'tariffId'
 *   },
 * });
 */
export function useMakeTariffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeTariffMutation,
    MakeTariffMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MakeTariffMutation, MakeTariffMutationVariables>(
    MakeTariffDocument,
    options
  );
}
export type MakeTariffMutationHookResult = ReturnType<
  typeof useMakeTariffMutation
>;
export type MakeTariffMutationResult =
  Apollo.MutationResult<MakeTariffMutation>;
export type MakeTariffMutationOptions = Apollo.BaseMutationOptions<
  MakeTariffMutation,
  MakeTariffMutationVariables
>;
export const MakeInventoryDocument = gql`
  mutation MakeInventory($input: MakeInventoryInput!) {
    makeInventory(input: $input) {
      ...CoreInventoryDetailsFields
    }
  }
  ${CoreInventoryDetailsFieldsFragmentDoc}
`;
export type MakeInventoryMutationFn = Apollo.MutationFunction<
  MakeInventoryMutation,
  MakeInventoryMutationVariables
>;

/**
 * __useMakeInventoryMutation__
 *
 * To run a mutation, you first call `useMakeInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeInventoryMutation, { data, loading, error }] = useMakeInventoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeInventoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeInventoryMutation,
    MakeInventoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MakeInventoryMutation,
    MakeInventoryMutationVariables
  >(MakeInventoryDocument, options);
}
export type MakeInventoryMutationHookResult = ReturnType<
  typeof useMakeInventoryMutation
>;
export type MakeInventoryMutationResult =
  Apollo.MutationResult<MakeInventoryMutation>;
export type MakeInventoryMutationOptions = Apollo.BaseMutationOptions<
  MakeInventoryMutation,
  MakeInventoryMutationVariables
>;
export const MakeMailingRecordDocument = gql`
  mutation MakeMailingRecord(
    $type: CustomFieldMethodType!
    $roomId: ID!
    $leadId: Int
    $sendAt: String
    $actionType: MailingActionType
  ) {
    makeMailingRecord(
      type: $type
      roomId: $roomId
      leadId: $leadId
      sendAt: $sendAt
      actionType: $actionType
    ) {
      ...CoreMailingRecordFields
    }
  }
  ${CoreMailingRecordFieldsFragmentDoc}
`;
export type MakeMailingRecordMutationFn = Apollo.MutationFunction<
  MakeMailingRecordMutation,
  MakeMailingRecordMutationVariables
>;

/**
 * __useMakeMailingRecordMutation__
 *
 * To run a mutation, you first call `useMakeMailingRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeMailingRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeMailingRecordMutation, { data, loading, error }] = useMakeMailingRecordMutation({
 *   variables: {
 *      type: // value for 'type'
 *      roomId: // value for 'roomId'
 *      leadId: // value for 'leadId'
 *      sendAt: // value for 'sendAt'
 *      actionType: // value for 'actionType'
 *   },
 * });
 */
export function useMakeMailingRecordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeMailingRecordMutation,
    MakeMailingRecordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MakeMailingRecordMutation,
    MakeMailingRecordMutationVariables
  >(MakeMailingRecordDocument, options);
}
export type MakeMailingRecordMutationHookResult = ReturnType<
  typeof useMakeMailingRecordMutation
>;
export type MakeMailingRecordMutationResult =
  Apollo.MutationResult<MakeMailingRecordMutation>;
export type MakeMailingRecordMutationOptions = Apollo.BaseMutationOptions<
  MakeMailingRecordMutation,
  MakeMailingRecordMutationVariables
>;
export const ChangeTrialPeriodDocument = gql`
  mutation ChangeTrialPeriod(
    $organizationId: String!
    $trialFinishAt: String!
  ) {
    changeTrialPeriod(
      organizationId: $organizationId
      trialFinishAt: $trialFinishAt
    )
  }
`;
export type ChangeTrialPeriodMutationFn = Apollo.MutationFunction<
  ChangeTrialPeriodMutation,
  ChangeTrialPeriodMutationVariables
>;

/**
 * __useChangeTrialPeriodMutation__
 *
 * To run a mutation, you first call `useChangeTrialPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTrialPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTrialPeriodMutation, { data, loading, error }] = useChangeTrialPeriodMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      trialFinishAt: // value for 'trialFinishAt'
 *   },
 * });
 */
export function useChangeTrialPeriodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeTrialPeriodMutation,
    ChangeTrialPeriodMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeTrialPeriodMutation,
    ChangeTrialPeriodMutationVariables
  >(ChangeTrialPeriodDocument, options);
}
export type ChangeTrialPeriodMutationHookResult = ReturnType<
  typeof useChangeTrialPeriodMutation
>;
export type ChangeTrialPeriodMutationResult =
  Apollo.MutationResult<ChangeTrialPeriodMutation>;
export type ChangeTrialPeriodMutationOptions = Apollo.BaseMutationOptions<
  ChangeTrialPeriodMutation,
  ChangeTrialPeriodMutationVariables
>;
export const SetNotificationIsReadDocument = gql`
  mutation SetNotificationIsRead($notificationId: String!) {
    setNotificationIsRead(notificationId: $notificationId) {
      ...CoreNotificationsFields
    }
  }
  ${CoreNotificationsFieldsFragmentDoc}
`;
export type SetNotificationIsReadMutationFn = Apollo.MutationFunction<
  SetNotificationIsReadMutation,
  SetNotificationIsReadMutationVariables
>;

/**
 * __useSetNotificationIsReadMutation__
 *
 * To run a mutation, you first call `useSetNotificationIsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationIsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationIsReadMutation, { data, loading, error }] = useSetNotificationIsReadMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useSetNotificationIsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetNotificationIsReadMutation,
    SetNotificationIsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetNotificationIsReadMutation,
    SetNotificationIsReadMutationVariables
  >(SetNotificationIsReadDocument, options);
}
export type SetNotificationIsReadMutationHookResult = ReturnType<
  typeof useSetNotificationIsReadMutation
>;
export type SetNotificationIsReadMutationResult =
  Apollo.MutationResult<SetNotificationIsReadMutation>;
export type SetNotificationIsReadMutationOptions = Apollo.BaseMutationOptions<
  SetNotificationIsReadMutation,
  SetNotificationIsReadMutationVariables
>;
export const SetOrganizationSettingsDocument = gql`
  mutation setOrganizationSettings($input: OrganizationSettingsInput!) {
    setOrganizationSettings(input: $input) {
      canOperatorAssignAppointments
    }
  }
`;
export type SetOrganizationSettingsMutationFn = Apollo.MutationFunction<
  SetOrganizationSettingsMutation,
  SetOrganizationSettingsMutationVariables
>;

/**
 * __useSetOrganizationSettingsMutation__
 *
 * To run a mutation, you first call `useSetOrganizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganizationSettingsMutation, { data, loading, error }] = useSetOrganizationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOrganizationSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetOrganizationSettingsMutation,
    SetOrganizationSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetOrganizationSettingsMutation,
    SetOrganizationSettingsMutationVariables
  >(SetOrganizationSettingsDocument, options);
}
export type SetOrganizationSettingsMutationHookResult = ReturnType<
  typeof useSetOrganizationSettingsMutation
>;
export type SetOrganizationSettingsMutationResult =
  Apollo.MutationResult<SetOrganizationSettingsMutation>;
export type SetOrganizationSettingsMutationOptions = Apollo.BaseMutationOptions<
  SetOrganizationSettingsMutation,
  SetOrganizationSettingsMutationVariables
>;
export const GetRolesDocument = gql`
  query GetRoles {
    getRoles {
      ...CoreRoleFields
    }
  }
  ${CoreRoleFieldsFragmentDoc}
`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(
    GetRolesDocument,
    options
  );
}
export function useGetRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRolesQuery,
    GetRolesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(
    GetRolesDocument,
    options
  );
}
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<
  typeof useGetRolesLazyQuery
>;
export type GetRolesQueryResult = Apollo.QueryResult<
  GetRolesQuery,
  GetRolesQueryVariables
>;
export const GetUserDocument = gql`
  query GetUser($userId: String) {
    getUser(userId: $userId) {
      ...CoreUserFields
      ...InternalUserFields
    }
  }
  ${CoreUserFieldsFragmentDoc}
  ${InternalUserFieldsFragmentDoc}
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options
  );
}
export function useGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(
    GetUserDocument,
    options
  );
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<
  GetUserQuery,
  GetUserQueryVariables
>;
export const CheckEmailAvailabilityDocument = gql`
  query CheckEmailAvailability($email: String!) {
    checkEmailAvailability(email: $email) {
      taken
    }
  }
`;

/**
 * __useCheckEmailAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckEmailAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmailAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEmailAvailabilityQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckEmailAvailabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckEmailAvailabilityQuery,
    CheckEmailAvailabilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckEmailAvailabilityQuery,
    CheckEmailAvailabilityQueryVariables
  >(CheckEmailAvailabilityDocument, options);
}
export function useCheckEmailAvailabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckEmailAvailabilityQuery,
    CheckEmailAvailabilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckEmailAvailabilityQuery,
    CheckEmailAvailabilityQueryVariables
  >(CheckEmailAvailabilityDocument, options);
}
export type CheckEmailAvailabilityQueryHookResult = ReturnType<
  typeof useCheckEmailAvailabilityQuery
>;
export type CheckEmailAvailabilityLazyQueryHookResult = ReturnType<
  typeof useCheckEmailAvailabilityLazyQuery
>;
export type CheckEmailAvailabilityQueryResult = Apollo.QueryResult<
  CheckEmailAvailabilityQuery,
  CheckEmailAvailabilityQueryVariables
>;
export const GetCommentsOnClient2Document = gql`
  query GetCommentsOnClient2($clientId: String!) {
    getCommentsOnClient2(clientId: $clientId) {
      commentCount
      comments {
        ...CoreCommentsFields
      }
    }
  }
  ${CoreCommentsFieldsFragmentDoc}
`;

/**
 * __useGetCommentsOnClient2Query__
 *
 * To run a query within a React component, call `useGetCommentsOnClient2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsOnClient2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsOnClient2Query({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetCommentsOnClient2Query(
  baseOptions: Apollo.QueryHookOptions<
    GetCommentsOnClient2Query,
    GetCommentsOnClient2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCommentsOnClient2Query,
    GetCommentsOnClient2QueryVariables
  >(GetCommentsOnClient2Document, options);
}
export function useGetCommentsOnClient2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommentsOnClient2Query,
    GetCommentsOnClient2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCommentsOnClient2Query,
    GetCommentsOnClient2QueryVariables
  >(GetCommentsOnClient2Document, options);
}
export type GetCommentsOnClient2QueryHookResult = ReturnType<
  typeof useGetCommentsOnClient2Query
>;
export type GetCommentsOnClient2LazyQueryHookResult = ReturnType<
  typeof useGetCommentsOnClient2LazyQuery
>;
export type GetCommentsOnClient2QueryResult = Apollo.QueryResult<
  GetCommentsOnClient2Query,
  GetCommentsOnClient2QueryVariables
>;
export const GetUsersDocument = gql`
  query GetUsers($input: GetUsersInput!) {
    getUsers(input: $input) {
      users {
        ...CoreUserFields
        ...ClientFields
        ...InternalUserFields
      }
      pagination {
        itemsPerPage
        pageNumber
        totalItems
      }
    }
  }
  ${CoreUserFieldsFragmentDoc}
  ${ClientFieldsFragmentDoc}
  ${InternalUserFieldsFragmentDoc}
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options
  );
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUsersQuery,
    GetUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options
  );
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<
  typeof useGetUsersLazyQuery
>;
export type GetUsersQueryResult = Apollo.QueryResult<
  GetUsersQuery,
  GetUsersQueryVariables
>;
export const GetChannels2Document = gql`
  query GetChannels2($isActiveOnly: Boolean! = true) {
    getChannels2(isActiveOnly: $isActiveOnly) {
      ...ExtendedChannelFields
    }
  }
  ${ExtendedChannelFieldsFragmentDoc}
`;

/**
 * __useGetChannels2Query__
 *
 * To run a query within a React component, call `useGetChannels2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetChannels2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannels2Query({
 *   variables: {
 *      isActiveOnly: // value for 'isActiveOnly'
 *   },
 * });
 */
export function useGetChannels2Query(
  baseOptions?: Apollo.QueryHookOptions<
    GetChannels2Query,
    GetChannels2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChannels2Query, GetChannels2QueryVariables>(
    GetChannels2Document,
    options
  );
}
export function useGetChannels2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChannels2Query,
    GetChannels2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChannels2Query, GetChannels2QueryVariables>(
    GetChannels2Document,
    options
  );
}
export type GetChannels2QueryHookResult = ReturnType<
  typeof useGetChannels2Query
>;
export type GetChannels2LazyQueryHookResult = ReturnType<
  typeof useGetChannels2LazyQuery
>;
export type GetChannels2QueryResult = Apollo.QueryResult<
  GetChannels2Query,
  GetChannels2QueryVariables
>;
export const GetBotsDocument = gql`
  query GetBots($status: BotStatus!) {
    getBots(status: $status) {
      ...ExtendedBotFields
    }
  }
  ${ExtendedBotFieldsFragmentDoc}
`;

/**
 * __useGetBotsQuery__
 *
 * To run a query within a React component, call `useGetBotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBotsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetBotsQuery(
  baseOptions: Apollo.QueryHookOptions<GetBotsQuery, GetBotsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBotsQuery, GetBotsQueryVariables>(
    GetBotsDocument,
    options
  );
}
export function useGetBotsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBotsQuery, GetBotsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBotsQuery, GetBotsQueryVariables>(
    GetBotsDocument,
    options
  );
}
export type GetBotsQueryHookResult = ReturnType<typeof useGetBotsQuery>;
export type GetBotsLazyQueryHookResult = ReturnType<typeof useGetBotsLazyQuery>;
export type GetBotsQueryResult = Apollo.QueryResult<
  GetBotsQuery,
  GetBotsQueryVariables
>;
export const GetBotDocument = gql`
  query GetBot($id: String!) {
    getBot(id: $id) {
      ...ExtendedBotFields
    }
  }
  ${ExtendedBotFieldsFragmentDoc}
`;

/**
 * __useGetBotQuery__
 *
 * To run a query within a React component, call `useGetBotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBotQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBotQuery(
  baseOptions: Apollo.QueryHookOptions<GetBotQuery, GetBotQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBotQuery, GetBotQueryVariables>(
    GetBotDocument,
    options
  );
}
export function useGetBotLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBotQuery, GetBotQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBotQuery, GetBotQueryVariables>(
    GetBotDocument,
    options
  );
}
export type GetBotQueryHookResult = ReturnType<typeof useGetBotQuery>;
export type GetBotLazyQueryHookResult = ReturnType<typeof useGetBotLazyQuery>;
export type GetBotQueryResult = Apollo.QueryResult<
  GetBotQuery,
  GetBotQueryVariables
>;
export const GetFlowsDocument = gql`
  query GetFlows($botId: String!) {
    getFlows(botId: $botId) {
      ...CoreFlowFields
    }
  }
  ${CoreFlowFieldsFragmentDoc}
`;

/**
 * __useGetFlowsQuery__
 *
 * To run a query within a React component, call `useGetFlowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlowsQuery({
 *   variables: {
 *      botId: // value for 'botId'
 *   },
 * });
 */
export function useGetFlowsQuery(
  baseOptions: Apollo.QueryHookOptions<GetFlowsQuery, GetFlowsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFlowsQuery, GetFlowsQueryVariables>(
    GetFlowsDocument,
    options
  );
}
export function useGetFlowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFlowsQuery,
    GetFlowsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFlowsQuery, GetFlowsQueryVariables>(
    GetFlowsDocument,
    options
  );
}
export type GetFlowsQueryHookResult = ReturnType<typeof useGetFlowsQuery>;
export type GetFlowsLazyQueryHookResult = ReturnType<
  typeof useGetFlowsLazyQuery
>;
export type GetFlowsQueryResult = Apollo.QueryResult<
  GetFlowsQuery,
  GetFlowsQueryVariables
>;
export const GetFlowDocument = gql`
  query GetFlow($input: GetFlowInput) {
    getFlow(input: $input) {
      ...CoreFlowFields
    }
  }
  ${CoreFlowFieldsFragmentDoc}
`;

/**
 * __useGetFlowQuery__
 *
 * To run a query within a React component, call `useGetFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlowQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFlowQuery(
  baseOptions?: Apollo.QueryHookOptions<GetFlowQuery, GetFlowQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFlowQuery, GetFlowQueryVariables>(
    GetFlowDocument,
    options
  );
}
export function useGetFlowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFlowQuery, GetFlowQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFlowQuery, GetFlowQueryVariables>(
    GetFlowDocument,
    options
  );
}
export type GetFlowQueryHookResult = ReturnType<typeof useGetFlowQuery>;
export type GetFlowLazyQueryHookResult = ReturnType<typeof useGetFlowLazyQuery>;
export type GetFlowQueryResult = Apollo.QueryResult<
  GetFlowQuery,
  GetFlowQueryVariables
>;
export const GetTeamsDocument = gql`
  query GetTeams {
    getTeams {
      ...ExtendedTeamFields
    }
  }
  ${ExtendedTeamFieldsFragmentDoc}
`;

/**
 * __useGetTeamsQuery__
 *
 * To run a query within a React component, call `useGetTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamsQuery, GetTeamsQueryVariables>(
    GetTeamsDocument,
    options
  );
}
export function useGetTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTeamsQuery,
    GetTeamsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamsQuery, GetTeamsQueryVariables>(
    GetTeamsDocument,
    options
  );
}
export type GetTeamsQueryHookResult = ReturnType<typeof useGetTeamsQuery>;
export type GetTeamsLazyQueryHookResult = ReturnType<
  typeof useGetTeamsLazyQuery
>;
export type GetTeamsQueryResult = Apollo.QueryResult<
  GetTeamsQuery,
  GetTeamsQueryVariables
>;
export const GetRooms2Document = gql`
  query GetRooms2($input: GetRoomsInput!) {
    getRooms2(input: $input) {
      rooms {
        ...CoreRoomFields
      }
      hasUnreadMessages
      pagination {
        totalItems
        nextCursor
      }
      requestedStatus
      error
    }
  }
  ${CoreRoomFieldsFragmentDoc}
`;

/**
 * __useGetRooms2Query__
 *
 * To run a query within a React component, call `useGetRooms2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetRooms2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRooms2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRooms2Query(
  baseOptions: Apollo.QueryHookOptions<GetRooms2Query, GetRooms2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRooms2Query, GetRooms2QueryVariables>(
    GetRooms2Document,
    options
  );
}
export function useGetRooms2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRooms2Query,
    GetRooms2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRooms2Query, GetRooms2QueryVariables>(
    GetRooms2Document,
    options
  );
}
export type GetRooms2QueryHookResult = ReturnType<typeof useGetRooms2Query>;
export type GetRooms2LazyQueryHookResult = ReturnType<
  typeof useGetRooms2LazyQuery
>;
export type GetRooms2QueryResult = Apollo.QueryResult<
  GetRooms2Query,
  GetRooms2QueryVariables
>;
export const GetRoom2Document = gql`
  query GetRoom2($input: GetRoomInput!) {
    getRoom2(input: $input) {
      room {
        ...CoreRoomFields
      }
      error
    }
  }
  ${CoreRoomFieldsFragmentDoc}
`;

/**
 * __useGetRoom2Query__
 *
 * To run a query within a React component, call `useGetRoom2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetRoom2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoom2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRoom2Query(
  baseOptions: Apollo.QueryHookOptions<GetRoom2Query, GetRoom2QueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRoom2Query, GetRoom2QueryVariables>(
    GetRoom2Document,
    options
  );
}
export function useGetRoom2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRoom2Query,
    GetRoom2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRoom2Query, GetRoom2QueryVariables>(
    GetRoom2Document,
    options
  );
}
export type GetRoom2QueryHookResult = ReturnType<typeof useGetRoom2Query>;
export type GetRoom2LazyQueryHookResult = ReturnType<
  typeof useGetRoom2LazyQuery
>;
export type GetRoom2QueryResult = Apollo.QueryResult<
  GetRoom2Query,
  GetRoom2QueryVariables
>;
export const GetChatRoomMessagesDocument = gql`
  query GetChatRoomMessages(
    $chatRoomId: String!
    $fetchSize: Int!
    $pagingState: String
  ) {
    getChatRoomMessages(
      chatRoomId: $chatRoomId
      fetchSize: $fetchSize
      pagingState: $pagingState
    ) {
      chatRoomMessages {
        ...CoreMessageFields
      }
      roomId
      pagingState
    }
  }
  ${CoreMessageFieldsFragmentDoc}
`;

/**
 * __useGetChatRoomMessagesQuery__
 *
 * To run a query within a React component, call `useGetChatRoomMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatRoomMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatRoomMessagesQuery({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *      fetchSize: // value for 'fetchSize'
 *      pagingState: // value for 'pagingState'
 *   },
 * });
 */
export function useGetChatRoomMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChatRoomMessagesQuery,
    GetChatRoomMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetChatRoomMessagesQuery,
    GetChatRoomMessagesQueryVariables
  >(GetChatRoomMessagesDocument, options);
}
export function useGetChatRoomMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChatRoomMessagesQuery,
    GetChatRoomMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChatRoomMessagesQuery,
    GetChatRoomMessagesQueryVariables
  >(GetChatRoomMessagesDocument, options);
}
export type GetChatRoomMessagesQueryHookResult = ReturnType<
  typeof useGetChatRoomMessagesQuery
>;
export type GetChatRoomMessagesLazyQueryHookResult = ReturnType<
  typeof useGetChatRoomMessagesLazyQuery
>;
export type GetChatRoomMessagesQueryResult = Apollo.QueryResult<
  GetChatRoomMessagesQuery,
  GetChatRoomMessagesQueryVariables
>;
export const GetFoundMessagesDocument = gql`
  query GetFoundMessages($chatRoomId: String!, $search: String!) {
    foundMessages @client {
      ...CoreMessageFields
    }
  }
  ${CoreMessageFieldsFragmentDoc}
`;

/**
 * __useGetFoundMessagesQuery__
 *
 * To run a query within a React component, call `useGetFoundMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFoundMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoundMessagesQuery({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFoundMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFoundMessagesQuery,
    GetFoundMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFoundMessagesQuery, GetFoundMessagesQueryVariables>(
    GetFoundMessagesDocument,
    options
  );
}
export function useGetFoundMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFoundMessagesQuery,
    GetFoundMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFoundMessagesQuery,
    GetFoundMessagesQueryVariables
  >(GetFoundMessagesDocument, options);
}
export type GetFoundMessagesQueryHookResult = ReturnType<
  typeof useGetFoundMessagesQuery
>;
export type GetFoundMessagesLazyQueryHookResult = ReturnType<
  typeof useGetFoundMessagesLazyQuery
>;
export type GetFoundMessagesQueryResult = Apollo.QueryResult<
  GetFoundMessagesQuery,
  GetFoundMessagesQueryVariables
>;
export const GetNodesDocument = gql`
  query GetNodes($input: GetNodesAndEdgesInput) {
    getNodes(input: $input) @persist {
      ...CoreNodeFields
    }
  }
  ${CoreNodeFieldsFragmentDoc}
`;

/**
 * __useGetNodesQuery__
 *
 * To run a query within a React component, call `useGetNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNodesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetNodesQuery, GetNodesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNodesQuery, GetNodesQueryVariables>(
    GetNodesDocument,
    options
  );
}
export function useGetNodesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNodesQuery,
    GetNodesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNodesQuery, GetNodesQueryVariables>(
    GetNodesDocument,
    options
  );
}
export type GetNodesQueryHookResult = ReturnType<typeof useGetNodesQuery>;
export type GetNodesLazyQueryHookResult = ReturnType<
  typeof useGetNodesLazyQuery
>;
export type GetNodesQueryResult = Apollo.QueryResult<
  GetNodesQuery,
  GetNodesQueryVariables
>;
export const GetEdgesDocument = gql`
  query GetEdges($input: GetNodesAndEdgesInput) {
    getEdges(input: $input) @persist {
      ...CoreEdgeFields
    }
  }
  ${CoreEdgeFieldsFragmentDoc}
`;

/**
 * __useGetEdgesQuery__
 *
 * To run a query within a React component, call `useGetEdgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEdgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEdgesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEdgesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetEdgesQuery, GetEdgesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEdgesQuery, GetEdgesQueryVariables>(
    GetEdgesDocument,
    options
  );
}
export function useGetEdgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEdgesQuery,
    GetEdgesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEdgesQuery, GetEdgesQueryVariables>(
    GetEdgesDocument,
    options
  );
}
export type GetEdgesQueryHookResult = ReturnType<typeof useGetEdgesQuery>;
export type GetEdgesLazyQueryHookResult = ReturnType<
  typeof useGetEdgesLazyQuery
>;
export type GetEdgesQueryResult = Apollo.QueryResult<
  GetEdgesQuery,
  GetEdgesQueryVariables
>;
export const GetChatSnippetsDocument = gql`
  query GetChatSnippets(
    $snippetId: String
    $categoryId: String
    $userId: String!
  ) {
    getChatSnippets(
      snippetId: $snippetId
      categoryId: $categoryId
      userId: $userId
    ) {
      snippets {
        ...CoreSnippetFields
      }
      totalNumberOfSnippets
    }
  }
  ${CoreSnippetFieldsFragmentDoc}
`;

/**
 * __useGetChatSnippetsQuery__
 *
 * To run a query within a React component, call `useGetChatSnippetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatSnippetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatSnippetsQuery({
 *   variables: {
 *      snippetId: // value for 'snippetId'
 *      categoryId: // value for 'categoryId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetChatSnippetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChatSnippetsQuery,
    GetChatSnippetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChatSnippetsQuery, GetChatSnippetsQueryVariables>(
    GetChatSnippetsDocument,
    options
  );
}
export function useGetChatSnippetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChatSnippetsQuery,
    GetChatSnippetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChatSnippetsQuery,
    GetChatSnippetsQueryVariables
  >(GetChatSnippetsDocument, options);
}
export type GetChatSnippetsQueryHookResult = ReturnType<
  typeof useGetChatSnippetsQuery
>;
export type GetChatSnippetsLazyQueryHookResult = ReturnType<
  typeof useGetChatSnippetsLazyQuery
>;
export type GetChatSnippetsQueryResult = Apollo.QueryResult<
  GetChatSnippetsQuery,
  GetChatSnippetsQueryVariables
>;
export const GetChatSnippetsFavoritesDocument = gql`
  query GetChatSnippetsFavorites($userId: String!) {
    getChatSnippetsFavorites(userId: $userId) {
      snippets {
        ...CoreSnippetFields
      }
      totalNumberOfSnippets
    }
  }
  ${CoreSnippetFieldsFragmentDoc}
`;

/**
 * __useGetChatSnippetsFavoritesQuery__
 *
 * To run a query within a React component, call `useGetChatSnippetsFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatSnippetsFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatSnippetsFavoritesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetChatSnippetsFavoritesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChatSnippetsFavoritesQuery,
    GetChatSnippetsFavoritesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetChatSnippetsFavoritesQuery,
    GetChatSnippetsFavoritesQueryVariables
  >(GetChatSnippetsFavoritesDocument, options);
}
export function useGetChatSnippetsFavoritesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChatSnippetsFavoritesQuery,
    GetChatSnippetsFavoritesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChatSnippetsFavoritesQuery,
    GetChatSnippetsFavoritesQueryVariables
  >(GetChatSnippetsFavoritesDocument, options);
}
export type GetChatSnippetsFavoritesQueryHookResult = ReturnType<
  typeof useGetChatSnippetsFavoritesQuery
>;
export type GetChatSnippetsFavoritesLazyQueryHookResult = ReturnType<
  typeof useGetChatSnippetsFavoritesLazyQuery
>;
export type GetChatSnippetsFavoritesQueryResult = Apollo.QueryResult<
  GetChatSnippetsFavoritesQuery,
  GetChatSnippetsFavoritesQueryVariables
>;
export const GetChatSnippetsCategoriesDocument = gql`
  query GetChatSnippetsCategories(
    $parentId: String
    $categoryId: String
    $userId: String
  ) {
    getChatSnippetsCategories(
      parentId: $parentId
      categoryId: $categoryId
      userId: $userId
    ) {
      categories {
        ...CoreSnippetCategoryFields
      }
      totalNumberOfCategories
    }
  }
  ${CoreSnippetCategoryFieldsFragmentDoc}
`;

/**
 * __useGetChatSnippetsCategoriesQuery__
 *
 * To run a query within a React component, call `useGetChatSnippetsCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatSnippetsCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatSnippetsCategoriesQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      categoryId: // value for 'categoryId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetChatSnippetsCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetChatSnippetsCategoriesQuery,
    GetChatSnippetsCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetChatSnippetsCategoriesQuery,
    GetChatSnippetsCategoriesQueryVariables
  >(GetChatSnippetsCategoriesDocument, options);
}
export function useGetChatSnippetsCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChatSnippetsCategoriesQuery,
    GetChatSnippetsCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChatSnippetsCategoriesQuery,
    GetChatSnippetsCategoriesQueryVariables
  >(GetChatSnippetsCategoriesDocument, options);
}
export type GetChatSnippetsCategoriesQueryHookResult = ReturnType<
  typeof useGetChatSnippetsCategoriesQuery
>;
export type GetChatSnippetsCategoriesLazyQueryHookResult = ReturnType<
  typeof useGetChatSnippetsCategoriesLazyQuery
>;
export type GetChatSnippetsCategoriesQueryResult = Apollo.QueryResult<
  GetChatSnippetsCategoriesQuery,
  GetChatSnippetsCategoriesQueryVariables
>;
export const RequestRoomsHistoryAsFileDocument = gql`
  query RequestRoomsHistoryAsFile(
    $reportType: ReportType!
    $userId: String!
    $roomId: String
    $operatorId: String
    $dateStart: String
    $dateEnd: String
  ) {
    requestRoomsHistoryAsFile(
      reportType: $reportType
      userId: $userId
      roomId: $roomId
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
    ) {
      id
      userId
      name
      url
      status
      createdAt
    }
  }
`;

/**
 * __useRequestRoomsHistoryAsFileQuery__
 *
 * To run a query within a React component, call `useRequestRoomsHistoryAsFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestRoomsHistoryAsFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestRoomsHistoryAsFileQuery({
 *   variables: {
 *      reportType: // value for 'reportType'
 *      userId: // value for 'userId'
 *      roomId: // value for 'roomId'
 *      operatorId: // value for 'operatorId'
 *      dateStart: // value for 'dateStart'
 *      dateEnd: // value for 'dateEnd'
 *   },
 * });
 */
export function useRequestRoomsHistoryAsFileQuery(
  baseOptions: Apollo.QueryHookOptions<
    RequestRoomsHistoryAsFileQuery,
    RequestRoomsHistoryAsFileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RequestRoomsHistoryAsFileQuery,
    RequestRoomsHistoryAsFileQueryVariables
  >(RequestRoomsHistoryAsFileDocument, options);
}
export function useRequestRoomsHistoryAsFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RequestRoomsHistoryAsFileQuery,
    RequestRoomsHistoryAsFileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RequestRoomsHistoryAsFileQuery,
    RequestRoomsHistoryAsFileQueryVariables
  >(RequestRoomsHistoryAsFileDocument, options);
}
export type RequestRoomsHistoryAsFileQueryHookResult = ReturnType<
  typeof useRequestRoomsHistoryAsFileQuery
>;
export type RequestRoomsHistoryAsFileLazyQueryHookResult = ReturnType<
  typeof useRequestRoomsHistoryAsFileLazyQuery
>;
export type RequestRoomsHistoryAsFileQueryResult = Apollo.QueryResult<
  RequestRoomsHistoryAsFileQuery,
  RequestRoomsHistoryAsFileQueryVariables
>;
export const ValidateBotDocument = gql`
  query ValidateBot($id: String!) {
    validateBot(id: $id) {
      ...CoreValidateBotFields
    }
  }
  ${CoreValidateBotFieldsFragmentDoc}
`;

/**
 * __useValidateBotQuery__
 *
 * To run a query within a React component, call `useValidateBotQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateBotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateBotQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useValidateBotQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValidateBotQuery,
    ValidateBotQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValidateBotQuery, ValidateBotQueryVariables>(
    ValidateBotDocument,
    options
  );
}
export function useValidateBotLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValidateBotQuery,
    ValidateBotQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ValidateBotQuery, ValidateBotQueryVariables>(
    ValidateBotDocument,
    options
  );
}
export type ValidateBotQueryHookResult = ReturnType<typeof useValidateBotQuery>;
export type ValidateBotLazyQueryHookResult = ReturnType<
  typeof useValidateBotLazyQuery
>;
export type ValidateBotQueryResult = Apollo.QueryResult<
  ValidateBotQuery,
  ValidateBotQueryVariables
>;
export const GetGeneralAnalyticsDocument = gql`
  query GetGeneralAnalytics($input: GetGeneralAnalyticsInput!) {
    getGeneralAnalytics(input: $input) {
      ...CoreGeneralAnalyticsFields
    }
  }
  ${CoreGeneralAnalyticsFieldsFragmentDoc}
`;

/**
 * __useGetGeneralAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetGeneralAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGeneralAnalyticsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGeneralAnalyticsQuery,
    GetGeneralAnalyticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGeneralAnalyticsQuery,
    GetGeneralAnalyticsQueryVariables
  >(GetGeneralAnalyticsDocument, options);
}
export function useGetGeneralAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGeneralAnalyticsQuery,
    GetGeneralAnalyticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGeneralAnalyticsQuery,
    GetGeneralAnalyticsQueryVariables
  >(GetGeneralAnalyticsDocument, options);
}
export type GetGeneralAnalyticsQueryHookResult = ReturnType<
  typeof useGetGeneralAnalyticsQuery
>;
export type GetGeneralAnalyticsLazyQueryHookResult = ReturnType<
  typeof useGetGeneralAnalyticsLazyQuery
>;
export type GetGeneralAnalyticsQueryResult = Apollo.QueryResult<
  GetGeneralAnalyticsQuery,
  GetGeneralAnalyticsQueryVariables
>;
export const GetChatsAnalyticsDocument = gql`
  query GetChatsAnalytics($input: GetChatsAnalyticsInput!) {
    getChatsAnalytics(input: $input) {
      ...CoreChatsAnalyticsFields
    }
  }
  ${CoreChatsAnalyticsFieldsFragmentDoc}
`;

/**
 * __useGetChatsAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetChatsAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatsAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatsAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChatsAnalyticsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChatsAnalyticsQuery,
    GetChatsAnalyticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetChatsAnalyticsQuery,
    GetChatsAnalyticsQueryVariables
  >(GetChatsAnalyticsDocument, options);
}
export function useGetChatsAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChatsAnalyticsQuery,
    GetChatsAnalyticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChatsAnalyticsQuery,
    GetChatsAnalyticsQueryVariables
  >(GetChatsAnalyticsDocument, options);
}
export type GetChatsAnalyticsQueryHookResult = ReturnType<
  typeof useGetChatsAnalyticsQuery
>;
export type GetChatsAnalyticsLazyQueryHookResult = ReturnType<
  typeof useGetChatsAnalyticsLazyQuery
>;
export type GetChatsAnalyticsQueryResult = Apollo.QueryResult<
  GetChatsAnalyticsQuery,
  GetChatsAnalyticsQueryVariables
>;
export const GetOperatorsAnalyticsDocument = gql`
  query GetOperatorsAnalytics($input: GetOperatorsAnalyticsInput) {
    getOperatorsAnalytics(input: $input) {
      ...CoreOperatorsAnalyticsFields
    }
  }
  ${CoreOperatorsAnalyticsFieldsFragmentDoc}
`;

/**
 * __useGetOperatorsAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetOperatorsAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperatorsAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperatorsAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOperatorsAnalyticsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOperatorsAnalyticsQuery,
    GetOperatorsAnalyticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOperatorsAnalyticsQuery,
    GetOperatorsAnalyticsQueryVariables
  >(GetOperatorsAnalyticsDocument, options);
}
export function useGetOperatorsAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOperatorsAnalyticsQuery,
    GetOperatorsAnalyticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOperatorsAnalyticsQuery,
    GetOperatorsAnalyticsQueryVariables
  >(GetOperatorsAnalyticsDocument, options);
}
export type GetOperatorsAnalyticsQueryHookResult = ReturnType<
  typeof useGetOperatorsAnalyticsQuery
>;
export type GetOperatorsAnalyticsLazyQueryHookResult = ReturnType<
  typeof useGetOperatorsAnalyticsLazyQuery
>;
export type GetOperatorsAnalyticsQueryResult = Apollo.QueryResult<
  GetOperatorsAnalyticsQuery,
  GetOperatorsAnalyticsQueryVariables
>;
export const GetAppsDocument = gql`
  query GetApps(
    $ids: [ID]
    $types: [AppType]
    $isAvailableOnly: Boolean
    $isInstalledOnly: Boolean
  ) {
    getApps(
      ids: $ids
      types: $types
      isAvailableOnly: $isAvailableOnly
      isInstalledOnly: $isInstalledOnly
    ) {
      ...CoreAppFields
    }
  }
  ${CoreAppFieldsFragmentDoc}
`;

/**
 * __useGetAppsQuery__
 *
 * To run a query within a React component, call `useGetAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      types: // value for 'types'
 *      isAvailableOnly: // value for 'isAvailableOnly'
 *      isInstalledOnly: // value for 'isInstalledOnly'
 *   },
 * });
 */
export function useGetAppsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAppsQuery, GetAppsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAppsQuery, GetAppsQueryVariables>(
    GetAppsDocument,
    options
  );
}
export function useGetAppsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAppsQuery, GetAppsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAppsQuery, GetAppsQueryVariables>(
    GetAppsDocument,
    options
  );
}
export type GetAppsQueryHookResult = ReturnType<typeof useGetAppsQuery>;
export type GetAppsLazyQueryHookResult = ReturnType<typeof useGetAppsLazyQuery>;
export type GetAppsQueryResult = Apollo.QueryResult<
  GetAppsQuery,
  GetAppsQueryVariables
>;
export const GetChatRoomHistoryDocument = gql`
  query GetChatRoomHistory($roomId: String!) {
    getChatRoomHistory(roomId: $roomId) {
      chatRoomHistory {
        ...CoreRoomEventFields
      }
    }
  }
  ${CoreRoomEventFieldsFragmentDoc}
`;

/**
 * __useGetChatRoomHistoryQuery__
 *
 * To run a query within a React component, call `useGetChatRoomHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatRoomHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatRoomHistoryQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useGetChatRoomHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChatRoomHistoryQuery,
    GetChatRoomHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetChatRoomHistoryQuery,
    GetChatRoomHistoryQueryVariables
  >(GetChatRoomHistoryDocument, options);
}
export function useGetChatRoomHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChatRoomHistoryQuery,
    GetChatRoomHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChatRoomHistoryQuery,
    GetChatRoomHistoryQueryVariables
  >(GetChatRoomHistoryDocument, options);
}
export type GetChatRoomHistoryQueryHookResult = ReturnType<
  typeof useGetChatRoomHistoryQuery
>;
export type GetChatRoomHistoryLazyQueryHookResult = ReturnType<
  typeof useGetChatRoomHistoryLazyQuery
>;
export type GetChatRoomHistoryQueryResult = Apollo.QueryResult<
  GetChatRoomHistoryQuery,
  GetChatRoomHistoryQueryVariables
>;
export const GetAvailableTwilioPhoneNumbersDocument = gql`
  query GetAvailableTwilioPhoneNumbers($areaCode: Int!, $limit: Int) {
    getAvailableTwilioPhoneNumbers(areaCode: $areaCode, limit: $limit)
  }
`;

/**
 * __useGetAvailableTwilioPhoneNumbersQuery__
 *
 * To run a query within a React component, call `useGetAvailableTwilioPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableTwilioPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableTwilioPhoneNumbersQuery({
 *   variables: {
 *      areaCode: // value for 'areaCode'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAvailableTwilioPhoneNumbersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAvailableTwilioPhoneNumbersQuery,
    GetAvailableTwilioPhoneNumbersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvailableTwilioPhoneNumbersQuery,
    GetAvailableTwilioPhoneNumbersQueryVariables
  >(GetAvailableTwilioPhoneNumbersDocument, options);
}
export function useGetAvailableTwilioPhoneNumbersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailableTwilioPhoneNumbersQuery,
    GetAvailableTwilioPhoneNumbersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvailableTwilioPhoneNumbersQuery,
    GetAvailableTwilioPhoneNumbersQueryVariables
  >(GetAvailableTwilioPhoneNumbersDocument, options);
}
export type GetAvailableTwilioPhoneNumbersQueryHookResult = ReturnType<
  typeof useGetAvailableTwilioPhoneNumbersQuery
>;
export type GetAvailableTwilioPhoneNumbersLazyQueryHookResult = ReturnType<
  typeof useGetAvailableTwilioPhoneNumbersLazyQuery
>;
export type GetAvailableTwilioPhoneNumbersQueryResult = Apollo.QueryResult<
  GetAvailableTwilioPhoneNumbersQuery,
  GetAvailableTwilioPhoneNumbersQueryVariables
>;
export const GetCalendarEvents2Document = gql`
  query GetCalendarEvents2(
    $limit: Int
    $offset: Int
    $startsAfter: String
    $endsBefore: String
  ) {
    getCalendarEvents2(
      limit: $limit
      offset: $offset
      startsAfter: $startsAfter
      endsBefore: $endsBefore
    ) {
      total
      events {
        ...CoreCalendarEventFields2
      }
    }
  }
  ${CoreCalendarEventFields2FragmentDoc}
`;

/**
 * __useGetCalendarEvents2Query__
 *
 * To run a query within a React component, call `useGetCalendarEvents2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarEvents2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarEvents2Query({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      startsAfter: // value for 'startsAfter'
 *      endsBefore: // value for 'endsBefore'
 *   },
 * });
 */
export function useGetCalendarEvents2Query(
  baseOptions?: Apollo.QueryHookOptions<
    GetCalendarEvents2Query,
    GetCalendarEvents2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCalendarEvents2Query,
    GetCalendarEvents2QueryVariables
  >(GetCalendarEvents2Document, options);
}
export function useGetCalendarEvents2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalendarEvents2Query,
    GetCalendarEvents2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCalendarEvents2Query,
    GetCalendarEvents2QueryVariables
  >(GetCalendarEvents2Document, options);
}
export type GetCalendarEvents2QueryHookResult = ReturnType<
  typeof useGetCalendarEvents2Query
>;
export type GetCalendarEvents2LazyQueryHookResult = ReturnType<
  typeof useGetCalendarEvents2LazyQuery
>;
export type GetCalendarEvents2QueryResult = Apollo.QueryResult<
  GetCalendarEvents2Query,
  GetCalendarEvents2QueryVariables
>;
export const GetAiBotTemplatesWithFieldsDocument = gql`
  query GetAiBotTemplatesWithFields($templateId: ID) {
    getAiBotTemplatesWithFields(templateId: $templateId) {
      id
      createdAt
      name {
        ...CoreLanguageMapFields
      }
      description {
        ...CoreLanguageMapFields
      }
      fields
    }
  }
  ${CoreLanguageMapFieldsFragmentDoc}
`;

/**
 * __useGetAiBotTemplatesWithFieldsQuery__
 *
 * To run a query within a React component, call `useGetAiBotTemplatesWithFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiBotTemplatesWithFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiBotTemplatesWithFieldsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGetAiBotTemplatesWithFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAiBotTemplatesWithFieldsQuery,
    GetAiBotTemplatesWithFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAiBotTemplatesWithFieldsQuery,
    GetAiBotTemplatesWithFieldsQueryVariables
  >(GetAiBotTemplatesWithFieldsDocument, options);
}
export function useGetAiBotTemplatesWithFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAiBotTemplatesWithFieldsQuery,
    GetAiBotTemplatesWithFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAiBotTemplatesWithFieldsQuery,
    GetAiBotTemplatesWithFieldsQueryVariables
  >(GetAiBotTemplatesWithFieldsDocument, options);
}
export type GetAiBotTemplatesWithFieldsQueryHookResult = ReturnType<
  typeof useGetAiBotTemplatesWithFieldsQuery
>;
export type GetAiBotTemplatesWithFieldsLazyQueryHookResult = ReturnType<
  typeof useGetAiBotTemplatesWithFieldsLazyQuery
>;
export type GetAiBotTemplatesWithFieldsQueryResult = Apollo.QueryResult<
  GetAiBotTemplatesWithFieldsQuery,
  GetAiBotTemplatesWithFieldsQueryVariables
>;
export const GetAiBotUserSettingsDocument = gql`
  query GetAiBotUserSettings($botId: ID!) {
    getAiBotUserSettings(botId: $botId) {
      id
      createdAt
      updatedAt
      templateId
      botId
      userSettings
    }
  }
`;

/**
 * __useGetAiBotUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetAiBotUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiBotUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiBotUserSettingsQuery({
 *   variables: {
 *      botId: // value for 'botId'
 *   },
 * });
 */
export function useGetAiBotUserSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAiBotUserSettingsQuery,
    GetAiBotUserSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAiBotUserSettingsQuery,
    GetAiBotUserSettingsQueryVariables
  >(GetAiBotUserSettingsDocument, options);
}
export function useGetAiBotUserSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAiBotUserSettingsQuery,
    GetAiBotUserSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAiBotUserSettingsQuery,
    GetAiBotUserSettingsQueryVariables
  >(GetAiBotUserSettingsDocument, options);
}
export type GetAiBotUserSettingsQueryHookResult = ReturnType<
  typeof useGetAiBotUserSettingsQuery
>;
export type GetAiBotUserSettingsLazyQueryHookResult = ReturnType<
  typeof useGetAiBotUserSettingsLazyQuery
>;
export type GetAiBotUserSettingsQueryResult = Apollo.QueryResult<
  GetAiBotUserSettingsQuery,
  GetAiBotUserSettingsQueryVariables
>;
export const GetOrganizationsDocument = gql`
  query GetOrganizations(
    $search: String
    $statuses: [OrganizationStatus]
    $isWithInvoices: Boolean
    $isDeleted: Boolean
  ) {
    getOrganizations(
      search: $search
      statuses: $statuses
      isWithInvoices: $isWithInvoices
      isDeleted: $isDeleted
    ) {
      current {
        ...CoreOrganizationFields
      }
      parent {
        ...CoreOrganizationFields
      }
      subsidiaries {
        ...CoreOrganizationFields
      }
      totalCountsByStatus {
        ACTIVE
        INACTIVE
        DRAFT
        ARCHIVED
      }
    }
  }
  ${CoreOrganizationFieldsFragmentDoc}
`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      isWithInvoices: // value for 'isWithInvoices'
 *      isDeleted: // value for 'isDeleted'
 *   },
 * });
 */
export function useGetOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrganizationsQuery,
    GetOrganizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(
    GetOrganizationsDocument,
    options
  );
}
export function useGetOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationsQuery,
    GetOrganizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationsQuery,
    GetOrganizationsQueryVariables
  >(GetOrganizationsDocument, options);
}
export type GetOrganizationsQueryHookResult = ReturnType<
  typeof useGetOrganizationsQuery
>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationsLazyQuery
>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<
  GetOrganizationsQuery,
  GetOrganizationsQueryVariables
>;
export const GetCustomFieldsDocument = gql`
  query GetCustomFields {
    getCustomFields {
      ...CoreCustomFieldFields
    }
  }
  ${CoreCustomFieldFieldsFragmentDoc}
`;

/**
 * __useGetCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGetCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomFieldsQuery,
    GetCustomFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>(
    GetCustomFieldsDocument,
    options
  );
}
export function useGetCustomFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomFieldsQuery,
    GetCustomFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCustomFieldsQuery,
    GetCustomFieldsQueryVariables
  >(GetCustomFieldsDocument, options);
}
export type GetCustomFieldsQueryHookResult = ReturnType<
  typeof useGetCustomFieldsQuery
>;
export type GetCustomFieldsLazyQueryHookResult = ReturnType<
  typeof useGetCustomFieldsLazyQuery
>;
export type GetCustomFieldsQueryResult = Apollo.QueryResult<
  GetCustomFieldsQuery,
  GetCustomFieldsQueryVariables
>;
export const GetClientTodoTasksDocument = gql`
  query GetClientTodoTasks($clientId: String!) {
    getClientTodoTasks(clientId: $clientId) {
      ...CoreClientTodoFields
    }
  }
  ${CoreClientTodoFieldsFragmentDoc}
`;

/**
 * __useGetClientTodoTasksQuery__
 *
 * To run a query within a React component, call `useGetClientTodoTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTodoTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTodoTasksQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetClientTodoTasksQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientTodoTasksQuery,
    GetClientTodoTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClientTodoTasksQuery,
    GetClientTodoTasksQueryVariables
  >(GetClientTodoTasksDocument, options);
}
export function useGetClientTodoTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientTodoTasksQuery,
    GetClientTodoTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClientTodoTasksQuery,
    GetClientTodoTasksQueryVariables
  >(GetClientTodoTasksDocument, options);
}
export type GetClientTodoTasksQueryHookResult = ReturnType<
  typeof useGetClientTodoTasksQuery
>;
export type GetClientTodoTasksLazyQueryHookResult = ReturnType<
  typeof useGetClientTodoTasksLazyQuery
>;
export type GetClientTodoTasksQueryResult = Apollo.QueryResult<
  GetClientTodoTasksQuery,
  GetClientTodoTasksQueryVariables
>;
export const SendCodeDocument = gql`
  query SendCode($recipient: String!, $channel: VerifyCodeStatus!) {
    sendCode(recipient: $recipient, channel: $channel) {
      status
    }
  }
`;

/**
 * __useSendCodeQuery__
 *
 * To run a query within a React component, call `useSendCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendCodeQuery({
 *   variables: {
 *      recipient: // value for 'recipient'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useSendCodeQuery(
  baseOptions: Apollo.QueryHookOptions<SendCodeQuery, SendCodeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SendCodeQuery, SendCodeQueryVariables>(
    SendCodeDocument,
    options
  );
}
export function useSendCodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SendCodeQuery,
    SendCodeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SendCodeQuery, SendCodeQueryVariables>(
    SendCodeDocument,
    options
  );
}
export type SendCodeQueryHookResult = ReturnType<typeof useSendCodeQuery>;
export type SendCodeLazyQueryHookResult = ReturnType<
  typeof useSendCodeLazyQuery
>;
export type SendCodeQueryResult = Apollo.QueryResult<
  SendCodeQuery,
  SendCodeQueryVariables
>;
export const CheckCodeDocument = gql`
  query CheckCode($recipient: String!, $code: String!) {
    checkCode(recipient: $recipient, code: $code)
  }
`;

/**
 * __useCheckCodeQuery__
 *
 * To run a query within a React component, call `useCheckCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCodeQuery({
 *   variables: {
 *      recipient: // value for 'recipient'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCheckCodeQuery(
  baseOptions: Apollo.QueryHookOptions<CheckCodeQuery, CheckCodeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckCodeQuery, CheckCodeQueryVariables>(
    CheckCodeDocument,
    options
  );
}
export function useCheckCodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckCodeQuery,
    CheckCodeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckCodeQuery, CheckCodeQueryVariables>(
    CheckCodeDocument,
    options
  );
}
export type CheckCodeQueryHookResult = ReturnType<typeof useCheckCodeQuery>;
export type CheckCodeLazyQueryHookResult = ReturnType<
  typeof useCheckCodeLazyQuery
>;
export type CheckCodeQueryResult = Apollo.QueryResult<
  CheckCodeQuery,
  CheckCodeQueryVariables
>;
export const GetLinkToAddCardDocument = gql`
  query GetLinkToAddCard($successUrl: String!) {
    getLinkToAddCard(successUrl: $successUrl)
  }
`;

/**
 * __useGetLinkToAddCardQuery__
 *
 * To run a query within a React component, call `useGetLinkToAddCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkToAddCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkToAddCardQuery({
 *   variables: {
 *      successUrl: // value for 'successUrl'
 *   },
 * });
 */
export function useGetLinkToAddCardQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLinkToAddCardQuery,
    GetLinkToAddCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLinkToAddCardQuery, GetLinkToAddCardQueryVariables>(
    GetLinkToAddCardDocument,
    options
  );
}
export function useGetLinkToAddCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLinkToAddCardQuery,
    GetLinkToAddCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLinkToAddCardQuery,
    GetLinkToAddCardQueryVariables
  >(GetLinkToAddCardDocument, options);
}
export type GetLinkToAddCardQueryHookResult = ReturnType<
  typeof useGetLinkToAddCardQuery
>;
export type GetLinkToAddCardLazyQueryHookResult = ReturnType<
  typeof useGetLinkToAddCardLazyQuery
>;
export type GetLinkToAddCardQueryResult = Apollo.QueryResult<
  GetLinkToAddCardQuery,
  GetLinkToAddCardQueryVariables
>;
export const GetSigningDocumentDocument = gql`
  query GetSigningDocument {
    getSigningDocument {
      signDocumentUrl
    }
  }
`;

/**
 * __useGetSigningDocumentQuery__
 *
 * To run a query within a React component, call `useGetSigningDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSigningDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSigningDocumentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSigningDocumentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSigningDocumentQuery,
    GetSigningDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSigningDocumentQuery,
    GetSigningDocumentQueryVariables
  >(GetSigningDocumentDocument, options);
}
export function useGetSigningDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSigningDocumentQuery,
    GetSigningDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSigningDocumentQuery,
    GetSigningDocumentQueryVariables
  >(GetSigningDocumentDocument, options);
}
export type GetSigningDocumentQueryHookResult = ReturnType<
  typeof useGetSigningDocumentQuery
>;
export type GetSigningDocumentLazyQueryHookResult = ReturnType<
  typeof useGetSigningDocumentLazyQuery
>;
export type GetSigningDocumentQueryResult = Apollo.QueryResult<
  GetSigningDocumentQuery,
  GetSigningDocumentQueryVariables
>;
export const GetInvoicesDocument = gql`
  query GetInvoices(
    $organizationId: String
    $sortOrder: SortOrder
    $sortBy: InvoiceSortBy
    $itemsPerPage: Int
    $pageNumber: Int
  ) {
    getInvoices(
      organizationId: $organizationId
      sortOrder: $sortOrder
      sortBy: $sortBy
      itemsPerPage: $itemsPerPage
      pageNumber: $pageNumber
    ) {
      invoices {
        ...CoreInvoicesFields
      }
      pagination {
        itemsPerPage
        pageNumber
        totalItems
      }
    }
  }
  ${CoreInvoicesFieldsFragmentDoc}
`;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      sortOrder: // value for 'sortOrder'
 *      sortBy: // value for 'sortBy'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useGetInvoicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetInvoicesQuery,
    GetInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(
    GetInvoicesDocument,
    options
  );
}
export function useGetInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicesQuery,
    GetInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(
    GetInvoicesDocument,
    options
  );
}
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<
  typeof useGetInvoicesLazyQuery
>;
export type GetInvoicesQueryResult = Apollo.QueryResult<
  GetInvoicesQuery,
  GetInvoicesQueryVariables
>;
export const GetCardDocument = gql`
  query GetCard {
    getCard {
      ...CoreCardFields
    }
  }
  ${CoreCardFieldsFragmentDoc}
`;

/**
 * __useGetCardQuery__
 *
 * To run a query within a React component, call `useGetCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCardQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCardQuery, GetCardQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCardQuery, GetCardQueryVariables>(
    GetCardDocument,
    options
  );
}
export function useGetCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCardQuery, GetCardQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCardQuery, GetCardQueryVariables>(
    GetCardDocument,
    options
  );
}
export type GetCardQueryHookResult = ReturnType<typeof useGetCardQuery>;
export type GetCardLazyQueryHookResult = ReturnType<typeof useGetCardLazyQuery>;
export type GetCardQueryResult = Apollo.QueryResult<
  GetCardQuery,
  GetCardQueryVariables
>;
export const GetInquiriesDocument = gql`
  query GetInquiries($clientId: String!) {
    getInquiries(clientId: $clientId) {
      ...CoreInquiryFields
    }
  }
  ${CoreInquiryFieldsFragmentDoc}
`;

/**
 * __useGetInquiriesQuery__
 *
 * To run a query within a React component, call `useGetInquiriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInquiriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInquiriesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetInquiriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInquiriesQuery,
    GetInquiriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInquiriesQuery, GetInquiriesQueryVariables>(
    GetInquiriesDocument,
    options
  );
}
export function useGetInquiriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInquiriesQuery,
    GetInquiriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInquiriesQuery, GetInquiriesQueryVariables>(
    GetInquiriesDocument,
    options
  );
}
export type GetInquiriesQueryHookResult = ReturnType<
  typeof useGetInquiriesQuery
>;
export type GetInquiriesLazyQueryHookResult = ReturnType<
  typeof useGetInquiriesLazyQuery
>;
export type GetInquiriesQueryResult = Apollo.QueryResult<
  GetInquiriesQuery,
  GetInquiriesQueryVariables
>;
export const GetNotificationsDocument = gql`
  query GetNotifications(
    $fetchSize: Int!
    $pagingState: String
    $onlyTasks: Boolean
    $onlyAppointments: Boolean
  ) {
    getNotifications(
      fetchSize: $fetchSize
      pagingState: $pagingState
      onlyTasks: $onlyTasks
      onlyAppointments: $onlyAppointments
    ) {
      notifications {
        ...CoreNotificationsFields
      }
      pagingState
      unreadCount
    }
  }
  ${CoreNotificationsFieldsFragmentDoc}
`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      fetchSize: // value for 'fetchSize'
 *      pagingState: // value for 'pagingState'
 *      onlyTasks: // value for 'onlyTasks'
 *      onlyAppointments: // value for 'onlyAppointments'
 *   },
 * });
 */
export function useGetNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(
    GetNotificationsDocument,
    options
  );
}
export function useGetNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >(GetNotificationsDocument, options);
}
export type GetNotificationsQueryHookResult = ReturnType<
  typeof useGetNotificationsQuery
>;
export type GetNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetNotificationsLazyQuery
>;
export type GetNotificationsQueryResult = Apollo.QueryResult<
  GetNotificationsQuery,
  GetNotificationsQueryVariables
>;
export const GetNotificationsSettingsDocument = gql`
  query GetNotificationsSettings {
    getNotificationsSettings {
      subtype
      enabled
    }
  }
`;

/**
 * __useGetNotificationsSettingsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNotificationsSettingsQuery,
    GetNotificationsSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNotificationsSettingsQuery,
    GetNotificationsSettingsQueryVariables
  >(GetNotificationsSettingsDocument, options);
}
export function useGetNotificationsSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotificationsSettingsQuery,
    GetNotificationsSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNotificationsSettingsQuery,
    GetNotificationsSettingsQueryVariables
  >(GetNotificationsSettingsDocument, options);
}
export type GetNotificationsSettingsQueryHookResult = ReturnType<
  typeof useGetNotificationsSettingsQuery
>;
export type GetNotificationsSettingsLazyQueryHookResult = ReturnType<
  typeof useGetNotificationsSettingsLazyQuery
>;
export type GetNotificationsSettingsQueryResult = Apollo.QueryResult<
  GetNotificationsSettingsQuery,
  GetNotificationsSettingsQueryVariables
>;
export const GetSignedDocumentDocument = gql`
  query GetSignedDocument($input: SignedDocumentInput!) {
    getSignedDocument(input: $input) {
      link
    }
  }
`;

/**
 * __useGetSignedDocumentQuery__
 *
 * To run a query within a React component, call `useGetSignedDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedDocumentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSignedDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSignedDocumentQuery,
    GetSignedDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSignedDocumentQuery,
    GetSignedDocumentQueryVariables
  >(GetSignedDocumentDocument, options);
}
export function useGetSignedDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSignedDocumentQuery,
    GetSignedDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSignedDocumentQuery,
    GetSignedDocumentQueryVariables
  >(GetSignedDocumentDocument, options);
}
export type GetSignedDocumentQueryHookResult = ReturnType<
  typeof useGetSignedDocumentQuery
>;
export type GetSignedDocumentLazyQueryHookResult = ReturnType<
  typeof useGetSignedDocumentLazyQuery
>;
export type GetSignedDocumentQueryResult = Apollo.QueryResult<
  GetSignedDocumentQuery,
  GetSignedDocumentQueryVariables
>;
export const GetInventoryDocument = gql`
  query getInventory($input: GetInventoryInput!) {
    getInventory(input: $input) {
      inventory {
        id
        year
        make
        model
        price
        centsPrice
        bodyType
        exteriorColor
        mileage
        trim
        mpg
        isAvailable
        vin
        url
        carfaxLink
        priceHistory {
          price
          createdAt
        }
        leadsCount
        testDriveCount
        stockId
        source
        isNew
        status
        isConflictingStatus
      }
      pagination {
        itemsPerPage
        pageNumber
        totalItems
      }
    }
  }
`;

/**
 * __useGetInventoryQuery__
 *
 * To run a query within a React component, call `useGetInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInventoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInventoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInventoryQuery,
    GetInventoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInventoryQuery, GetInventoryQueryVariables>(
    GetInventoryDocument,
    options
  );
}
export function useGetInventoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInventoryQuery,
    GetInventoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInventoryQuery, GetInventoryQueryVariables>(
    GetInventoryDocument,
    options
  );
}
export type GetInventoryQueryHookResult = ReturnType<
  typeof useGetInventoryQuery
>;
export type GetInventoryLazyQueryHookResult = ReturnType<
  typeof useGetInventoryLazyQuery
>;
export type GetInventoryQueryResult = Apollo.QueryResult<
  GetInventoryQuery,
  GetInventoryQueryVariables
>;
export const GetTranslationDocument = gql`
  query GetTranslation(
    $textToTranslation: String!
    $translateToCode: LanguageCode_ISO_639_1
  ) {
    getTranslation(
      textToTranslation: $textToTranslation
      translateToCode: $translateToCode
    ) {
      isTranslated
      translatedText
      fromCode
      toCode
    }
  }
`;

/**
 * __useGetTranslationQuery__
 *
 * To run a query within a React component, call `useGetTranslationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationQuery({
 *   variables: {
 *      textToTranslation: // value for 'textToTranslation'
 *      translateToCode: // value for 'translateToCode'
 *   },
 * });
 */
export function useGetTranslationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTranslationQuery,
    GetTranslationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTranslationQuery, GetTranslationQueryVariables>(
    GetTranslationDocument,
    options
  );
}
export function useGetTranslationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTranslationQuery,
    GetTranslationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTranslationQuery, GetTranslationQueryVariables>(
    GetTranslationDocument,
    options
  );
}
export type GetTranslationQueryHookResult = ReturnType<
  typeof useGetTranslationQuery
>;
export type GetTranslationLazyQueryHookResult = ReturnType<
  typeof useGetTranslationLazyQuery
>;
export type GetTranslationQueryResult = Apollo.QueryResult<
  GetTranslationQuery,
  GetTranslationQueryVariables
>;
export const GetTariffsDocument = gql`
  query GetTariffs {
    getTariffs {
      ...CoreTariffFields
    }
  }
  ${CoreTariffFieldsFragmentDoc}
`;

/**
 * __useGetTariffsQuery__
 *
 * To run a query within a React component, call `useGetTariffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTariffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTariffsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTariffsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTariffsQuery,
    GetTariffsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTariffsQuery, GetTariffsQueryVariables>(
    GetTariffsDocument,
    options
  );
}
export function useGetTariffsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTariffsQuery,
    GetTariffsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTariffsQuery, GetTariffsQueryVariables>(
    GetTariffsDocument,
    options
  );
}
export type GetTariffsQueryHookResult = ReturnType<typeof useGetTariffsQuery>;
export type GetTariffsLazyQueryHookResult = ReturnType<
  typeof useGetTariffsLazyQuery
>;
export type GetTariffsQueryResult = Apollo.QueryResult<
  GetTariffsQuery,
  GetTariffsQueryVariables
>;
export const GetTariffsByOidDocument = gql`
  query GetTariffsByOID {
    getTariffsByOID {
      ...CoreTariffFields
    }
  }
  ${CoreTariffFieldsFragmentDoc}
`;

/**
 * __useGetTariffsByOidQuery__
 *
 * To run a query within a React component, call `useGetTariffsByOidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTariffsByOidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTariffsByOidQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTariffsByOidQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTariffsByOidQuery,
    GetTariffsByOidQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTariffsByOidQuery, GetTariffsByOidQueryVariables>(
    GetTariffsByOidDocument,
    options
  );
}
export function useGetTariffsByOidLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTariffsByOidQuery,
    GetTariffsByOidQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTariffsByOidQuery,
    GetTariffsByOidQueryVariables
  >(GetTariffsByOidDocument, options);
}
export type GetTariffsByOidQueryHookResult = ReturnType<
  typeof useGetTariffsByOidQuery
>;
export type GetTariffsByOidLazyQueryHookResult = ReturnType<
  typeof useGetTariffsByOidLazyQuery
>;
export type GetTariffsByOidQueryResult = Apollo.QueryResult<
  GetTariffsByOidQuery,
  GetTariffsByOidQueryVariables
>;
export const GetTrialFinishDateDocument = gql`
  query GetTrialFinishDate {
    getTrialFinishDate
  }
`;

/**
 * __useGetTrialFinishDateQuery__
 *
 * To run a query within a React component, call `useGetTrialFinishDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrialFinishDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrialFinishDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTrialFinishDateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTrialFinishDateQuery,
    GetTrialFinishDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTrialFinishDateQuery,
    GetTrialFinishDateQueryVariables
  >(GetTrialFinishDateDocument, options);
}
export function useGetTrialFinishDateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTrialFinishDateQuery,
    GetTrialFinishDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTrialFinishDateQuery,
    GetTrialFinishDateQueryVariables
  >(GetTrialFinishDateDocument, options);
}
export type GetTrialFinishDateQueryHookResult = ReturnType<
  typeof useGetTrialFinishDateQuery
>;
export type GetTrialFinishDateLazyQueryHookResult = ReturnType<
  typeof useGetTrialFinishDateLazyQuery
>;
export type GetTrialFinishDateQueryResult = Apollo.QueryResult<
  GetTrialFinishDateQuery,
  GetTrialFinishDateQueryVariables
>;
export const GetInventoryDetailsDocument = gql`
  query GetInventoryDetails($id: ID!) {
    getInventoryDetails(id: $id) {
      ...CoreInventoryDetailsFields
    }
  }
  ${CoreInventoryDetailsFieldsFragmentDoc}
`;

/**
 * __useGetInventoryDetailsQuery__
 *
 * To run a query within a React component, call `useGetInventoryDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInventoryDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInventoryDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInventoryDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInventoryDetailsQuery,
    GetInventoryDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInventoryDetailsQuery,
    GetInventoryDetailsQueryVariables
  >(GetInventoryDetailsDocument, options);
}
export function useGetInventoryDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInventoryDetailsQuery,
    GetInventoryDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInventoryDetailsQuery,
    GetInventoryDetailsQueryVariables
  >(GetInventoryDetailsDocument, options);
}
export type GetInventoryDetailsQueryHookResult = ReturnType<
  typeof useGetInventoryDetailsQuery
>;
export type GetInventoryDetailsLazyQueryHookResult = ReturnType<
  typeof useGetInventoryDetailsLazyQuery
>;
export type GetInventoryDetailsQueryResult = Apollo.QueryResult<
  GetInventoryDetailsQuery,
  GetInventoryDetailsQueryVariables
>;
export const GetMailingRecordDocument = gql`
  query GetMailingRecord($roomId: String!) {
    getMailingRecord(roomId: $roomId) {
      ...CoreMailingRecordFields
    }
  }
  ${CoreMailingRecordFieldsFragmentDoc}
`;

/**
 * __useGetMailingRecordQuery__
 *
 * To run a query within a React component, call `useGetMailingRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailingRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailingRecordQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useGetMailingRecordQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMailingRecordQuery,
    GetMailingRecordQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMailingRecordQuery, GetMailingRecordQueryVariables>(
    GetMailingRecordDocument,
    options
  );
}
export function useGetMailingRecordLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMailingRecordQuery,
    GetMailingRecordQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMailingRecordQuery,
    GetMailingRecordQueryVariables
  >(GetMailingRecordDocument, options);
}
export type GetMailingRecordQueryHookResult = ReturnType<
  typeof useGetMailingRecordQuery
>;
export type GetMailingRecordLazyQueryHookResult = ReturnType<
  typeof useGetMailingRecordLazyQuery
>;
export type GetMailingRecordQueryResult = Apollo.QueryResult<
  GetMailingRecordQuery,
  GetMailingRecordQueryVariables
>;
export const GetFtpSyncStatusDocument = gql`
  query GetFTPSyncStatus($organizationId: String) {
    getFTPSyncStatus(organizationId: $organizationId) {
      lastSyncAt
      lastSyncStatus
    }
  }
`;

/**
 * __useGetFtpSyncStatusQuery__
 *
 * To run a query within a React component, call `useGetFtpSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFtpSyncStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFtpSyncStatusQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetFtpSyncStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFtpSyncStatusQuery,
    GetFtpSyncStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFtpSyncStatusQuery, GetFtpSyncStatusQueryVariables>(
    GetFtpSyncStatusDocument,
    options
  );
}
export function useGetFtpSyncStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFtpSyncStatusQuery,
    GetFtpSyncStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFtpSyncStatusQuery,
    GetFtpSyncStatusQueryVariables
  >(GetFtpSyncStatusDocument, options);
}
export type GetFtpSyncStatusQueryHookResult = ReturnType<
  typeof useGetFtpSyncStatusQuery
>;
export type GetFtpSyncStatusLazyQueryHookResult = ReturnType<
  typeof useGetFtpSyncStatusLazyQuery
>;
export type GetFtpSyncStatusQueryResult = Apollo.QueryResult<
  GetFtpSyncStatusQuery,
  GetFtpSyncStatusQueryVariables
>;
export const GetOrganizationSettingsDocument = gql`
  query GetOrganizationSettings {
    getOrganizationSettings {
      canOperatorAssignAppointments
    }
  }
`;

/**
 * __useGetOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrganizationSettingsQuery,
    GetOrganizationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganizationSettingsQuery,
    GetOrganizationSettingsQueryVariables
  >(GetOrganizationSettingsDocument, options);
}
export function useGetOrganizationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationSettingsQuery,
    GetOrganizationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationSettingsQuery,
    GetOrganizationSettingsQueryVariables
  >(GetOrganizationSettingsDocument, options);
}
export type GetOrganizationSettingsQueryHookResult = ReturnType<
  typeof useGetOrganizationSettingsQuery
>;
export type GetOrganizationSettingsLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationSettingsLazyQuery
>;
export type GetOrganizationSettingsQueryResult = Apollo.QueryResult<
  GetOrganizationSettingsQuery,
  GetOrganizationSettingsQueryVariables
>;
export const EvaluateFeatureFlagsDocument = gql`
  query EvaluateFeatureFlags(
    $flagIds: [String!]!
    $traits: [FeatureFlagTraitInput!]
  ) {
    evaluateFeatureFlags(flagIds: $flagIds, traits: $traits) {
      flagId
      enabled
      value
    }
  }
`;

/**
 * __useEvaluateFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useEvaluateFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluateFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluateFeatureFlagsQuery({
 *   variables: {
 *      flagIds: // value for 'flagIds'
 *      traits: // value for 'traits'
 *   },
 * });
 */
export function useEvaluateFeatureFlagsQuery(
  baseOptions: Apollo.QueryHookOptions<
    EvaluateFeatureFlagsQuery,
    EvaluateFeatureFlagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EvaluateFeatureFlagsQuery,
    EvaluateFeatureFlagsQueryVariables
  >(EvaluateFeatureFlagsDocument, options);
}
export function useEvaluateFeatureFlagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EvaluateFeatureFlagsQuery,
    EvaluateFeatureFlagsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EvaluateFeatureFlagsQuery,
    EvaluateFeatureFlagsQueryVariables
  >(EvaluateFeatureFlagsDocument, options);
}
export type EvaluateFeatureFlagsQueryHookResult = ReturnType<
  typeof useEvaluateFeatureFlagsQuery
>;
export type EvaluateFeatureFlagsLazyQueryHookResult = ReturnType<
  typeof useEvaluateFeatureFlagsLazyQuery
>;
export type EvaluateFeatureFlagsQueryResult = Apollo.QueryResult<
  EvaluateFeatureFlagsQuery,
  EvaluateFeatureFlagsQueryVariables
>;
export const WatchUsersDocument = gql`
  subscription WatchUsers {
    watchUsers {
      user {
        ...CoreUserFields
        ...InternalUserFields
      }
      method
    }
  }
  ${CoreUserFieldsFragmentDoc}
  ${InternalUserFieldsFragmentDoc}
`;

/**
 * __useWatchUsersSubscription__
 *
 * To run a query within a React component, call `useWatchUsersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchUsersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchUsersSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWatchUsersSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    WatchUsersSubscription,
    WatchUsersSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchUsersSubscription,
    WatchUsersSubscriptionVariables
  >(WatchUsersDocument, options);
}
export type WatchUsersSubscriptionHookResult = ReturnType<
  typeof useWatchUsersSubscription
>;
export type WatchUsersSubscriptionResult =
  Apollo.SubscriptionResult<WatchUsersSubscription>;
export const WatchRooms2Document = gql`
  subscription WatchRooms2($teamId: String!, $userId: String!) {
    watchRooms2(teamId: $teamId, userId: $userId) {
      rooms {
        ...CoreRoomFields
      }
      error
    }
  }
  ${CoreRoomFieldsFragmentDoc}
`;

/**
 * __useWatchRooms2Subscription__
 *
 * To run a query within a React component, call `useWatchRooms2Subscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchRooms2Subscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchRooms2Subscription({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useWatchRooms2Subscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WatchRooms2Subscription,
    WatchRooms2SubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchRooms2Subscription,
    WatchRooms2SubscriptionVariables
  >(WatchRooms2Document, options);
}
export type WatchRooms2SubscriptionHookResult = ReturnType<
  typeof useWatchRooms2Subscription
>;
export type WatchRooms2SubscriptionResult =
  Apollo.SubscriptionResult<WatchRooms2Subscription>;
export const WatchCreateMessageDocument = gql`
  subscription WatchCreateMessage($channelType: ChannelType!) {
    watchCreateMessage(channelType: $channelType) {
      ...CoreMessageFields
    }
  }
  ${CoreMessageFieldsFragmentDoc}
`;

/**
 * __useWatchCreateMessageSubscription__
 *
 * To run a query within a React component, call `useWatchCreateMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchCreateMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchCreateMessageSubscription({
 *   variables: {
 *      channelType: // value for 'channelType'
 *   },
 * });
 */
export function useWatchCreateMessageSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WatchCreateMessageSubscription,
    WatchCreateMessageSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchCreateMessageSubscription,
    WatchCreateMessageSubscriptionVariables
  >(WatchCreateMessageDocument, options);
}
export type WatchCreateMessageSubscriptionHookResult = ReturnType<
  typeof useWatchCreateMessageSubscription
>;
export type WatchCreateMessageSubscriptionResult =
  Apollo.SubscriptionResult<WatchCreateMessageSubscription>;
export const WatchUpdateMessageDataDocument = gql`
  subscription WatchUpdateMessageData($channelType: ChannelType!) {
    watchUpdateMessageData(channelType: $channelType) {
      channelId
      channelTypeName
      chatRoomId
      chatRoomMessages {
        ...CoreMessageFields
      }
      chatRoomStatus
      isClient
      unreadMessagesNumber
    }
  }
  ${CoreMessageFieldsFragmentDoc}
`;

/**
 * __useWatchUpdateMessageDataSubscription__
 *
 * To run a query within a React component, call `useWatchUpdateMessageDataSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchUpdateMessageDataSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchUpdateMessageDataSubscription({
 *   variables: {
 *      channelType: // value for 'channelType'
 *   },
 * });
 */
export function useWatchUpdateMessageDataSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WatchUpdateMessageDataSubscription,
    WatchUpdateMessageDataSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchUpdateMessageDataSubscription,
    WatchUpdateMessageDataSubscriptionVariables
  >(WatchUpdateMessageDataDocument, options);
}
export type WatchUpdateMessageDataSubscriptionHookResult = ReturnType<
  typeof useWatchUpdateMessageDataSubscription
>;
export type WatchUpdateMessageDataSubscriptionResult =
  Apollo.SubscriptionResult<WatchUpdateMessageDataSubscription>;
export const WatchDeleteMessageDocument = gql`
  subscription WatchDeleteMessage($channelType: ChannelType!) {
    watchDeleteMessage(channelType: $channelType) {
      channelType
      channelId
      chatRoomId
      messageId
    }
  }
`;

/**
 * __useWatchDeleteMessageSubscription__
 *
 * To run a query within a React component, call `useWatchDeleteMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchDeleteMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchDeleteMessageSubscription({
 *   variables: {
 *      channelType: // value for 'channelType'
 *   },
 * });
 */
export function useWatchDeleteMessageSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WatchDeleteMessageSubscription,
    WatchDeleteMessageSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchDeleteMessageSubscription,
    WatchDeleteMessageSubscriptionVariables
  >(WatchDeleteMessageDocument, options);
}
export type WatchDeleteMessageSubscriptionHookResult = ReturnType<
  typeof useWatchDeleteMessageSubscription
>;
export type WatchDeleteMessageSubscriptionResult =
  Apollo.SubscriptionResult<WatchDeleteMessageSubscription>;
export const WatchChannelsDocument = gql`
  subscription WatchChannels {
    watchChannels {
      channel {
        ...CoreChannelFields
      }
      method
    }
  }
  ${CoreChannelFieldsFragmentDoc}
`;

/**
 * __useWatchChannelsSubscription__
 *
 * To run a query within a React component, call `useWatchChannelsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchChannelsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchChannelsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWatchChannelsSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    WatchChannelsSubscription,
    WatchChannelsSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchChannelsSubscription,
    WatchChannelsSubscriptionVariables
  >(WatchChannelsDocument, options);
}
export type WatchChannelsSubscriptionHookResult = ReturnType<
  typeof useWatchChannelsSubscription
>;
export type WatchChannelsSubscriptionResult =
  Apollo.SubscriptionResult<WatchChannelsSubscription>;
export const WatchCommentsDocument = gql`
  subscription WatchComments {
    watchComments {
      method
      comment {
        ...CoreCommentsFields
      }
    }
  }
  ${CoreCommentsFieldsFragmentDoc}
`;

/**
 * __useWatchCommentsSubscription__
 *
 * To run a query within a React component, call `useWatchCommentsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchCommentsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchCommentsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWatchCommentsSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    WatchCommentsSubscription,
    WatchCommentsSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchCommentsSubscription,
    WatchCommentsSubscriptionVariables
  >(WatchCommentsDocument, options);
}
export type WatchCommentsSubscriptionHookResult = ReturnType<
  typeof useWatchCommentsSubscription
>;
export type WatchCommentsSubscriptionResult =
  Apollo.SubscriptionResult<WatchCommentsSubscription>;
export const WatchBotsDocument = gql`
  subscription WatchBots {
    watchBots {
      bots {
        ...ExtendedBotFields
      }
    }
  }
  ${ExtendedBotFieldsFragmentDoc}
`;

/**
 * __useWatchBotsSubscription__
 *
 * To run a query within a React component, call `useWatchBotsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchBotsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchBotsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWatchBotsSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    WatchBotsSubscription,
    WatchBotsSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchBotsSubscription,
    WatchBotsSubscriptionVariables
  >(WatchBotsDocument, options);
}
export type WatchBotsSubscriptionHookResult = ReturnType<
  typeof useWatchBotsSubscription
>;
export type WatchBotsSubscriptionResult =
  Apollo.SubscriptionResult<WatchBotsSubscription>;
export const WatchCalendarEvents2Document = gql`
  subscription WatchCalendarEvents2($oid: String!) {
    watchCalendarEvents2(oid: $oid) {
      actionType
      event {
        ...CoreCalendarEventFields2
      }
    }
  }
  ${CoreCalendarEventFields2FragmentDoc}
`;

/**
 * __useWatchCalendarEvents2Subscription__
 *
 * To run a query within a React component, call `useWatchCalendarEvents2Subscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchCalendarEvents2Subscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchCalendarEvents2Subscription({
 *   variables: {
 *      oid: // value for 'oid'
 *   },
 * });
 */
export function useWatchCalendarEvents2Subscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WatchCalendarEvents2Subscription,
    WatchCalendarEvents2SubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchCalendarEvents2Subscription,
    WatchCalendarEvents2SubscriptionVariables
  >(WatchCalendarEvents2Document, options);
}
export type WatchCalendarEvents2SubscriptionHookResult = ReturnType<
  typeof useWatchCalendarEvents2Subscription
>;
export type WatchCalendarEvents2SubscriptionResult =
  Apollo.SubscriptionResult<WatchCalendarEvents2Subscription>;
export const WatchOnboardStatusDocument = gql`
  subscription WatchOnboardStatus($oid: String!) {
    watchOnboardStatus(oid: $oid) {
      oid
      onboardStatus
    }
  }
`;

/**
 * __useWatchOnboardStatusSubscription__
 *
 * To run a query within a React component, call `useWatchOnboardStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchOnboardStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchOnboardStatusSubscription({
 *   variables: {
 *      oid: // value for 'oid'
 *   },
 * });
 */
export function useWatchOnboardStatusSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WatchOnboardStatusSubscription,
    WatchOnboardStatusSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchOnboardStatusSubscription,
    WatchOnboardStatusSubscriptionVariables
  >(WatchOnboardStatusDocument, options);
}
export type WatchOnboardStatusSubscriptionHookResult = ReturnType<
  typeof useWatchOnboardStatusSubscription
>;
export type WatchOnboardStatusSubscriptionResult =
  Apollo.SubscriptionResult<WatchOnboardStatusSubscription>;
export const WatchClientInquiriesDocument = gql`
  subscription WatchClientInquiries($oid: String!) {
    watchClientInquiries(oid: $oid) {
      oid
      id
      createdAt
      clientId
      channelIdSource
      channelId
      leadSource
      vehicle
    }
  }
`;

/**
 * __useWatchClientInquiriesSubscription__
 *
 * To run a query within a React component, call `useWatchClientInquiriesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchClientInquiriesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchClientInquiriesSubscription({
 *   variables: {
 *      oid: // value for 'oid'
 *   },
 * });
 */
export function useWatchClientInquiriesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WatchClientInquiriesSubscription,
    WatchClientInquiriesSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchClientInquiriesSubscription,
    WatchClientInquiriesSubscriptionVariables
  >(WatchClientInquiriesDocument, options);
}
export type WatchClientInquiriesSubscriptionHookResult = ReturnType<
  typeof useWatchClientInquiriesSubscription
>;
export type WatchClientInquiriesSubscriptionResult =
  Apollo.SubscriptionResult<WatchClientInquiriesSubscription>;
export const WatchNotificationsDocument = gql`
  subscription WatchNotifications($userId: String!) {
    watchNotifications(userId: $userId) {
      ...CoreNotificationsFields
    }
  }
  ${CoreNotificationsFieldsFragmentDoc}
`;

/**
 * __useWatchNotificationsSubscription__
 *
 * To run a query within a React component, call `useWatchNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchNotificationsSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useWatchNotificationsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WatchNotificationsSubscription,
    WatchNotificationsSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchNotificationsSubscription,
    WatchNotificationsSubscriptionVariables
  >(WatchNotificationsDocument, options);
}
export type WatchNotificationsSubscriptionHookResult = ReturnType<
  typeof useWatchNotificationsSubscription
>;
export type WatchNotificationsSubscriptionResult =
  Apollo.SubscriptionResult<WatchNotificationsSubscription>;
export const WatchPushNotificationsDocument = gql`
  subscription WatchPushNotifications($userId: String!) {
    watchPushNotifications(userId: $userId) {
      ...CoreNotificationsFields
    }
  }
  ${CoreNotificationsFieldsFragmentDoc}
`;

/**
 * __useWatchPushNotificationsSubscription__
 *
 * To run a query within a React component, call `useWatchPushNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchPushNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchPushNotificationsSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useWatchPushNotificationsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WatchPushNotificationsSubscription,
    WatchPushNotificationsSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchPushNotificationsSubscription,
    WatchPushNotificationsSubscriptionVariables
  >(WatchPushNotificationsDocument, options);
}
export type WatchPushNotificationsSubscriptionHookResult = ReturnType<
  typeof useWatchPushNotificationsSubscription
>;
export type WatchPushNotificationsSubscriptionResult =
  Apollo.SubscriptionResult<WatchPushNotificationsSubscription>;
export const WatchOrganizationStatusDocument = gql`
  subscription WatchOrganizationStatus($oid: String!) {
    watchOrganizationStatus(oid: $oid)
  }
`;

/**
 * __useWatchOrganizationStatusSubscription__
 *
 * To run a query within a React component, call `useWatchOrganizationStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchOrganizationStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchOrganizationStatusSubscription({
 *   variables: {
 *      oid: // value for 'oid'
 *   },
 * });
 */
export function useWatchOrganizationStatusSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WatchOrganizationStatusSubscription,
    WatchOrganizationStatusSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchOrganizationStatusSubscription,
    WatchOrganizationStatusSubscriptionVariables
  >(WatchOrganizationStatusDocument, options);
}
export type WatchOrganizationStatusSubscriptionHookResult = ReturnType<
  typeof useWatchOrganizationStatusSubscription
>;
export type WatchOrganizationStatusSubscriptionResult =
  Apollo.SubscriptionResult<WatchOrganizationStatusSubscription>;
export const WatchMailingDocument = gql`
  subscription WatchMailing {
    watchMailing {
      type
      roomId
      leadId
      sendAt
      actionType
      deletedAt
      deleterName
      transferTo
    }
  }
`;

/**
 * __useWatchMailingSubscription__
 *
 * To run a query within a React component, call `useWatchMailingSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchMailingSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchMailingSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWatchMailingSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    WatchMailingSubscription,
    WatchMailingSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WatchMailingSubscription,
    WatchMailingSubscriptionVariables
  >(WatchMailingDocument, options);
}
export type WatchMailingSubscriptionHookResult = ReturnType<
  typeof useWatchMailingSubscription
>;
export type WatchMailingSubscriptionResult =
  Apollo.SubscriptionResult<WatchMailingSubscription>;
export const OnFeatureFlagsChangedDocument = gql`
  subscription OnFeatureFlagsChanged(
    $flagIds: [String!]!
    $traits: [FeatureFlagTraitInput!]
  ) {
    onFeatureFlagsChanged(flagIds: $flagIds, traits: $traits) {
      flagId
      enabled
      value
    }
  }
`;

/**
 * __useOnFeatureFlagsChangedSubscription__
 *
 * To run a query within a React component, call `useOnFeatureFlagsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnFeatureFlagsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnFeatureFlagsChangedSubscription({
 *   variables: {
 *      flagIds: // value for 'flagIds'
 *      traits: // value for 'traits'
 *   },
 * });
 */
export function useOnFeatureFlagsChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OnFeatureFlagsChangedSubscription,
    OnFeatureFlagsChangedSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OnFeatureFlagsChangedSubscription,
    OnFeatureFlagsChangedSubscriptionVariables
  >(OnFeatureFlagsChangedDocument, options);
}
export type OnFeatureFlagsChangedSubscriptionHookResult = ReturnType<
  typeof useOnFeatureFlagsChangedSubscription
>;
export type OnFeatureFlagsChangedSubscriptionResult =
  Apollo.SubscriptionResult<OnFeatureFlagsChangedSubscription>;
